import {
  countryListDE,
  countryListEN,
  countryListES,
  countryListFR,
  countryListIT,
  countryListPL,
} from "./countriesData";

const translationData = [
  {
    FIELD1: "t('home.app.appstore')",
    English: "/assets/app/download-on-app-store.png",
    French: "/assets/app/download-on-app-store-fr.png",
    German: "/assets/app/download-on-app-store-de.png",
    Spanish: "/assets/app/download-on-app-store-es.png",
    Italian: "/assets/app/download-on-app-store-it.png",
    Polish: "/assets/app/download-on-app-store-pl.png",
  },
  {
    FIELD1: "t('home.app.playstore')",
    English: "/assets/app/download-on-google-play-store.png",
    French: "/assets/app/download-on-google-play-store-fr.png",
    German: "/assets/app/download-on-google-play-store-de.png",
    Spanish: "/assets/app/download-on-google-play-store-es.png",
    Italian: "/assets/app/download-on-google-play-store-it.png",
    Polish: "/assets/app/download-on-google-play-store-pl.png",
  },
  {
    FIELD1: "t('app.main.ratings')",
    English: "1K+ Ratings",
    French: "Plus de 1000 votes",
    German: "1K+ Bewertungen",
    Spanish: "Más de 1.000 valoraciones",
    Italian: "1K+ recensioni",
    Polish: "Ponad 1 tys. ocen",
  },
  {
    FIELD1: "t('localization.main.4g')",
    English: "4G Only",
    French: "4G uniquement",
    German: "nur 4G",
    Spanish: "Solo 4G",
    Italian: "Solo 4G",
    Polish: "Tylko 4G",
  },
  {
    FIELD1: "t('signup.helmet.title')",
    English: "SafeTag Portal Sign-Up",
    French: "Inscription à SafeTag",
    German: "SafeTag anmelden",
    Spanish: "Registro en SafeTag",
    Italian: "Registrazione SafeTag",
    Polish: "Rejestracja w portalu SafeTag",
  },
  {
    FIELD1: "t('signup.helmet.desc')",
    English:
      "Sign up to SafeTag to register and activate your trackers and get full access to our platform.",
    French:
      "Inscrivez-vous à SafeTag pour enregistrer et activer vos traceurs et obtenir un accès complet à notre plateforme.",
    German:
      "Melden Sie sich bei SafeTag an, um Ihre Tracker zu registrieren und zu aktivieren und vollen Zugriff auf unsere Plattform zu erhalten.",
    Spanish:
      "Regístrese en SafeTag para registrar y activar sus rastreadores y obtener acceso completo a nuestra plataforma.",
    Italian:
      "Registrati su SafeTag per attivare i tuoi dispositivi e ottenere l'accesso completo alla nostra piattaforma.",
    Polish:
      "Zarejestruj się w SafeTag, aby zarejestrować i aktywować swoje lokalizatory oraz uzyskać pełny dostęp do naszej platformy.",
  },
  {
    FIELD1: "t('signup.main.title')",
    English: "Create your SafeTag Account",
    French: "Créer votre compte SafeTag",
    German: "Erstellen Sie Ihr SafeTag-Konto",
    Spanish: "Crear su cuenta SafeTag",
    Italian: "Crea il tuo account SafeTag",
    Polish: "Utwórz konto SafeTag",
  },
  {
    FIELD1: "t('signup.main.login_statement')",
    English: "Already have an account?",
    French: "Vous avez déjà un compte ?",
    German: "Sie haben bereits ein Konto?",
    Spanish: "¿Ya tiene una cuenta?",
    Italian: "Hai già un account?",
    Polish: "Masz już konto?",
  },
  {
    FIELD1: "t('signup.main.placeholder_name')",
    English: "Name",
    French: "Nom",
    German: "Name",
    Spanish: "Nombre",
    Italian: "Nome",
    Polish: "Imię",
  },
  {
    FIELD1: "t('signup.main.placeholder_email')",
    English: "Email",
    French: "Email",
    German: "E-Mail",
    Spanish: "Correo electrónico",
    Italian: "Email",
    Polish: "E-mail",
  },
  {
    FIELD1: "t('signup.main.placeholder_password')",
    English: "Password",
    French: "Mot de passe",
    German: "Passwort",
    Spanish: "Contraseña",
    Italian: "Password",
    Polish: "Hasło",
  },
  {
    FIELD1: "t('signup.main.placeholder_confirm')",
    English: "Confirm Password",
    French: "Confirmer le mot de passe",
    German: "Passwort bestätigen",
    Spanish: "Confirmar contraseña",
    Italian: "Conferma password",
    Polish: "Potwierdź hasło",
  },
  {
    FIELD1: "t('signup.main.select_country')",
    English: "Select your country...",
    French: "Sélectionner votre pays...",
    German: "Wählen Sie ihr Land aus...",
    Spanish: "Seleccione su país...",
    Italian: "Seleziona il tuo paese...",
    Polish: "Wybierz swój kraj...",
  },
  {
    FIELD1: "t('signup.main.char8')",
    English: "8 characters or longer",
    French: "8 caractères ou plus",
    German: "8 Charackter oder mehr",
    Spanish: "8 caracteres o más",
    Italian: "8 caratteri o più",
    Polish: "8 lub więcej znaków",
  },
  {
    FIELD1: "t('signup.main.combine')",
    English: "Combine",
    French: "Combiner",
    German: "Kombinieren",
    Spanish: "Combina",
    Italian: "Combina",
    Polish: "Połącz:",
  },
  {
    FIELD1: "t('signup.main.uppercase')",
    English: "uppercase letters",
    French: "lettres majuscules",
    German: "großbuchstaben",
    Spanish: "letras mayúsculas",
    Italian: "lettere maiuscole",
    Polish: "wielkie litery",
  },
  {
    FIELD1: "t('signup.main.lowercase')",
    English: "lowercase letters",
    French: "lettres minuscules",
    German: "Kleinbuchstaben",
    Spanish: "letras minúsculas",
    Italian: "lettere minuscole",
    Polish: "małe litery",
  },
  {
    FIELD1: "t('signup.main.and')",
    English: "and",
    French: "et",
    German: "und",
    Spanish: "y",
    Italian: "e",
    Polish: "oraz",
  },
  {
    FIELD1: "t('signup.main.numbers')",
    English: "numbers",
    French: "chiffres",
    German: "Zahlen",
    Spanish: "números",
    Italian: "numeri",
    Polish: "cyfry",
  },
  {
    FIELD1: "t('signup.main.match')",
    English: "Passwords match",
    French: "Les mots de passe correspondent",
    German: "Passwörter stimmen überein",
    Spanish: "Las contraseñas coinciden",
    Italian: "Le password coincidono",
    Polish: "Hasła są zgodne",
  },
  {
    FIELD1: "t('signup.main.personal_title')",
    English: "What will you be using your trackers for?",
    French: "À quelles fins utiliserez-vous vos traceurs ?",
    German: "Wofür werden Sie Ihre Tracker verwenden?",
    Spanish: "¿Para qué usará sus rastreadores?",
    Italian: "Per cosa utilizzerai i tuoi dispositivi?",
    Polish: "Do czego będziesz używać swoich lokalizatorów?",
  },
  {
    FIELD1: "t('signup.main.personal')",
    English: "Personal",
    French: "Personnel",
    German: "Persönlich",
    Spanish: "Personal",
    Italian: "Personale",
    Polish: "Prywatnie",
  },
  {
    FIELD1: "t('signup.main.business')",
    English: "Business",
    French: "Professionnel",
    German: "Unternehmen",
    Spanish: "Empresa",
    Italian: "Aziendale",
    Polish: "Biznesowo",
  },
  {
    FIELD1: "t('signup.main.promotions')",
    English:
      "Please keep me up to date with SafeTag Service Updates, Promotional Offers, Rewards and Marketing",
    French:
      "Veuillez me tenir au courant des mises à jour du service SafeTag, des offres promotionnelles, des récompenses et du marketing.",
    German:
      "Bitte halten Sie mich über SafeTag-Service-Updates, Werbeangebote, Belohnungen und Marketing auf dem Laufenden",
    Spanish:
      "Por favor, manténganme al día de las actualizaciones del servicio SafeTag, ofertas promocionales, premios y marketing",
    Italian:
      "Tienimi al corrente degli aggiornamenti del servizio SafeTag, delle offerte promozionali, dei premi e del marketing.",
    Polish:
      "Proszę informować mnie o aktualizacjach usług SafeTag, ofertach promocyjnych, nagrodach i marketingu",
  },
  {
    FIELD1: "t('signup.main.terms_and_services_accept')",
    English: "I accept the ",
    French: "J'accepte les ",
    German: "Ich akzeptiere die ",
    Spanish: "Acepto las",
    Italian: "Accetto i ",
    Polish: "Akceptuję",
  },
  {
    FIELD1: "t('signup.main.terms_and_services_link')",
    English: "Terms of Service",
    French: "Conditions d'utilisation.",
    German: "Nutzungsbedingungen",
    Spanish: "Condiciones del servicio",
    Italian: "Termini di servizio",
    Polish: "Warunki korzystania z usługi",
  },
  {
    FIELD1: "t('signup.main.button')",
    English: "Create Account",
    French: "Créer un compte",
    German: "Konto erstellen",
    Spanish: "Crear cuenta",
    Italian: "Crea un account",
    Polish: "Utwórz konto",
  },
  {
    FIELD1: "t('signup.main.error_general')",
    English: "Something went wrong, please try again later.",
    French: "Un problème est survenu, veuillez réessayer plus tard.",
    German: "Etwas ist schiefgelaufen ",
    Spanish: "Algo ha ido mal, por favor inténtelo de nuevo más tarde.",
    Italian: "Qualcosa è andato storto, riprova più tardi.",
    Polish: "Coś poszło nie tak, spróbuj ponownie później.",
  },
  {
    FIELD1: "t('signup.main.error_empty_fields')",
    English: "Fields can't be empty",
    French: "Les champs ne doivent pas être vides",
    German: "Die Felder könen nicht leer gelassen werden",
    Spanish: "Los campos no pueden estar vacíos",
    Italian: "Questi campi non possono essere vuoti",
    Polish: "Pola nie mogą być puste",
  },
  {
    FIELD1: "t('signup.main.error_name_length')",
    English: "Name length must be min 1 and max 100 letters",
    French: "La longueur du nom doit être comprise entre 1 et 100 lettres.",
    German:
      "Die Länge des Namens muss mindestens 1 und max 100 Buchstaben habe",
    Spanish: "La longitud del nombre debe ser mínimo 1 y máximo 100 letras",
    Italian: "La lunghezza del nome deve essere compresa tra 1 e 100 lettere.",
    Polish: "Długość imienia musi wynosić od 1 do 100 znaków",
  },
  {
    FIELD1: "t('signup.main.error_email_invalid')",
    English: "Please enter a valid email address.",
    French: "Veuillez saisir une adresse e-mail valide.",
    German: "Bitte geben Sie eine gültige E-Mail Adresse ein",
    Spanish: "Introduzca una dirección de correo electrónico válida.",
    Italian: "Sei pregato di inserire un indirizzo e-mail valido.",
    Polish: "Wprowadź poprawny adres e-mail.",
  },
  {
    FIELD1: "t('signup.main.error_email_exists')",
    English:
      "This email is associated with an existing account. Please login by clicking the link below.",
    French:
      "Cet e-mail est lié à un compte existant. Veuillez vous connecter en cliquant sur le lien ci-dessous.",
    German:
      "Diese E-Mail ist mit einem bestehenden Konto verknüpft. Bitte loggen Sie sich ein, indem Sie auf den unten stehenden Link klicken",
    Spanish:
      "Este correo electrónico está asociado a una cuenta existente. Inicie sesión haciendo clic en el siguiente enlace.",
    Italian:
      "Questa e-mail è associata a un account esistente. Effettua il login facendo clic sul link sottostante.",
    Polish:
      "Ten adres e-mail jest już powiązany z istniejącym kontem. Zaloguj się, klikając poniższy link.",
  },
  {
    FIELD1: "t('signup.main.error_password_short')",
    English: "Passwords should be at least 8 characters long.",
    French: "Les mots de passe doivent comporter au moins 8 caractères.",
    German: "Passwörter sollten mindestens 8 Charackter lang sein. ",
    Spanish: "Las contraseñas deben tener al menos 8 caracteres.",
    Italian: "Le password devono essere lunghe almeno 8 caratteri.",
    Polish: "Hasło powinno mieć co najmniej 8 znaków.",
  },
  {
    FIELD1: "t('signup.main.error_password_invalid')",
    English:
      "Passwords should contain at least one uppercase letter, one lower case letter and one number.",
    French:
      "Les mots de passe doivent contenir au moins une lettre majuscule, une lettre minuscule et un chiffre.",
    German:
      "Passwörter sollten mindestens einen Großbuchstaben, einen Kleinbuchstaben und eine Zahl enthalten.",
    Spanish:
      "Las contraseñas deben contener al menos una letra mayúscula, una letra minúscula y un número.",
    Italian:
      "Le password devono contenere almeno una lettera maiuscola, una lettera minuscola e un numero.",
    Polish:
      "Hasło powinno zawierać co najmniej jedną wielką literę, jedną małą literę oraz jedną cyfrę.",
  },
  {
    FIELD1: "t('signup.main.error_passwords_not_matched')",
    English: "Passwords do not match.",
    French: "Les mots de passe ne correspondent pas.",
    German: "Die Passwörter stimmen nicht überein",
    Spanish: "Las contraseñas no coinciden.",
    Italian: "Le password non coincidono.",
    Polish: "Hasła nie są zgodne.",
  },
  {
    FIELD1: "t('signup.main.error_tos')",
    English: "Please accept the terms of service to complete registration",
    French:
      "Veuillez accepter les conditions d'utilisation pour terminer l'inscription",
    German:
      "Bitte akzeptiere die Geschäftsbedingungen ge , um die Anmeldung zu beenden",
    Spanish: "Acepte las condiciones del servicio para completar el registro.",
    Italian: "Accetta i termini di servizio per completare la registrazione",
    Polish:
      "Aby zakończyć rejestrację, zaakceptuj warunki korzystania z usługi",
  },
  {
    FIELD1: "t('signup.main.error_captcha')",
    English: "Please complete the captcha",
    French: "Veuillez compléter le captcha",
    German: "Bitte beende die Captcha",
    Spanish: "Complete el captcha",
    Italian: "Sei pregato di completare il captcha",
    Polish: "Uzupełnij captcha",
  },
  {
    FIELD1: "t('login.helmet.title')",
    English: "SafeTag Portal Login",
    French: "Connexion à SafeTag",
    German: "SafeTag Login",
    Spanish: "Inicio de sesión en SafeTag",
    Italian: "Accesso a SafeTag",
    Polish: "Logowanie do portalu SafeTag",
  },
  {
    FIELD1: "t('login.helmet.desc')",
    English:
      "Login to your SafeTag account to monitor and manage your trackers.",
    French:
      "Connectez-vous à votre compte SafeTag pour surveiller et gérer vos traceurs.",
    German:
      "Melden Sie sich in Ihrem SafeTag-Konto an, um Ihre Tracker zu überwachen und zu verwalten.",
    Spanish:
      "Inicie sesión en su cuenta SafeTag para supervisar y gestionar sus rastreadores.",
    Italian:
      "Accedi al tuo account SafeTag per monitorare e gestire i dispositivi.",
    Polish:
      "Zaloguj się do swojego konta SafeTag, aby monitorować i zarządzać lokalizatorami.",
  },
  {
    FIELD1: "t('login.main.title')",
    English: "Sign in to SafeTag",
    French: "Se connecter à SafeTag",
    German: "Melden Sie sich bei SafeTag an",
    Spanish: "Iniciar sesión en SafeTag",
    Italian: "Accedi a SafeTag",
    Polish: "Zaloguj się do SafeTag",
  },
  {
    FIELD1: "t('login.main.signup_statement')",
    English: "New to SafeTag?",
    French: "Nouveau sur SafeTag ?",
    German: "Neu bei SafeTag?",
    Spanish: "¿Nuevo en SafeTag?",
    Italian: "Nuovo su SafeTag?",
    Polish: "Nowy w SafeTag?",
  },
  {
    FIELD1: "t('login.main.placeholder_email')",
    English: "Email",
    French: "Email",
    German: "E-Mail",
    Spanish: "Correo electrónico",
    Italian: "Email",
    Polish: "E-mail",
  },
  {
    FIELD1: "t('login.main.placeholder_password')",
    English: "Password",
    French: "Mot de passe",
    German: "Passwort",
    Spanish: "Contraseña",
    Italian: "Password",
    Polish: "Hasło",
  },
  {
    FIELD1: "t('login.main.forget_statement')",
    English: "Forgot your password?",
    French: "Vous avez oublié votre mot de passe ?",
    German: "Haben Sie Ihr Passwort vergessen?",
    Spanish: "¿Olvidó su contraseña?",
    Italian: "Hai dimenticato la password?",
    Polish: "Nie pamiętasz hasła?",
  },
  {
    FIELD1: "t('login.main.stay_signed')",
    English: "Stay signed in",
    French: "Rester connecté",
    German: "Eingeloggt bleiben",
    Spanish: "Mantener sesión iniciada",
    Italian: "Rimani connesso",
    Polish: "Pozostań zalogowany",
  },
  {
    FIELD1: "t('login.main.button')",
    English: "Sign in",
    French: "S'inscrire",
    German: "Anmeldung",
    Spanish: "Iniciar sesión",
    Italian: "Accedi",
    Polish: "Zaloguj się",
  },
  {
    FIELD1: "t('login.main.button_loading')",
    English: "Signing in",
    French: "S'identifier",
    German: "Anmelden",
    Spanish: "Iniciando sesión",
    Italian: "Accesso",
    Polish: "Logowanie",
  },
  {
    FIELD1: "t('login.main.error_disabled')",
    English: "Your account has been suspended, please contact support.",
    French: "Votre compte a été suspendu, veuillez contacter le support.",
    German: "Ihr Konto wurde gesperrt, bitte kontaktieren Sie den Support.",
    Spanish: "Su cuenta ha sido suspendida, por favor contacte con soporte.",
    Italian: "Il tuo account è stato sospeso, contatta il supporto.",
    Polish:
      "Twoje konto zostało zawieszone. Skontaktuj się z pomocą techniczną.",
  },
  {
    FIELD1: "t('login.main.error_general')",
    English: "Something went wrong, please try again later.",
    French: "Un problème est survenu, veuillez réessayer plus tard.",
    German: "Etwas ist schiefgelaufen, versuchen Sie es bitte später erneut",
    Spanish: "Algo salió mal, por favor inténtelo más tarde.",
    Italian: "Qualcosa è andato storto, riprova più tardi.",
    Polish: "Coś poszło nie tak, spróbuj ponownie później.",
  },
  {
    FIELD1: "t('login.main.error_incorrect')",
    English: "Incorrect username or password.",
    French: "Nom d'utilisateur ou mot de passe incorrect.",
    German: "Falscher Nutzername oder Passwort.",
    Spanish: "Nombre de usuario o contraseña incorrectos.",
    Italian: "Nome utente o password errati.",
    Polish: "Nieprawidłowa nazwa użytkownika lub hasło.",
  },
  {
    FIELD1: "t('login.main.error_attempts')",
    English:
      "Password attempt limit exceeded, please try again later or reset your password.",
    French:
      "Limite de tentatives de mot de passe dépassée, veuillez réessayer plus tard ou réinitialiser votre mot de passe.",
    German:
      "Limit für Passwortversuche überschritten, bitte versuchen Sie es später erneut oder setzen Sie Ihr Passwort zurück.",
    Spanish:
      "Se ha superado el límite de intentos de contraseña, inténtelo de nuevo más tarde o restablezca su contraseña.",
    Italian:
      "Limite di tentativi per la password superato, riprova piu tardi o reimposta la password.",
    Polish:
      "Przekroczono limit prób wpisania hasła. Spróbuj ponownie później lub zresetuj hasło.",
  },
  {
    FIELD1: "t('login.main.error_not_exist')",
    English: "Account could not be found.",
    French: "Le compte n'a pas pu être trouvé.",
    German: "Konto konnte nicht gefunden werden.",
    Spanish: "No se ha encontrado la cuenta.",
    Italian: "L'account non è stato trovato.",
    Polish: "Nie znaleziono konta.",
  },
  {
    FIELD1: "t('mua.main.login_statement')",
    English: "Already accepted your account?",
    French: "Vous avez déjà accepté votre compte ?",
    German: "Haben Sie schon Ihr Konto akzeptiert?",
    Spanish: "¿Ya ha aceptado su cuenta?",
    Italian: "Il tuo account è stato già accettato?",
    Polish: "Już zaakceptowano konto?",
  },
  {
    FIELD1: "t('mua.main.title')",
    English: "Join an existing SafeTag Account",
    French: "Rejoindre un compte SafeTag existant",
    German:
      "Schließen Sie sich eine einen bereits existierenden SafeTag Konto an",
    Spanish: "Unirse a una cuenta existente de SafeTag",
    Italian: "Aggiungere un account SafeTag esistente",
    Polish: "Dołącz do istniejącego konta SafeTag",
  },
  {
    FIELD1: "t('mua.main.label_account')",
    English: "Account Email (Joining Account)",
    French: "E-mail du compte (rejoindre un compte)",
    German: "Konto E-Mail( Konto beitreten)",
    Spanish: "Correo electrónico de la cuenta (Uniéndose a la cuenta)",
    Italian: "Email dell'account (account condiviso)",
    Polish: "E-mail konta (konto, do którego dołączasz)",
  },
  {
    FIELD1: "t('mua.main.button')",
    English: "Join Account",
    French: "Rejoindre un compte",
    German: "Konto beitreten",
    Spanish: "Unirse a la cuenta",
    Italian: "Condividi account",
    Polish: "Dołącz do konta",
  },
  {
    FIELD1: "t('mua.main.success')",
    English:
      "Successfully accepted invitation, please verify your email address",
    French:
      "Invitation acceptée avec succès, veuillez vérifier votre adresse e-mail",
    German:
      "Die Einladung wurde erfolgreich akzeptiert, bitte verifizieren Sie Ihre E-Mail Adresse",
    Spanish:
      "Invitación aceptada con éxito, por favor verifique su dirección de correo electrónico",
    Italian:
      "Invito accettato con successo, si prega di verificare l'indirizzo e-mail",
    Polish:
      "Zaproszenie zostało pomyślnie zaakceptowane, potwierdź swój adres e-mail",
  },
  {
    FIELD1: "t('mua.main.error')",
    English: "Something went wrong, please contact your account owner",
    French:
      "Un problème s'est produit, veuillez contacter le propriétaire de votre compte",
    German:
      "Etwas ist schiefgelaufen, bitte verifizieren Sie ihre E-mail Adresse",
    Spanish: "Algo salió mal, por favor contacte al propietario de su cuenta",
    Italian:
      "Qualcosa è andato storto, contattare il proprietario dell'account",
    Polish: "Coś poszło nie tak, skontaktuj się z właścicielem konta",
  },
  {
    FIELD1: "t('mua.main.error1')",
    English: "Invite already accepted",
    French: "Invitation déjà acceptée",
    German: "Die Einladung wurde bereits akzeptiert",
    Spanish: "Invitación ya aceptada",
    Italian: "Invito già accettato",
    Polish: "Zaproszenie zostało już zaakceptowane",
  },
  {
    FIELD1: "t('mua.main.error2')",
    English: "No invites found for this email address",
    French: "Aucune invitation n'a été trouvée pour cette adresse e-mail",
    German: "es wurde keine Einladung für diese E-Mail gefunden",
    Spanish:
      "No se encontraron invitaciones para esta dirección de correo electrónico",
    Italian: "Nessun invito trovato per questo indirizzo e-mail",
    Polish: "Nie znaleziono zaproszeń dla tego adresu e-mail",
  },
  {
    FIELD1: "t('confirm_email.helmet.title')",
    English: "SafeTag Account Confirmation",
    French: "Confirmation du compte SafeTag",
    German: "SafeTag Kontobestätigung",
    Spanish: "Confirmación de cuenta SafeTag",
    Italian: "Conferma dell'account SafeTag",
    Polish: "Potwierdzenie konta SafeTag",
  },
  {
    FIELD1: "t('confirm_email.main.title')",
    English: "Confirm your Email",
    French: "Confirmez votre adresse e-mail",
    German: "Bestätigen Sie Ihre E-Mail",
    Spanish: "Confirmar su correo electrónico",
    Italian: "Conferma la tua email",
    Polish: "Potwierdź swój adres e-mail",
  },
  {
    FIELD1: "t('confirm_email.main.desc')",
    English:
      "We've sent a 6 digit verification code to your email. If you can't find it, please check that the email is correct, and check your spam/junk folder.",
    French:
      "Nous avons envoyé un code de vérification à 6 chiffres à votre adresse électronique. Si vous ne le trouvez pas, vérifiez que l'email est correct et vérifiez votre dossier spam/junk.",
    German:
      "Wir haben einen 6 stelligen Code an Ihre E-mail Adresse geschickt. Wenn Sie diesen nicht finden können, überleven Sie, ob die Email richtig ist und überprüfen Sie ihren Spam/Junk Ordner.",
    Spanish:
      "Hemos enviado un código de verificación de 6 dígitos a su correo electrónico. Si no lo encuentra, compruebe que el correo electrónico es correcto y revise su carpeta de correo no deseado.",
    Italian:
      "Abbiamo inviato un codice di verifica di 6 cifre al tuo indirizzo e-mail. Se non lo trovi, verifica che l'e-mail sia corretta e controlla la cartella spam/posta indesiderata.",
    Polish:
      "Wysłaliśmy 6-cyfrowy kod weryfikacyjny na Twój adres e-mail. Jeśli go nie widzisz, sprawdź poprawność adresu oraz folder spam/oferty.",
  },
  {
    FIELD1: "t('confirm_email.main.placeholder_email')",
    English: "Email",
    French: "Email",
    German: "E-Mail",
    Spanish: "Correo electrónico",
    Italian: "Email",
    Polish: "E-mail",
  },
  {
    FIELD1: "t('confirm_email.main.placeholder_code')",
    English: "Confirmation Code",
    French: "Code de confirmation",
    German: "Bestätigungscode",
    Spanish: "Código de confirmación",
    Italian: "Codice di conferma",
    Polish: "Kod weryfikacyjny",
  },
  {
    FIELD1: "t('confirm_email.main.not_arrived')",
    English: "Not arrived after a few minutes? Please check your spam folder.",
    French:
      "Pas reçu après quelques minutes ? Veuillez vérifier votre dossier spam.",
    German:
      "Nach ein paar Minuten nicht angekommen? Bitte überprüfen Sie Ihren Spam-Ordner.",
    Spanish:
      "¿No ha llegado después de unos minutos? Compruebe su carpeta de correo no deseado.",
    Italian: "Non è arrivato dopo pochi minuti? Controlla la cartella spam.",
    Polish: "Nie dotarł po kilku minutach? Sprawdź folder spam.",
  },
  {
    FIELD1: "t('confirm_email.main.resend')",
    English: "Resend",
    French: "Renvoyer",
    German: "Erneut senden",
    Spanish: "Reenviar",
    Italian: "Reinvia",
    Polish: "Wyślij ponownie",
  },
  {
    FIELD1: "t('confirm_email.main.button_confirm')",
    English: "Confirm Email",
    French: "Confirmer l'e-mail",
    German: "E-Mail bestätigen",
    Spanish: "Confirmar correo electrónico",
    Italian: "Conferma la tua email",
    Polish: "Potwierdź e-mail",
  },
  {
    FIELD1: "t('confirm_email.main.button_confirming')",
    English: "Confirming",
    French: "Confirmation",
    German: "Bestätigung",
    Spanish: "Confirmando",
    Italian: "In attesa di conferma",
    Polish: "Potwierdzanie",
  },
  {
    FIELD1: "t('confirm_email.main.error_invalid_code')",
    English: "Invalid verification code provided, please try again.",
    French: "Le code de vérification fourni est invalide, veuillez réessayer.",
    German:
      "Ungültiger Bestätigungscode angegeben, bitte versuchen Sie es erneut.",
    Spanish: "Código de verificación no válido, inténtelo de nuevo.",
    Italian: "Codice di verifica non valido, riprovare.",
    Polish: "Podano nieprawidłowy kod weryfikacyjny, spróbuj ponownie.",
  },
  {
    FIELD1: "t('confirm_email.main.error_invalid_code2')",
    English: "This code is invalid, a new one has been sent to your inbox.",
    French:
      "Ce code est incorrect, un nouveau code a été envoyé à votre adresse électronique.",
    German:
      "Dieser Code ist ungültig, ein neuer Code wurde in deinen Posteingang geschickt",
    Spanish:
      "Este código no es válido, se ha enviado uno nuevo a su bandeja de entrada.",
    Italian:
      "Questo codice non è valido, ne è stato inviato uno nuovo alla tua casella di posta.",
    Polish:
      "Ten kod jest nieprawidłowy. Nowy kod został wysłany na Twoją skrzynkę odbiorczą.",
  },
  {
    FIELD1: "t('confirm_email.main.error_not_found')",
    English: "Account Not Found",
    French: "Compte introuvable",
    German: "Konto wurde nicht gefunden",
    Spanish: "Cuenta no encontrada",
    Italian: "Account non trovato",
    Polish: "Nie znaleziono konta",
  },
  {
    FIELD1: "t('confirm_email.main.error_empty_fields')",
    English: "Fields can't be empty",
    French: "Les champs ne peuvent pas être vides",
    German: "Die Felder könen nicht leer gelassen werden",
    Spanish: "Los campos no pueden estar vacíos",
    Italian: "Questi campi non possono essere vuoti",
    Polish: "Pola nie mogą być puste",
  },
  {
    FIELD1: "t('confirm_email.main.error_general')",
    English: "Something went wrong, please try again later.",
    French: "Un problème est survenu, veuillez réessayer plus tard.",
    German: "Etwas ist schiefgelaufen, versuchen Sie es bitte später erneut.",
    Spanish: "Algo ha ido mal, por favor inténtelo de nuevo más tarde.",
    Italian: "Qualcosa è andato storto, riprova più tardi.",
    Polish: "Coś poszło nie tak, spróbuj ponownie później.",
  },
  {
    FIELD1: "t('confirm_email.main.no_code')",
    English: "Didn't receive a code?",
    French: "Vous n'avez pas reçu de code ?",
    German: "Sie haben keinen Code erhalten?",
    Spanish: "¿No ha recibido el código?",
    Italian: "Non hai ricevuto il codice?",
    Polish: "Nie otrzymałeś(-aś) kodu?",
  },
  {
    FIELD1: "t('confirm_email.main.resend')",
    English: "Resend",
    French: "Renvoyer",
    German: "Erneut senden",
    Spanish: "Reenviar",
    Italian: "Reinvia",
    Polish: "Wyślij ponownie",
  },
  {
    FIELD1: "t('confirm_email.main.contact')",
    English: "Contact Us",
    French: "Contactez-nous",
    German: "Kontaktieren Sie uns",
    Spanish: "Contáctenos",
    Italian: "Contattaci",
    Polish: "Skontaktuj się z nami",
  },
  {
    FIELD1: "t('confirm_email.validation.email_required')",
    English: "Please enter an email address",
    French: "Veuillez saisir une adresse électronique",
    German: "Bitte geben Sie eine E-Mail-Adresse ein",
    Spanish: "Por favor, introduzca una dirección de correo electrónico",
    Italian: "Inserisci un indirizzo email",
    Polish: "Wprowadź adres e-mail",
  },
  {
    FIELD1: "t('confirm_email.validation.email_invalid')",
    English: "Please check you have entered your email address correctly",
    French:
      "Veuillez vérifier que vous avez saisi correctement votre adresse électronique",
    German:
      "Bitte überprüfen Sie, ob Sie Ihre E-Mail-Adresse korrekt eingegeben haben.",
    Spanish:
      "Por favor, verifique que ha introducido correctamente su dirección de correo electrónico",
    Italian: "Verifica di aver inserito correttamente il tuo indirizzo email",
    Polish: "Sprawdź, czy poprawnie wpisałeś(-aś) adres e-mail",
  },
  {
    FIELD1: "t('confirm_email.validation.code_required')",
    English: "Please enter your verification code",
    French: "Veuillez saisir votre code de vérification",
    German: "Bitte geben Sie Ihren Verifizierungscode ein",
    Spanish: "Por favor, introduzca su código de verificación",
    Italian: "Sei pregato di inserire il tuo codice di verifica",
    Polish: "Wprowadź kod weryfikacyjny",
  },
  {
    FIELD1: "t('confirm_email.validation.code_invalid')",
    English: "Your verification code should be 6 digits long",
    French: "Le code de vérification doit être composé de 6 chiffres",
    German: "Der Verifizierungscode sollte 6 Ziffern lang sein",
    Spanish: "El código de verificación debe tener 6 dígitos",
    Italian: "Il codice di verifica deve essere di 6 cifre",
    Polish: "Kod weryfikacyjny powinien mieć 6 cyfr",
  },
  {
    FIELD1: "t('confirm_email.success.line1')",
    English: "You've successfully verified your account!",
    French: "Vous avez vérifié votre compte avec succès !",
    German: "Sie haben Ihr Konto erfolgreich verifiziert!",
    Spanish: "¡Usted ha verificado con éxito su cuenta!",
    Italian: "Hai verificato con successo il tuo account!",
    Polish: "Twoje konto zostało pomyślnie zweryfikowane!",
  },
  {
    FIELD1: "t('confirm_email.success.line2')",
    English:
      "To continue with the activation process, please click the button below and log in!.",
    French:
      "Vous pouvez maintenant fermer cette fenêtre ou cliquer ci-dessous pour vous connecter à notre site web.",
    German:
      "Sie können dieses Fenster nun schließen oder unten klicken, um sich auf unserer Website anzumelden",
    Spanish:
      "Ahora puede cerrar esta ventana o hacer clic a continuación para iniciar sesión en nuestro sitio web",
    Italian:
      "Ora è possibile chiudere questa finestra, oppure fare clic qui sotto per accedere al nostro sito web",
    Polish:
      "Aby kontynuować proces aktywacji, kliknij poniższy przycisk i zaloguj się!",
  },
  {
    FIELD1: "t('confirm_email.success.btn')",
    English: "Go to Login",
    French: "Accéder à la connexion",
    German: "Zum Anmelden gehen",
    Spanish: "Ir a Inicio de Sesión",
    Italian: "Esegui il login",
    Polish: "Przejdź do logowania",
  },
  {
    FIELD1: "t('confirm_email.resend.confirmed')",
    English: "Your account is already confirmed, redirecting to login...",
    French: "Votre compte est déjà confirmé, redirection vers la connexion...",
    German:
      "Ihr Konto ist bereits bestätigt, Sie werden zum Login weitergeleitet...",
    Spanish: "Su cuenta ya está confirmada, redirigiendo a inicio de sesión...",
    Italian: "Il tuo account è già confermato, reindirizza al login...",
    Polish:
      "Twoje konto jest już potwierdzone, przekierowujemy do logowania...",
  },
  {
    FIELD1: "t('forget_password.helmet.title')",
    English: "SafeTag Password Reset",
    French: "Réinitialisation du mot de passe SafeTag",
    German: "SafeTag Passwort zurücksetzen",
    Spanish: "Restablecer contraseña SafeTag",
    Italian: "Ripristino della password SafeTag",
    Polish: "Reset hasła SafeTag",
  },
  {
    FIELD1: "t('forget_password.helmet.desc')",
    English: "Reset your SafeTag password.",
    French: "Réinitialiser votre mot de passe SafeTag.",
    German: "setzten Sie ihr SafeTag Passswort zurück.",
    Spanish: "Restablezca su contraseña SafeTag.",
    Italian: "Ripristina la tua password SafeTag",
    Polish: "Zresetuj swoje hasło SafeTag.",
  },
  {
    FIELD1: "t('forget_password.main.title')",
    English: "Reset your password",
    French: "Réinitialiser votre mot de passe",
    German: "Setzen Sie Ihr Passwort zurück",
    Spanish: "Restablecer su contraseña",
    Italian: "Reimposta la password",
    Polish: "Zresetuj hasło",
  },
  {
    FIELD1: "t('forget_password.main.title_confirm')",
    English: "Enter your verification code",
    French: "Entrez votre code de vérification",
    German: "Geben Sie Ihren Verifizierungscode ein",
    Spanish: "Ingrese su código de verificación",
    Italian: "Inserisci il tuo codice di verifica",
    Polish: "Wprowadź kod weryfikacyjny",
  },
  {
    FIELD1: "t('forget_password.main.subheading')",
    English:
      "Enter the email address associated with your account and we'll send you a link to reset your password",
    French:
      "Saisissez l'adresse électronique associée à votre compte et nous vous enverrons un lien pour réinitialiser votre mot de passe.",
    German:
      "Geben Sie die mit Ihrem Konto verknüpfte E-Mail-Adresse ein und wir senden Ihnen einen Link, um Ihr Passwort zurückzusetzen.",
    Spanish:
      "Ingrese la dirección de correo electrónico asociada a su cuenta y le enviaremos un enlace para restablecer su contraseña",
    Italian:
      "Inserisci l'indirizzo e-mail associato al tuo account e ti invieremo un link per reimpostare la password.",
    Polish:
      "Wprowadź adres e-mail powiązany z kontem, a wyślemy link do resetowania hasła",
  },
  {
    FIELD1: "t('forget_password.main.subheading_confirm')",
    English: "We've sent an email with the code to reset your password",
    French:
      "Nous vous avons envoyé un e-mail contenant le code de réinitialisation de votre mot de passe.",
    German:
      "Wir haben Ihnen eine E-Mail mit dem Code zum Zurücksetzen Ihres Passworts geschickt.",
    Spanish:
      "Hemos enviado un correo electrónico con el código para restablecer su contraseña",
    Italian:
      "Ti abbiamo inviato un'e-mail con il codice per reimpostare la tua password.",
    Polish: "Wysłaliśmy e-mail z kodem do resetowania hasła",
  },
  {
    FIELD1: "t('forget_password.main.verification_code')",
    English: "Verification code",
    French: "Code de vérification",
    German: "Überprüfungscode",
    Spanish: "Código de verificación",
    Italian: "Codice di verifica",
    Polish: "Kod weryfikacyjny",
  },
  {
    FIELD1: "t('forget_password.main.button_send_code')",
    English: "Send verification code",
    French: "Envoyer le code de vérification",
    German: "Verifizierungscode senden",
    Spanish: "Enviar código de verificación",
    Italian: "Invia il codice di verifica",
    Polish: "Wyślij kod weryfikacyjny",
  },
  {
    FIELD1: "t('forget_password.main.placeholder_email')",
    English: "Email",
    French: "Email",
    German: "E-Mail",
    Spanish: "Correo electrónico",
    Italian: "Email",
    Polish: "E-mail",
  },
  {
    FIELD1: "t('forget_password.main.placeholder_code')",
    English: "Confirmation Code",
    French: "Code de confirmation",
    German: "Bestätigungscode",
    Spanish: "Código de confirmación",
    Italian: "Codice di conferma",
    Polish: "Kod potwierdzający",
  },
  {
    FIELD1: "t('forget_password.main.placeholder_new_pass')",
    English: "New Password",
    French: "Nouveau mot de passe",
    German: "Neues Passwort",
    Spanish: "Nueva Contraseña",
    Italian: "Nuova password",
    Polish: "Nowe hasło",
  },
  {
    FIELD1: "t('forget_password.main.placeholder_confirm')",
    English: "Confirm Password",
    French: "Confirmer le mot de passe",
    German: "Passwort bestätigen ",
    Spanish: "Confirmar contraseña",
    Italian: "Conferma la password",
    Polish: "Potwierdź hasło",
  },
  {
    FIELD1: "t('forget_password.main.label_password')",
    English:
      "8 characters or longer. Combine upper and lowercase letters and numbers.",
    French:
      "8 caractères ou plus. Combinez les lettres majuscules et minuscules et les chiffres.",
    German:
      "8 Zeichen oder länger. Kombinieren Sie Groß- und Kleinbuchstaben und Zahlen.",
    Spanish: "8 caracteres o más. Combine mayúsculas, minúsculas y números.",
    Italian:
      "8 caratteri o più. Combina lettere maiuscole, minuscole e numeri.",
    Polish: "8 lub więcej znaków. Użyj wielkich i małych liter oraz cyfr.",
  },
  {
    FIELD1: "t('forget_password.main.button_sending_code')",
    English: "Sending Code",
    French: "Envoi du code",
    German: "Code schicken",
    Spanish: "Enviar Código",
    Italian: "Inviando il codice",
    Polish: "Wysyłanie kodu",
  },
  {
    FIELD1: "t('forget_password.main.button_update_password')",
    English: "Update Password",
    French: "Mettre à jour le mot de passe",
    German: "Passwort aktualisieren",
    Spanish: "Actualizar contraseña",
    Italian: "Aggiorna la tua password",
    Polish: "Zaktualizuj hasło",
  },
  {
    FIELD1: "t('forget_password.main.button_signup')",
    English: "Sign Up",
    French: "S'inscrire",
    German: "Anmelden",
    Spanish: "Registrarse",
    Italian: "Iscriviti",
    Polish: "Zarejestruj się",
  },
  {
    FIELD1: "t('forget_password.main.button_updating_password')",
    English: "Updating Password",
    French: "Mise à jour du mot de passe",
    German: "Passwort aktualisieren",
    Spanish: "Actualizar contraseña",
    Italian: "Aggiornamento della password",
    Polish: "Aktualizowanie hasła",
  },
  {
    FIELD1: "t('forget_password.main.error_general')",
    English: "Something went wrong, please try again later.",
    French: "Un problème est survenu, veuillez réessayer plus tard.",
    German: "Etwas ist schiefgelaufen, versuchen Sie es bitte später erneut.",
    Spanish: "Algo salió mal, por favor inténtelo más tarde.",
    Italian: "Qualcosa è andato storto, riprova più tardi.",
    Polish: "Coś poszło nie tak, spróbuj ponownie później.",
  },
  {
    FIELD1: "t('forget_password.main.error_send_code_failed')",
    English:
      "Couldn't send your reset code, please try again later, then contact support.",
    French:
      "Impossible d'envoyer votre code de réinitialisation, veuillez réessayer plus tard, puis contactez l'assistance.",
    German:
      "Der Reset-Code konnte nicht gesendet werden. Bitte versuchen Sie es später erneut und wenden Sie sich dann an den Support.",
    Spanish:
      "No se ha podido enviar el código de recuperación. Inténtelo más tarde y póngase en contacto con el servicio de soporte.",
    Italian:
      "Non è stato possibile inviare il codice di ripristino, riprova più tardi. Se il problema persiste, contatta l'assistenza.",
    Polish:
      "Nie udało się wysłać kodu resetowania. Spróbuj ponownie później, a następnie skontaktuj się z pomocą techniczną.",
  },
  {
    FIELD1: "t('forget_password.main.error_email_invalid')",
    English: "Please enter a valid email address.",
    French: "Veuillez saisir une adresse e-mail valide.",
    German: "Bitte geben Sie eine gültige E-Mail Adresse ein.",
    Spanish: "Introduzca una dirección de correo electrónico válida.",
    Italian: "Sei pregato di inserire un indirizzo e-mail valido.",
    Polish: "Wprowadź poprawny adres e-mail.",
  },
  {
    FIELD1: "t('forget_password.main.error_request_limit')",
    English: "Too many verification codes requested, please try again later.",
    French:
      "Un trop grand nombre de codes de vérification a été demandé, veuillez réessayer plus tard.",
    German:
      "Zu viele  Bestätigungscodes Anfragen, bitte versuchen Sie es später nochmal.",
    Spanish:
      "Se han solicitado demasiados códigos de verificación, inténtelo más tarde.",
    Italian:
      "Sono stati richiesti troppi codici di verifica, riprova più tardi.",
    Polish:
      "Zażądano zbyt wielu kodów weryfikacyjnych. Spróbuj ponownie później.",
  },
  {
    FIELD1: "t('forget_password.main.error_invalid_code')",
    English:
      "Invalid code provided, please press send confirmation code to request a code again.",
    French:
      "Le code fourni n'est pas valide, veuillez appuyer sur le bouton envoyer le code de confirmation pour demander un nouveau code.",
    German:
      "Ungültiger Code angegeben, drücken Sie bitte auf Bestätigungscode senden, um erneut einen Code anzufordern.",
    Spanish:
      "Código no válido proporcionado, por favor presione enviar código de confirmación para solicitar un código de nuevo.",
    Italian:
      "Codice non valido, seleziona Invia codice di conferma per richiedere nuovamente un codice.",
    Polish:
      "Podano nieprawidłowy kod. Kliknij „Wyślij kod potwierdzający”, aby poprosić o nowy kod.",
  },
  {
    FIELD1: "t('forget_password.main.error_confirm')",
    English:
      "You need to confirm your email to reset the password, please wait while you are redirected to the email confirmation page.",
    French:
      "Vous devez confirmer votre email pour réinitialiser le mot de passe, veuillez patienter pendant que vous êtes redirigé vers la page de confirmation de l'email.",
    German:
      "Sie müssen Ihre E-Mail bestätigen, um das Passwort zurückzusetzen. Bitte warten Sie, während Sie zur E-Mail-Bestätigungsseite weitergeleitet werden.",
    Spanish:
      "Debe confirmar su correo electrónico para restablecer la contraseña, espere mientras se le redirige a la página de confirmación de correo electrónico.",
    Italian:
      "Per reimpostare la password è necessario confermare l'e-mail; aspetta di essere reindirizzato alla pagina di conferma dell'e-mail.",
    Polish:
      "Musisz potwierdzić swój adres e-mail, aby zresetować hasło. Poczekaj, aż nastąpi przekierowanie do strony potwierdzenia adresu e-mail.",
  },
  {
    FIELD1: "t('forget_password.main.error_no_account')",
    English:
      "We couldn't find this account. Please check you entered your email address correctly.",
    French:
      "Nous n'avons pas pu trouver ce compte. Veuillez vérifier que vous avez saisi votre email correctement.",
    German:
      "Wir konnten dieses Konto nicht finden. Bitte überprüfen Sie, ob Sie Ihre E-Mail-Adresse korrekt eingegeben haben.",
    Spanish:
      "No hemos podido encontrar esta cuenta. Compruebe que ha introducido correctamente su dirección de correo electrónico.",
    Italian:
      "Non siamo riusciti a trovare questo account. Verifica di aver inserito correttamente il tuo indirizzo e-mail.",
    Polish:
      "Nie mogliśmy znaleźć tego konta. Sprawdź, czy poprawnie wpisałeś(-aś) adres e-mail.",
  },
  {
    FIELD1: "t('forget_password.main.error_password_short')",
    English: "Passwords should be at least 8 characters long.",
    French: "Les mots de passe doivent comporter au moins 8 caractères.",
    German: "Passwörter sollten mindestens 8 Zeichen lang sein.",
    Spanish: "Las contraseñas deben tener al menos 8 caracteres.",
    Italian: "Le password devono essere lunghe almeno 8 caratteri.",
    Polish: "Hasło powinno mieć co najmniej 8 znaków.",
  },
  {
    FIELD1: "t('forget_password.main.error_password_invalid')",
    English:
      "Passwords should contain at least one uppercase letter, one lower case letter and one number.",
    French:
      "Les mots de passe doivent contenir au moins une lettre majuscule, une lettre minuscule et un chiffre.",
    German:
      "Passwörter sollten mindestens einen Großbuchstaben, einen Kleinbuchstaben und eine Zahl enthalten.",
    Spanish:
      "Las contraseñas deben contener al menos una letra mayúscula, una letra minúscula y un número.",
    Italian:
      "Le password devono contenere almeno una lettera maiuscola, una lettera minuscola e un numero.",
    Polish:
      "Hasło powinno zawierać co najmniej jedną wielką literę, jedną małą literę oraz jedną cyfrę.",
  },
  {
    FIELD1: "t('forget_password.main.error_password_not_matched')",
    English: "Passwords do not match.",
    French: "Les mots de passe ne correspondent pas.",
    German: "Die Passwörter stimmen nicht überein.",
    Spanish: "Las contraseñas no coinciden.",
    Italian: "Le password non coincidono.",
    Polish: "Hasła nie są zgodne.",
  },
  {
    FIELD1: "t('forget_password.main.password_updated')",
    English: "Password updated successfully, redirecting to login...",
    French: "Mot de passe mis à jour avec succès, redirection vers le login...",
    German:
      "Das Passwort wurde erfolgreich hochgeladen, umleiten zur Anmeldung...",
    Spanish:
      "Contraseña actualizada con éxito, redirigiendo al inicio de sesión...",
    Italian: "Password aggiornata con successo, reindirizzamento al login...",
    Polish:
      "Hasło zostało pomyślnie zaktualizowane, przekierowujemy do logowania...",
  },
  {
    FIELD1: "t('success.helmet.title')",
    English: "Activation Successful!",
    French: "Activation réussie!",
    German: "Aktivierung war erfolgreich!",
    Spanish: "¡Activación exitosa!",
    Italian: "Attivazione riuscita!",
    Polish: "Aktywacja zakończona pomyślnie!",
  },
  {
    FIELD1: "t('success.main.title')",
    English: "Your tracker has been successfully activated!",
    French: "Votre traceur a été activé avec succès !",
    German: "Ihr Tracker wurde erfolgreich aktiviert!",
    Spanish: "Su rastreador se ha activado correctamente.",
    Italian: "Il tuo dispositivo è stato attivato con successo!",
    Polish: "Twój lokalizator został pomyślnie aktywowany!",
  },
  {
    FIELD1: "t('success.main.wait_message')",
    English:
      "Please allow 15-20 minutes for your tracker to come online after it's been charged/installed.",
    French:
      "Comptez 15 à 20 minutes pour que votre traceur se mette en ligne une fois qu'il a été chargé/installé.",
    German:
      "Bitte geben Sie Ihrem Tracker 15-20 Minuten Zeit, um online zu gehen, nachdem er aufgeladen/ installiert wurde.",
    Spanish:
      "Por favor, espere 15-20 minutos para que su rastreador se conecte después de haber sido cargado/instalado.",
    Italian:
      "Si prega di attendere 15-20 minuti affinché il tracker sia online dopo essere stato caricato/installato.",
    Polish:
      "Poczekaj 15–20 minut, aż lokalizator po ładowaniu / instalacji połączy się z siecią.",
  },
  {
    FIELD1: "t('success.wv.back_to_app')",
    English:
      "If you've finished activating your trackers, return to the SafeTag App by clicking 'Back to App'.",
    French:
      "Si vous avez terminé d'activer vos traceurs, revenez à l'application SafeTag en cliquant sur 'Retour à l'application'.",
    German:
      "Wenn Sie Ihre Tracker aktiviert haben, kehren Sie zur SafeTag-App zurück, indem Sie auf 'Zurück zur App' klicken.",
    Spanish:
      "Si ha terminado de activar sus rastreadores, vuelva a la aplicación SafeTag haciendo clic en 'Volver a la aplicación'.",
    Italian:
      "Se hai finito di attivare i tuoi tracker, torna all'app SafeTag facendo clic su 'Torna all'app'.",
    Polish:
      "Jeśli zakończyłeś(-aś) aktywację lokalizatorów, wróć do aplikacji SafeTag, klikając „Powrót do aplikacji”.",
  },
  {
    FIELD1: "t('success.main.read')",
    English: "Please take a look at the product manual for more information.",
    French: "Veuillez consulter le manuel du produit pour plus d'informations.",
    German:
      "Bitte sehen Sie sich die Bedienungsanleitung für weitere Informationen an.",
    Spanish: "Consulte el manual del producto para obtener más información.",
    Italian: "Per ulteriori informazioni, consultare il manuale del prodotto.",
    Polish:
      "Zapoznaj się z instrukcją produktu, aby uzyskać więcej informacji.",
  },
  {
    FIELD1: "t('success.wv.btn1')",
    English: "Go back to the app",
    French: "Retournez à l'application",
    German: "Gehen Sie zurück zur App",
    Spanish: "Vuelve a la aplicación",
    Italian: "Torna all'app",
    Polish: "Powrót do aplikacji",
  },
  {
    FIELD1: "t('success.wv.btn2')",
    English: "Activate another",
    French: "Activer un autre",
    German: "Aktiviere einen anderen",
    Spanish: "Activar otro",
    Italian: "Attivare un altro",
    Polish: "Aktywuj kolejny",
  },
  {
    FIELD1: "t('success.wv.wait_message')",
    English:
      "Your tracker will take 15-20 minutes to come online after it's been charged/installed.",
    French:
      "Votre traceur mettra 15 à 20 minutes à se connecter après avoir été chargé/installé.",
    German:
      "Bitte geben Sie Ihrem Tracker 15-20 Minuten Zeit, um online zu gehen, nachdem er aufgeladen/ installiert wurde.",
    Spanish:
      "Su rastreador tardará entre 15 y 20 minutos en conectarse después de haber sido cargado/instalado.",
    Italian:
      "Il tracker impiegherà 15-20 minuti per connettersi dopo essere stato caricato/installato.",
    Polish:
      "Twój lokalizator połączy się z siecią w ciągu 15–20 minut po naładowaniu / instalacji.",
  },
  {
    FIELD1: "t('success.main.next')",
    English:
      "Next, if you're new to SafeTag, and have activated all of your trackers, download the SafeTag app.",
    French:
      "Ensuite, si vous êtes nouveau sur SafeTag et que vous avez activé tous vos traceurs, téléchargez l'application SafeTag.",
    German:
      "Als nächstes falls Sie neu bei SafeTag und alle Ihre Tracker aktiviert haben, laden Sie diese SafeTag- App herunter.",
    Spanish:
      "A continuación, si usted es nuevo en SafeTag, y ha activado todos sus rastreadores, descargue la aplicación SafeTag.",
    Italian:
      "Quindi, se sei nuovo su SafeTag e hai attivato tutti i tuoi tracker, scarica l'app SafeTag.",
    Polish:
      "Następnie, jeśli jesteś nowym użytkownikiem SafeTag i aktywowałeś(-aś) już wszystkie lokalizatory, pobierz aplikację SafeTag.",
  },
  {
    FIELD1: "t('success.main.back_to_app')",
    English:
      "Or, if you are inside the app now, click 'Back to App' at the top left of the screen.",
    French:
      "Si vous utilisez l'application maintenant, cliquez sur 'Retour à l'application' en haut à gauche de l'écran.",
    German:
      "Oder, wenn Sie die App jetzt verwenden, klicken Sie oben links auf 'Zurück zur App'.",
    Spanish:
      "O, si está utilizando la aplicación ahora, haga clic en 'Volver a la aplicación' en la parte superior izquierda de la pantalla.",
    Italian:
      "Oppure, se stai utilizzando l'applicazione ora, fai clic su 'Torna all'app' in alto a sinistra dello schermo.",
    Polish:
      "Lub, jeśli jesteś już w aplikacji, kliknij „Powrót do aplikacji” w lewym górnym rogu ekranu.",
  },
  {
    FIELD1: "t('success.main.ios_button')",
    English: "Apple App",
    French: "Application Apple",
    German: "Apple-App",
    Spanish: "Aplicación Apple",
    Italian: "Applicazione Apple",
    Polish: "Aplikacja Apple",
  },
  {
    FIELD1: "t('success.main.android_button')",
    English: "Android App",
    French: "Application Android",
    German: "Android-App",
    Spanish: "Aplicación Android",
    Italian: "Applicazione Android",
    Polish: "Aplikacja Android",
  },
  {
    FIELD1: "t('success.main.payment_tip')",
    English:
      "Please note, payments from SafeTag may appear as 'DownRiver' on your bank statement.",
    French:
      'Veuillez noter que les paiement de SafeTag pourraient apparaitre sous le nom de "DownRiver" sur votre relevé de banque.',
    German:
      "Bitte beachten Sie, dass Zahlungen von SafeTag auf Ihrem Kontoauszug als 'DownRiver' erscheinen können.",
    Spanish:
      'Los pagos de SafeTag pueden aparecer como "DownRiver" en su resumen bancario.',
    Italian:
      'Ricorda che i pagamenti effettuati da SafeTag possono apparire come "DownRiver" sull\'estratto conto bancario.',
    Polish:
      "Pamiętaj, że płatności od SafeTag mogą być widoczne na wyciągu bankowym jako „DownRiver”.",
  },
  {
    FIELD1: "t('compliance.helmet.title')",
    English: "SafeTag Compliance",
    French: "Documentation de conformité SafeTag",
    German: "SafeTag-Compliance-Dokumentation",
    Spanish: "Documentación de conformidad de SafeTag",
    Italian: "Conformita SafeTag",
    Polish: "Zgodność SafeTag",
  },
  {
    FIELD1: "t('compliance.helmet.desc')",
    English: "View SafeTag compliance documentation and certifications.",
    French:
      "Consultez la documentation et les certifications de conformité SafeTag.",
    German:
      "Zeigen Sie die SafeTag-Compliance-Dokumentation und -Zertifizierungen an.",
    Spanish:
      "Consulte la documentación de conformidad y las certificaciones de SafeTag.",
    Italian:
      "Visualizza la documentazione e le certificazioni di conformita di SafeTag.",
    Polish: "Zobacz dokumentację zgodności i certyfikaty SafeTag.",
  },
  {
    FIELD1: "t('compliance.main.title')",
    English: "Compliance",
    French: "Conformité",
    German: "Einhaltung",
    Spanish: "Conformidad",
    Italian: "Conformita",
    Polish: "Zgodność",
  },
  {
    FIELD1: "t('compliance.main.desc')",
    English:
      "In line with EU, UK & US regulations, please find our compliance information below, record of technical documentation and safety and compliance certificates.",
    French:
      "Conformément aux réglementations de l'UE, du Royaume-Uni et des États-Unis, vous trouverez ci-dessous nos informations sur la conformité, l'enregistrement de la documentation technique et les certificats de sécurité et de conformité.",
    German:
      "In Übereinstimmung mit den EU-, UK- und US-Vorschriften finden Sie unten unsere Compliance-Informationen, die Aufzeichnung der technischen Dokumentation und die Sicherheits- und Compliance-Zertifikate.",
    Spanish:
      "En línea con las normativas de la UE, Reino Unido y EE.UU., a continuación encontrará nuestra información de conformidad, registro de documentación técnica y certificados de seguridad y conformidad.",
    Italian:
      "In linea con le normative dell'UE, del Regno Unito e degli Stati Uniti, di seguito sono riportate le nostre informazioni sulla conformità, la documentazione tecnica e i certificati di sicurezza e conformità.",
    Polish:
      "Zgodnie z przepisami UE, Wielkiej Brytanii i USA poniżej znajdziesz informacje dotyczące zgodności, dokumentację techniczną oraz certyfikaty bezpieczeństwa i zgodności.",
  },
  {
    FIELD1: "t('compliance.main.product')",
    English: "Product",
    French: "Produit",
    German: "Produkt",
    Spanish: "Producto",
    Italian: "Prodotto",
    Polish: "Produkt",
  },
  {
    FIELD1: "t('compliance.main.certificate')",
    English: "Certificate",
    French: "Certificat",
    German: "Zertifikat",
    Spanish: "Certificado",
    Italian: "Certificato",
    Polish: "Certyfikat",
  },
  {
    FIELD1: "t('compliance.main.download')",
    English: "Download",
    French: "Télécharger",
    German: "Herunterladen",
    Spanish: "Descargar",
    Italian: "Scarica",
    Polish: "Pobierz",
  },
  {
    FIELD1: "t('compliance.main.eu_declaration')",
    English: "EU Declaration Of Conformity",
    French: "Déclaration de conformité de l’UE",
    German: "EU-Konformitätserklärung",
    Spanish: "Declaración de conformidad de la UE",
    Italian: "Dichiarazione di conformità UE",
    Polish: "Deklaracja zgodności UE",
  },
  {
    FIELD1: "t('compliance.main.technical_file')",
    English: "Technical File",
    French: "Fiche technique",
    German: "Sicherheit & Einhaltungszertifikat",
    Spanish: "Ficha técnica",
    Italian: "Scheda tecnica",
    Polish: "Dokumentacja techniczna",
  },
  {
    FIELD1: "t('compliance.main.safety')",
    English: "Safety & Compliance Certificates",
    French: "Certificats de sécurité et de conformité",
    German: "Sicherheit& Übereinstimmungsbescheinigung",
    Spanish: "Certificados de seguridad y conformidad",
    Italian: "Certificati di sicurezza e conformità",
    Polish: "Certyfikaty bezpieczeństwa i zgodności",
  },
  {
    FIELD1: "t('product.app.title')",
    English: "Track on all platforms",
    French: "Tracez sur toutes les plateformes",
    German: "Auf allen Plattformen verfolgen",
    Spanish: "Seguimiento en todas las plataformas",
    Italian: "Traccia su tutte le piattaforme",
    Polish: "Śledzenie na wszystkich platformach",
  },
  {
    FIELD1: "t('product.app.desc')",
    English:
      "Our acclaimed app is available on Android, iOS and the web, and works with mobile, tablet, laptop and desktop devices. With SafeTag, you can track as many trackers as you need, on any number of devices, at the same time.",
    French:
      "Notre application acclamée est disponible sur Android, iOS et sur le web et elle fonctionne avec smartphone, tablette, ordinateur portable et ordinateur de bureau. Avec SafeTag, vous pouvez suivre autant de traceur que nécessaire, sur autant d'appareils que vous le souhaitez et en même temps.",
    German:
      "Unsere hochgelobte App ist für Android, iOS und das Internet verfügbar und funktioniert mit Mobil-, Tablet-, Laptop- und Desktop-Geräten. Mit SafeTag können Sie so viele Tracker wie nötig auf einer beliebigen Anzahl von Geräten gleichzeitig verfolgen.",
    Spanish:
      "Nuestra aclamada aplicación está disponible en Android, iOS y la web, y funciona con dispositivos móviles, tabletas, portátiles y de sobremesa. Con SafeTag, puede rastrear tantos rastreadores como necesite, en cualquier número de dispositivos, al mismo tiempo.",
    Italian:
      "La nostra famosa applicazione è disponibile su Android, iOS e web e funziona con dispositivi mobili, tablet, laptop e desktop. Con SafeTag è possibile monitorare tuttio ciò che si desidera, su qualsiasi numero di dispositivi, contemporaneamente.",
    Polish:
      "Nasza ceniona aplikacja jest dostępna na Androida, iOS oraz w wersji webowej i działa na telefonach, tabletach, laptopach i komputerach stacjonarnych. Dzięki SafeTag możesz śledzić dowolną liczbę lokalizatorów na wielu urządzeniach jednocześnie.",
  },
  {
    FIELD1: "t('demo.helmet.title')",
    English: "Tracking Demo",
    French: "Démonstration de suivi",
    German: "Verfolgungs-Demo",
    Spanish: "Demostración de seguimiento",
    Italian: "Dimostrazione di tracciamento",
    Polish: "Demo śledzenia",
  },
  {
    FIELD1: "t('demo.tracking.title')",
    English: "Live Trackers",
    French: "Traceurs en temps réel",
    German: "Live Tracking",
    Spanish: "Seguidores en vivo",
    Italian: "Localizzatori in tempo reale",
    Polish: "Lokalizatory na żywo",
  },
  {
    FIELD1: "t('demo.dashboard.title')",
    English: "Dashboard",
    French: "Tableau de bord",
    German: "Armaturenbrett",
    Spanish: "Panel",
    Italian: "Pannello di controllo",
    Polish: "Panel główny",
  },
  {
    FIELD1: "t('demo.tracking.heading')",
    English: "My Trackers",
    French: "Mes traceurs",
    German: "Meine Trackers",
    Spanish: "Mis rastreadores",
    Italian: "I Miei Dispositivi",
    Polish: "Moje lokalizatory",
  },
  {
    FIELD1: "t('demo.history.title')",
    English: "Location History",
    French: "Historique des localisations",
    German: "Standortgeschichte",
    Spanish: "Historial de ubicaciones",
    Italian: "Cronologia di posizione",
    Polish: "Historia lokalizacji",
  },
  {
    FIELD1: "t('demo.history.heading')",
    English: "Location History",
    French: "Historique des localisations",
    German: "Standortgeschichte",
    Spanish: "Historial de ubicaciones",
    Italian: "Cronologia di posizione",
    Polish: "Historia lokalizacji",
  },
  {
    FIELD1: "t('demo.mobile.line1')",
    English: "Sorry, our demo is only accessible on a laptop or desktop.",
    French:
      "Désolé, notre démo n'est accessible que sur un ordinateur portable ou de bureau.",
    German:
      "Unsere Demo ist leider nur auf einem Laptop oder Desktop zugänglich.",
    Spanish:
      "Lo sentimos, nuestra demo sólo es accesible en un ordenador portátil o de escritorio.",
    Italian:
      "Siamo spiacenti, la nostra demo è accessibile solo da computer portatile o fisso.",
    Polish:
      "Przepraszamy, nasze demo jest dostępne wyłącznie na laptopie lub komputerze stacjonarnym.",
  },
  {
    FIELD1: "t('demo.mobile.line2')",
    English: "You can download our app by clicking the links below.",
    French:
      "Vous pouvez télécharger notre application en cliquant sur les liens ci-dessous.",
    German:
      "Es tut uns leid, unsere Demo ist nur auf dem Laptop oder Desktop erhältlich. ",
    Spanish:
      "Puede descargar nuestra aplicación haciendo clic en los enlaces siguientes.",
    Italian:
      "Puoi scaricare la nostra applicazione cliccando sui link sottostanti.",
    Polish: "Możesz pobrać naszą aplikację, klikając poniższe linki.",
  },
  {
    FIELD1: "t('demo.mobile.business')",
    English:
      "If you're a business interested in a mobile demo, please reach out to us.",
    French:
      "Si vous êtes une entreprise intéressée par une démonstration mobile, n'hésitez pas à nous contacter.",
    German:
      "Wenn Sie ein Unternehmen sind, das an einer mobilen Demo interessiert ist, wenden Sie sich bitte an uns.",
    Spanish:
      "Si su empresa está interesada en una demostración móvil, póngase en contacto con nosotros.",
    Italian: "Se fai parte di un'azienda interessata a una demo, contattaci",
    Polish:
      "Jeśli reprezentujesz firmę i jesteś zainteresowany(-a) mobilnym demo, skontaktuj się z nami.",
  },
  {
    FIELD1: "t('error404.main.title')",
    English: "404 Error.",
    French: "Erreur 404.",
    German: "404 Fehler.",
    Spanish: "Error 404.",
    Italian: "Errore 404.",
    Polish: "Błąd 404.",
  },
  {
    FIELD1: "t('error404.main.desc1')",
    English:
      "Sorry about that, we can't locate the page you're looking for. We should've put a tracker on it!",
    French:
      "Désolé pour ça, nous ne pouvons pas trouver la page que vous cherchez. Nous avons dû y placer un traceur !",
    German:
      "Es tut uns leid, wir können die Seite, die Sie suchen, nicht finden. Wir hätten einen Tracker anbringen sollen!",
    Spanish:
      "Disculpe, no podemos localizar la página que está buscando. ¡Deberíamos haberle puesto un rastreador!",
    Italian:
      "Ci dispiace, non riusciamo a trovare la pagina che stai cercando. Avremmo dovuto metterci un localizzatore!",
    Polish:
      "Przepraszamy, nie możemy znaleźć strony, której szukasz. Powinniśmy byli założyć jej lokalizator!",
  },
  {
    FIELD1: "t('error404.main.desc2')",
    English:
      "Please head back to the home page or use the Navigation Bar at the top of the page to find your destination.",
    French:
      "Veuillez retourner sur la page d'accueil ou utilisez la barre de navigation en haut de la page pour trouver votre destination. ",
    German:
      "Bitte gehen Sie zurück zur Startseite oder verwenden Sie die Navigationsleiste oben auf der Seite, um Ihr Ziel zu finden.",
    Spanish:
      "Por favor, regrese a la página de inicio o utilice la barra de navegación en la parte superior de la página para encontrar su destino.",
    Italian:
      "Torna alla pagina iniziale o utilizza la barra di navigazione in cima alla pagina per trovare la tua destinazione.",
    Polish:
      "Wróć na stronę główną lub użyj paska nawigacji u góry strony, aby znaleźć właściwe miejsce.",
  },
  {
    FIELD1: "t('error404.main.button')",
    English: "Home",
    French: "Page d'accueil",
    German: "Home",
    Spanish: "Inicio",
    Italian: "Home",
    Polish: "Strona główna",
  },
  {
    FIELD1: "t('error_boundary.main.image')",
    English: "We've hit an Error",
    French: "Nous avons rencontré une erreur",
    German: "Wir sind auf einen Fehler gestoßen",
    Spanish: "Se ha producido un error",
    Italian: "Abbiamo riscontrato un errore",
    Polish: "Wystąpił błąd",
  },
  {
    FIELD1: "t('error_boundary.main.desc1')",
    English:
      "Sorry, we encountered an error with the site. Please hit reload below to get back up and running again.",
    French:
      "Désolé, nous avons rencontré une erreur avec le site. Veuillez cliquer sur recharger ci-dessous pour le remettre en service.",
    German:
      'Leider ist ein Fehler auf der Website aufgetreten. Bitte klicken Sie unten auf "Neu laden", um die Seite wieder zum Laufen zu bringen.',
    Spanish:
      'Lo sentimos, se ha producido un error en el sitio. Por favor, presione "recargar" a continuación para volver a funcionar.',
    Italian:
      "Siamo spiacenti, si è verificato un errore nel sito. Sei pregato di eseguire il reload qui sotto.",
    Polish:
      "Przepraszamy, wystąpił błąd witryny. Kliknij „Odśwież” poniżej, aby ponownie uruchomić stronę",
  },
  {
    FIELD1: "t('error_boundary.main.desc2')",
    English: "If that doesn’t work, please let us know using the help widget!",
    French:
      "Si cela ne fonctionne pas, veuillez nous en informer en utilisant le widget d'aide !",
    German:
      "Wenn das nicht funktioniert, lassen Sie es uns bitte über das Hilfe-Widget wissen!",
    Spanish:
      "Si no funciona, por favor, infórmenos utilizando el widget de ayuda.",
    Italian:
      "Se continua a non funzionare, faccelo sapere contattando l'assistenza clienti!",
    Polish: "Jeśli to nie pomoże, daj nam znać za pomocą widżetu pomocy!",
  },
  {
    FIELD1: "t('error_boundary.main.button')",
    English: "Reload",
    French: "Recharger",
    German: "Neu laden",
    Spanish: "Recargar",
    Italian: "Ricarica",
    Polish: "Odśwież",
  },
  {
    FIELD1: "t('error_boundary.main.report')",
    English: "Report an issue",
    French: "Signaler un problème",
    German: "Ein Problem melden",
    Spanish: "Informar sobre un problema",
    Italian: "Segnala un problema",
    Polish: "Zgłoś problem",
  },
  {
    FIELD1: "t('track.helmet.title')",
    English: "SafeTag Live Tracking",
    French: "Localisation en temps réel",
    German: "SafeTag Live-Tracking",
    Spanish: "SafeTag Seguimiento en vivo",
    Italian: "Tracciamento in tempo reale SafeTag",
    Polish: "SafeTag — śledzenie na żywo",
  },
  {
    FIELD1: "t('track.sidebar.title')",
    English: "My Trackers",
    French: "Mes traceurs",
    German: "Meine Trackers",
    Spanish: "Mis rastreadores",
    Italian: "I Miei Dispositivi",
    Polish: "Moje lokalizatory",
  },
  {
    FIELD1: "t('track.sidebar.search')",
    English: "Search by name or IMEI",
    French: "Recherche par nom ou IMEI",
    German: "Nach Namen oder IMEI suchen",
    Spanish: "Búsqueda por nombre o IMEI",
    Italian: "Ricerca per nome o imei",
    Polish: "Wyszukaj po nazwie lub IMEI",
  },
  {
    FIELD1: "t('track.sidebar.charge_true')",
    English: "Power Connected",
    French: "Alimentation connectée",
    German: "Mit dem Strom verbunden",
    Spanish: "Alimentación conectada",
    Italian: "Alimentazione collegata",
    Polish: "Zasilanie podłączone",
  },
  {
    FIELD1: "t('track.sidebar.charge_false')",
    English: "Power Disconnected",
    French: "Alimentation déconnectée",
    German: "Vom Strom getrennt",
    Spanish: "Energía desconectada",
    Italian: "Alimentazione scollegata",
    Polish: "Zasilanie odłączone",
  },
  {
    FIELD1: "t('track.sidebar.tooltip_map')",
    English: "Export to Google Maps",
    French: "Exporter vers Google Maps",
    German: "Zu Google Maps exportieren",
    Spanish: "Exportar a Google Maps",
    Italian: "Esporta su Google Maps",
    Polish: "Eksportuj do Google Maps",
  },
  {
    FIELD1: "t('track.sidebar.tooltip_alerts')",
    English: "See Alerts",
    French: "Voir les alertes",
    German: "Siehe Alerts",
    Spanish: "Ver Alertas",
    Italian: "Visualizza le notifiche",
    Polish: "Zobacz alerty",
  },
  {
    FIELD1: "t('track.sidebar.tooltip_history')",
    English: "See History",
    French: "Voir l'historique",
    German: "Siehe Geschichte",
    Spanish: "Ver Historial",
    Italian: "Visualizza la cronologia",
    Polish: "Zobacz historię",
  },
  {
    FIELD1: "t('track.sidebar.tooltip_settings')",
    English: "Edit Settings",
    French: "Modifier les paramètres",
    German: "Einstellungen bearbeiten",
    Spanish: "Editar ajustes",
    Italian: "Modifica le impostazioni",
    Polish: "Edytuj ustawienia",
  },
  {
    FIELD1: "t('track.settings.tamper')",
    English: "Tamper",
    French: "Trafiquer",
    German: "Sabotage",
    Spanish: "Manipulación",
    Italian: "Manomissione",
    Polish: "Manipulacja urządzeniem",
  },
  {
    FIELD1: "t('track.settings.turning')",
    English: "Sharp Turning",
    French: "Virage brusque",
    German: "Scharfes Wenden",
    Spanish: "Giro Brusco",
    Italian: "Curva stretta",
    Polish: "Ostry skręt",
  },
  {
    FIELD1: "t('track.settings.collision')",
    English: "Collision",
    French: "Collision",
    German: "Kollision",
    Spanish: "Colisión",
    Italian: "Collisione",
    Polish: "Kolizja",
  },
  {
    FIELD1: "t('track.settings.sos')",
    English: "SOS",
    Spanish: "SOS",
    Italian: "SOS",
    Polish: "SOS",
  },
  {
    FIELD1: "t('track.settings.speed')",
    English: "Speed",
    French: "Vitesse",
    German: "Geschwindigkeit",
    Spanish: "Velocidad",
    Italian: "Velocità",
    Polish: "Prędkość",
  },
  {
    FIELD1: "t('track.settings.movement')",
    English: "Movement",
    French: "Déplacement",
    German: "Bewegen",
    Spanish: "En movimiento",
    Italian: "Movimento",
    Polish: "Ruch",
  },
  {
    FIELD1: "t('track.settings.activated')",
    English: "Account",
    French: "Compte",
    German: "Konto",
    Spanish: "Cuenta",
    Italian: "Attivato",
    Polish: "Konto",
  },
  {
    FIELD1: "t('track.settings.geofence')",
    English: "Geofences",
    French: "Géofences",
    German: "Geofences",
    Spanish: "Geocercas",
    Italian: "Geofence",
    Polish: "Geostrefy",
  },
  {
    FIELD1: "t('track.settings.geofence_link')",
    English: "Go to Geofences Settings",
    French: "Aller aux paramètres des géofences",
    German: "Gehen Sie zu Geofences Einstellungen",
    Spanish: "Ir a Configuración de Geocercas",
    Italian: "Vai a Impostazioni di geofence",
    Polish: "Przejdź do ustawień geostref",
  },
  {
    FIELD1: "t('track.settings.geofence_link2')",
    English: "Create your first geofences",
    French: "Créez vos premières géofences",
    German: "Erstellen Sie Ihre ersten Geofences",
    Spanish: "Cree su primera geocerca",
    Italian: "Crea le tue prime geofence",
    Polish: "Utwórz swoją pierwszą geostrefę",
  },
  {
    FIELD1: "t('track.settings.battery')",
    English: "Battery",
    French: "Batterie",
    German: "Batterie",
    Spanish: "Batería",
    Italian: "Batteria",
    Polish: "Bateria",
  },
  {
    FIELD1: "t('track.settings.acc')",
    English: "Ignition",
    French: "Démarrage",
    German: "Zündung",
    Spanish: "Encendido",
    Italian: "Accensione",
    Polish: "Zapłon",
  },
  {
    FIELD1: "t('track.settings.submitError')",
    English:
      "Settings could not be saved, please try again later or contact support.",
    French:
      "Les paramètres n'ont pas pu être enregistrés, veuillez réessayer plus tard ou contacter l’assistance.",
    German:
      "Die Einstellungen konnten nicht gespeichert werden. Bitte versuchen Sie es später erneut oder wenden Sie sich an den Support.",
    Spanish:
      "No se ha podido guardar la configuración, inténtelo más tarde o póngase en contacto con el servicio de asistencia.",
    Italian:
      "Non è stato possibile salvare le impostazioni, riprovare più tardi o contattare l'assistenza.",
    Polish:
      "Nie udało się zapisać ustawień. Spróbuj ponownie później lub skontaktuj się z pomocą techniczną.",
  },
  {
    FIELD1: "t('track.settings.name')",
    English: "Name",
    French: "Nom",
    German: "Name",
    Spanish: "Nombre",
    Italian: "Nome",
    Polish: "Nazwa",
  },
  {
    FIELD1: "t('track.settings.nameError')",
    English: "Tracker names must be between 2 to 16 characters long.",
    French: "Les noms des traceurs doivent contenir entre 2 et 16 caracteres.",
    German: "Tracker-Namen mussen zwischen 2 und 16 Zeichen lang sein.",
    Spanish:
      "Los nombres de los rastreadores deben tener entre 2 y 16 caracteres.",
    Italian:
      "I nomi dei dispositivi devono avere una lunghezza compresa tra 2 e 16 caratteri.",
    Polish: "Nazwy lokalizatorów muszą mieć od 2 do 16 znaków.",
  },
  {
    FIELD1: "t('track.settings.remove')",
    English: "Remove",
    French: "Retirer",
    German: "Entfernen",
    Spanish: "Eliminar",
    Italian: "Rimuovi",
    Polish: "Usuń",
  },
  {
    FIELD1: "t('track.settings.set')",
    English: "Set",
    French: "Definir",
    German: "Festlegen",
    Spanish: "Configurar",
    Italian: "Imposta",
    Polish: "Ustaw",
  },
  {
    FIELD1: "t('track.settings.geofenceLabel')",
    English: "Enter geofence size",
    French: "Saisir la taille du Géorepérage",
    German: "Geofence Größe eingeben",
    Spanish: "Introduzca el tamaño de la geocerca",
    Italian: "Inserisci le dimensioni del geofence",
    Polish: "Wprowadź rozmiar geostrefy",
  },
  {
    FIELD1: "t('track.settings.miles')",
    English: "Miles",
    French: "Miles",
    German: "Meilen",
    Spanish: "Millas",
    Italian: "Miglia",
    Polish: "Mile",
  },
  {
    FIELD1: "t('track.settings.kilometers')",
    English: "Kilometers",
    French: "Kilomètres",
    German: "Kilometer",
    Spanish: "Kilómetros",
    Italian: "Chilometri",
    Polish: "Kilometry",
  },
  {
    FIELD1: "t('track.settings.geofenceError')",
    English: "Please set a valid Geofence Size.",
    French: "Veuillez définir une taille de Géorepérage valide.",
    German: "Bitte geben Sie eine gültige Geofence Größe ein.",
    Spanish: "Introduzca un tamaño de geocerca válido.",
    Italian: "Impostare una dimensione di geofence valida.",
    Polish: "Ustaw poprawny rozmiar geostrefy.",
  },
  {
    FIELD1: "t('track.settings.speedLimitTitle')",
    English: "Speed Limit",
    French: "Limite de vitesse",
    German: "Geschwindigkeitslimit",
    Spanish: "Límite de velocidad",
    Italian: "Limite di velocità",
    Polish: "Limit prędkości",
  },
  {
    FIELD1: "t('track.settings.distanceTravelled')",
    English: "Distance Travelled",
    French: "Distance parcourue",
    German: "Zurückgelegte Strecke",
    Spanish: "Distancia recorrida",
    Italian: "Distanza percorsa",
    Polish: "Przebyta odległość",
  },
  {
    FIELD1: "t('track.settings.geofence_desc')",
    English: "Update Geofence preferences for this tracker",
    French: "Mettre à jour les préférences de Geofence pour ce traceur",
    German: "Geofence-Einstellungen für diesen Tracker aktualisieren",
    Spanish: "Actualice las preferencias de la geocerca para este rastreador",
    Italian: "Aggiorna le preferenze di Geofence per questo dispositivo",
    Polish: "Zaktualizuj preferencje geostrefy dla tego lokalizatora",
  },
  {
    FIELD1: "t('track.settings.speedLimitLabel')",
    English: "Enter Speed Limit",
    French: "Saisir la limite de vitesse",
    German: "Geben Sie den Geschwindigkeitslimit ein",
    Spanish: "Introduzca el límite de velocidad",
    Italian: "Inserisci il limite di velocità",
    Polish: "Wprowadź limit prędkości",
  },
  {
    FIELD1: "t('track.settings.mph')",
    English: "Miles per hour",
    French: "Miles par heure",
    German: "Meilen pro Stunde",
    Spanish: "Millas por hora",
    Italian: "Miglia all'ora",
    Polish: "Mile na godzinę",
  },
  {
    FIELD1: "t('track.settings.kph')",
    English: "Kilometers per hour",
    French: "Kilomètres par heure",
    German: "Kilometer pro Stunde",
    Spanish: "Kilómetros por hora",
    Italian: "Chilometri all'ora",
    Polish: "Kilometry na godzinę",
  },
  {
    FIELD1: "t('track.settings.speedLimitError')",
    English: "Speed Limits must be above 0 and below",
    French:
      "Les limites de vitesse doivent être supérieures à 0 et inférieures à",
    German: "Die Geschwindigkeitsbegrenzung, muss über 0 sein",
    Spanish: "Los límites de velocidad deben ser superiores a 0 e inferiores a",
    Italian: "I limiti di velocità devono essere superiori e inferiori a 0",
    Polish: "Limity prędkości muszą być większe od 0 i mniejsze niż",
  },
  {
    FIELD1: "t('track.settings.icons')",
    English: "Select an Icon",
    French: "Sélectionner une icône",
    German: "Wählen Sie ein Icon",
    Spanish: "Seleccione un icono",
    Italian: "Seleziona un'icona",
    Polish: "Wybierz ikonę",
  },
  {
    FIELD1: "t('track.settings.markers')",
    English: "Select a Marker",
    French: "Sélectionner un marqueur",
    German: "Wählen Sie eine Markierung",
    Spanish: "Seleccione un marcador",
    Italian: "Seleziona un marcatore",
    Polish: "Wybierz znacznik",
  },
  {
    FIELD1: "t('track.settings.alerts')",
    English: "Alerts",
    French: "Alertes",
    German: "Benachrichtigungen",
    Spanish: "Alertas",
    Italian: "Notifiche",
    Polish: "Alerty",
  },
  {
    FIELD1: "t('track.settings.saveBtn')",
    English: "Save Changes",
    French: "Enregistrer les modifications",
    German: "Änderungen speichern",
    Spanish: "Guardar cambios",
    Italian: "Salva le modifiche",
    Polish: "Zapisz zmiany",
  },
  {
    FIELD1: "t('track.settings.back')",
    English: "Back to My Trackers",
    French: "Retour à Mes traceurs",
    German: "Zurück zu Meine Tracker",
    Spanish: "Volver a Mis Rastreadores",
    Italian: "Torna a i miei dispositivi",
    Polish: "Powrót do moich lokalizatorów",
  },
  {
    FIELD1: "t('track.settings.editing')",
    English: "Editing",
    French: "Édition",
    German: "Bearbeitung",
    Spanish: "Edición",
    Italian: "Modifica",
    Polish: "Edytowanie",
  },
  {
    FIELD1: "t('track.settings.mileage')",
    English: "Mileage",
    French: "Kilométrage",
    German: "Kilometerstand",
    Spanish: "Kilometraje",
    Italian: "Chilometraggio",
    Polish: "Przebieg",
  },
  {
    FIELD1: "t('track.settings.acc')",
    English: "Ignition",
    French: "Démarrage",
    German: "Zündung",
    Spanish: "Encendido",
    Italian: "Accensione",
    Polish: "Zapłon",
  },
  {
    FIELD1: "t('track.settings.accel')",
    English: "Rapid Acceleration",
    French: "Accélération rapide",
    German: "Schnelle Beschleunigung",
    Spanish: "Aceleración rápida",
    Italian: "Rapida accellerazione",
    Polish: "Gwałtowne przyspieszenie",
  },
  {
    FIELD1: "t('track.settings.deccel')",
    English: "Harsh Braking",
    French: "Freinage brutal",
    German: "Hartes Bremsen",
    Spanish: "Frenada brusca",
    Italian: "Frenata brusca",
    Polish: "Gwałtowne hamowanie",
  },
  {
    FIELD1: "t('track.settings.tilt')",
    English: "Tilt",
    French: "Inclinaison",
    German: "Neigung",
    Spanish: "Inclinación",
    Italian: "Inclinazione",
    Polish: "Przechylenie",
  },
  {
    FIELD1: "t('track.settings.impact')",
    English: "Impact",
    French: "Impact",
    German: "Auswirkungen",
    Spanish: "Impacto",
    Italian: "Impatto",
    Polish: "Uderzenie",
  },
  {
    FIELD1: "t('track.sidebar.demo')",
    English: "Demo",
    French: "Démo",
    German: "Demo",
    Spanish: "Demo",
    Italian: "Dimostrazione",
    Polish: "Demo",
  },
  {
    FIELD1: "t('track.sidebar.error_no_tracker_title')",
    English: "You don't have any trackers",
    French: "Vous n'avez pas de traceurs",
    German: "Sie haben keine Tracker",
    Spanish: "Usted no tiene rastreadores",
    Italian: "Non hai nessun dispositivo",
    Polish: "Nie masz żadnych lokalizatorów",
  },
  {
    FIELD1: "t('track.sidebar.error_no_tracker')",
    English:
      "Looks like you don’t have any active trackers associated with your account. Please press <b>“Activate Tracker”</b> below to get started.",
    French:
      'Il semble que vous n\'ayez pas de traceurs actifs associés à votre compte. Veuillez cliquer sur <b>"Activer le traceur"</b> ci-dessous pour commencer.',
    German:
      'Sieht so aus, als hätten Sie keine aktiven Tracker mit Ihrem Konto verknüpft. Bitte klicken Sie unten auf <b>"Tracker aktivieren"</b>, um zu beginnen.',
    Spanish:
      'Parece que no tiene ningún rastreador activo asociado a su cuenta. Pulse <b>"Activar rastreador"</b> a continuación para empezar.',
    Italian:
      'Sembra che non ci siano tracker attivi associati al tuo account. Per iniziare, premere <b>"Attiva il tracker"</b> qui sotto.',
    Polish:
      "Wygląda na to, że nie masz żadnych aktywnych lokalizatorów powiązanych z kontem. Kliknij <b>„Aktywuj lokalizator”</b> poniżej, aby rozpocząć.",
  },
  {
    FIELD1: "t('track.sidebar.error_no_tracker_search')",
    English: "No Trackers Found",
    French: "Aucun traceur n'a été trouvé",
    German: "Es wurden keine Tracker gefunden",
    Spanish: "No se han encontrado rastreadores",
    Italian: "Nessun dispositivo trovato",
    Polish: "Nie znaleziono lokalizatorów",
  },
  {
    FIELD1: "t('track.sidebar.button_add_tracker')",
    English: "Activate Tracker",
    French: "Activer le traceur",
    German: "Tracker aktivieren",
    Spanish: "Activar rastreador",
    Italian: "Attiva il tracker",
    Polish: "Aktywuj lokalizator",
  },
  {
    FIELD1: "t('track.sidebar.error_calibration')",
    English:
      "It looks like your tracker is still awaititng calibration. Please follow the instructions in your activation guide to complete this.",
    French:
      "Il semble que votre traceur soit toujours en attente de calibration. Veuillez suivre les instructions dans votre guide d'activation pour compléter cette opération.",
    German:
      "Es sieht so aus, als ob Ihr Tracker immer noch auf die Kalibrierung wartet. Bitte folgen Sie den Anweisungen in Ihrem Aktivierungshandbuch, um dies zu vervollständigen.",
    Spanish:
      "Parece que su rastreador está pendiente de calibración. Por favor, siga las instrucciones de su guía de activación para completarla.",
    Italian:
      "Sembra che il tracker sia ancora in attesa di calibrazione. Seguire le istruzioni della guida all'attivazione per completare l'operazione.",
    Polish:
      "Wygląda na to, że Twój lokalizator nadal oczekuje na kalibrację. Postępuj zgodnie z instrukcjami w przewodniku aktywacji, aby ją zakończyć.",
  },
  {
    FIELD1: "t('track.sidebar.online')",
    English: "Online",
    French: "En ligne",
    German: "Online",
    Spanish: "Online",
    Italian: "Online",
    Polish: "Online",
  },
  {
    FIELD1: "t('track.sidebar.offline')",
    English: "Offline",
    French: "Hors ligne",
    German: "Offline",
    Spanish: "Offline",
    Italian: "Offline",
    Polish: "Offline",
  },
  {
    FIELD1: "t('track.sidebar.offline_msg')",
    English: "Showing last available data",
    French: "Afficher les dernières données disponibles",
    German: "Die aktuellsten verfügbaren Daten zeigen",
    Spanish: "Últimos datos disponibles",
    Italian: "Mostra gli ultimi dati disponibili",
    Polish: "Wyświetlanie ostatnio dostępnych danych",
  },
  {
    FIELD1: "t('track.sidebar.id_not_found')",
    English: "This Tracker ID could not be found.",
    French: "Cet identifiant de traceur n'a pas pu être trouvé.",
    German: "Diese Tracker ID konnte nicht gefunden werden. ",
    Spanish: "No se ha podido encontrar este ID de rastreador.",
    Italian: "Non è stato possibile trovare l'ID di questo dispositivo.",
    Polish: "Nie znaleziono tego identyfikatora lokalizatora.",
  },
  {
    FIELD1: "t('track.sidebar.deactivated')",
    English: "Deactivated",
    French: "Désactivé",
    German: "Wurde deaktiviert.",
    Spanish: "Desactivado",
    Italian: "Disattivato",
    Polish: "Dezaktywowany",
  },
  {
    FIELD1: "t('track.sidebar.awaiting_calibration')",
    English: "Awaiting Calibration",
    French: "En attente de calibrage",
    German: "Kalibrierung ausstehend",
    Spanish: "En espera de calibración",
    Italian: "In attesa di calibrazione",
    Polish: "Oczekiwanie na kalibrację",
  },
  {
    FIELD1: "t('track.sidebar.tracker_management')",
    English: "This button would take you to your tracker management page.",
    French: "Ce bouton vous conduira à la page de gestion de votre traceur.",
    German:
      "Mit dieser Schaltfläche gelangen Sie zu Ihrer Tracker-Verwaltungsseite.",
    Spanish:
      "Este botón lo llevará a la página de administración de su rastreador.",
    Italian: "Questo pulsante porta alla pagina di gestione del dispositivo.",
    Polish: "Ten przycisk przeniesie Cię do strony zarządzania lokalizatorem.",
  },
  {
    FIELD1: "t('track.sidebar.unavailable')",
    English: "Unavailable",
    French: "Non disponible",
    German: "Nicht verfügbar",
    Spanish: "No disponible",
    Italian: "Non disponibile",
    Polish: "Niedostępne",
  },
  {
    FIELD1: "t('track.sidebar.inside')",
    English: "Inside Geofence",
    French: "À l'intérieur Geofence",
    German: "Innen Geofence",
    Spanish: "Adentro",
    Italian: "Dentro",
    Polish: "Wewnątrz geostrefy",
  },
  {
    FIELD1: "t('track.sidebar.outside')",
    English: "Outside Geofence",
    French: "À l'extérieur Geofence",
    German: "Außen Geofence",
    Spanish: "Afuera",
    Italian: "Fuori",
    Polish: "Poza geostrefą",
  },
  {
    FIELD1: "t('track.sidebar.filter')",
    English: "Filter",
    French: "Filtre",
    German: "Filter",
    Spanish: "Filtrar",
    Italian: "Filtro",
    Polish: "Filtruj",
  },
  {
    FIELD1: "t('track.sidebar.sort')",
    English: "Sort",
    French: "Trier",
    German: "Sortieren",
    Spanish: "Ordenar",
    Italian: "Ordina",
    Polish: "Sortuj",
  },
  {
    FIELD1: "t('track.filter.inside')",
    English: "Inside Geofence",
    French: "Intérieur de la géofence",
    German: "Innerhalb von Geofence",
    Spanish: "Geocerca interior",
    Italian: "All'interno del Geofence",
    Polish: "Wewnątrz geostrefy",
  },
  {
    FIELD1: "t('track.filter.outside')",
    English: "Outside Geofence",
    French: "En dehors de la géofence",
    German: "Außerhalb des Geofence",
    Spanish: "Geocerca exterior",
    Italian: "Fuori dal Geofence",
    Polish: "Poza geostrefą",
  },
  {
    FIELD1: "t('track.filter.color')",
    English: "Marker Color",
    French: "Couleur du marqueur",
    German: "Marker Farbe",
    Spanish: "Color del marcador",
    Italian: "Colore del marcatore",
    Polish: "Kolor znacznika",
  },
  {
    FIELD1: "t('track.filter.type')",
    English: "Icon Type",
    French: "Type d'icône",
    German: "Icon Typ",
    Spanish: "Tipo de icono",
    Italian: "Tipo di icona",
    Polish: "Typ ikony",
  },
  {
    FIELD1: "t('track.filter.reset')",
    English: "Reset",
    French: "Réinitialisation",
    German: "Zurücksetzen",
    Spanish: "Restablecer",
    Italian: "Reimposta",
    Polish: "Resetuj",
  },
  {
    FIELD1: "t('track.filter.apply')",
    English: "Apply",
    French: "Appliquer",
    German: "Anwenden",
    Spanish: "Aplicar",
    Italian: "Applica",
    Polish: "Zastosuj",
  },
  {
    FIELD1: "t('track.sort.default')",
    English: "Default",
    French: "Défaut",
    German: "Standard",
    Spanish: "Predeterminado",
    Italian: "Predefinito",
    Polish: "Domyślny",
  },
  {
    FIELD1: "t('track.sort.last_connected')",
    English: "Last Connected",
    French: "Dernière connexion",
    German: "Zuletzt verbunden",
    Spanish: "Última conexión",
    Italian: "Ultimo collegamento",
    Polish: "Ostatnie połączenie",
  },
  {
    FIELD1: "t('track.sort.last_movement')",
    English: "Last Movement",
    French: "Dernier mouvement",
    German: "Letzte Bewegung",
    Spanish: "Último movimiento",
    Italian: "Ultimo movimento",
    Polish: "Ostatni ruch",
  },
  {
    FIELD1: "t('track.map.tooltip_journey')",
    English: "Trace journeys in real time",
    French: "Tracer les parcours en temps réel",
    German: "Verfolgen Sie Fahrten in Echtzeit",
    Spanish: "Rastrear viajes en tiempo real",
    Italian: "Traccia i percorsi in tempo reale",
    Polish: "Śledź trasy w czasie rzeczywistym",
  },
  {
    FIELD1: "t('track.map.tooltip_geofence')",
    English: "Show geofences",
    French: "Afficher les géofences",
    German: "Geofences anzeigen",
    Spanish: "Mostrar geocercas",
    Italian: "Mostra geofence",
    Polish: "Pokaż geostrefy",
  },
  {
    FIELD1: "t('track.map.tooltip_navigation')",
    English: "Follow Tracker",
    French: "Suivre le traceur",
    German: "Tracker folgen",
    Spanish: "Seguimiento del Rastreador",
    Italian: "Segui i dispositivi",
    Polish: "Śledź lokalizator",
  },
  {
    FIELD1: "t('track.map.tooltip_free')",
    English: "Freely pan/zoom",
    French: "Panoramique/zoom libre",
    German: "Freies Schwenken/Zoomen",
    Spanish: "Desplazarse libremente",
    Italian: "Panoramica/zoom libero",
    Polish: "Swobodne przesuwanie / przybliżanie",
  },
  {
    FIELD1: "t('track.map.tooltip_trackers')",
    English: "Show all Trackers",
    French: "Afficher tous les traceurs",
    German: "Alle Tracker anzeigen",
    Spanish: "Mostrar todos los Rastreadores",
    Italian: "Mostra tutti i dispositivi",
    Polish: "Pokaż wszystkie lokalizatory",
  },
  {
    FIELD1: "t('track.mobile.sorry')",
    English: "Sorry, tracking on a web browser is unavailable on mobile devices.",
    French:
      "Désolé, la localisation web n'est pas disponible sur les appareils mobiles.",
    German:
      "Es tut uns leid, die web tracking is auf Handys nicht erhältlich. ",
    Spanish:
      "Lo sentimos, el seguimiento web no está disponible en dispositivos móviles.",
    Italian:
      "Siamo spiacenti, il tracciamento web non è disponibile sui dispositivi mobili.",
    Polish:
      "Przepraszamy, śledzenie przez stronę internetową nie jest dostępne na urządzeniach mobilnych.",
  },
  {
    FIELD1: "t('track.mobile.download')",
    English: "Please download the SafeTag App for the best performance, mobile features and real-time alerts.",
    French: "Merci de télécharger l'application SafeTag",
    German: "Bitte laden Sie die SafeTag App herunter",
    Spanish: "Descargue la aplicación SafeTag",
    Italian: "Scarica l'applicazione SafeTag",
    Polish: "Pobierz aplikację SafeTag",
  },
  {
    FIELD1: "t('track.mobile.ios_button')",
    English: "Download for IOS",
    French: "Téléchargement pour IOS",
    German: "Für IOS herunterladen",
    Spanish: "Descargar para IOS",
    Italian: "Scarica per IOS",
    Polish: "Pobierz dla iOS",
  },
  {
    FIELD1: "t('track.mobile.android_button')",
    English: "Download for Android",
    French: "Téléchargement pour Android",
    German: "Für Android herunterladen",
    Spanish: "Descargar para Android",
    Italian: "Scarica per Android",
    Polish: ".Pobierz dla Androida",
  },
  {
    FIELD1: "t('track.popup.button')",
    English: "Load Address",
    French: "Recherche d'adresse",
    German: "Adressen nachsehen",
    Spanish: "Buscar dirección",
    Italian: "Cerca indirizzo",
    Polish: "Załaduj adres",
  },
  {
    FIELD1: "t('track.popup.loading')",
    English: "Loading",
    French: "Chargement",
    German: "Laden",
    Spanish: "Cargando",
    Italian: "Caricamento",
    Polish: "Ładowanie",
  },
  {
    FIELD1: "t('track.popup.error')",
    English: "Couldn't Retrieve Address, please Try Again Later",
    French: "Impossible de récupérer l'adresse, veuillez réessayer plus tard.",
    German:
      "Adresse konnte nicht abgerufen werden, bitte versuchen Sie es später erneut.",
    Spanish:
      "No se pudo recuperar la dirección, por favor inténtelo más tarde.",
    Italian: "Impossibile recuperare l'indirizzo, riprova piu tardi.",
    Polish: "Nie udało się pobrać adresu. Spróbuj ponownie później.",
  },
  {
    FIELD1: "t('track.popup.demo')",
    English:
      "This button will load your trackers current full address or location name.",
    French: "Ce bouton vous conduira à la page de gestion de votre traceur.",
    German:
      "Mit dieser Schaltfläche gelangen Sie zu Ihrer Tracker-Verwaltungsseite.",
    Spanish:
      "Este botón cargará la dirección completa actual de su rastreador o el nombre de la ubicación.",
    Italian:
      "Questo pulsante carica l'indirizzo completo o il nome della località del dispositivo.",
    Polish:
      "Ten przycisk załaduje pełny aktualny adres lub nazwę lokalizacji Twojego lokalizatora.",
  },
  {
    FIELD1: "t('track.alerts.title')",
    English: "Alerts",
    French: "Alertes",
    German: "Benachrichtigungen",
    Spanish: "Alertas",
    Italian: "Notifiche",
    Polish: "Alerty",
  },
  {
    FIELD1: "t('track.alerts.empty1')",
    English: "No Alerts Found",
    French: "Aucune alerte trouvée",
    German: "Es wurden keine Benachrichtigungen gefunden",
    Spanish: "No se han encontrado alertas",
    Italian: "Nessun avviso trovato",
    Polish: "Nie znaleziono alertów",
  },
  {
    FIELD1: "t('track.alerts.empty2')",
    English: "You're all caught up.",
    French: "Vous êtes à jour.",
    German: "Sie haben alles aufgeholt",
    Spanish: "Ya está al día.",
    Italian: "Sei aggiornato.",
    Polish: "Wszystko jest aktualne.",
  },
  {
    FIELD1: "t('track.alerts.no_location')",
    English: "No Location Found",
    French: "Aucune localisation trouvée",
    German: "Kein Standort gefunden",
    Spanish: "No se ha encontrado ninguna ubicación",
    Italian: "Nessuna posizione trovata",
    Polish: "Nie znaleziono lokalizacji",
  },
  {
    FIELD1: "t('track.alerts.sent')",
    English: "Sent at",
    French: "Envoyé à",
    German: "Gesendet um",
    Spanish: "Enviado a",
    Italian: "Inviato a",
    Polish: "Wysłano o",
  },
  {
    FIELD1: "t('track.alerts.bottom')",
    English: "Alerts are stored in the cloud and retained for 30 days.",
    French:
      "Les alertes sont stockées dans le cloud et conservées pendant 30 jours.",
    German:
      "Warnungen werden in der Cloud gespeichert und 30 Tage lang aufbewahrt.",
    Spanish:
      "Las alertas se almacenan en la nube y se conservan durante 30 días.",
    Italian:
      "Gli avvisi vengono archiviati nel cloud e conservati per 30 giorni.",
    Polish: "Alerty są przechowywane w chmurze przez 30 dni.",
  },
  {
    FIELD1: "t('track.alerts.supressed')",
    English: "Alert supressed due to your quiet hour settings",
    French: "Alerte supprimée en raison des réglages de l'heure de repos",
    German: "Alarm unterdrückt aufgrund Ihrer Ruhezeit-Einstellungen",
    Spanish: "Alerta suprimida debido a su configuración de hora de silencio",
    Italian:
      "Segnalazione disattivata a causa delle impostazioni dell'ora di silenzio",
    Polish: "Alert został wyciszony zgodnie z ustawieniami godzin ciszy",
  },
  {
    FIELD1: "t('history.helmet.title')",
    English: "SafeTag Location History",
    French: "Historique des localisations SafeTag",
    German: "SafeTag Orstverlauf",
    Spanish: "Historial de localizaciones de SafeTag",
    Italian: "Cronologia della posizione SafeTag",
    Polish: "Historia lokalizacji SafeTag",
  },
  {
    FIELD1: "t('history.sidebar.title')",
    English: "Location History",
    French: "Historique des localisations",
    German: "Standortverlauf",
    Spanish: "Historial de ubicaciones",
    Italian: "Cronologia della posizione",
    Polish: "Historia lokalizacji",
  },
  {
    FIELD1: "t('history.sidebar.error_no_location')",
    English: "No Location Data Found",
    French: "Aucune donnée de localisation trouvée",
    German: "Keine Ortsdaten wurden gefunden",
    Spanish: "No se han encontrado datos de ubicación",
    Italian: "Non sono stati trovati dati sulla posizione",
    Polish: "Nie znaleziono danych lokalizacji",
  },
  {
    FIELD1: "t('history.sidebar.error_no_location_desc')",
    English: "Try selecting another tracker.",
    French: "Essayez de sélectionner un autre traceur.",
    German: "Versuchen Sie, einen anderen Tracker auszuwählen.",
    Spanish: "Intente seleccionar otro rastreador.",
    Italian: "Prova a selezionare un altro dispositivo",
    Polish: "Spróbuj wybrać inny lokalizator.",
  },
  {
    FIELD1: "t('history.demo.note1')",
    English:
      "DEMO NOTE: Please note there may be small discrepancies with distance / speed & time travelled compared to the route shown on the map due to the randomly generated demo data.",
    French:
      "NOTE POUR LA DÉMO : Veuillez noter qu'il peut y avoir de légères différences entre la distance, la vitesse et la durée du trajet par rapport à l'itinéraire indiqué sur la carte, en raison des données de démonstration générées de manière aléatoire.",
    German:
      "DEMO-HINWEIS: Bitte beachten Sie, dass es aufgrund der zufällig generierten Demodaten zu kleinen Abweichungen bei der zurückgelegten Strecke/ Geschwindigkeit und Zeit im Vergleich zu der auf der Karte angezeigten Route kommen kann",
    Spanish:
      "NOTA DEMO: Tenga en cuenta que puede haber pequeñas discrepancias con la distancia / velocidad y tiempo de viaje en comparación con la ruta que se muestra en el mapa debido a los datos de demostración generados en forma aleatoria.",
    Italian:
      "NOTA DEMO: si prega di notare che potrebbero esserci piccole discrepanze con la distanza, la velocità e il tempo di percorrenza rispetto al percorso mostrato sulla mappa, a causa dei dati demo generati casualmente.",
    Polish:
      "UWAGA DEMO: Mogą wystąpić niewielkie różnice w dystansie / prędkości oraz czasie podróży w porównaniu do trasy pokazanej na mapie z powodu losowo generowanych danych demonstracyjnych.",
  },
  {
    FIELD1: "t('history.demo.note2')",
    English:
      "In your live account, the map & summary view will correspond 1:1 with your tracker's information.",
    French:
      "Dans votre compte en ligne, la carte et la synthèse vont correspondre 1:1 avec les informations de votre traceur.",
    German:
      "In Ihrem Live-Konto entspricht die Karten- und Übersichtsansicht 1:1 den Informationen Ihres Trackers.",
    Spanish:
      "En su cuenta real, el mapa y la vista de resumen se corresponderán 1:1 con la información de su rastreador.",
    Italian:
      "Nell'account live, la mappa e il riepilogo corrispondono alle informazioni del dispositivo con rapporto 1:1",
    Polish:
      "W Twoim rzeczywistym koncie mapa i widok podsumowania będą odpowiadały informacjom lokalizatora w stosunku 1:1.",
  },
  {
    FIELD1: "t('history.mobile.sorry')",
    English:
      "Sorry, seeing your tracker's location history on our website is only accessible on a laptop or desktop.",
    French:
      "Désolé, la consultation de l'historique de localisation de votre traceur sur notre site web n'est accessible que sur un ordinateur portable ou de bureau.",
    German:
      "Leider kann der Standortverlauf Ihres Trackers auf unserer Website nur auf einem Laptop oder Desktop-Computer abgerufen werden.",
    Spanish:
      "Lo sentimos, pero el historial de localización de su rastreador en nuestro sitio web sólo es accesible desde un ordenador portátil o de escritorio.",
    Italian:
      "Siamo spiacenti, la cronologia della posizione del dispositivo sul nostro sito web è accessibile solo su un computer portatile o fisso.",
    Polish:
      "Przepraszamy, przeglądanie historii lokalizacji lokalizatora na naszej stronie internetowej jest dostępne wyłącznie na laptopie lub komputerze stacjonarnym.",
  },
  {
    FIELD1: "t('history.mobile.download')",
    English: "Please download the SafeTag App",
    French: "Merci de télécharger l'application SafeTag",
    German: "Bitte laden Sie die SafeTag App herunter",
    Spanish: "Descargue la aplicación SafeTag",
    Italian: "Scarica l'applicazione SafeTag",
    Polish: "Pobierz aplikację SafeTag",
  },
  {
    FIELD1: "t('history.mobile.ios_button')",
    English: "Download for IOS",
    French: "Téléchargement pour IOS",
    German: "Download für IOS",
    Spanish: "Descargar para IOS",
    Italian: "Scarica per IOS",
    Polish: "Pobierz dla iOS",
  },
  {
    FIELD1: "t('history.mobile.android_button')",
    English: "Download for Android",
    French: "Téléchargement pour Android",
    German: "Download für Android",
    Spanish: "Descargar para Android",
    Italian: "Scarica per Android",
    Polish: "Pobierz dla Androida",
  },
  {
    FIELD1: "t('history.button.show_all_journeys')",
    English: "Show all Journeys",
    French: "Afficher tous les trajets",
    German: "Alle Reisen anzeigen",
    Spanish: "Mostrar todos los viajes",
    Italian: "Visualizza tutti i viaggi",
    Polish: "Pokaż wszystkie trasy",
  },
  {
    FIELD1: "history.map.speed_limit",
    English: "Speed Limit Exceeded",
    French: "Dépassement de la limite de vitesse",
    German: "Geschwindigkeitsüberschreitung",
    Spanish: "Límite de velocidad superado",
    Italian: "Limite di velocità superato",
    Polish: "Przekroczono limit prędkości",
  },
  {
    FIELD1: "t('tutorial.main.title')",
    English: "Web Tracking Tutorial",
    French: "Tutoriel pour la localisation sur le web",
    German: "Web Tracking Tutorial",
    Spanish: "Tutorial de seguimiento web",
    Italian: "Tutorial sul tracciamento web",
    Polish: "Samouczek śledzenia w sieci",
  },
  {
    FIELD1: "t('tutorial.main.skip')",
    English: "Skip",
    French: "Passer",
    German: "Überspringen",
    Spanish: "Omitir",
    Italian: "Salta",
    Polish: "Pomiń",
  },
  {
    FIELD1: "t('tutorial.main.next')",
    English: "Next",
    French: "Suivant",
    German: "Nächstes",
    Spanish: "Siguiente",
    Italian: "Prossimo",
    Polish: "Dalej",
  },
  {
    FIELD1: "t('tutorial.main.done')",
    English: "Done",
    French: "Terminé",
    German: "Fertig",
    Spanish: "Listo",
    Italian: "Fatto",
    Polish: "Gotowe",
  },
  {
    FIELD1: "t('footer.shop.title')",
    English: "Shop",
    French: "Boutique",
    German: "Shop",
    Spanish: "Tienda",
    Italian: "Catalogo",
    Polish: "Sklep",
  },
  {
    FIELD1: "t('footer.shop.our_shop')",
    English: "Our Shop",
    French: "Notre Boutique",
    German: "Unser Shop ",
    Spanish: "Nuestra Tienda",
    Italian: "Il nostro negozio",
    Polish: "Nasz sklep",
  },
  {
    FIELD1: "t('footer.shop.wired')",
    English: "Shop Wired",
    French: "Acheter filaires",
    German: "Geschäft verkabelt",
    Spanish: "Comprar con cable",
    Italian: "Acquista Wired",
    Polish: "Sklep przewodowy",
  },
  {
    FIELD1: "t('footer.shop.wireless')",
    English: "Shop Wireless",
    French: "Acheter sans fil",
    German: "Drahtlos einkaufen",
    Spanish: "Tienda inalámbrica",
    Italian: "Acquista Wireless",
    Polish: "Sklep bezprzewodowy",
  },
  {
    FIELD1: "t('footer.help.title')",
    English: "Help",
    French: "Aide",
    German: "Hilfe & Center",
    Spanish: "Ayuda",
    Italian: "Aiuto",
    Polish: "Pomoc",
  },
  {
    FIELD1: "t('footer.help.faqs')",
    English: "Help Center",
    French: "Centre d'aide",
    German: "Hilfe-Center",
    Spanish: "Centro de Ayuda",
    Italian: "Centro assistenza",
    Polish: "Centrum pomocy",
  },
  {
    FIELD1: "t('footer.help.contact')",
    English: "Contact Us",
    French: "Nous contacter",
    German: "Kontaktieren Sie uns",
    Spanish: "Contacto",
    Italian: "Contattaci",
    Polish: "Skontaktuj się z nami",
  },
  {
    FIELD1: "t('footer.help.privacy')",
    English: "Privacy",
    French: "Confidentialité",
    German: "Privatsphäre",
    Spanish: "Privacidad",
    Italian: "Privacy",
    Polish: "Prywatność",
  },
  {
    FIELD1: "t('footer.help.terms')",
    English: "Terms",
    French: "Conditions d'utilisation",
    German: "Bestimmungen",
    Spanish: "Términos",
    Italian: "Termini",
    Polish: "Warunki",
  },
  {
    FIELD1: "t('footer.connect.title')",
    English: "Connect with Us",
    French: "Restons connectés",
    German: "Verbinden Sie sich  mit uns",
    Spanish: "Contáctenos",
    Italian: "Mettiti in contatto con noi",
    Polish: "Połącz z nami",
  },
  {
    FIELD1: "t('footer.connect.about')",
    English: "About Us",
    French: "À propos de nous",
    German: "Über uns",
    Spanish: "Quiénes somos",
    Italian: "Chi siamo",
    Polish: "O nas",
  },
  {
    FIELD1: "t('footer.contact.sales')",
    English: "Contact Sales",
    French: "Contact de vente",
    German: "Kontakt Vertrieb",
    Spanish: "Contacto de ventas",
    Italian: "Contatta il dipartimento vendite",
    Polish: "Kontakt sprzedażowy",
  },
  {
    FIELD1: "t('footer.connect.contact_form')",
    English: "Contact Form",
    French: "Formulaire de contact",
    German: "Kontaktform",
    Spanish: "Formulario de contacto",
    Italian: "Modulo di contatto",
    Polish: "Formularz kontaktowy",
  },
  {
    FIELD1: "t('footer.connect.email')",
    English: "Email Support",
    French: "Support par e-mail",
    German: "E-Mail Support",
    Spanish: "Soporte por correo electrónico",
    Italian: "Assistenza via e-mail",
    Polish: "Wsparcie e-mail",
  },
  {
    FIELD1: "t('footer.connect.email_sales')",
    English: "Email Sales",
    French: "Ventes par e-mail",
    German: "E-Mail Verkäufe",
    Spanish: "Ventas por correo electrónico",
    Italian: "Vendite via e-mail",
    Polish: "Sprzedaż e-mail",
  },
  {
    FIELD1: "t('footer.connect.referral')",
    English: "Referral Scheme",
    French: "Programme de parrainage",
    German: "Empfehlungsschema",
    Spanish: "Esquema de Referencias",
    Italian: "Programma di referenza.",
    Polish: "Program poleceń",
  },
  {
    FIELD1: "t('footer.download.title')",
    English: "Download the SafeTag App for iOS or Android.",
    French: "Télécharger l'application SafeTag pour iOS ou Android.",
    German: "Laden Sie die SafeTag App für iOS oder Android herunter.",
    Spanish: "Descargue la aplicación SafeTag para iOS o Android.",
    Italian: "Scarica l'applicazione SafeTag per iOS o Android.",
    Polish: "Pobierz aplikację SafeTag na iOS lub Androida.",
  },
  {
    FIELD1: "t('footer.copyright.text')",
    English: "© XXXX DownRiver Limited, DownRiver LLC, All Rights Reserved.",
    French: "© XXXX DownRiver Limited, DownRiver LLC, Tous droits réservés.",
    German: "© XXXX DownRiver Limited, DownRiver LLC, Alle Rechte vorbehalten.",
    Spanish:
      "© XXXX DownRiver Limited, DownRiver LLC, Todos los derechos reservados.",
    Italian:
      "© XXXX DownRiver Limited, DownRiver LLC, Tutti i diritti riservati.",
    Polish:
      "© XXXX DownRiver Limited, DownRiver LLC, Wszelkie prawa zastrzeżone.",
  },
  {
    FIELD1: "t('footer.address.line1')",
    English: "2nd Floor, Grabex Business Centre, Murray Rd, Orpington, BR5 3QY",
    French: "2e étage, Grabex Business Centre, Murray Rd, Orpington, BR5 3QY",
    German: "2. Stock, Grabex Business Centre, Murray Rd, Orpington, BR5 3QY",
    Spanish: "2º Piso, Grabex Business Centre, Murray Rd, Orpington, BR5 3QY",
    Italian: "2° piano, Grabex Business Centre, Murray Rd, Orpington, BR5 3QY",
    Polish: "2nd Floor, Grabex Business Centre, Murray Rd, Orpington, BR5 3QY",
  },
  {
    FIELD1: "t('footer.address.line2')",
    English: "30 N Gould St Ste N  Sheridan, WY, 82801",
    French: "30 N Gould St Ste N Sheridan, WY, 82801",
    German: "30 N Gould St Ste N  Sheridan, WY, 82801",
    Spanish: "30 N Gould St Ste N Sheridan, WY, 82801",
    Italian: "30 N Gould St Ste N Sheridan, WY, 82801",
    Polish: "30 N Gould St Ste N, Sheridan, WY, 82801",
  },
  {
    FIELD1: "t('footer.sidebar_footer.support')",
    English: "Support",
    French: "Assistance",
    German: "Support",
    Spanish: "Ayuda",
    Italian: "Supporto",
    Polish: "Wsparcie",
  },
  {
    FIELD1: "t('footer.sidebar_footer.privacy')",
    English: "Privacy",
    French: "Confidentialité",
    German: "Privatsphäre",
    Spanish: "Privacidad",
    Italian: "Privacy",
    Polish: "Prywatność",
  },
  {
    FIELD1: "t('footer.sidebar_footer.terms')",
    English: "Terms",
    French: "Conditions d'utilisation",
    German: "Bestimmungen",
    Spanish: "Términos",
    Italian: "Termini",
    Polish: "Warunki",
  },
  {
    FIELD1: "t('account.helmet.title')",
    English: "My SafeTag Account",
    French: "Mon compte SafeTag",
    German: "SafeTag Mein Konto",
    Spanish: "SafeTag Mi cuenta",
    Italian: "Il mio account SafeTag",
    Polish: "Moje konto SafeTag",
  },
  {
    FIELD1: "t('account.buttons.billing')",
    English: "Go to Billings Settings",
    French: "Accéder aux paramètres de facturation",
    German: "Gehen Sie zu Abrechnungseinstellungen",
    Spanish: "Ir a Configuración de Facturación",
    Italian: "Vai alle Impostazioni di fatturazione",
    Polish: "Przejdź do ustawień rozliczeń",
  },
  {
    FIELD1: "t('account.billing.message')",
    English: "Update your payment method, view past invoices and more.",
    French:
      "Mettez à jour votre mode de paiement, consultez les factures antérieures et bien plus encore.",
    German:
      "Aktualisieren Sie Ihre Zahlungsmethode, sehen Sie sich frühere Rechnungen an und mehr.",
    Spanish: "Actualice su método de pago, vea facturas anteriores y más.",
    Italian:
      "Aggiorna il tuo metodo di pagamento, visualizza le fatture passate e altro ancora.",
    Polish: "Aktualizuj dane, zobacz faktury i więcej",
  },
  {
    FIELD1: "t('account.buttons.update')",
    English: "Update Details",
    French: "Mise à jour de vos renseignements",
    German: "Details aktualisieren",
    Spanish: "Actualizar detalles",
    Italian: "Aggiornamento Dettagli",
    Polish: "Aktualizuj dane",
  },
  {
    FIELD1: "t('account.buttons.success')",
    English: "Success",
    French: "Succès",
    German: "Erfolgreich",
    Spanish: "Éxito",
    Italian: "Riuscito",
    Polish: "Sukces",
  },
  {
    FIELD1: "t('account.buttons.redirecting')",
    English: "Redirecting",
    French: "Rediriger",
    German: "Umleitung",
    Spanish: "Redireccionando",
    Italian: "Reindirizzamento",
    Polish: "Przekierowywanie",
  },
  {
    FIELD1: "t('account.buttons.updating')",
    English: "Updating",
    French: "Actualisation",
    German: "Wird aktualisiert",
    Spanish: "Actualizando",
    Italian: "Aggiornamento",
    Polish: "Aktualizowanie",
  },
  {
    FIELD1: "t('account.buttons.delete')",
    English: "Delete ",
    French: "Supprimer",
    German: "Löschen",
    Spanish: "Eliminar",
    Italian: "Elimina",
    Polish: "Usuń",
  },
  {
    FIELD1: "t('account.billing.title')",
    English: "Billing",
    French: "Facturation",
    German: "Rechnungsstellung",
    Spanish: "Facturación",
    Italian: "Fatturazione",
    Polish: "Rozliczenia",
  },
  {
    FIELD1: "t('account.api.title')",
    English: "API Integration",
    French: "Intégration de l'API",
    German: "API Integration",
    Spanish: "Integración de la API",
    Italian: "Integrazione API",
    Polish: "Integracja API",
  },
  {
    FIELD1: "t('account.api.manage')",
    English: "Manage",
    French: "Gérer",
    German: "Verwalten",
    Spanish: "Administrar",
    Italian: "Maneggio",
    Polish: "Zarządzaj",
  },
  {
    FIELD1: "t('account.api.api_keys')",
    English: "API Keys",
    French: "Clés API",
    German: "API-Schlüssel",
    Spanish: "Claves API",
    Italian: "Chiavi API",
    Polish: "Klucze API",
  },
  {
    FIELD1: "t('account.api.api_key')",
    English: "API Key",
    French: "Clé API",
    German: "API-Schlüssel",
    Spanish: "Clave API",
    Italian: "Chiave API",
    Polish: "Klucz API",
  },
  {
    FIELD1: "t('account.api.no_expiry')",
    English: "No Expiry",
    French: "Pas d'expiration",
    German: "Kein Ablauf",
    Spanish: "Sin caducidad",
    Italian: "Nessuna scadenza",
    Polish: "Brak wygaśnięcia",
  },
  {
    FIELD1: "t('account.api.set_expiry')",
    English: "Set Expiry",
    French: "Définir l'expiration",
    German: "Ablauf festlegen",
    Spanish: "Establecer vencimiento",
    Italian: "Imposta scadenza",
    Polish: "Ustaw wygaśnięcie",
  },
  {
    FIELD1: "t('account.api.error_required')",
    English: "Required",
    French: "Requis",
    German: "Erforderlich",
    Spanish: "Requerido",
    Italian: "Necessario",
    Polish: "Wymagane",
  },
  {
    FIELD1: "t('account.api.error_invalid_url')",
    English: "Invalid url",
    French: "URL invalide",
    German: "Ungültige URL",
    Spanish: "URL no válida",
    Italian: "URL non valido",
    Polish: "Nieprawidłowy URL",
  },
  {
    FIELD1: "t('account.api.error_max')",
    English: "Maximum 100 characters",
    French: "100 caractères maximum",
    German: "Maximal 100 Zeichen",
    Spanish: "Máximo 100 caracteres",
    Italian: "Massimo 100 caratteri",
    Polish: "Maksymalnie 100 znaków",
  },
  {
    FIELD1: "t('account.api.error_min')",
    English: "Atleast 20 characters",
    French: "Au moins 20 caractères",
    German: "Mindestens 20 Zeichen",
    Spanish: "Al menos 20 caracteres",
    Italian: "Almeno 20 caratteri",
    Polish: "Co najmniej 20 znaków",
  },
  {
    FIELD1: "t('account.api.add')",
    English: "Add Token",
    French: "Ajouter un jeton",
    German: "Token hinzufügen",
    Spanish: "Agregar ficha",
    Italian: "Aggiungi gettone",
    Polish: "Dodaj token",
  },
  {
    FIELD1: "t('account.api.created')",
    English: "Created On",
    French: "Créé le",
    German: "Erstellt am",
    Spanish: "Creado el",
    Italian: "Creato il",
    Polish: "Utworzono",
  },
  {
    FIELD1: "t('account.api.expires')",
    English: "Expires At",
    French: "Expire à",
    German: "Läuft ab um",
    Spanish: "Vence en",
    Italian: "Scade alle",
    Polish: "Wygasa",
  },
  {
    FIELD1: "t('account.api.webhook_setup')",
    English: "Webhook Setup",
    French: "Configuration du webhook",
    German: "Webhook-Setup",
    Spanish: "Configuración del webhook",
    Italian: "Configurazione del webhook",
    Polish: "Konfiguracja webhooka",
  },
  {
    FIELD1: "t('account.api.webhook_url')",
    English: "Webhook URL",
    French: "URL du webhook",
    German: "Webhook-URL",
    Spanish: "URL de webhook",
    Italian: "URL del webhook",
    Polish: "URL webhooka",
  },
  {
    FIELD1: "t('account.api.webhook_secret')",
    English: "Webhook Secret",
    French: "Secret du webhook",
    German: "Webhook-Geheimnis",
    Spanish: "Secreto del webhook",
    Italian: "Segreto del webhook",
    Polish: "Sekret webhooka",
  },
  {
    FIELD1: "t('account.api.update_webhook')",
    English: "Update Webhook",
    French: "Mettre à jour le webhook",
    German: "Webhook aktualisieren",
    Spanish: "Actualizar webhook",
    Italian: "Aggiorna webhook",
    Polish: "Zaktualizuj webhook",
  },
  {
    FIELD1: "t('account.api.enable_webhook')",
    English: "Enable Webhook",
    French: "Activer le webhook",
    German: "Webhook aktivieren",
    Spanish: "Habilitar webhook",
    Italian: "Abilita Webhook",
    Polish: "Włącz webhook",
  },
  {
    FIELD1: "t('account.api.no_tokens')",
    English: "No API Tokens Created",
    French: "Aucun jeton API créé",
    German: "Keine API-Token erstellt",
    Spanish: "No se crearon tokens API",
    Italian: "Nessun token API creato",
    Polish: "Brak utworzonych tokenów API",
  },
  {
    FIELD1: "t('account.api.delete_msg')",
    English: "This will revoke access of any application using this token",
    French: "Cela révoquera l'accès à toute application utilisant ce jeton.",
    German:
      "Damit wird der Zugriff auf alle Anwendungen, die dieses Token verwenden, gesperrt.",
    Spanish:
      "Esto revocará el acceso de cualquier aplicación que utilice este token",
    Italian:
      "In questo modo si revoca l'accesso a qualsiasi applicazione che utilizzi questo token",
    Polish:
      "Spowoduje to cofnięcie dostępu wszystkim aplikacjom używającym tego tokena",
  },
  {
    FIELD1: "t('account.api.delete_webhook_msg')",
    English: "Would you like to permanently delete this Webhook?",
    French: "Souhaitez-vous supprimer définitivement ce Webhook ?",
    German: "Möchten Sie diesen Webhook dauerhaft löschen?",
    Spanish: "¿Le gustaría eliminar permanentemente este webhook?",
    Italian: "Desideri eliminare definitivamente questo webhook?",
    Polish: "Czy chcesz trwale usunąć ten webhook?",
  },
  {
    FIELD1: "t('account.api.delete')",
    English: "Delete",
    French: "Supprimer",
    German: "Löschen",
    Spanish: "Borrar",
    Italian: "Eliminare",
    Polish: "Usuń",
  },
  {
    FIELD1: "t('account.api.cancel')",
    English: "Cancel",
    French: "Annuler",
    German: "Stornieren",
    Spanish: "Cancelar",
    Italian: "Cancellare",
    Polish: "Anuluj",
  },
  {
    FIELD1: "t('account.api.copy')",
    English: "Token copied to clipboard",
    French: "Jeton copié dans le presse-papiers",
    German: "Token in die Zwischenablage kopiert",
    Spanish: "Token copiado al portapapeles",
    Italian: "Token copiato negli appunti",
    Polish: "Token skopiowany do schowka",
  },
  {
    FIELD1: "t('account.api.create_error')",
    English: "There was an error creating your key, please contact support",
    French:
      "Une erreur s'est produite lors de la création de votre clé, veuillez contacter l'assistance",
    German:
      "Beim Erstellen Ihres Schlüssels ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Support",
    Spanish:
      "Se produjo un error al crear su clave, comuníquese con el soporte",
    Italian:
      "Si è verificato un errore durante la creazione della chiave, contatta l'assistenza",
    Polish:
      "Wystąpił błąd podczas tworzenia klucza. Skontaktuj się z pomocą techniczną.",
  },
  {
    FIELD1: "t('account.api.delete_error')",
    English: "There was an error deleteing your key, please contact support.",
    French:
      "Une erreur s'est produite lors de la suppression de votre clé, veuillez contacter l'assistance.",
    German:
      "Beim Löschen Ihres Schlüssels ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Support.",
    Spanish:
      "Se produjo un error al eliminar su clave, comuníquese con el soporte.",
    Italian:
      "Si è verificato un errore durante l'eliminazione della chiave, contatta l'assistenza.",
    Polish: "Wystąpił błąd podczas usuwania klucza.",
  },
  {
    FIELD1: "t('account.api.delete_success')",
    English: "Key successfully deleted.",
    French: "Clé supprimée avec succès.",
    German: "Schlüssel erfolgreich gelöscht.",
    Spanish: "Clave eliminada exitosamente.",
    Italian: "Chiave eliminata con successo.",
    Polish: "Klucz został pomyślnie usunięty.",
  },
  {
    FIELD1: "t('account.api.webhook_create_error')",
    English:
      "Something went wrong updating your webhook. Please contact support.",
    French:
      "Une erreur s'est produite lors de la mise à jour de votre webhook. Veuillez contacter l'assistance.",
    German:
      "Beim Aktualisieren Ihres Webhooks ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Support.",
    Spanish:
      "Algo salió mal al actualizar tu webhook. Por favor contacte al soporte.",
    Italian:
      "Qualcosa è andato storto durante l'aggiornamento del tuo webhook. Si prega di contattare l'assistenza.",
    Polish: "Wystąpił błąd podczas aktualizacji webhooka.",
  },
  {
    FIELD1: "t('account.api.webhook_delete_error')",
    English:
      "There was an error deleting your webhook, please contact support.",
    French:
      "Une erreur s'est produite lors de la suppression de votre webhook, veuillez contacter l'assistance.",
    German:
      "Beim Löschen Ihres Webhooks ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Support.",
    Spanish:
      "Se produjo un error al eliminar su webhook; comuníquese con el soporte.",
    Italian:
      "Si è verificato un errore durante l'eliminazione del tuo webhook, contatta l'assistenza.",
    Polish: "Wystąpił błąd podczas usuwania webhooka.",
  },
  {
    FIELD1: "t('account.location.delete_history')",
    English: "Delete All History",
    French: "Supprimer tout l’historique",
    German: "Lösche den gesamten Verlauf.",
    Spanish: "Borrar todo el historial",
    Italian: "Elimina tutta la cronologia",
    Polish: "Usuń całą historię",
  },
  {
    FIELD1: "t('account.location.download')",
    English: "Download",
    French: "Télécharger",
    German: "Herunterladen",
    Spanish: "Descargar",
    Italian: "Scarica",
    Polish: "Pobierz",
  },
  {
    FIELD1: "t('account.tab.general')",
    English: "General",
    French: "Général",
    German: "Allgemein",
    Spanish: "General",
    Italian: "Generale",
    Polish: "Ogólne",
  },
  {
    FIELD1: "t('account.tab.billing')",
    English: "Billing",
    French: "Facturation",
    German: "Rechnungsstellung",
    Spanish: "Facturación",
    Italian: "Fatturazione",
    Polish: "Rozliczenia",
  },
  {
    FIELD1: "t('account.tab.developer')",
    English: "Developer Tools",
    French: "Outils du développeur",
    German: "Entwickler-Tools",
    Spanish: "Herramientas para Desarrolladores",
    Italian: "Strumenti",
    Polish: "Narzędzia deweloperskie",
  },
  {
    FIELD1: "t('account.tab.users')",
    English: "Account Sharing",
    French: "Partage de compte",
    German: "Gemeinsame Nutzung eines Kontos",
    Spanish: "Compartir Cuenta",
    Italian: "Condivisione dell'account",
    Polish: "Udostępnianie konta",
  },
  {
    FIELD1: "t('account.tab.referrals')",
    English: "Referrals",
    French: "Références",
    German: "Referenzen",
    Spanish: "Referencias",
    Italian: "Referenze",
    Polish: "Polecenia",
  },
  {
    FIELD1: "t('account.delete.title')",
    English: "Delete your Account",
    French: "Supprimer votre compte",
    German: "Löschen Sie Ihr Konto",
    Spanish: "Eliminar su Cuenta",
    Italian: "Cancellare l'account",
    Polish: "Usuń konto",
  },
  {
    FIELD1: "t('account.settings.title')",
    English: "Account Settings",
    French: "Paramètres du compte",
    German: "Kontoeinstellungen",
    Spanish: "Configuración de la cuenta",
    Italian: "Impostazioni dell'account",
    Polish: "Ustawienia konta",
  },
  {
    FIELD1: "t('account.schedule.title')",
    English: "Alert Schedules",
    French: "Calendrier des alertes",
    German: "Zeitpläne für Alarme",
    Spanish: "Horarios de alertas",
    Italian: "Programmi di avviso",
    Polish: "Harmonogramy alertów",
  },
  {
    FIELD1: "t('account.schedule.schedule')",
    English: "Schedule",
    French: "Calendrier",
    German: "Zeitplan",
    Spanish: "Horario",
    Italian: "Programma",
    Polish: "Harmonogram",
  },
  {
    FIELD1: "t('account.schedule.subheading')",
    English:
      "Set times when you want to pause all alerts for this account, on every device logged in.",
    French:
      "Définissez les heures auxquelles vous souhaitez mettre en pause toutes les alertes pour ce compte, sur chaque appareil connecté.",
    German:
      "Legen Sie Zeiten fest, zu denen Sie alle Benachrichtigungen für dieses Konto auf jedem angemeldeten Gerät unterbrechen möchten.",
    Spanish:
      "Establezca horarios en los que desee pausar todas las alertas para esta cuenta, en todos los dispositivos conectados.",
    Italian:
      "Impostare gli orari in cui si desidera mettere in pausa tutti gli avvisi per questo account, su ogni dispositivo connesso.",
    Polish:
      "Ustaw godziny wstrzymania alertów dla konta na wszystkich urządzeniac",
  },
  {
    FIELD1: "t('account.schedule.add')",
    English: "Add New",
    French: "Nouveau",
    German: "Neu hinzufügen",
    Spanish: "Agregar nuevo",
    Italian: "Aggiungi nuovo",
    Polish: "Dodaj nowe",
  },
  {
    FIELD1: "t('account.schedule.success')",
    English: "Schedule Saved!",
    French: "Calendrier sauvegardé !",
    German: "Zeitplan gespeichert!",
    Spanish: "¡Horario guardado!",
    Italian: "Programma salvato!",
    Polish: "Harmonogram zapisany",
  },
  {
    FIELD1: "t('account.schedule.success_delete')",
    English: "Schedule Deleted!",
    French: "Calendrier supprimé !",
    German: "Zeitplan gelöscht!",
    Spanish: "Horario eliminado!",
    Italian: "Programma eliminato!",
    Polish: "Harmonogram usunięty",
  },
  {
    FIELD1: "t('account.schedule.error')",
    English: "Your schedule can't be saved, please contact support",
    French:
      "Votre calendrier ne peut pas être sauvegardé, veuillez contacter le support",
    German:
      "Ihr Zeitplan kann nicht gespeichert werden, bitte kontaktieren Sie den Support",
    Spanish: "Su horario no se puede guardar, por favor contacte con soporte",
    Italian: "Non è possibile salvare il programma, contattare l'assistenza.",
    Polish: "Nie można zapisać harmonogramu",
  },
  {
    FIELD1: "t('account.schedule.max')",
    English: "You can only have 5 alert schedules saved",
    French: "Vous ne pouvez enregistrer que 5 calendriers d'alerte",
    German: "Sie können nur 5 Alarmzeitpläne speichern",
    Spanish: "Solo puede tener 5 horarios de alertas guardados",
    Italian: "È possibile salvare solo 5 programmi di avviso",
    Polish: "Możesz mieć maksymalnie 5 harmonogramów alertów",
  },
  {
    FIELD1: "t('account.schedule.empty')",
    English: "No schedule data found",
    French: "Aucune donnée de calendrier n'a été trouvée",
    German: "Keine Zeitplandaten gefunden",
    Spanish: "No se encontraron datos de horario",
    Italian: "Non sono stati trovati dati di pianificazione",
    Polish: "Brak danych harmonogramu",
  },
  {
    FIELD1: "t('account.schedule_modal.title')",
    English: "Set Quiet Schedule",
    French: "Définir un calendrier de repos",
    German: "Zeitplan für Stille einstellen",
    Spanish: "Establecer horario silencioso",
    Italian: "Impostare un programma silenzioso",
    Polish: "Ustaw harmonogram ciszy",
  },
  {
    FIELD1: "t('account.delete_schedule.title')",
    English: "Delete Alarm Schedule",
    French: "Supprimer un calendrier d'alarme",
    German: "Alarmzeitplan löschen",
    Spanish: "Eliminar horario de alarma",
    Italian: "Cancellare la pianificazione degli allarmi",
    Polish: "Usuń harmonogram alarmu",
  },
  {
    FIELD1: "t('account.delete_schedule.message')",
    English: "Are you sure you want to remove this schedule?",
    French: "Êtes-vous sûr de vouloir supprimer cet horaire ?",
    German: "Wollen Sie wirklich diesen Plan entefernen?",
    Spanish: "¿Está seguro de que desea eliminar este horario?",
    Italian: "Sei sicuro di voler rimuovere questo programma?",
    Polish: "Czy na pewno chcesz usunąć ten harmonogram?",
  },
  {
    FIELD1: "t('account.schedule_modal.from')",
    English: "From",
    French: "De",
    German: "Von",
    Spanish: "De",
    Italian: "Da",
    Polish: "Od",
  },
  {
    FIELD1: "t('account.schedule_modal.to')",
    English: "To",
    French: "Au",
    German: "Bis",
    Spanish: "Para",
    Italian: "a",
    Polish: "Do",
  },
  {
    FIELD1: "t('account.schedule_modal.days')",
    English: "Select days",
    French: "Sélectionner les jours",
    German: "Tage auswählen",
    Spanish: "Seleccionar días",
    Italian: "Giorni selezionati",
    Polish: "Wybierz dni",
  },
  {
    FIELD1: "t('account.schedule_modal.repeat')",
    English: "Repeat Everyday",
    French: "Répéter tous les jours",
    German: "Täglich wiederholen",
    Spanish: "Repetir todos los días",
    Italian: "Ripeti ogni giorno",
    Polish: "Powtarzaj codziennie",
  },
  {
    FIELD1: "t('account.schedule_modal.set')",
    English: "Set Schedule",
    French: "Définir le calendrier",
    German: "Zeitplan festlegen",
    Spanish: "Establecer horario",
    Italian: "Imposta programma",
    Polish: "Ustaw harmonogram",
  },
  {
    FIELD1: "t('account.schedule.invalid')",
    English: "End time cannot be before the start time",
    French: "L'heure de fin ne peut pas être antérieure à l'heure de début",
    German: "Das Enddatum kann nicht vor dem Startdatum liegen.",
    Spanish:
      "La hora de finalización no puede ser anterior a la hora de inicio.",
    Italian: "L'ora di arrivo non può essere precedente all'ora di partenza",
    Polish:
      "Godzina zakończenia nie może być wcześniejsza niż godzina rozpoczęcia",
  },
  {
    FIELD1: "t('account.delete.message')",
    English:
      "Deleting your account will remove your login credentials and user data from our systems. This account will also unpair your trackers from your account, cancel associated subscriptions and delete associated data.",
    French:
      "En supprimant votre compte, vous supprimez vos identifiants de connexion et vos données d'utilisateur de nos systèmes. Ce compte permettra également de dissocier vos traceurs de votre compte, d'annuler les abonnements associés et de supprimer les données associées.",
    German:
      "Wenn Sie Ihr Konto löschen, werden Ihre Anmeldedaten und Benutzerdaten aus unseren Systemen entfernt. Dieses Konto hebt auch die Kopplung Ihrer Tracker mit Ihrem Konto auf, kündigt die damit verbundenen Abonnements und löscht die damit verbundenen Daten.",
    Spanish:
      "Eliminar su cuenta eliminará sus credenciales de inicio de sesión y datos de usuario de nuestros sistemas. Esta cuenta también desvinculará sus rastreadores de su cuenta, cancelará suscripciones asociadas y eliminará datos asociados.",
    Italian:
      "L'eliminazione dell'account rimuoverà le credenziali di accesso e i dati dell'utente dai nostri sistemi. Inoltre, l'eliminazione dell'account disaccoppierà i dispositivi di tracciamento dal proprio account, annullerà gli abbonamenti associati e cancellerà i dati associati.",
    Polish:
      "Usunięcie konta spowoduje usunięcie danych logowania i danych użytkownika z naszych systemów. Konto zostanie również odłączone od lokalizatorów, powiązane subskrypcje zostaną anulowane, a wszystkie powiązane dane usunięte.",
  },
  {
    FIELD1: "t('account.buttons.deleting')",
    English: "Deleting Account",
    French: "Suppression du compte",
    German: "Konto löschen",
    Spanish: "Eliminar cuenta",
    Italian: "Eliminazione dell'account in corso",
    Polish: "Usuwanie konta",
  },
  {
    FIELD1: "t('account.buttons.phrase')",
    English: "Please enter the phrase correctly.",
    French: "Veuillez saisir correctement la phrase.",
    German: "Bitte geben Sie den Satz richtig ein.",
    Spanish: "Por favor, introduzca la frase correctamente.",
    Italian: "Inserire correttamente la frase.",
    Polish: "Wpisz poprawnie frazę.",
  },
  {
    FIELD1: "t('account.buttons.cancel')",
    English: "Cancel",
    French: "Annuler",
    German: "Abbrechen",
    Spanish: "Cancelar",
    Italian: "Elimina",
    Polish: "Anuluj",
  },
  {
    FIELD1: "t('account.errors.general')",
    English: "Something went wrong, please try again later.",
    French: "Un problème est survenu, veuillez réessayer plus tard.",
    German: "Etwas ist schiefgelaufen, bitte versuchen Sie es später nochmal.",
    Spanish: "Algo ha ido mal, por favor inténtelo de nuevo más tarde.",
    Italian: "Qualcosa è andato storto, riprovare più tardi.",
    Polish: "Coś poszło nie tak, spróbuj ponownie później.",
  },
  {
    FIELD1: "t('account.errors.success')",
    English: "Updated Successfully",
    French: "Mise à jour réussie",
    German: "Es wurde erfolgreich aktualisiert",
    Spanish: "Actualizado correctamente",
    Italian: "Aggiornamento riuscito",
    Polish: "Zaktualizowano pomyślnie",
  },
  {
    FIELD1: "t('account.errors.not_found')",
    English: "Account could not be found.",
    French: "Le compte n'a pas pu être trouvé.",
    German: "Das Konto konnte nicht gefunden werden.",
    Spanish: "No se pudo encontrar la cuenta.",
    Italian: "L'account non è stato trovato.",
    Polish: "Nie znaleziono konta.",
  },
  {
    FIELD1: "t('account.errors.incorrect')",
    English: "Incorrect username or password.",
    French: "Nom d'utilisateur ou mot de passe incorrect.",
    German: "Falscher Nutzername oder Passwort.",
    Spanish: "Nombre de usuario o contraseña incorrectos.",
    Italian: "Nome utente o password errati.",
    Polish: "Nieprawidłowa nazwa użytkownika lub hasło.",
  },
  {
    FIELD1: "t('account.location.title')",
    English: "History Management",
    French: "Gestion de l'historique",
    German: "Geschichte Management",
    Spanish: "Gestión del historial",
    Italian: "Gestione della cronologia",
    Polish: "Zarządzanie historią",
  },
  {
    FIELD1: "t('account.location.export_title')",
    English: "Location Data Export",
    French: "Exportation des données de localisation",
    German: "Standortdatenexport",
    Spanish: "Exportación de datos de ubicación",
    Italian: "Esportazione dei dati di localizzazione",
    Polish: "Eksport danych lokalizacji",
  },
  {
    FIELD1: "t('account.location_delete.title')",
    English: "Delete All Location Data",
    French: "Supprimer toutes les données de localisation",
    German: "Alle Standortdaten löschen",
    Spanish: "Eliminar todos los datos de ubicación",
    Italian: "Elimina tutti i dati di localizzazione",
    Polish: "Usuń wszystkie dane lokalizacji",
  },
  {
    FIELD1: "t('account.errors.history')",
    English: "No location data found.",
    French: "Aucune donnée de localisation n'a été trouvée.",
    German: "Es wurden keine Standortdaten gefunden.",
    Spanish: "No se encontraron datos de ubicación.",
    Italian: "Non sono stati trovati dati sulla posizione.",
    Polish: "Nie znaleziono danych lokalizacji.",
  },
  {
    FIELD1: "t('account.errors.noDevices')",
    English: "No trackers found.",
    French: "Aucun appareil n'a été trouvé.",
    German: "Es wurden keine Geräte gefunden",
    Spanish: "No se encontraron dispositivos.",
    Italian: "Nessun dispositivo trovato",
    Polish: "Nie znaleziono lokalizatorów.",
  },
  {
    FIELD1: "t('account.errors.noHistory')",
    English: "Failed to retrieve data. Please contact support.",
    French:
      "Échec de la récupération des données. Veuillez contacter l'assistance.",
    German:
      "Fehler beim Abrufen der Daten. Bitte wenden Sie sich an den Support.",
    Spanish:
      "No se pudieron recuperar los datos. Por favor, póngase en contacto con soporte.",
    Italian: "Impossibile recuperare i dati. Contattare l'assistenza.",
    Polish: "Nie udało się pobrać danych. Skontaktuj się z pomocą techniczną.",
  },
  {
    FIELD1: "t('account.errors.historyWarn')",
    English:
      "Please confirm you would like to delete all location history of your tracker. This action is irreversable.",
    French:
      "Veuillez confirmer que vous souhaitez supprimer tout l'historique de localisation de votre traceur. Cette action est irréversible.",
    German:
      "Bitte bestätigen Sie, dass Sie den gesamten Standortverlauf Ihres Trackers löschen möchten. Diese Aktion ist unumkehrbar.",
    Spanish:
      "Por favor, confirme que desea eliminar todo el historial de localización de su rastreador. Esta acción es irreversible.",
    Italian:
      "Confermare che si desidera eliminare tutta la cronologia delle posizioni del dispositivo. Questa azione è irreversibile.",
    Polish:
      "Potwierdź, że chcesz usunąć całą historię lokalizacji swojego lokalizatora. Ta operacja jest nieodwracalna.",
  },
  {
    FIELD1: "t('account.errors.historyDelete')",
    English:
      "Sorry we encountered an error while deleting your history. Please contact support.",
    French:
      "Désolé, nous rencontrons une erreur lors de la suppression de votre historique. Veuillez contacter l'assistance.",
    German:
      "Es tut uns leid, es gibt einen Fehlee bei der Löschung deines Verlaufs.",
    Spanish:
      "Lo sentimos, hemos encontrado un error al eliminar su historial. Póngase en contacto con soporte.",
    Italian:
      "Si e verificato un errore durante l'eliminazione della cronologia. Contatta l'assistenza.",
    Polish:
      "Przepraszamy, wystąpił błąd podczas usuwania historii. Skontaktuj się z pomocą techniczną.",
  },
  {
    FIELD1: "t('account.errors.unauthorized')",
    English: "Unauthorized",
    French: "Non autorisé",
    German: "Nicht authoriziert",
    Spanish: "No autorizado",
    Italian: "Non autorizzato",
    Polish: "Brak autoryzacji",
  },
  {
    FIELD1: "t('account.main.title')",
    English: "My Account",
    French: "Mon compte",
    German: "Mein Konto",
    Spanish: "Mi cuenta",
    Italian: "Il mio account",
    Polish: "Moje konto",
  },
  {
    FIELD1: "t('account.main.label_name')",
    English: "Name",
    French: "Nom",
    German: "Name",
    Spanish: "Nombre",
    Italian: "Nome",
    Polish: "Imię",
  },
  {
    FIELD1: "t('account.main.label_language')",
    English: "Global Language",
    French: "Langue mondiale",
    German: "Weltsprache",
    Spanish: "Idioma global",
    Italian: "Lingua generale",
    Polish: "Globalny język",
  },
  {
    FIELD1: "t('account.main.language_tooltip')",
    English:
      "Your global language is used to display your chosen language in notifications, emails, and use with any other external service.",
    French:
      "Votre langue globale est utilisée pour afficher la langue que vous avez choisie dans les notifications, les e-mails et l'utilisation avec tout autre service externe.",
    German:
      "Ihre globale Sprache wird verwendet, um Ihre gewählte Sprache in Benachrichtigungen, E-Mails und bei der Verwendung mit anderen externen Diensten anzuzeigen.",
    Spanish:
      "Tu idioma global se utiliza para mostrar el idioma elegido en notificaciones, correos electrónicos y para utilizarlo con cualquier otro servicio externo.",
    Italian:
      "La lingua generale viene utilizzata per visualizzare la lingua scelta nelle notifiche, nelle e-mail e nell'utilizzo con qualsiasi altro servizio esterno.",
    Polish:
      "Twój globalny język jest używany do wyświetlania wybranego języka w powiadomieniach, wiadomościach e-mail i innych usługach zewnętrznych.",
  },
  {
    FIELD1: "t('account.main.label_email')",
    English: "Email",
    French: "Email",
    German: "E-Mail",
    Spanish: "Correo electrónico",
    Italian: "Email",
    Polish: "E-mail",
  },
  {
    FIELD1: "t('account.main.label_country')",
    English: "Country",
    French: "Pays",
    German: "Land",
    Spanish: "País",
    Italian: "Paese",
    Polish: "Kraj",
  },
  {
    FIELD1: "t('account.main.label_contact')",
    English: "Contact me with offers and updates",
    French: "Contact",
    German: "Kontakt",
    Spanish: "Contacto",
    Italian: "Contatto",
    Polish: "Kontaktuj się ze mną w sprawie ofert i aktualizacji",
  },
  {
    FIELD1: "t('account.main.label_notifyEmail')",
    English: "Send tracker notifications to my email",
    French: "Envoyer les notifications du traceur sur mon adresse e-mail",
    German: "Senden Sie Tracker Nachrichten an meine E-Mail",
    Spanish: "Enviar notificaciones de seguimiento a mi correo electrónico.",
    Italian: "Invia le notifiche del dispositivo al mio indirizzo e-mail.",
    Polish: "Wysyłaj powiadomienia lokalizatora na mój adres e-mail",
  },
  {
    FIELD1: "t('account.main.label_password')",
    English: "Password",
    French: "Mot de passe",
    German: "Passwort",
    Spanish: "Nombre",
    Italian: "Nome",
    Polish: "Hasło",
  },
  {
    FIELD1: "t('account.location.label_startTime')",
    English: "Start Time",
    French: "Heure de début",
    German: "Startzeit",
    Spanish: "Hora de inicio",
    Italian: "Orario di inizio",
    Polish: "Godzina rozpoczęcia",
  },
  {
    FIELD1: "t('account.location.label_endTime')",
    English: "End Time",
    French: "Heure de fin",
    German: "Endzeit",
    Spanish: "Hora de finalización",
    Italian: "Orario di fine",
    Polish: "Godzina zakończenia",
  },
  {
    FIELD1: "t('account.main.type')",
    English: "Please type “delete my account”:",
    French: 'Veuillez saisir "supprimer mon compte" :',
    German: 'Bitte geben Sie ein " mein Konto löschen',
    Spanish: 'Por favor escriba "eliminar mi cuenta":',
    Italian: 'Sei pregato di digitare "cancella il mio account":',
    Polish: "Wpisz „delete my account”:",
  },
  {
    FIELD1: "t('account.main.delete_fail')",
    English:
      "Sorry we encountered an error while deleting your account. Please contact support.",
    French:
      "Désolé, nous avons rencontré une erreur lors de la suppression de votre compte. Veuillez contacter le service d’assistance.",
    German:
      "Beim Löschen Ihres Kontos ist leider ein Fehler aufgetreten. Bitte wenden Sie sich an den Support.",
    Spanish:
      "Lo sentimos, hemos encontrado un error al eliminar su cuenta. Por favor, póngase en contacto con soporte.",
    Italian:
      "Siamo spiacenti. Abbiamo riscontrato un errore durante la cancellazione del suo account. Si prega di contattare l'assistenza.",
    Polish:
      "Przepraszamy, wystąpił błąd podczas usuwania konta. Skontaktuj się z pomocą techniczną.",
  },
  {
    FIELD1: "t('account.main.warning')",
    English:
      "Deleting your account will remove your login credentials and user data from our systems. This action will also unpair your trackers from your account, cancel associated subscriptions and delete associated data. <br /> <b>This action is irreversable.</b>",
    French:
      "La suppression de votre compte entraînera la perte de vos identifiants de connexion et de vos données utilisateur dans nos systèmes. Cette action entraînera également la dissociation de vos traceurs de votre compte, l'annulation des abonnements associés et la suppression des données associées. <br /> <b>Cette action est irréversible.</b>",
    German:
      "Wenn Sie Ihr Konto löschen, werden Ihre Anmeldedaten und Benutzerdaten aus unseren Systemen entfernt. Durch diese Aktion werden auch Ihre Tracker von Ihrem Konto getrennt, zugehörige Abonnements gekündigt und zugehörige Daten gelöscht. <br /> <b>Diese Aktion ist unumkehrbar.</b>",
    Spanish:
      "Eliminar su cuenta eliminará sus credenciales de inicio de sesión y datos de usuario de nuestros sistemas. Esta acción también desvinculará sus rastreadores de su cuenta, cancelará las suscripciones asociadas y eliminará los datos asociados. <br /> <b>Esta acción es irreversible.</b>",
    Italian:
      "L'eliminazione dell'account rimuoverà anche le credenziali di accesso e i dati utente dal nostro sistema. Quest'azione disaccoppierà anche i dispositivi dall'account, annullerà gli abbonamenti associati e cancellerà i dati associati. Questa azione è irreversibile.",
    Polish:
      "Usunięcie konta spowoduje usunięcie danych logowania i danych użytkownika z naszych systemów. Ta operacja odłączy również lokalizatory od konta, anuluje powiązane subskrypcje i usunie powiązane dane. <br /> <b>Ta operacja jest nieodwracalna.</b>",
  },
  {
    FIELD1: "t('account.main.reset')",
    English:
      "Looking to change your password? Log out and go to the login page to find the link.",
    French:
      "Vous souhaitez réinitialiser votre mot de passe ? Déconnectez-vous et allez à la page de connexion pour trouver le lien.",
    German:
      "Möchtest du dein Passwort zurücksetzen? Melde ab und gehe zur Anmeldeseite, um den entsprechenden Link zu finden.",
    Spanish:
      "¿Desea restablecer su contraseña? Cierre sesión y vaya a la página de inicio de sesión para encontrar el enlace.",
    Italian:
      "Vuoi reimpostare la tua password? Esci e vai alla pagina di login per trovare il link.",
    Polish:
      "Chcesz zmienić hasło? Wyloguj się i przejdź do strony logowania, aby znaleźć odpowiedni link.",
  },
  {
    FIELD1: "t('add_device.helmet.title')",
    English: "SafeTag Tracker Activation",
    French: "Enregistrer votre traceur SafeTag",
    German: "SafeTag Register Tracker",
    Spanish: "Rastreador de registros SafeTag",
    Italian: "Registro di tracciamento SafeTag",
    Polish: "Aktywacja lokalizatora SafeTag",
  },
  {
    FIELD1: "t('add_device.button.purchase')",
    English: "Purchase Subscription",
    French: "Acheter un abonnement",
    German: "Kauf Abomment",
    Spanish: "Comprar suscripción",
    Italian: "Acquista un abbonamento",
    Polish: "Zakup subskrypcji",
  },
  {
    FIELD1: "t('add_device.button.redirecting')",
    English: "Pairing Tracker",
    French: "Suivi de l'appariement",
    German: "Tracker miteinander verkoppeln ",
    Spanish: "Emparejando rastreador",
    Italian: "Collegando il tracker",
    Polish: "Parowanie lokalizatora",
  },
  {
    FIELD1: "t('add_device.button.success')",
    English: "Redirecting to Checkout",
    French: "Redirection vers la caisse",
    German: "Zum Checkout umleiten",
    Spanish: "Redirigiendo a la caja",
    Italian: "Reindirizzamento al checkout",
    Polish: "Przekierowywanie do płatności",
  },
  {
    FIELD1: "t('add_device.error.general')",
    English: "Something went wrong, please try again later.",
    French: "Un problème est survenu, veuillez réessayer plus tard.",
    German: "Etwas ist schiefgelaufen, bitte versuchen Sie es später nochmal.",
    Spanish: "Algo salió mal, por favor inténtelo de nuevo más tarde.",
    Italian: "Qualcosa è andato storto, riprovare più tardi.",
    Polish: "Coś poszło nie tak, spróbuj ponownie później.",
  },
  {
    FIELD1: "t('add_device.error.too_many_requests')",
    English: "Too many attempts, please retry in a few minutes",
    French: "Trop de tentatives, veuillez réessayer dans quelques minutes.",
    German:
      "Sie haben zu viele falsche Versuche, bitte versuchen Sie es in ein paar Minuten noch einmal.",
    Spanish:
      "Demasiados intentos, por favor vuelva a intentarlo en unos minutos",
    Italian: "Troppi tentativi, riprovare tra qualche minuto",
    Polish: "Zbyt wiele prób, spróbuj ponownie za kilka minut.",
  },
  {
    FIELD1: "t('add_device.error.already_registered')",
    English:
      "It looks like you've already registered and activated your tracker, you can find it on the 'My Trackers' page.",
    French:
      'Il semble que vous ayez déjà enregistré et activé votre traceur, vous pouvez le trouver sur la page "Mes traceurs".',
    German:
      'Es sieht so aus, als hätten Sie Ihren Tracker bereits registriert und aktiviert. Sie finden ihn auf der Seite "Meine Tracker".',
    Spanish:
      "Parece que ya ha registrado y activado su rastreador, puede encontrarlo en la página 'Mis rastreadores'.",
    Italian:
      'Sembra che tu abbia già registrato e attivato il tuo dispositivo, lo puoi trovare nella pagina "I miei dispositivi".',
    Polish:
      "Wygląda na to, że już zarejestrowałeś(-aś) i aktywowałeś(-aś) ten lokalizator. Znajdziesz go na stronie „Moje lokalizatory”.",
  },
  {
    FIELD1: "t('add_device.error.already_added')",
    English:
      "Your tracker was added to your account, but we're having some trouble setting up your subscription. Please try again later by pressing the Activate Button on your tracker on the 'My Trackers' page.",
    French:
      'Votre traceur a été ajouté à votre compte, mais nous avons des difficultés à configurer votre abonnement. Veuillez réessayer plus tard en appuyant sur le bouton "Activer" de votre traceur sur la page "Mes traceurs".',
    German:
      'Ihr Tracker wurde Ihrem Konto hinzugefügt, aber wir haben einige Probleme beim Einrichten Ihres Abonnements. Bitte versuchen Sie es später erneut, indem Sie auf der Seite "Meine Tracker" auf die Schaltfläche "Aktivieren" auf Ihrem Tracker klicken',
    Spanish:
      "Su rastreador se ha añadido a su cuenta, pero estamos teniendo problemas para configurar su suscripción. Por favor, inténtelo de nuevo más tarde presionando el botón Activar de su rastreador en la página 'Mis rastreadores'.",
    Italian:
      "Il tuo dispositivo è stato aggiunto al tuo account, ma abbiamo riscontrato dei problemi nell'impostazione dell'abbonamento. Riprova più tardi premendo il pulsante Attiva sul tuo dispositivo nella pagina \"I miei dispositivi\".",
    Polish:
      "Twój lokalizator został dodany do konta, ale wystąpił problem z konfiguracją subskrypcji. Spróbuj ponownie później, klikając przycisk „Aktywuj” przy lokalizatorze na stronie „Moje lokalizatory”.",
  },
  {
    FIELD1: "t('add_device.error.not_found')",
    English:
      "This Tracker could not be found, please check that you have entered it correctly, or contact support.",
    French:
      "Ce traceur n'a pas pu être trouvé, veuillez vérifier que vous l'avez saisi correctement, ou contactez le support.",
    German:
      "Dieser Tracker konnte nicht gefunden werden. Bitte überprüfen Sie, ob Sie ihn korrekt eingegeben haben, oder wenden Sie sich an den Support.",
    Spanish:
      "No se ha podido encontrar este rastreador, compruebe que lo ha introducido correctamente o póngase en contacto con el servicio de asistencia.",
    Italian:
      "Questo Dispositivo non è stato trovato, verificare che sia stato inserito correttamente o contattare l'assistenza.",
    Polish:
      "Nie znaleziono tego lokalizatora. Sprawdź, czy dane zostały wpisane poprawnie lub skontaktuj się z pomocą techniczną.",
  },
  {
    FIELD1: "t('add_device.error.paired')",
    English:
      "This Tracker is already registered to an account, please check that you have entered it correctly, or contact support.",
    French:
      "Ce traceur est déjà enregisté sur un compte. Veuillez verifier que vous l'avez inscrit correctement ou contactez l'assistance.",
    German:
      "Dieser Tracjer ist schon angemeldet, bitte prüfen ob du es richtig eingegeben hast oder kontaktiere den Support",
    Spanish:
      "Este rastreador ya está registrado en una cuenta, verifique que lo haya introducido correctamente o póngase en contacto con soporte.",
    Italian:
      "Questo Dispositivo è già registrato a un account, verificare che sia stato inserito correttamente o contattare l'assistenza.",
    Polish:
      "Ten lokalizator jest już zarejestrowany na innym koncie. Sprawdź poprawność danych lub skontaktuj się z pomocą techniczną.",
  },
  {
    FIELD1: "t('add_device.error.contact_step')",
    English:
      "Désolé, ce traceur necessite une étape d'activation nécessaire. Veuillez nous contacter à support@safetagtracking.com",
    French:
      "Entschuldigung dieser Tracker braucht zusätzliche Aktivierungsschritte, bitte kontaktiere uns unter support@safetagtracking.com",
    German:
      "Lo sentimos, este Rastreador requiere un paso de activación adicional, por favor contáctenos a través de support@safetagtracking.com",
    Spanish:
      "Lo sentimos, este Rastreador requiere un paso de activación adicional, por favor contáctenos a través de support@safetagtracking.com",
    Italian:
      "Siamo spiacenti, questo tracker richiede un passaggio di attivazione. Contattaci a support@safetagtracking.com",
    Polish:
      "Przepraszamy, ten lokalizator wymaga dodatkowego etapu aktywacji. Skontaktuj się z nami pod adresem support@safetagtracking.com",
  },
  {
    FIELD1: "t('add_device.error.contact_plans')",
    English:
      "Sorry, we are unable to retrieve the subscription plans for this tracker, please contact us at support@safetagtracking.com",
    French:
      "Désolé, ce Tracker nécessite une étape d'activation supplémentaire, veuillez nous contacter à support@safetagtracking.com",
    German:
      "Entschuldigung, dieser Tracker erfordert einen zusätzlichen Aktivierungsschritt, bitte kontaktieren Sie uns unter support@safetagtracking.com",
    Italian:
      "Siamo spiacenti, non riusciamo a recuperare i piani di abbonamento per questo tracker, contattaci a support@safetagtracking.com",
    Polish:
      "Przepraszamy, nie możemy pobrać planów subskrypcji dla tego lokalizatora. Skontaktuj się z nami pod adresem support@safetagtracking.com",
  },
  {
    FIELD1: "t('add_device.error.max15')",
    English: "The Tracker IMEI should be maximum 15 digits long",
    French: "L'IMEI du traceur doit comporter 15 chiffres maximum",
    German: "Die Tracker-IMEI sollte maximal 15 Ziffern lang sein",
    Spanish: "El IMEI del localizador debe tener un máximo de 15 dígitos.",
    Italian: "L'IMEI del Dispositivo deve essere di massimo 15 cifre.",
    Polish: "Numer IMEI lokalizatora może mieć maksymalnie 15 cyfr.",
  },
  {
    FIELD1: "t('add_device.error.min10')",
    English: "The Tracker IMEI should be at least 10 digits long",
    French: "L'IMEI du traceur doit comporter au moins 10 chiffres",
    German: "Die Tracker IMEI sollte mindestens 10 Ziffern lang sein",
    Spanish: "El IMEI del rastreador debe tener al menos 10 dígitos.",
    Italian: "L'IMEI del Dispositivo deve essere di almeno 10 cifre.",
    Polish: "Numer IMEI lokalizatora powinien mieć co najmniej 10 cyfr.",
  },
  {
    FIELD1: "t('add_device.error.min2')",
    English: "Tracker names have to be 2 letters or over.",
    French: "Les noms des traceurs doivent être de 2 lettres ou plus.",
    German: "Tracker-Namen müssen mindestens 2 Buchstaben lang sein.",
    Spanish: "Los nombres de los rastreadores deben tener 2 letras o más.",
    Italian: "I nomi dei dispositivi devono essere di 2 lettere o più.",
    Polish: "Nazwy lokalizatorów muszą mieć co najmniej 2 znaki.",
  },
  {
    FIELD1: "t('add_device.error.max16')",
    English: "Tracker names have to be under 16 letters long.",
    French: "Les noms des traceurs doivent comporter moins de 16 lettres.",
    German: "Tracker-Namen müssen weniger als 16 Buchstaben lang sein.",
    Spanish: "Los nombres de los rastreadores deben tener menos de 16 letras.",
    Italian: "I nomi dei tracker devono contenere meno di 16 caratteri.",
    Polish: "Nazwy lokalizatorów muszą mieć mniej niż 16 znaków.",
  },
  {
    FIELD1: "t('add_device.main.title1')",
    English: "Activate",
    French: "Activer",
    German: "Aktivieren",
    Spanish: "Activar",
    Italian: "Attiva",
    Polish: "Aktywuj",
  },
  {
    FIELD1: "t('add_device.main.title2')",
    English: "Activate Tracker",
    French: "Activer le traceur",
    German: "Tracker aktivieren",
    Spanish: "Activar rastreador",
    Italian: "Attiva il tracker",
    Polish: "Aktywuj lokalizator",
  },
  {
    FIELD1: "t('add_device.main.trackerPresent')",
    English:
      "It looks like this tracker is already in your account, so you can use the below form to activate it. You will be redirected to stripe to purchase a subscription and activate your tracker.",
    French:
      "Il semble que ce traceur soit déjà dans votre compte, vous pouvez donc utiliser le formulaire ci-dessous pour l'activer. Vous serez redirigé vers Stripe pour acheter un abonnement et activer votre traceur.",
    German:
      "Es sieht so aus, als ob dieser Tracker bereits in Ihrem Konto vorhanden ist, also können Sie das untenstehende Formular verwenden, um ihn zu aktivieren. Sie werden zu Stripe weitergeleitet, um ein Abonnement zu erwerben und Ihren Tracker zu aktivieren.",
    Spanish:
      "Parece que este rastreador ya está en su cuenta, así que puede utilizar el siguiente formulario para activarlo. Será redirigido a Stripe para comprar una suscripción y activar su rastreador.",
    Italian:
      "Sembra che questo dispositivo sia già presente nel tuo account, quindi potrai utilizzare il modulo sottostante per attivarlo. Verrai reindirizzato a stripe per acquistare un abbonamento e attivare il dispositivo.",
    Polish:
      "Wygląda na to, że ten lokalizator jest już przypisany do Twojego konta, więc możesz użyć poniższego formularza, aby go aktywować. Zostaniesz przekierowany(-a) do Stripe w celu zakupu subskrypcji i aktywacji lokalizatora.",
  },
  {
    FIELD1: "t('add_device.main.trackerNotPresent')",
    English:
      "Fill out the below form to add your new tracker to your account. You will be redirected to stripe to purchase a subscription and activate your tracker.",
    French:
      "Remplissez le formulaire ci-dessous pour ajouter votre nouveau traceur à votre compte. Vous serez redirigé vers stripe pour acheter un abonnement et activer votre traceur.",
    German:
      "Füllen Sie das untenstehende Formular aus, um Ihren neuen Tracker zu Ihrem Konto hinzuzufügen. Sie werden dann zu Stripe weitergeleitet, um ein Abonnement zu erwerben und Ihren Tracker zu aktivieren.",
    Spanish:
      "Rellene el siguiente formulario para añadir su nuevo rastreador a su cuenta. Será redirigido a Stripe para comprar una suscripción y activar su rastreador.",
    Italian:
      "Compila il modulo sottostante per aggiungere il nuovo dispositivo al tuo account. Verrai reindirizzato a stripe per acquistare un abbonamento e attivare il dispositivo.",
    Polish:
      "Wypełnij poniższy formularz, aby dodać nowy lokalizator do swojego konta. Zostaniesz przekierowany(-a) do Stripe w celu zakupu subskrypcji i aktywacji lokalizatora.",
  },
  {
    FIELD1: "t('add_device.main.tracker_imei')",
    English: "Tracker IMEI",
    French: "IMEI du traceur",
    German: "Tracker-IMEI",
    Spanish: "IMEI del rastreador",
    Italian: "IMEI del dispositivo",
    Polish: "Numer IMEI lokalizatora",
  },
  {
    FIELD1: "t('add_device.main.imei_tooltip')",
    English:
      "This is a unique 15 digit code located on a sticker on your tracker.",
    French:
      "Il s'agit d'un code unique à 15 chiffres situé sur un autocollant apposé sur votre traceur.",
    German:
      "Dies ist ein einzigartiger 15-stelliger Code, der sich auf einem Aufkleber auf Ihrem Tracker befindet.",
    Spanish:
      "Se trata de un código único de 15 dígitos que se encuentra en una calcomanía en su rastreador.",
    Italian:
      "Si tratta di un codice univoco di 15 cifre che si trova su un adesivo del dispositivo.",
    Polish:
      "Jest to unikalny 15-cyfrowy kod znajdujący się na naklejce na lokalizatorze.",
  },
  {
    FIELD1: "t('add_device.main.tracker_name')",
    English: "Tracker Name",
    French: "Nom du traceur",
    German: "Tracker-Name",
    Spanish: "Nombre del rastreador",
    Italian: "Nome del dispositivo",
    Polish: "Nazwa lokalizatora",
  },
  {
    FIELD1: "t('add_device.main.name_tooltip')",
    English:
      "This is a friendly name of your choice, to help you identify your tracker.",
    French:
      "Il s'agit d'un nom amical de votre choix, pour vous aider à identifier votre traceur.",
    German:
      "Dies ist ein freundlicher Name Ihrer Wahl, mit dem Sie Ihren Tracker identifizieren können.",
    Spanish:
      "Se trata de un nombre amigable de su elección, para ayudarle a identificar su rastreador.",
    Italian:
      "Si tratta di un nome amichevole scelto da te, per aiutarti a identificare il tuo dispositivo.",
    Polish:
      "To przyjazna nazwa wybrana przez Ciebie, pomagająca zidentyfikować lokalizator",
  },
  {
    FIELD1: "t('add_device.main.coverage_plan')",
    English: "Coverage Plan",
    French: "Forfait de couverture",
    German: "Abdeckungsplan",
    Spanish: "Plan de cobertura",
    Italian: "Piano di copertura",
    Polish: "Plan zasięgu",
  },
  {
    FIELD1: "t('add_device.main.option1')",
    English: "Enter a valid Tracker IMEI...",
    French: "Saisir un IMEI valide pour le traceur...",
    German: "Geben Sie eine gültige Tracker IMEI ein...",
    Spanish: "Introduzca un IMEI de rastreador válido...",
    Italian: "Inserire un IMEI valido per il dispositivo...",
    Polish: "Wprowadź poprawny numer IMEI lokalizatora...",
  },
  {
    FIELD1: "t('add_device.main.option2')",
    English: "Select a Coverage Plan",
    French: "Sélectionner un forfait de couverture",
    German: "Wählen Sie einen Abdeckungsplan aus...",
    Spanish: "Seleccione un plan de cobertura",
    Italian: "Seleziona un piano di copertura",
    Polish: "Wybierz plan zasięgu",
  },
  {
    FIELD1: "t('add_device.main.learn_more')",
    English: "Want to learn more about coverage zones?",
    French: "Vous voulez en savoir plus sur les zones de couverture ?",
    German: "Wollen Sie mehr über die Abdeckungszonen lernen?",
    Spanish: "¿Quieres saber más sobre las zonas de cobertura?",
    Italian: "Vuoi scoprire di più sulle zone di copertura?",
    Polish: "Chcesz dowiedzieć się więcej o strefach zasięgu?",
  },
  {
    FIELD1: "t('add_device.main.map')",
    English: "Map",
    French: "Carte",
    German: "Karte",
    Spanish: "Mapa",
    Italian: "Mappa",
    Polish: "Mapa",
  },
  {
    FIELD1: "t('add_device.main.countries')",
    English: "Countries",
    French: "Pays",
    German: "Länder",
    Spanish: "Países",
    Italian: "Paesi",
    Polish: "Kraje",
  },
  {
    FIELD1: "t('add_device.main.enter_imei')",
    English: "Enter a valid Tracker IMEI...",
    French: "Saisir un IMEI valide pour le traceur...",
    German: "Geben Sie eine gültige Tracker IMEI ein...",
    Spanish: "Introduzca un IMEI de rastreador válido...",
    Italian: "Inserisci un IMEI valido per il dispositivo...",
    Polish: "Wprowadź poprawny numer IMEI lokalizatora...",
  },
  {
    FIELD1: "t('add_device.main.select_plan')",
    English: "Select a Coverage Plan",
    French: "Sélectionner un forfait de couverture",
    German: "Wählen Sie einen Abdeckungsplan aus...",
    Spanish: "Seleccione un plan de cobertura",
    Italian: "Seleziona un piano di copertura",
    Polish: "Wybierz plan zasięgu",
  },
  {
    FIELD1: "t('add_device.plans.track1')",
    English: "/ Tracker / Month",
    French: "/ Traceur / Mois",
    German: "/ Tracker / Monat",
    Spanish: "/ Rastreador / Mes",
    Italian: "/localizzatore / Mese",
    Polish: "/ lokalizator / miesiąc",
  },
  {
    FIELD1: "t('add_device.plans.billed_monthly')",
    English: "automatically billed Monthly",
    French: "automatiquement facturé au mois",
    German: "automatisch monatlich abgerechnet",
    Spanish: "facturado automáticamente mensualmente",
    Italian: "fatturazione automatica mensile",
    Polish: "automatyczne rozliczenie miesięczne",
  },
  {
    FIELD1: "t('add_device.plans.billed_quarterly')",
    English: "automatically billed Quarterly",
    French: "automatiquement facturé trimestriellement",
    German: "automatisch vierteljährlich abgerechnet",
    Spanish: "facturado automáticamente trimestralmente",
    Italian: "fatturazione automatica trimestrale",
    Polish: "automatyczne rozliczenie kwartalne",
  },
  {
    FIELD1: "t('add_device.plans.billed_annually')",
    English: "automatically billed Annually",
    French: "automatiquement facturé annuellement",
    German: "automatisch jährlich abgerechnet",
    Spanish: "facturado automáticamente anualmente",
    Italian: "fatturazione automatica annuale",
    Polish: "automatyczne rozliczenie roczne",
  },
  {
    FIELD1: "t('add_device.plans.title')",
    English: "Billing Cycle",
    French: "Cycle de facturation",
    German: "Abrechnungszyklus",
    Spanish: "Ciclo de facturación",
    Italian: "Ciclo di fatturazione",
    Polish: "Cykl rozliczeniowy",
  },
  {
    FIELD1: "t('add_device.plans.monthly')",
    English: "1 Month",
    French: "1 Mois",
    German: "1 Monat",
    Spanish: "1 Mes",
    Italian: "1 mese",
    Polish: "1 miesiąc",
  },
  {
    FIELD1: "t('add_device.plans.charged_monthly')",
    English: "Automatically charged Monthly",
    French: "Prélèvement automatique mensuel",
    German: "Automatisch monatlich abgebucht",
    Spanish: "Facturación automática mensual",
    Italian: "Addebitato automaticamente ogni mese",
    Polish: "Automatyczne obciążenie co miesiąc",
  },
  {
    FIELD1: "t('add_device.plans.best_value')",
    English: "Best Value",
    French: "Meilleure offre",
    German: "Bester Wert",
    Spanish: "Mejor precio",
    Italian: "Miglior offerta",
    Polish: "Najlepsza oferta",
  },
  {
    FIELD1: "t('add_device.plans.best_value_quarterly')",
    English: " off",
    French: " de réduction",
    German: " Rabatt",
    Spanish: " de descuento",
    Italian: "Sconto del 5%",
    Polish: "zniżki",
  },
  {
    FIELD1: "t('add_device.plans.annually')",
    English: "1 Year",
    French: "1 An",
    German: "1 Jahr",
    Spanish: "1 Año",
    Italian: "1 anno",
    Polish: "1 rok",
  },
  {
    FIELD1: "t('add_device.plans.charged_annually')",
    English: "Automatically charged Annually",
    French: "Prélèvement automatique annuel",
    German: "wird jährlich abgebucht",
    Spanish: "Facturación automática anual",
    Italian: "Automaticamente addebitato mensilmente",
    Polish: "Automatyczne obciążenie co rok",
  },
  {
    FIELD1: "t('add_device.plans.quarterly')",
    English: "3 Months",
    French: "3 mois",
    German: "3 Monate",
    Spanish: "3 meses",
    Italian: "3 Mesi",
    Polish: "3 miesiące",
  },
  {
    FIELD1: "t('add_device.plans.charged_quarterly')",
    English: "Automatically charged every 3 Months",
    French: "Recharge automatique tous les 3 mois",
    German: "Wird automatisch alle 3 Monate geändert",
    Spanish: "Facturación automática cada 3 meses",
    Italian: "Automaticamente addebitato ogni 3 mesi",
    Polish: "Automatyczne obciążenie co 3 miesiące",
  },
  {
    FIELD1: "t('add_device.plans.trial')",
    English: "7 Day Free Trial",
    French: "7 jours d'essai gratuit",
    German: "7 Tage kostenlose Testversion",
    Spanish: "7 días de prueba gratuita",
    Italian: "7 giorni di prova gratuita",
    Polish: "7-dniowy darmowy okres próbny",
  },
  {
    FIELD1: "t('add_device.main.accept')",
    English: "I accept the",
    French: "J’accepte les",
    German: "Ich akzeptiere die ",
    Spanish: "Acepto los",
    Italian: "Accetto i",
    Polish: "Akceptuję",
  },
  {
    FIELD1: "t('add_device.main.tos')",
    English: "Terms of Service",
    French: "Conditions d'utilisation",
    German: "Nutzungsbestimmungen",
    Spanish: "Términos del Servicio",
    Italian: "Termini e Condizioni",
    Polish: "Warunki korzystania z usługi",
  },
  {
    FIELD1: "t('add_device.main.purchase')",
    English: "Purchase Subscription",
    French: "Acheter un abonnement",
    German: "Kaur von Abomment",
    Spanish: "Suscripción de compra",
    Italian: "Acquista abbonamento",
    Polish: "Zakup subskrypcji",
  },
  {
    FIELD1: "t('add_device.main.trial')",
    English: "One free trial per tracker available.",
    French: "Un essai gratuit par traceur disponible.",
    German: "Ein kostenloser Versuch pro Tracker erhältlich",
    Spanish: "Una prueba gratuita por rastreador disponible.",
    Italian: "È disponibile una prova gratuita per ogni dispositivo.",
    Polish: "Jeden darmowy okres próbny na lokalizator.",
  },
  {
    FIELD1: "t('add_device.main.monthly')",
    English: "Monthly",
    French: "Mensuel",
    German: "Monatlich",
    Spanish: "Mensual",
    Italian: "Mensilmente",
    Polish: "Miesięcznie",
  },
  {
    FIELD1: "t('add_device.main.quarterly')",
    English: "Quarterly",
    French: "Trimestriel",
    German: "Pro Quartal",
    Spanish: "Trimestral",
    Italian: "Trimestralmente",
    Polish: "Kwartalnie",
  },
  {
    FIELD1: "t('add_device.main.yearly')",
    English: "Yearly",
    French: "Annuel",
    German: "Jährlich",
    Spanish: "Anual",
    Italian: "Annuale",
    Polish: "Rocznie",
  },
  {
    FIELD1: "t('add_device.contract.imei_check')",
    English: "Please check every IMEI Number",
    French: "Veuillez vérifier chaque numéro IMEI",
    German: "Bitte überprüfen Sie jede IMEI Nummer",
    Spanish: "Verifique cada número IMEI",
    Italian: "Verifica ogni numero IMEI",
    Polish: "Sprawdź każdy numer IMEI",
  },
  {
    FIELD1: "t('add_device.contract.activating')",
    English: "Activating",
    French: "Activer",
    German: "Aktivierung",
    Spanish: "Activando",
    Italian: "Attivazione",
    Polish: "Aktywowanie",
  },
  {
    FIELD1: "t('add_device.contract.submit')",
    English: "Submit Activation",
    French: "Soumettre l'activation",
    German: "Aktivierung einreichen",
    Spanish: "Enviar activación",
    Italian: "Richiedi attivazione",
    Polish: "Prześlij aktywację",
  },
  {
    FIELD1: "t('add_device.contract.contracts')",
    English: "Contracts",
    French: "Contrats",
    German: "Verträge",
    Spanish: "Contratos",
    Italian: "Contratti",
    Polish: "Umowy",
  },
  {
    FIELD1: "t('add_device.contract.no_contract')",
    English: "No Contract - Individual Activation",
    French: "Sans contrat - Activation individuelle",
    German: "Kein Vertrag - Individuelle Aktivierung",
    Spanish: "Sin contrato - Activación individual",
    Italian: "Nessun contratto - Attivazione individuale",
    Polish: "Brak umowy — indywidualna aktywacja",
  },
  {
    FIELD1: "t('add_device.contract.tracker_list')",
    English: "Trackers",
    French: "Traceurs",
    German: "Verfolgung",
    Spanish: "Rastreadores",
    Italian: "Dispositivi",
    Polish: "Lokalizatory",
  },
  {
    FIELD1: "t('add_device.contract.name_tip')",
    English:
      "If you would like to use the IMEI as the name, you can leave the name field blank",
    French:
      "Si vous souhaitez utiliser l'IMEI comme nom, vous pouvez laisser le champ du nom vide.",
    German:
      "Falls Sie die IMEI als Name nutzen wollen, können Sie das Namenfeld leer lassen.",
    Spanish:
      "Si desea utilizar el IMEI como nombre, puede dejar el campo de nombre en blanco",
    Italian:
      "Se si desidera utilizzare l'IMEI come nome, è possibile lasciare vuoto il campo del nome.",
    Polish:
      "Jeśli chcesz użyć numeru IMEI jako nazwy, możesz pozostawić pole nazwy puste.",
  },
  {
    FIELD1: "t('add_device.contract.billing')",
    English: "Per Active Device, per Calendar Month",
    French: "Par appareil actif, par mois civil",
    German: "Pro aktives Gerät, pro Kalendermonat",
    Spanish: "Por dispositivo activo, por mes natural",
    Italian: "Per dispositivo attivo, per mese solare",
    Polish: "Za aktywne urządzenie, za miesiąc kalendarzowy",
  },
  {
    FIELD1: "t('add_device.contract.cycle')",
    English: "Invoiced Monthly",
    French: "Facturation mensuelle",
    German: "Montaliche Abrechnung",
    Spanish: "Facturación mensual",
    Italian: "Fatturato mensilmente",
    Polish: "Rozliczane miesięcznie",
  },
  {
    FIELD1: "t('add_device.billing_cycle.rage_click')",
    English:
      "If you are finished choosing your plan, please proceed to the next step by scrolling down to the 'Next Step' button.",
    French:
      "Si vous avez terminé de choisir votre forfait, veuillez passer à l'étape suivante en faisant défiler jusqu'au bouton 'Étape suivante'.",
    German:
      "Wenn Sie mit der Auswahl Ihres Plans fertig sind, fahren Sie bitte mit dem nächsten Schritt fort, indem Sie zum 'Nächster Schritt'-Button scrollen.",
    Spanish:
      "Si ha terminado de elegir su plan, continúe con el siguiente paso desplazándose hacia abajo hasta el botón 'Siguiente paso'.",
    Italian:
      "Se hai finito di scegliere il tuo piano, procedi al passaggio successivo scorrendo fino al pulsante 'Passaggio successivo'.",
    Polish:
      "Jeśli zakończyłeś(-aś) wybór planu, przejdź do następnego kroku, przewijając w dół do przycisku „Następny krok”.",
  },
  {
    FIELD1: "t('navigation.main.home')",
    English: "Home",
    French: "Page d'accueil",
    German: "Home",
    Spanish: "Inicio",
    Italian: "Home",
    Polish: "Strona główna",
  },
  {
    FIELD1: "t('navigation.main.shop')",
    English: "Shop",
    French: "Boutique",
    German: "Shop",
    Spanish: "Tienda",
    Italian: "Negozio",
    Polish: "Sklep",
  },
  {
    FIELD1: "t('navigation.main.shop_trackers')",
    English: "Shop Trackers",
    French: "Acheter traceurs",
    German: "Shop Tracker",
    Spanish: "Comprar rastreadores",
    Italian: "Acquista dispositivi",
    Polish: "Kup lokalizatory",
  },
  {
    FIELD1: "t('navigation.main.wired')",
    English: "Wired Vehicle Trackers",
    French: "Traceur de véhicule filaire",
    German: "Fahrzeug-Tracker mit Kabel",
    Spanish: "Seguimiento de vehículos cableados",
    Italian: "Localizzatore di veicoli cablato",
    Polish: "Przewodowe lokalizatory pojazdów",
  },
  {
    FIELD1: "t('navigation.main.asset')",
    English: "Asset Tracking",
    French: "Suivi des actifs",
    German: "Asset-Verfolgung",
    Spanish: "Seguimiento de activos",
    Italian: "Tracciamento delle attività",
    Polish: "Śledzenie zasobów",
  },
  {
    FIELD1: "t('navigation.main.wireless')",
    English: "Wireless Vehicle Trackers",
    French: "Traceur de véhicule sans fil",
    German: "Kabelloser Fahrzeug-Tracker",
    Spanish: "Rastreador de vehículos inalámbrico",
    Italian: "Tracker wireless per veicoli",
    Polish: "Bezprzewodowe lokalizatory pojazdów",
  },
  {
    FIELD1: "t('navigation.main.catalogue')",
    English: "Tracker Catalogue",
    French: "Catalogue des traceurs",
    German: "Tracker Katalog",
    Spanish: "Catálogo Tracker",
    Italian: "Catalogo del dispositivo",
    Polish: "Katalog lokalizatorów",
  },
  {
    FIELD1: "t('navigation.main.wired_mobile')",
    English: "Wired Vehicle Trackers",
    French: "Traceur de véhicule filaire",
    German: "Fahrzeug-Tracker mit Kabel",
    Spanish: "Seguimiento de vehículos cableados",
    Italian: "Localizzatore di veicoli cablato",
    Polish: "Przewodowe lokalizatory pojazdów",
  },
  {
    FIELD1: "t('navigation.main.wireless_mobile')",
    English: "Wireless Vehicle Trackers",
    French: "Traceur de véhicule sans fil",
    German: "Kabelloser Fahrzeug-Tracker",
    Spanish: "Rastreador de vehículos inalámbrico",
    Italian: "Tracker wireless per veicoli",
    Polish: "Bezprzewodowe lokalizatory pojazdów",
  },
  {
    FIELD1: "t('navigation.main.our_app')",
    English: "Our App",
    French: "Notre application",
    German: "Unsere App",
    Spanish: "Nuestra Aplicación",
    Italian: "La nostra app",
    Polish: "Nasza aplikacja",
  },
  {
    FIELD1: "t('navigation.main.plans')",
    English: "Plans",
    French: "Plans d'abonnement",
    German: "Pläne",
    Spanish: "Planes",
    Italian: "Piani",
    Polish: "Plany",
  },
  {
    FIELD1: "t('navigation.main.b2b')",
    English: "For Business",
    French: "Pour les entreprises",
    German: "Für Unternehmen",
    Spanish: "Para Empresas",
    Italian: "Per le aziende",
    Polish: "Dla biznesu",
  },
  {
    FIELD1: "t('navigation.main.support')",
    English: "Support",
    French: "Soutien",
    German: "Unterstützung",
    Spanish: "Soporte",
    Italian: "Supporto",
    Polish: "Wsparcie",
  },
  {
    FIELD1: "t('navigation.main.login')",
    English: "Login",
    French: "Connexion",
    German: "Anmelden",
    Spanish: "Iniciar sesión",
    Italian: "Login",
    Polish: "Logowanie",
  },
  {
    FIELD1: "t('navigation.main.register')",
    English: "Register",
    French: "S’enregistrer",
    German: "Registrieren",
    Spanish: "Registro",
    Italian: "Registrazione",
    Polish: "Rejestracja",
  },
  {
    FIELD1: "t('navigation.main.devices')",
    English: "My Trackers",
    French: "Mes traceurs",
    German: "Meine Tracker",
    Spanish: "Mis Seguidores",
    Italian: "I Miei Dispositivi",
    Polish: "Moje lokalizatory",
  },
  {
    FIELD1: "t('navigation.main.add_tracker')",
    English: "Activate Trackers",
    French: "Activer le traceur",
    German: "Tracker aktivieren",
    Spanish: "Activar rastreador",
    Italian: "Attiva il tracker",
    Polish: "Aktywuj lokalizatory",
  },
  {
    FIELD1: "t('navigation.main.account')",
    English: "Account",
    French: "Compte",
    German: "Konto",
    Spanish: "Cuenta",
    Italian: "Account",
    Polish: "Konto",
  },
  {
    FIELD1: "t('navigation.main.logout')",
    English: "Logout",
    French: "Déconnexion",
    German: "Abmelden",
    Spanish: "Cerrar sesión",
    Italian: "Esci",
    Polish: "Wyloguj",
  },
  {
    FIELD1: "t('navigation.main.tracking')",
    English: "Tracking",
    French: "Localisation",
    German: "Verfolgen",
    Spanish: "Seguimiento de",
    Italian: "Tracciamento",
    Polish: "Śledzenie",
  },
  {
    FIELD1: "t('navigation.main.live')",
    English: "Live View",
    French: "Visualisation en direct",
    German: "Live verfolgen",
    Spanish: "Vista en directo",
    Italian: "In diretta",
    Polish: "Widok na żywo",
  },
  {
    FIELD1: "t('navigation.main.history')",
    English: "History",
    French: "Historique",
    German: "Verlauf",
    Spanish: "Historial",
    Italian: "Cronologia",
    Polish: "Historia",
  },
  {
    FIELD1: "t('navigation.main.dashboard')",
    English: "Dashboard",
    French: "Tableau de bord",
    German: "Armaturenbrett",
    Spanish: "Panel",
    Italian: "Pannello di controllo",
    Polish: "Panel główny",
  },
  {
    FIELD1: "t('navigation.main.geofences')",
    English: "Geofences",
    French: "Géofences",
    German: "Geozäune",
    Spanish: "Geocercas",
    Italian: "Geofence",
    Polish: "Geostrefy",
  },
  {
    FIELD1: "t('navigation.main.manage')",
    English: "Manage",
    French: "Gérer",
    German: "Verwalten ",
    Spanish: "Gestionar",
    Italian: "Gestisci",
    Polish: "Zarządzaj",
  },
  {
    FIELD1: "t('my_devices.helmet.title')",
    English: "My SafeTag Trackers",
    French: "SafeTag Mes traceurs",
    German: "SafeTag Meine Tracker",
    Spanish: "SafeTag Mis rastreadores",
    Italian: "I miei dispositivi SafeTag",
    Polish: "Moje lokalizatory SafeTag",
  },
  {
    FIELD1: "t('my_devices.error.general')",
    English: "Something went wrong, please try again later.",
    French: "Un problème s'est produit, veuillez réessayer plus tard.",
    German:
      "Etwas ist schief gelaufen, bitte versuchen Sie es später noch einmal.",
    Spanish: "Algo salió mal, inténtelo de nuevo más tarde.",
    Italian: "Qualcosa è andato storto. Riprovare più tardi.",
    Polish: "Coś poszło nie tak, spróbuj ponownie później.",
  },
  {
    FIELD1: "t('my_devices.battery.unavailable')",
    English: "Unavailable",
    French: "Non disponible",
    German: "Nicht verfügbar",
    Spanish: "No disponible",
    Italian: "Non disponibile",
    Polish: "Niedostępne",
  },
  {
    FIELD1: "t('my_devices.battery.none')",
    English: "None (0%)",
    French: "Aucune (0%)",
    German: "Gar nicht (0%)",
    Spanish: "Ninguno (0%)",
    Italian: "Assente (0%)",
    Polish: "Brak (0%)",
  },
  {
    FIELD1: "t('my_devices.battery.ext_low')",
    English: "Extremely Low (1-15%)",
    French: "Extrêmement Faible (1-15%)",
    German: "Extrem niedrig (1-15%)",
    Spanish: "Extremadamente bajo (1-15%)",
    Italian: "Estremamente bassa (1-15%)",
    Polish: "Ekstremalnie niski (1–15%)",
  },
  {
    FIELD1: "t('my_devices.battery.very_low')",
    English: "Very Low (16-35%)",
    French: "Très Faible (16-35%)",
    German: "Sehr niedrig ( 16-35%)",
    Spanish: "Muy bajo (16-35%)",
    Italian: "Molto bassa (16-35%)",
    Polish: "Bardzo niski (16–35%)",
  },
  {
    FIELD1: "t('my_devices.battery.low')",
    English: "Low (36-50%)",
    French: "Faible (36-50%)",
    German: "Niedrig (36-50%)",
    Spanish: "Bajo (36-50%)",
    Italian: "Bassa (36-50%)",
    Polish: "Niski (36–50%)",
  },
  {
    FIELD1: "t('my_devices.battery.medium')",
    English: "Medium (51-65%)",
    French: "Moyenne (51-65%)",
    German: "Mittel (51-65%)",
    Spanish: "Medio (51-65%)",
    Italian: "Media (51-65%)",
    Polish: "Średni (51–65%)",
  },
  {
    FIELD1: "t('my_devices.battery.high')",
    English: "High (66-80%)",
    French: "Élevée (66-80%)",
    German: "Hoch (66-80%)",
    Spanish: "Alto (66-80%)",
    Italian: "Alta (66-80%)",
    Polish: "Wysoki (66–80%)",
  },
  {
    FIELD1: "t('my_devices.battery.very_high')",
    English: "Very High (81-100%)",
    French: "Très élevée (81-100%)",
    German: "Sehr hoch (81%-100%)",
    Spanish: "Muy Alto (81-100%)",
    Italian: "Molto Alta (81-100%)",
    Polish: "Bardzo wysoki (81–100%)",
  },
  {
    FIELD1: "t('my_devices.error.not_found')",
    English: "This Tracker ID could not be found.",
    French: "Ce numéro de traceur n'a pas pu être trouvé.",
    German: "Diese Tracker ID konnte nicht gefunden werden. ",
    Spanish: "No se pudo encontrar este ID de rastreador.",
    Italian: "Non è stato possibile trovare l'ID di questo dispositivo.",
    Polish: "Nie znaleziono tego identyfikatora lokalizatora.",
  },
  {
    FIELD1: "t('my_devices.error.cancellation')",
    English:
      "Your subscription cancellation was not successful, please contact support.",
    French:
      "L'annulation de votre abonnement n'a pas abouti, veuillez contacter le service support.",
    German:
      "Ihre Abooment Künidiguung war nicht erfolgreich, bitte kontaktieren Sie den Support.",
    Spanish:
      "La cancelación de su suscripción no se realizó correctamente, comuníquese con soporte.",
    Italian:
      "La cancellazione dell'abbonamento non è andata a buon fine, si prega di contattare l'assistenza.",
    Polish:
      "Anulowanie subskrypcji nie powiodło się. Skontaktuj się z pomocą techniczną.",
  },
  {
    FIELD1: "t('my_devices.main.title')",
    English: "My Trackers",
    French: "Mes traceurs",
    German: "Meine Tracker",
    Spanish: "Mis rastreadores",
    Italian: "I Miei Dispositivi",
    Polish: "Moje lokalizatory",
  },
  {
    FIELD1: "t('my_devices.main.subheading')",
    English: "Manage the trackers registered to your account",
    French: "Gérez les trackers enregistrés sur votre compte",
    German: "Verwalten Sie die in Ihrem Konto registrierten Tracker",
    Spanish: "Gestiona los rastreadores registrados en tu cuenta.",
    Italian: "Gestisci i tracker registrati sul tuo account",
    Polish: "Zarządzaj lokalizatorami przypisanymi do Twojego konta",
  },
  {
    FIELD1: "t('my_devices.main.no_trackers')",
    English:
      "It looks like you don’t have any trackers associated with your account. <br /> Please press “Activate Tracker” to get started.",
    French:
      "Il semble que vous n'ayez aucun traceur associé à votre compte. <br /> Veuillez appuyer sur “Activer le traceur” pour commencer.",
    German:
      "Es sieht so aus, als hättest du keine Tracker mit deinem Konto verbunden. <br /> Bitte drücke auf “Tracker aktivieren”, um loszulegen.",
    Spanish:
      "Parece que no tienes ningún rastreador asociado a tu cuenta. <br /> Por favor, presiona “Activar rastreador” para comenzar.",
    Italian:
      "Sembra che non ci siano dispositivi associati al tuo account. <br /> Premi “Attiva il tracker” per iniziare.",
    Polish:
      "Wygląda na to, że nie masz żadnych lokalizatorów powiązanych z kontem. <br /> Kliknij „Aktywuj lokalizator”, aby rozpocząć.",
  },
  {
    FIELD1: "t('my_devices.button.add')",
    English: "Activate Tracker",
    French: "Activer le traceur",
    German: "Tracker aktivieren",
    Spanish: "Activar rastreador",
    Italian: "Attiva il tracker",
    Polish: "Aktywuj lokalizator",
  },
  {
    FIELD1: "t('my_devices.button.email_support')",
    English: "Need help?",
    French: "Support par e-mail",
    German: "E-Mail Support",
    Spanish: "Soporte por correo electrónico",
    Italian: "Email Support",
    Polish: "Potrzebujesz pomocy?",
  },
  {
    FIELD1: "t('my_devices.desc.email_support')",
    English:
      "If you are having an issue with your tracker, please reach out to our dedicated support team, who will be happy to help you within 12 hours.",
    French:
      "Si vous rencontrez un problème avec votre traceur, veuillez joindre notre équpe d'assistance dédiée, qui se fera un plaisir de vous aider dans un délai de 12 heures.",
    German:
      "Falls du ein Problem mit deinem Tracker hast, kontaktier3 unser Team, es wird dir innerhalb von 12 Stunden antworten.",
    Spanish:
      "Si tiene algún problema con su rastreador, póngase en contacto con nuestro equipo de soporte, que estará encantado de ayudarle en un plazo de 12 horas.",
    Italian:
      "Se stai riscontrando un problema con il tuo dispositivo, contatta il nostro team di supporto dedicato, che sarà lieto di aiutarti entro 12 ore.",
    Polish:
      "Jeśli masz problem z lokalizatorem, skontaktuj się z naszym dedykowanym zespołem wsparcia — chętnie pomożemy w ciągu 12 godzin.",
  },
  {
    FIELD1: "t('my_devices.main.deactivated')",
    English: "Deactivated",
    French: "Désactivé",
    German: "Wurde deaktiviert.",
    Spanish: "Desactivado",
    Italian: "Disattivato",
    Polish: "Dezaktywowany",
  },
  {
    FIELD1: "t('my_devices.main.awaiting_calibration')",
    English: "Uncalibrated",
    French: "Non calibré",
    German: "Unkalibriert",
    Spanish: "Descalibrado",
    Italian: "Non calibrato",
    Polish: "Nieskalibrowany",
  },
  {
    FIELD1: "t('my_devices.main.unavailable')",
    English: "Unavailable",
    French: "Non disponible",
    German: "Nicht verfügbar",
    Spanish: "No disponible",
    Italian: "Non disponibile",
    Polish: "Niedostępny",
  },
  {
    FIELD1: "t('my_devices.subs.trial')",
    English: "Trialling",
    French: "Essai",
    German: "Erproben",
    Spanish: "Probando",
    Italian: "In prova",
    Polish: "W okresie próbnym",
  },
  {
    FIELD1: "t('my_devices.subs.active')",
    English: "Active",
    French: "Actif",
    German: "Aktiv",
    Spanish: "Activo",
    Italian: "Attivo",
    Polish: "Aktywny",
  },
  {
    FIELD1: "t('my_devices.subs.registered')",
    English: "Registered",
    French: "Enregistré",
    German: "Registiert",
    Spanish: "Registrado",
    Italian: "Registrato",
    Polish: "Zarejestrowany",
  },
  {
    FIELD1: "t('my_devices.subs.failed')",
    English: "Payment Failed",
    French: "Échec du paiement",
    German: "Die Zahlung ist fehlgeschlagen",
    Spanish: "Pago fallido",
    Italian: "Pagamento non riuscito",
    Polish: "Płatność nie powiodła się",
  },
  {
    FIELD1: "t('my_devices.subs.overdue')",
    English: "Overdue",
    French: "En retard",
    German: "Fällig",
    Spanish: "Atrasado",
    Italian: "In ritardo",
    Polish: "Zaległość w płatności",
  },
  {
    FIELD1: "t('my_devices.subs.incomplete')",
    English: "Incomplete Payment",
    French: "Paiement incomplet",
    German: "Nicht beendete Zahlung",
    Spanish: "Pago incompleto",
    Italian: "Pagamento incompleto",
    Polish: "Niekompletna płatność",
  },
  {
    FIELD1: "t('my_devices.subs.cancelled')",
    English: "Cancelled",
    French: "Annulé",
    German: "Gekündigt",
    Spanish: "Cancelado",
    Italian: "Cancellato",
    Polish: "Anulowano",
  },
  {
    FIELD1: "t('my_devices.update.dismiss')",
    English: "Don't alert me about late payments again.",
    French: "Ne m'alertez pas encore au sujet des derniers paiement",
    German: "Alarmieren Sie mich nicht mehr wegen verspäteter Zahlungen.",
    Spanish: "No me avisen sobre retrasos en los pagos otra vez.",
    Italian: "Non avvisatemi più dei ritardi nei pagamenti.",
    Polish: "Nie powiadamiaj mnie więcej o opóźnionych płatnościach.",
  },
  {
    FIELD1: "t('my_devices.button.cancel')",
    English: "Cancel",
    French: "Annuler",
    German: "Kündigen",
    Spanish: "Cancelar",
    Italian: "Cancella",
    Polish: "Anuluj",
  },
  {
    FIELD1: "t('my_devices.button.manage')",
    English: "Manage",
    French: "Gérer",
    German: "Verwalten ",
    Spanish: "Gestionar",
    Italian: "Gestisci",
    Polish: "Zarządzaj",
  },
  {
    FIELD1: "t('my_devices.button.complete')",
    English: "Complete",
    French: "Complet",
    German: "Vollständig",
    Spanish: "Completar",
    Italian: "Completa",
    Polish: "Zakończ",
  },
  {
    FIELD1: "t('my_devices.button.activate')",
    English: "Activate",
    French: "Activer",
    German: "Aktivieren",
    Spanish: "Activar",
    Italian: "Attiva",
    Polish: "Aktywuj",
  },
  {
    FIELD1: "t('my_devices.button.reactivate')",
    English: "Reactivate",
    French: "Réactiver",
    German: "Aktivieren",
    Spanish: "Reactivar",
    Italian: "Riattiva",
    Polish: "Aktywuj",
  },
  {
    FIELD1: "t('my_devices.button.saving')",
    English: "Saving...",
    French: "Sauvegarde...",
    German: "Speichern...",
    Spanish: "Guardando...",
    Italian: "Salvando...",
    Polish: "Zapisywanie…",
  },
  {
    FIELD1: "t('my_devices.button.save')",
    English: "Save",
    French: "Sauvegarder",
    German: "Speichern",
    Spanish: "Guardar",
    Italian: "Salva",
    Polish: "Zapisz",
  },
  {
    FIELD1: "t('my_devices.button.redirecting')",
    English: "Redirecting",
    French: "Redirection",
    German: "Umleitung",
    Spanish: "Redireccionando",
    Italian: "Reindirizzamento",
    Polish: "Przekierowywanie",
  },
  {
    FIELD1: "t('my_devices.button.manage_billing')",
    English: "Update Payment Method",
    French: "Gérer la facturation",
    German: "Rechnungen verwalten",
    Spanish: "Gestionar facturación",
    Italian: "Gestire la fatturazione",
    Polish: "Zaktualizuj metodę płatności",
  },
  {
    FIELD1: "t('my_devices.button.confirming')",
    English: "Confirming",
    French: "Confirmation",
    German: "Bestätigung",
    Spanish: "Confirmando",
    Italian: "In conferma",
    Polish: "Potwierdzanie",
  },
  {
    FIELD1: "t('my_devices.button.confirm')",
    English: "Confirm",
    French: "Confirmer",
    German: "bestätigen",
    Spanish: "Confirmar",
    Italian: "Conferma",
    Polish: "Potwierdź",
  },
  {
    FIELD1: "t('my_devices.popup.label_tracker')",
    English: "Enter Your Tracker's Name",
    French: "Saisir le nom de votre traceur",
    German: "Geben Sie den Namen ihres Trackers ein",
    Spanish: "Introduzca el nombre de su rastreador",
    Italian: "Inserisci il nome del dispositivo",
    Polish: "Wprowadź nazwę lokalizatora",
  },
  {
    FIELD1: "t('my_devices.popup.placeholder_tracker')",
    English: "Tracker Name",
    French: "Nom du traceur",
    German: "Trackername",
    Spanish: "Nombre del rastreador",
    Italian: "Nome del dispositivo",
    Polish: "Nazwa lokalizatora",
  },
  {
    FIELD1: "t('my_devices.popup.payments_failed')",
    English:
      "It looks like you have one or more failed subscription payments. Please update your payment method to continue using your trackers.",
    French:
      "Il semble qu'une ou plusieurs tentatives de paiement de votre abonnement aient échoué. Veuillez mettre à jour votre méthode de paiement pour continuer à utiliser votre/vos tracker(s).",
    German:
      "Es sieht so aus, als ob Sie eine oder mehrere fehlgeschlagene Abonnementzahlungen haben. Bitte aktualisieren Sie Ihre Zahlungsmethode, um Ihre (n) Tracker weiterhin zu verwenden.",
    Spanish:
      "Parece que ha fallado uno o más pagos de suscripción. Por favor, actualice su método de pago para continuar utilizando su(s) rastreador(es).",
    Italian:
      "Sembra che uno o più pagamenti dell'abbonamento non siano andati a buon fine. Aggiorna il metodo di pagamento per continuare a utilizzare i tracker.",
    Polish:
      "Wygląda na to, że masz jedną lub więcej nieudanych płatności subskrypcji. Zaktualizuj metodę płatności, aby nadal korzystać z lokalizatorów.",
  },
  {
    FIELD1: "t('my_devices.popup.remove_tracker')",
    English:
      "Would you like to remove this Tracker? This will cancel the associated subscription and remove all related data from your account.",
    French:
      "Souhaitez-vous supprimer ce traceur ? Cela annulera l'abonnement associé et supprimera toutes les données correspondantes de votre base de données.",
    German:
      "Möchten Sie diesen Tracker entfernen? Dadurch wird das zugehörige Abonnement gekündigt und alle zugehörigen Daten aus Ihrem",
    Spanish:
      "¿Desea eliminar este rastreador? Esto cancelará la suscripción asociada y eliminará todos los datos relacionados de su\n             ",
    Italian:
      "Desideri rimuovere questo Dispositivo? In questo modo si annullerà l'abbonamento associato e si rimuoveranno tutti i dati relativi dal tuo",
    Polish:
      "Czy chcesz usunąć ten lokalizator? Spowoduje to anulowanie subskrypcji i usunięcie wszystkich powiązanych danych z konta.",
  },
  {
    FIELD1: "t('my_devices.popup.cancel_subs')",
    English:
      "Would you like to cancel your subscription plan? This will suspend all tracker tracking capabilities and remove all associated data from your account.",
    French:
      "Souhaitez-vous annuler votre abonnement ? Cela suspendra toutes les capacités de localisation des traceurs et supprimera toutes les données associées de votre compte.",
    German:
      "Möchten Sie Ihr Abonnement kündigen? Dadurch werden alle Tracking-Funktionen ausgesetzt und alle zugehörigen Daten aus Ihrem Konto entfernt.",
    Spanish:
      "¿Desea cancelar su plan de suscripción? Esto suspenderá todas las funciones de seguimiento y eliminará todos los datos asociados de su cuenta.",
    Italian:
      "Desideri annullare il tuo abbonamento? Questo sospenderà tutte le funzionalità di tracciamento del dispositivo e rimuoverà tutti i dati associati dal tuo account.",
    Polish:
      "Czy chcesz anulować plan subskrypcji? Spowoduje to zawieszenie wszystkich funkcji śledzenia i usunięcie powiązanych danych z konta.",
  },
  {
    FIELD1: "t('my_devices.button.next')",
    English: "Next Bill",
  French: "Facture suiv.",
  German: "Nächste Rechnung",
  Spanish: "Próx. factura",
  Italian: "Fattura succ.",
  Polish: "Nast. faktura"
  },
  {
    FIELD1: "t('my_devices.button.cancel_at')",
    English: "Cancels on",
  French: "Fin le",
  German: "Endet am",
  Spanish: "Cancela el",
  Italian: "Annulla il",
  Polish: "Kończy się"
},
  {
    FIELD1: "t('my_devices.button.close')",
    English: "Close",
    French: "Fermer",
    German: "Schließen",
    Spanish: "Cerrar",
    Italian: "Chiudi",
    Polish: "Zamknij",
  },
  {
    FIELD1: "t('my_devices.submodal.success')",
    English: "Success",
    French: "Succès",
    German: "Erfolg",
    Spanish: "Éxito",
    Italian: "Fatto",
    Polish: "Sukces",
  },
  {
    FIELD1: "t('my_devices.submodal.plan')",
    English: "Plan",
    French: "Plan d'abonnement",
    German: "Tarif",
    Spanish: "Plan de cobertura",
    Italian: "Piano",
    Polish: "Plan",
  },
  {
    FIELD1: "t('my_devices.submodal.coverage_zones')",
    English: "Update Coverage Zone",
    French: "Mettre à jour la zone de couverture",
    German: "Abdeckungszone aktualisieren",
    Spanish: "Actualizar zona de cobertura",
    Italian: "Aggiorna la zona di copertura",
    Polish: "Zaktualizuj strefę zasięgu",
  },
  {
    FIELD1: "t('my_devices.submodal.billing_cycle')",
    English: "Update Billing Cycle",
    French: "Mise à jour du cycle de facturation",
    German: "Zahlungszyklen aktualisieren",
    Spanish: "Intervalo de facturación",
    Italian: "Aggiorna il ciclo di fatturazione",
    Polish: "Zaktualizuj cykl rozliczeniowy",
  },
  {
    FIELD1: "t('my_devices.submodal.new_price')",
    English: "New Price",
    French: "Nouveau prix",
    German: "Der neue Preis",
    Spanish: "Nuevo precio",
    Italian: "Prezzo nuovo",
    Polish: "Nowa cena",
  },
  {
    FIELD1: "t('my_devices.submodal.new_price_desc')",
    English:
      "When you are next billed, any remaining time on your current subscription term will be subtracted.",
    French:
      "Lors de la prochaine facturation, la durée restante de l'abonnement en cours sera déduite.",
    German:
      "Bei der nächsten Abrechnung wird die verbleibende Zeit Ihrer aktuellen Abonnementlaufzeit abgezogen.",
    Spanish:
      "La próxima vez que se le facture, se le restará el tiempo restante del periodo de suscripción actual.",
    Italian:
      "Al momento della prossima fatturazione, verrà sottratto il tempo residuo del periodo di abbonamento in corso.",
    Polish:
      "Przy następnym rozliczeniu pozostały czas bieżącego okresu subskrypcji zostanie odjęty.",
  },
  {
    FIELD1: "t('my_devices.submodal.update_plan')",
    English: "Update Plan",
    French: "Mise à jour du plan d'abonnement",
    German: "Den plan aktualisieren",
    Spanish: "Actualizar plan",
    Italian: "Aggiorna il tuo abbonamento",
    Polish: "Zaktualizuj plan",
  },
  {
    FIELD1: "t('my_devices.submodal.subscription_error')",
    English:
      "Sorry, we encountered an error while retrieving your subscription details. Please contact support, who will be glad to help.",
    French:
      "Désolé, nous avons rencontré une erreur lors de la récupération des détails de votre abonnement. Veuillez contacter l’assistance, qui se fera un plaisir de vous aider.",
    German:
      "Beim Abrufen Ihrer Abonnementdetails ist leider ein Fehler aufgetreten. Bitte wenden Sie sich an den Support, der Ihnen gerne weiterhilft.",
    Spanish:
      "Lo sentimos, hemos encontrado un error al recuperar los detalles de su suscripción. Póngase en contacto con el servicio de asistencia, que estará encantado de ayudarle.",
    Italian:
      "Siamo spiacenti, si è verificato un errore durante il recupero dei dati dell'abbonamento. Sei pregato di contattare l'assistenza, che sarà lieta di aiutarti.",
    Polish:
      "Przepraszamy, wystąpił błąd podczas pobierania szczegółów subskrypcji. Skontaktuj się z pomocą techniczną.",
  },
  {
    FIELD1: "t('my_devices.submodal.legacy_pricing_title')",
    English: "You're on long-time member pricing",
    French: "Vous bénéficiez d'un tarif membre fidèle",
    German: "Sie profitieren von Treuepreisen für langjährige Mitglieder",
    Spanish: "Tienes precios de miembro de larga data",
    Italian: "Hai la tariffa riservata ai membri di lunga data",
    Polish: "Masz cenę dla wieloletnich klientów",
  },
  {
    FIELD1: "t('my_devices.submodal.legacy_pricing_text')",
    English:
      "As one of our earliest members, you've locked in a rate that's no longer available to new subscribers. Keep your subscription active and unchanged, and that pricing stays yours. Thanks for being with us from the start!",
    French:
      "En tant que l'un de nos premiers membres, vous avez obtenu un tarif qui n'est plus proposé aux nouveaux abonnés. Gardez votre abonnement actif et inchangé, et ce tarif reste le vôtre. Merci d'être avec nous depuis le début.",
    German:
      "Als eines unserer ersten Mitglieder haben Sie sich einen Preis gesichert, der für neue Abonnenten nicht mehr verfügbar ist. Solange Ihr Abonnement aktiv und unverändert bleibt, behalten Sie diesen Preis. Danke, dass Sie von Anfang an dabei sind.",
    Spanish:
      "Como uno de nuestros primeros miembros, has asegurado una tarifa que ya no está disponible para nuevos suscriptores. Mantén tu suscripción activa y sin cambios, y conservarás ese precio. ¡Gracias por estar con nosotros desde el principio!",
    Italian:
      "Come uno dei nostri primi membri, hai bloccato una tariffa non più disponibile per i nuovi abbonati. Mantieni il tuo abbonamento attivo e invariato e quella tariffa resterà tua. Grazie per essere con noi fin dall'inizio!",
    Polish:
      "Jako jeden z naszych pierwszych klientów masz zablokowaną cenę, która nie jest już dostępna dla nowych subskrybentów. Utrzymaj subskrypcję aktywną i bez zmian, a ta cena pozostanie Twoja. Dziękujemy, że jesteś z nami od początku!",
  },
  {
    FIELD1: "t('my_devices.submodal.submit_error')",
    English:
      "Sorry, we encountered an error while updating your subscription details. Please contact support, who will be glad to help.",
    French:
      "Désolé, nous avons rencontré une erreur lors de la mise à jour des détails de votre abonnement. Veuillez contacter l’assistance, qui se fera un plaisir de vous aider.",
    German:
      "Beim Aktualisieren Ihrer Abonnementdetails ist leider ein Fehler aufgetreten. Bitte wenden Sie sich an den Support, der Ihnen gerne weiterhilft.",
    Spanish:
      "Lo sentimos, hemos encontrado un error al actualizar sus datos de suscripción. Póngase en contacto con el servicio de asistencia, que estará encantado de ayudarle.",
    Italian:
      "Spiacenti, si è verificato un errore durante l'aggiornamento dei dati dell'abbonamento. Sei pregato di contattare l'assistenza, che sarà lieta di aiutarti.",
    Polish:
      "Przepraszamy, wystąpił błąd podczas aktualizacji subskrypcji. Skontaktuj się z pomocą techniczną.",
  },
  {
    FIELD1: "t('my_devices.submodal.billed_monthly')",
    English: "Billed Monthly",
    French: "Facturation mensuelle",
    German: "Monatliche Rechnung",
    Spanish: "Facturación mensual",
    Italian: "Fatturato mensilmente",
    Polish: "Rozliczane miesięcznie",
  },
  {
    FIELD1: "t('my_devices.submodal.billed_3_months')",
    English: "Billed Every 3 Months",
    French: "Facturation tous les 3 mois",
    German: "Alle 3 Monate",
    Spanish: "Facturación trimestral",
    Italian: "Fatturato ogni 3 mesi",
    Polish: "Rozliczane co 3 miesiące",
  },
  {
    FIELD1: "t('my_devices.submodal.billed_yearly')",
    English: "Billed Yearly",
    French: "Facturation annuelle",
    German: "Jährliche Rechnung",
    Spanish: "Facturación anual",
    Italian: "Fatturato annualmente",
    Polish: "Rozliczane rocznie",
  },
  {
    FIELD1: "t('my_devices.submodal.updating')",
    English: "Updating",
    French: "Mise à jour",
    German: "Aktualisieren",
    Spanish: "Actualizando",
    Italian: "Aggiornamento",
    Polish: "Aktualizowanie",
  },
  {
    FIELD1: "t('my_devices.submodal.downgrade_warning')",
    English:
      "If you would like to downgrade your plan, please cancel it at the end of the cycle and reactivate on your desired plan.",
    French:
      "Si vous souhaitez rétrograder votre plan, veuillez l'annuler à la fin du cycle et le réactiver sur le plan souhaité.",
    German:
      "Wenn Sie Ihren Plan downgraden möchten, kündigen Sie ihn bitte am Ende des Zyklus und reaktivieren Sie ihn auf dem gewünschten Plan.",
    Spanish:
      "Si desea degradar su plan, cancele al final del ciclo y reactive en el plan deseado.",
    Italian:
      "Se desideri eseguire il downgrade del tuo piano, annullalo alla fine del ciclo e riattivalo sul piano desiderato.",
    Polish:
      "Jeśli chcesz obniżyć plan, anuluj go na koniec cyklu i ponownie aktywuj wybrany plan.",
  },
  {
    FIELD1: "t('my_devices.cancel_reason.title')",
    English: "Please select a cancellation reason",
    French: "Veuillez sélectionner un motif d'annulation",
    German: "Bitte wählen Sie einen Stornierungsgrund",
    Spanish: "Seleccione un motivo de cancelación",
    Italian: "Sei pregato di specificare un motivo di cancellazione",
    Polish: "Wybierz powód anulowania",
  },
  {
    FIELD1: "t('my_devices.cancel_reason.too_expensive')",
    English: "It’s too expensive",
    French: "C'est trop cher",
    German: "Es ist zu teuer",
    Spanish: "Es demasiado caro",
    Italian: "È troppo costoso",
    Polish: "Jest za drogie",
  },
  {
    FIELD1: "t('my_devices.cancel_reason.missing_features')",
    English: "Some features are missing",
    French: "Certaines fonctionnalités sont manquantes",
    German: "Es fehlen einige Funktionen",
    Spanish: "Faltan algunas funciones",
    Italian: "Mancano alcune funzioni",
    Polish: "Brakuje funkcji",
  },
  {
    FIELD1: "t('my_devices.cancel_reason.switched_service')",
    English: "I’m switching to a different service",
    French: "Je change de service",
    German: "Ich wechsle zu einem anderen Dienst",
    Spanish: "Cambiaré de proveedor de servicio.",
    Italian: "Sto passando a un altro servizio",
    Polish: "Zmieniam usługę",
  },
  {
    FIELD1: "t('my_devices.cancel_reason.unused')",
    English: "I don’t use the service enough",
    French: "Je n'utilise pas suffisamment le service",
    German: "Ich nutze den Service nicht genug",
    Spanish: "No utilizo el servicio lo suficiente",
    Italian: "Non uso il servizio a sufficienza",
    Polish: "Nie korzystam wystarczająco",
  },
  {
    FIELD1: "t('my_devices.cancel_reason.customer_service')",
    English: "Customer service was less than expected",
    French: "Le service clientèle n'a pas été à la hauteur des attentes",
    German: "Der Kundenservice war weniger als erwartet",
    Spanish: "El nivel de atención al cliente es inferior al esperado",
    Italian: "Il servizio clienti ha deluso le mie aspettative",
    Polish: "Obsługa klienta była poniżej oczekiwań",
  },
  {
    FIELD1: "t('my_devices.cancel_reason.too_complex')",
    English: "Ease of use was less than expected",
    French: "La facilité d'utilisation n'a pas été à la hauteur des attentes",
    German: "Die Benutzerfreundlichkeit war geringer als erwartet",
    Spanish: "La facilidad de uso es inferior a la esperado",
    Italian: "Mi aspettavo che il servizio fosse più facile da adoperare",
    Polish: "Obsługa była trudna",
  },
  {
    FIELD1: "t('my_devices.cancel_reason.low_quality')",
    English: "Quality was less than expected",
    French: "La qualité a été inférieure aux attentes",
    German: "Die Qualität war schlechter als erwartet",
    Spanish: "La calidad es inferior a la esperada",
    Italian: "Il servizio, in generale, era di bassa qualità",
    Polish: "Jakość była poniżej oczekiwań",
  },
  {
    FIELD1: "t('my_devices.cancel_reason.other')",
    English: "Other Reason",
    French: "Autre raison",
    German: "Anderer Grund",
    Spanish: "Otras razones",
    Italian: "Altre ragioni",
    Polish: "Inny powód",
  },
  {
    FIELD1: "t('welcome.main.title')",
    English: "Welcome to SafeTag! Please confirm your country and language:",
    French:
      "Bienvenue à SafeTag ! Veuillez confirmer votre pays et votre langue ",
    German:
      "Willkommen bei SafeTag! Bitte bestätigen Sie Ihr Land und Ihre Sprache:",
    Spanish: "Bienvenido a SafeTag Por favor, confirme su país e idioma:",
    Italian: "Benvenuto su SafeTag! Conferma il paese e la lingua:",
    Polish: "Witamy w SafeTag! Potwierdź swój kraj i język:",
  },
  {
    FIELD1: "t('welcome.main.country')",
    English: "Country:",
    French: "Pays:",
    German: "Land:",
    Spanish: "País:",
    Italian: "Paese:",
    Polish: "Kraj:",
  },
  {
    FIELD1: "t('welcome.main.language')",
    English: "Language:",
    French: "Langue:",
    German: "Sprache:",
    Spanish: "Idioma:",
    Italian: "Lingua:",
    Polish: "Język:",
  },
  {
    FIELD1: "t('welcome.main.button')",
    English: "OK!",
    French: "OK!",
    German: "OK!",
    Spanish: "¡OK!",
    Italian: "Ok!",
    Polish: "OK!",
  },
  {
    FIELD1: "t('localization.languages.en')",
    English: "English",
    French: "Anglais",
    German: "Englisch",
    Spanish: "Inglés",
    Italian: "Inglese",
    Polish: "Angielski",
  },
  {
    FIELD1: "t('localization.languages.fr')",
    English: "French",
    French: "Français",
    German: "Französisch",
    Spanish: "Francés",
    Italian: "Francese",
    Polish: "Francuski",
  },
  {
    FIELD1: "t('localization.languages.de')",
    English: "German",
    French: "Allemand",
    German: "Deutsch",
    Spanish: "Alemán",
    Italian: "Tedesco",
    Polish: "Niemiecki",
  },
  {
    FIELD1: "t('localization.languages.es')",
    English: "Spanish",
    French: "Espagnol",
    German: "Spanisch",
    Spanish: "Español",
    Italian: "Spagnolo",
    Polish: "Hiszpański",
  },
  {
    FIELD1: "t('localization.languages.it')",
    English: "Italian",
    French: "Italien",
    German: "Italienisch",
    Spanish: "Italiano",
    Italian: "Italiano",
    Polish: "Włoski",
  },
  {
    FIELD1: "t('localization.languages.pl')",
    English: "Polish",
    French: "Polonais",
    German: "Polnisch",
    Spanish: "Polaco",
    Italian: "Polacco",
    Polish: "Polski",
  },
  {
    FIELD1: "t('notifications.permission.denied')",
    English: "The notification permission is required. Turn on notifications.",
    French:
      "L'autorisation pour les notifications est nécessaire. Activez les notifications.",
    German:
      "Eine Benachrichtigungserlaubnis wird benötigt. Nachrichten anschalten.",
    Spanish:
      "El permiso de notificación es necesario. Active las notificaciones.",
    Italian:
      "L'autorizzazione alle notifiche è necessaria. Attiva le notifiche.",
    Polish: "Wymagane jest pozwolenie na powiadomienia. Włącz powiadomienia.",
  },
  {
    FIELD1: "t('notifications.permission.denied2')",
    English:
      "Notification setup failed. Please grant the notification permission. (See the FAQs for guidance)",
    French:
      "Réglage des notifications échoué. Veuillez autoriser les notifications. (Consultez la FAQ pour être guidé)",
    German:
      "Die Nachrichteneinstellung hat nicht funktioniert. Bitte genehmigen die Benachrichtigungserlaubnis.( Siehe die FAGs als Anleitung)",
    Spanish:
      "Error en la configuración de las notificaciones. Por favor, otorgue el permiso de notificaciones. (Consulte las preguntas frecuentes para más información)",
    Italian:
      "Impostazione delle notifiche non riuscita. Concedi l'autorizzazione alle notifiche. (Consulta le FAQ per indicazioni)",
    Polish:
      "Konfiguracja powiadomień nie powiodła się. Przyznaj uprawnienia do powiadomień. (Sprawdź FAQ, aby uzyskać pomoc)",
  },
  {
    FIELD1: "t('notifications.enable.success')",
    English: "Successfully registered for notifications",
    French: "Inscription aux notifications réussie",
    German: "Nachrichten wurden erfolgreich registriert",
    Spanish: "Registro de notificaciones exitoso",
    Italian: "Registrazione alle notifiche completata con successo",
    Polish: "Pomyślnie zarejestrowano do powiadomień",
  },
  {
    FIELD1: "t('notifications.enable.demo')",
    English: "This button enables desktop alerts",
    French: "Ce bouton permet d'activer les alertes de bureau",
    German: "Diese Schaltfläche aktiviert Desktop-Benachrichtigungen",
    Spanish: "Este botón activa las alertas de escritorio",
    Italian: "Questo tasto abilita le notifiche sul desktop",
    Polish: "Ten przycisk włącza alerty na pulpicie",
  },
  {
    FIELD1: "t('notifications.enable.failure')",
    English: "Notification registration failed, please contact support.",
    French:
      "Insctiption aux notifications échouée. Veuillez contacter l'assistance.",
    German:
      "Die Anmeldung der Benachrichtungen ist fehlgeschlagen, bitte kontaktiere den Suport.",
    Spanish:
      "El registro de notificaciones ha fallado, por favor póngase en contacto con soporte.",
    Italian:
      "Registrazione delle notifiche non riuscita, contatta l'assistenza.",
    Polish:
      "Rejestracja powiadomień nie powiodła się. Skontaktuj się z pomocą techniczną.",
  },
  {
    FIELD1: "t('notifications.disable.success')",
    English: "Successfully disabled notifications",
    French: "Désactivation des notifications réussie",
    German: "Die Benachrichtigungen wurden erfolgreich deaktiviert",
    Spanish: "Notificaciones desactivadas exitosamente",
    Italian: "Notifiche disattivate con successo",
    Polish: "Pomyślnie wyłączono powiadomienia",
  },
  {
    FIELD1: "t('notifications.disable.failure')",
    English: "Notification deregistration failed, please contact support.",
    French:
      "Désactivation des notifications échouée. Veuillez contacter l'assistance.",
    German:
      "Die Deaktivierung der Nachrichten hat nicht funktioniert, bitte kontaktiere den Support.",
    Spanish:
      "No se ha podido dar de baja la notificación, póngase en contacto con soporte.",
    Italian:
      "Disattivazione delle notifiche non riuscita, contatta l'assistenza.",
    Polish:
      "Wyrejestrowanie powiadomień nie powiodło się. Skontaktuj się z pomocą techniczną.",
  },
  {
    FIELD1: "t('notifications.permission.denied')",
    English: "The notification permission is required. Turn on notifications.",
    French:
      "L'autorisation de notification est nécessaire. Activez les notifications",
    German:
      "Die Benachrichtigungsberechtigung ist erforderlich. Schalten Sie Benachrichtigungen ein.",
    Spanish:
      "Es necesario el permiso de notificaciones. Active las notificaciones.",
    Italian:
      "L'autorizzazione di notifica è obbligatoria. Attivare le notifiche.",
    Polish: "Wymagane jest pozwolenie na powiadomienia. Włącz powiadomienia.",
  },
  {
    FIELD1: "t('notifications.enable.success')",
    English: "Successfully registered for notifications",
    French: "Enregistrement des notifications réussie",
    German: "Erfolgreich für Benachrichtigungen registriert",
    Spanish: "Registro de notificaciones correcto",
    Italian: "Registrazione alle notifiche completata con successo",
    Polish: "Pomyślnie zarejestrowano do powiadomień",
  },
  {
    FIELD1: "t('notifications.enable.failure')",
    English: "Notification registration failed, please contact support.",
    French:
      "Enregistrement des notifications échouée, veuillez contacter le service d'assistance.",
    German:
      "Registrierung der Benachrichtigung fehlgeschlagen, bitte kontaktieren Sie den Support.",
    Spanish:
      "Falló el registro de notificaciones, póngase en contacto con el servicio de asistencia.",
    Italian:
      "Registrazione delle notifiche non riuscita, contatta l'assistenza.",
    Polish:
      "Rejestracja powiadomień nie powiodła się. Skontaktuj się z pomocą techniczną.",
  },
  {
    FIELD1: "t('notifications.disable.success')",
    English: "Successfully disabled notifications",
    French: "Désactivation des notifications réussie",
    German: "Benachrichtigungen erfolgreich deaktiviert",
    Spanish: "Notificaciones desactivadas correctamente",
    Italian: "Notifiche disattivate con successo",
    Polish: "Pomyślnie wyłączono powiadomienia",
  },
  {
    FIELD1: "t('notifications.disable.failure')",
    English: "Notification deregistration failed, please contact support.",
    French:
      "Désactivation des notifications échouée, veuillez contacter le service d'assistance.",
    German:
      "Die Deregistrierung der Benachrichtigung ist fehlgeschlagen, bitte kontaktieren Sie den Support.",
    Spanish:
      "No se ha podido dar de baja la notificación, póngase en contacto con el servicio de asistencia.",
    Italian:
      "Disattivazione delle notifiche non riuscita, contatta l'assistenza.",
    Polish:
      "Wyrejestrowanie powiadomień nie powiodło się. Skontaktuj się z pomocą techniczną.",
  },
  {
    FIELD1: "t('notifications.permission.denied2')",
    English:
      "Notification setup failed. Please grant the notification permission. (See the FAQs for guidance)",
    French:
      "Configuration des notifications échouée. Veuillez accorder l'autorisation des notifications. (Consultez la FAQ pour être guidé)",
    German:
      "Einrichtung der Benachrichtigung fehlgeschlagen. Bitte erteilen Sie die Berechtigung zur Benachrichtigung. (Siehe die FAQs für eine Anleitung)",
    Spanish:
      "Error en la configuración de las notificaciones. Por favor, conceda el permiso de notificación. (Consulte las preguntas frecuentes)",
    Italian:
      "Impostazione delle notifiche non riuscita. Concedi l'autorizzazione alle notifiche. (Consulta le FAQ per indicazioni)",
    Polish:
      "Konfiguracja powiadomień nie powiodła się. Przyznaj uprawnienia do powiadomień. (Sprawdź FAQ, aby uzyskać pomoc)",
  },
  {
    FIELD1: "t('footer.shop.title1')",
    English: "Shop SafeTag",
    French: "Acheter sur SafeTag",
    German: "SafeTag einkaufen",
    Spanish: "Comprar SafeTag",
    Italian: "Negozio SafeTag",
    Polish: "Sklep SafeTag",
  },
  {
    FIELD1: "t('about.helmet.title')",
    English: "About SafeTag",
    French: "À propos de SafeTag",
    German: "Über SafeTag",
    Spanish: "Acerca de SafeTag",
    Italian: "Informazioni su SafeTag",
    Polish: "O SafeTag",
  },
  {
    FIELD1: "t('about.main.title')",
    English: "About Us",
    French: "À propos de nous",
    German: "Über uns",
    Spanish: "Quiénes somos",
    Italian: "Chi siamo",
    Polish: "O nas",
  },
  {
    FIELD1: "t('about.main.desc')",
    English: "We believe no-compromise security and service",
    French: "Nous croyons en une sécurité et un service sans compromis",
    German: "Wir glauben an kompromisslose Sicherheit und Service",
    Spanish: "Creemos en la seguridad y el servicio sin concesiones",
    Italian: "Crediamo in un servizio di qualità senza compromessi",
    Polish: "Wierzymy w bezkompromisowe bezpieczeństwo i obsługę",
  },
  {
    FIELD1: "t('about.testimonial.title')",
    English: "Great Product",
    French: "Excellent produit",
    German: "Großartiges Produkt",
    Spanish: "Gran producto",
    Italian: "Buon prodotto",
    Polish: "Świetny produkt",
  },
  {
    FIELD1: "t('about.testimonial.desc')",
    English:
      "After a neighbour had his car stolen, I decided to investigate GPS trackers. SafeTag impressed me by the comments about Customer Service, and the plug seemed the most satisfactory. I was amazed at the price, not just the initial purchase cost, but at the yearly license cost. Easy to install doesn't really do it justice. Clear instructions meant I had it running in no time, and tracked the short journey I needed to make to activate the product. I did have to contact support to enquire about changing from monthly to annual subscription, and had a reply within a couple of hours. Very helpful and chatty. My car shows clearly on the map, and I can see where my wife has parked for her shopping. I find this product amazing, and have no hesitation in recommending it.",
    French:
      "Après le vol de la voiture d'un voisin, j'ai décidé de me renseigner sur les traceurs GPS. SafeTag m'a impressionné par les commentaires sur le service clientèle, et la fiche semblait la plus satisfaisante. J'ai été surpris par le prix, non seulement le coût d'achat initial, mais aussi le coût de la licence annuelle. La facilité d'installation ne rend pas vraiment justice à ce produit. Des instructions claires m'ont permis de le faire fonctionner en un rien de temps et de suivre le court trajet que j'ai dû faire pour activer le produit. J'ai dû contacter le support pour demander à passer d'un abonnement mensuel à un abonnement annuel, et j'ai eu une réponse dans les deux heures qui ont suivi. Ils sont très serviables. Ma voiture apparaît clairement sur la carte et je peux voir où ma femme s'est garée pour faire ses courses. Je trouve ce produit extraordinaire et je n'hésite pas à le recommander.",
    German:
      "Nachdem einem Nachbarn sein Auto gestohlen worden war, beschloss ich, mich über GPS-Tracker zu informieren. SafeTag beeindruckte mich durch die Kommentare zum Kundenservice, und der Stecker schien mir am zufriedenstellendsten. Ich war über den Preis erstaunt, nicht nur über die Anschaffungskosten, sondern auch über die Kosten für die Jahreslizenz. Einfach zu installieren, wird dem Ganzen nicht wirklich gerecht. Dank der klaren Anweisungen konnte ich es im Handumdrehen installieren und den kurzen Weg zur Aktivierung des Produkts verfolgen. Ich musste mich an den Support wenden, um mich über den Wechsel vom Monats- zum Jahresabonnement zu erkundigen, und hatte innerhalb weniger Stunden eine Antwort. Sehr hilfreich und gesprächig. Mein Auto wird deutlich auf der Karte angezeigt, und ich kann sehen, wo meine Frau für ihre Einkäufe geparkt hat. Ich finde dieses Produkt großartig und kann es ohne zu zögern weiterempfehlen.",
    Spanish:
      "Después de que a un vecino le robaran el coche, decidí indagar sobre los rastreadores GPS. SafeTag me impresionó por los comentarios sobre el servicio de atención al cliente, y el enchufe me pareció el más satisfactorio. Me sorprendió el precio, no sólo el costo inicial de compra, sino el costo anual de la licencia. Decir que es fácil de instalar, realmente sería poco. Gracias a unas instrucciones claras, lo tuve funcionando en un instante, y seguí el corto trayecto que tuve que hacer para activar el producto. Tuve que ponerme en contacto con el servicio de asistencia para preguntar sobre el cambio de la suscripción mensual a la anual, y recibí una respuesta en un par de horas. Fueron muy serviciales y amables. Mi coche aparece claramente en el mapa y puedo ver dónde ha dejado el coche mi esposa para hacer la compra. Este producto me parece increíble y no dudo en recomendarlo.",
    Italian:
      "Dopo il furto dell'auto di un vicino, ho deciso di cercare un localizzatore GPS. Quando ho scoperto SafeTag, sono subito rimasto colpito dalle recensioni positive e l'efficienza del suo servizio clienti. Un altro elemento che mi ha colpito è stato, senza dubbio, il prezzo: non solo per l'acquisto iniziale, ma anche per il costo della licenza annuale. Il GPS in sé è semplicissimo da installare: le istruzioni che SafeTag ti fornisce ti permettono di farlo funzionare in pochissimo tempo e di percorrere il breve percorso per attivare il dispositivo. Quando ho sentito il bisogno di contattare l'assistenza clienti per chiedere informazioni sul passaggio dall'abbonamento mensile a quello annuale, ho ricevuto una risposta nel giro di un paio d'ore. L'operatore che mi ha risposto è stato gentile ed efficiente. Grazie a SafeTag, la mia auto viene visualizzata chiaramente sulla mappa e posso vedere dove mia moglie ha parcheggiato per fare la spesa. Trovo questo prodotto fantastico e non esito a consigliarlo.",
    Polish:
      "Po tym, jak sąsiadowi skradziono samochód, zdecydowałem się sprawdzić lokalizatory GPS. SafeTag zrobił na mnie wrażenie komentarzami o obsłudze klienta, a urządzenie wydawało się najbardziej satysfakcjonujące. Byłem zaskoczony ceną – nie tylko kosztem zakupu, ale też roczną opłatą licencyjną. Instalacja była bardzo prosta. Jasne instrukcje sprawiły, że uruchomiłem go w krótkim czasie i mogłem śledzić krótką trasę potrzebną do aktywacji produktu. Musiałem skontaktować się z pomocą techniczną w sprawie zmiany subskrypcji z miesięcznej na roczną i dostałem odpowiedź w ciągu kilku godzin – bardzo pomocną i przyjazną. Mój samochód jest wyraźnie widoczny na mapie i mogę sprawdzić, gdzie moja żona zaparkowała na zakupach. Uważam ten produkt za niesamowity i bez wahania go polecam.",
  },
  {
    FIELD1: "t('about.section1.title')",
    English: "What is our mission?",
    French: "Quelle est notre mission ?",
    German: "Was ist unser Auftrag?",
    Spanish: "¿Cuál es nuestra misión?",
    Italian: "Qual è il nostro scopo?",
    Polish: "Jaka jest nasza misja?",
  },
  {
    FIELD1: "t('about.section1.desc1')",
    English:
      "Using our combined experience across Embedded Systems, Cloud Computing and IoT technology, we founded SafeTag Tracking in early 2022 to offer an alternative to the prohibitive pricing and disappointing customer service offered by our competitors.",
    French:
      "En utilisant notre expérience combinée à travers les systèmes embarqués, l'informatique en nuage et la technologie IoT, nous avons fondé SafeTag Tracking au début de 2022 pour offrir une alternative aux prix prohibitifs et au service client décevant offerts par nos concurrents.",
    German:
      "Mit unserer kombinierten Erfahrung in den Bereichen Embedded Systems, Cloud-Computing und IoT-Technologie haben wir SafeTag Tracking Anfang 2022 gegründet, um eine Alternative zu den überhöhten Preisen und dem enttäuschenden Kundenservice unserer Konkurrenten zu bieten.",
    Spanish:
      "Combinando nuestra experiencia en sistemas integrados, computación en la nube y tecnología IoT, fundamos SafeTag Tracking a principios de 2022 para ofrecer una alternativa a los precios prohibitivos y el decepcionante servicio de atención al cliente que ofrecen nuestros competidores.",
    Italian:
      "Grazie alla nostra esperienza combinata nei sistemi embedded, nel cloud computing e nella tecnologia IoT, abbiamo fondato SafeTag Tracking all'inizio del 2022 per offrire un'alternativa ai prezzi proibitivi e al deludente servizio clienti offerto dai nostri concorrenti.",
    Polish:
      "Wykorzystując nasze doświadczenie w systemach wbudowanych, chmurze i technologii IoT, założyliśmy SafeTag Tracking na początku 2022 roku, aby zaoferować alternatywę dla wysokich cen i słabej obsługi klienta konkurencji.",
  },
  {
    FIELD1: "t('about.section1.desc2')",
    English:
      "We believe that every consumer and business should be able to secure and monitor their assets, with enterprise-grade features and SLAs, at a reasonable price, and now help over 10,000 customers achieve this.",
    French:
      "Nous pensons que chaque consommateur et chaque entreprise devrait être en mesure de sécuriser et de surveiller ses actifs, avec des fonctionnalités et des accords de niveau de service de qualité professionnelle, à un prix raisonnable, et nous aidons aujourd'hui plus de 10 000 clients à atteindre cet objectif.",
    German:
      "Wir sind der Meinung, dass jeder Verbraucher und jedes Unternehmen in der Lage sein sollte, seine Anlagen mit Funktionen und SLAs auf Unternehmensniveau zu einem vernünftigen Preis zu sichern und zu überwachen, und helfen inzwischen über 10.000 Kunden, dies zu erreichen.",
    Spanish:
      "Creemos que todos los consumidores y empresas deberían poder proteger y supervisar sus activos, con funciones y SLA de nivel empresarial, a un precio razonable, y actualmente ayudamos a más de 10 000 clientes a conseguirlo.",
    Italian:
      "Crediamo che ogni consumatore e azienda debba essere in grado di proteggere e monitorare i propri veicoli e possedimenti. Grazie a SafeTag, questo è adesso possibile: con funzionalità e SLA di livello enterprise, a un prezzo ragionevole, aiutiamo oltre 10.000 clienti a raggiungere questo obiettivo.",
    Polish:
      "Wierzymy, że każdy konsument i firma powinny mieć możliwość zabezpieczania i monitorowania swoich zasobów z funkcjami klasy enterprise i SLA w rozsądnej cenie — obecnie pomagamy ponad 10 000 klientów.",
  },
  {
    FIELD1: "t('about.section2.title')",
    English: "What makes us different?",
    French: "Qu'est-ce qui nous distingue ?",
    German: "Was macht uns anders?",
    Spanish: "¿Qué nos diferencia?",
    Italian: "Cosa ci differenzia?",
    Polish: "Co nas wyróżnia?",
  },
  {
    FIELD1: "t('about.section2.desc1')",
    English:
      "We always strive to put ourselves in the shoes of our customers, and provide the level of service and support that we would demand ourselves.",
    French:
      "Nous nous efforçons toujours de nous mettre à la place de nos clients et de leur fournir le niveau de service et d'assistance que nous exigerions nous-mêmes.",
    German:
      "Wir sind stets bestrebt, uns in die Lage unserer Kunden zu versetzen und ihnen das Maß an Service und Unterstützung zu bieten, das wir auch selbst verlangen würden.",
    Spanish:
      "Nos esforzamos siempre por ponernos en el lugar de nuestros clientes y ofrecerles el nivel de servicio y asistencia que nosotros mismos exigiríamos.",
    Italian:
      "Ci mettiamo sempre nei panni dei nostri clienti e cerchiamo di fornire il livello di servizio e assistenza che noi stessi pretenderemmo.",
    Polish:
      "Zawsze staramy się patrzeć oczami klienta i dostarczać poziom obsługi, jakiego sami byśmy oczekiwali.",
  },
  {
    FIELD1: "t('about.section2.desc2')",
    English:
      "We will always make sure that the decisions we make as a business put you first, and that we will maintain the best practises in our support and technical teams so you have the best and most consistent experience.",
    French:
      "Nous veillerons toujours à ce que les décisions que nous prenons en tant qu'entreprise vous placent au premier plan, et nous maintiendrons les meilleures pratiques au sein de nos équipes techniques et d'assistance afin que vous puissiez bénéficier de la meilleure expérience la meilleure possible.",
    German:
      "Wir werden immer darauf achten, dass Sie bei unseren Entscheidungen als Unternehmen an erster Stelle stehen und dass wir die besten Praktiken in unseren Support- und Technikteams beibehalten, damit Sie die besten und beständigsten Erfahrungen machen können.",
    Spanish:
      "Nos aseguramos siempre de que las decisiones que tomamos como empresa lo pongan a usted en primer lugar, y de que mantengamos las mejores prácticas en nuestros equipos técnicos y de asistencia para que usted tenga la mejor y más consistente experiencia.",
    Italian:
      "Tutte le decisioni che prendiamo come azienda mettono al primo posto il cliente. Inoltre, ci assicuriamo sempre di mantere alto il livello della nostra assistenza clienti per risolvere problemi tecnici, qualora si presentino, in modo che i clienti abbiano un'esperienza ottima.",
    Polish:
      "Dbamy, aby decyzje biznesowe stawiały klienta na pierwszym miejscu oraz utrzymywały najlepsze praktyki w obsłudze i technologii, aby zapewnić najlepsze doświadczenie.",
  },
  {
    FIELD1: "t('geofences.main.title')",
    English: "Your Geofences",
    French: "Vos géofences",
    German: "Ihre Geofences",
    Spanish: "Sus geocercas",
    Italian: "Le tue geofence",
    Polish: "Twoje geostrefy",
  },
  {
    FIELD1: "t('geofences.main.description')",
    English: "Edit and create your geofences",
    French: "Modifiez et créez vos géofences",
    German: "Bearbeiten und erstellen Sie Ihre Geofences",
    Spanish: "Edite y cree sus geocercas",
    Italian: "Modifica e crea geofence",
    Polish: "Edytuj i twórz geostrefy",
  },
  {
    FIELD1: "t('geofences.button.new')",
    English: "New Geofence",
    French: "Nouvelle géofence",
    German: "Neuer Geofence",
    Spanish: "Nueva geocerca",
    Italian: "Nuova geofence",
    Polish: "Nowa geostrefa",
  },
  {
    FIELD1: "t('geofences.button.delete_selected')",
    English: "Delete Selected Geofences",
    French: "Supprimer les géofences sélectionnées",
    German: "Ausgewählte Geofences löschen",
    Spanish: "Eliminar las geocercas seleccionadas",
    Italian: "Eliminare le geofence selezionate",
    Polish: "Usuń wybrane geostrefy",
  },
  {
    FIELD1: "t('geofences.main.no_geofence')",
    English: "There are no geofences in your account",
    French: "Il n'y a pas de géofences dans votre compte",
    German: "Es gibt keine Geofences in Ihrem Konto",
    Spanish: "No hay geocercas en su cuenta",
    Italian: "Non ci sono geofence nel tuo account",
    Polish: "Brak geostref na koncie",
  },
  {
    FIELD1: "t('geofences.main.maximum')",
    English: "Maximum of 10 Geofences Reached",
    French: "Maximum de 10 géofences atteint",
    German: "Maximum von 10 Geofences erreicht",
    Spanish: "Máximo de 10 geocercas alcanzadas",
    Italian: "Raggiunto un massimo di 10 Geofence",
    Polish: "Maksymalnie 10 geostref osiągnięte",
  },
  {
    FIELD1: "t('geofences.menu.select')",
    English: "Select",
    French: "Sélectionner",
    German: "Wählen",
    Spanish: "Seleccionar",
    Italian: "Seleziona",
    Polish: "Wybierz",
  },
  {
    FIELD1: "t('geofences.menu.delete_all')",
    English: "Delete All",
    French: "Supprimer tout",
    German: "Alle löschen",
    Spanish: "Borrar todo",
    Italian: "Elimina tutto",
    Polish: "Usuń wszystko",
  },
  {
    FIELD1: "t('geofences.delete.message_all')",
    English: "Permanently delete all Geofences",
    French: "Supprimer définitivement toutes les géofences",
    German: "Dauerhaftes Löschen aller Geofences",
    Spanish: "Eliminar permanentemente todas las geocercas",
    Italian: "Elimina definitivamente tutte le geofence",
    Polish: "Trwale usuń wszystkie geostrefy",
  },
  {
    FIELD1: "t('geofences.delete.message_selected')",
    English: "Permanently delete selected Geofences",
    French: "Supprimer définitivement les géofences sélectionnées",
    German: "Dauerhaftes Löschen ausgewählter Geofences",
    Spanish: "Eliminar permanentemente las geocercas seleccionadas",
    Italian: "Elimina definitivamente le geofence selezionate",
    Polish: "Trwale usuń wybrane geostrefy",
  },
  {
    FIELD1: "t('geofences.delete.message_one')",
    English: "Permanently delete",
    French: "Supprimer définitivement",
    German: "Dauerhaft löschen",
    Spanish: "Eliminar permanentemente",
    Italian: "Elimina definitivamente",
    Polish: "Trwale usuń",
  },
  {
    FIELD1: "t('geofences.button.delete')",
    English: "Delete",
    French: "Supprimer",
    German: "Löschen",
    Spanish: "Borrar",
    Italian: "Elimina",
    Polish: "Usuń",
  },
  {
    FIELD1: "t('geofences.button.delete_1')",
    English: "Delete Geofence",
    French: "Supprimer une géofence",
    German: "Geofence löschen",
    Spanish: "Eliminar geocerca",
    Italian: "Elimina geofence",
    Polish: "Usuń geostrefę",
  },
  {
    FIELD1: "t('geofences.button.deleting')",
    English: "Deleting",
    French: "Suppression",
    German: "Löschen",
    Spanish: "Borrando",
    Italian: "Eliminando",
    Polish: "Usuwanie",
  },
  {
    FIELD1: "t('geofences.button.cancel')",
    English: "Cancel",
    French: "Annuler",
    German: "Abbrechen",
    Spanish: "Cancelar",
    Italian: "Cancella",
    Polish: "Anuluj",
  },
  {
    FIELD1: "t('geofences.label.name')",
    English: "Name",
    French: "Nom",
    German: "Name",
    Spanish: "Nombre",
    Italian: "Nome",
    Polish: "Nazwa",
  },
  {
    FIELD1: "t('geofences.label.diameter_km')",
    English: "Geofence size (KM)",
    French: "Taille de la géofence (KM)",
    German: "Größe des Geofence (KM)",
    Spanish: "Tamaño de la geo-cerca (KM)",
    Italian: "Dimensione del geofence (KM)",
    Polish: "Rozmiar geostrefy (KM)",
  },
  {
    FIELD1: "t('geofences.label.diameter_m')",
    English: "Geofence size (Miles)",
    French: "Taille de la géofence (miles)",
    German: "Größe des Geofence (Meilen)",
    Spanish: "Tamaño de la geo-cerca (Millas)",
    Italian: "Dimensione del geofence (miglia)",
    Polish: "Rozmiar geostrefy (mile)",
  },
  {
    FIELD1: "t('geofences.label.color')",
    English: "Select a color",
    French: "Sélectionner une couleur",
    German: "Wählen Sie eine Farbe",
    Spanish: "Seleccione un color",
    Italian: "Seleziona un colore",
    Polish: "Wybierz kolor",
  },
  {
    FIELD1: "t('geofences.label.lat')",
    English: "Latitude",
    French: "Latitude",
    German: "Breitengrad",
    Spanish: "Latitud",
    Italian: "Latitudine",
    Polish: "Szerokość geograficzna",
  },
  {
    FIELD1: "t('geofences.label.lng')",
    English: "Longitude",
    French: "Longitude",
    German: "Länge",
    Spanish: "Longitud",
    Italian: "Longitudine",
    Polish: "Długość geograficzna",
  },
  {
    FIELD1: "t('geofences.validation.name_required')",
    English: "Name is Required",
    French: "Le nom est obligatoire",
    German: "Name ist erforderlich",
    Spanish: "Se requiere el nombre",
    Italian: "Il nome è obbligatorio",
    Polish: "Imię jest wymagane",
  },
  {
    FIELD1: "t('geofences.validation.name_max')",
    English: "Name must be 20 characters or less",
    French: "Le nom ne doit pas comporter plus de 20 caractères",
    German: "Der Name darf höchstens 20 Zeichen lang sein",
    Spanish: "El nombre debe tener 20 caracteres o menos",
    Italian: "Il nome deve essere di massimo 20 caratteri",
    Polish: "Imię musi mieć maksymalnie 20 znaków",
  },
  {
    FIELD1: "t('geofences.validation.diameter_required')",
    English: "Diameter is Required",
    French: "Le diamètre est obligatoire",
    German: "Durchmesser ist erforderlich",
    Spanish: "El diámetro es requerido",
    Italian: "Il diametro è necessario",
    Polish: "Wymagana jest średnica",
  },
  {
    FIELD1: "t('geofences.validation.diameter_min_km')",
    English: "Geofences can’t be less than 0 km",
    French: "Les géofences ne peuvent être inférieures à 0 km",
    German: "Geofences können nicht kleiner als 0 KM sein",
    Spanish: "Las geocercas no pueden ser inferiores a 0 km",
    Italian: "Le geofence non possono essere inferiori a 0 km",
    Polish: "Geostrefy nie mogą być mniejsze niż 0 km",
  },
  {
    FIELD1: "t('geofences.validation.diameter_min_m')",
    English: "Geofences can’t be less than 0 Miles",
    French: "Les géofences ne peuvent pas être inférieures à 0 mile",
    German: "Geofences können nicht kleiner als 0 Miles sein",
    Spanish: "Las geocercas no pueden ser inferiores a 0 Millas",
    Italian: "Le geofence non possono essere inferiori a 0 Miglia",
    Polish: "Geostrefy nie mogą być mniejsze niż 0 mil",
  },
  {
    FIELD1: "t('geofences.validation.diameter_max_km')",
    English: "Geofences can’t be greater than 300 km",
    French: "Les géofences ne peuvent pas être supérieures à 300 km",
    German: "Geofences können nicht größer als 300 KM sein",
    Spanish: "Las geocercas no pueden ser mayores de 300 km",
    Italian: "Le geofence non possono superare i 300 km.",
    Polish: "Geostrefy nie mogą być większe niż 300 km",
  },
  {
    FIELD1: "t('geofences.validation.diameter_max_m')",
    English: "Geofences can’t be greater than 186 Miles",
    French: "Les géofences ne peuvent pas être supérieures à 186 miles.",
    German: "Geofences können nicht größer als 186 Meilen sein",
    Spanish: "Las geocercas no pueden ser mayores de 186 millas",
    Italian: "Le geofence non possono superare le 186 miglia.",
    Polish: "Geostrefy nie mogą być większe niż 186 mil",
  },
  {
    FIELD1: "t('geofences.validation.diameter_number')",
    English: "Please enter a geofence distance greater than 0.2",
    French: "Veuillez saisir une distance de géofence supérieure à 0,2",
    German: "Bitte geben Sie einen Geofence-Abstand von mehr als 0,2 ein.",
    Spanish: "Introduzca una distancia de geocerca superior a 0,2",
    Italian: "Immettere una distanza di geofence maggiore di 0,2",
    Polish: "Wprowadź odległość geostrefy większą niż 0.2",
  },
  {
    FIELD1: "t('geofences.placeholder.name')",
    English: "Geofence 1",
    French: "Géofence 1",
    German: "Geozone 1",
    Spanish: "Geocerca 1",
    Italian: "Geofence 1",
    Polish: "Geostrefa 1",
  },
  {
    FIELD1: "t('geofences.placeholder.diameter_km')",
    English: "1 km",
    French: "1 km",
    German: "1 km",
    Spanish: "1 km",
    Italian: "1 km",
    Polish: "1 km",
  },
  {
    FIELD1: "t('geofences.placeholder.diameter_m')",
    English: "1 Mile",
    French: "1 Mile",
    German: "1 Meile",
    Spanish: "1 milla",
    Italian: "1 Miglio",
    Polish: "1 mila",
  },
  {
    FIELD1: "t('geofences.button.save')",
    English: "Save Changes",
    French: "Enregistrer les modifications",
    German: "Änderungen speichern",
    Spanish: "Guardar cambios",
    Italian: "Salva le modifiche",
    Polish: "Zapisz zmiany",
  },
  {
    FIELD1: "t('geofences.button.saving')",
    English: "Saving",
    French: "Enregistrement",
    German: "Sparen",
    Spanish: "Guardar",
    Italian: "Salvando",
    Polish: "Zapisywanie",
  },
  {
    FIELD1: "t('geofences.modal.edit')",
    English: "Edit",
    French: "Éditer",
    German: "Bearbeiten",
    Spanish: "Editar",
    Italian: "Modifica",
    Polish: "Edytuj",
  },
  {
    FIELD1: "t('geofences.modal.last_update')",
    English: "Last update",
    French: "Dernière mise à jour",
    German: "Letzte Aktualisierung",
    Spanish: "Última actualización",
    Italian: "Ultimo aggiornamento",
    Polish: "Ostatnia aktualizacja",
  },
  {
    FIELD1: "t('forget_password.main.code_required')",
    English: "Confirmation Code is Required",
    French: "Le code de confirmation est requis",
    German: "Bestätigungscode ist erforderlich",
    Spanish: "Se requiere código de confirmación",
    Italian: "Il codice di conferma è obbligatorio",
    Polish: "Kod potwierdzający jest wymagany",
  },
  {
    FIELD1: "t('forget_password.main.password_required')",
    English: "Password is Required",
    French: "Le mot de passe est requis",
    German: "Passwort ist erforderlich",
    Spanish: "Se requiere contraseña",
    Italian: "La password è obbligatoria",
    Polish: "Wymagane jest hasło",
  },
  {
    FIELD1: "t('forget_password.main.error_password_complexity')",
    English: "Combine upper and lowercase letters and numbers.",
    French:
      "Combinez des lettres majuscules et minuscules ainsi que des chiffres.",
    German: "Kombinieren Sie Groß- und Kleinbuchstaben sowie Zahlen.",
    Spanish: "Combina letras mayúsculas y minúsculas y números.",
    Italian: "Combina lettere maiuscole e minuscole e numeri.",
    Polish: "Połącz wielkie i małe litery oraz cyfry",
  },
  {
    FIELD1: "t('forget_password.main.error_resend_code')",
    English: "Verification Code Resent",
    French: "Code de vérification renvoyé",
    German: "Bestätigungscode erneut gesendet",
    Spanish: "Código de verificación reenviado",
    Italian: "Codice di verifica rinviato",
    Polish:
      "Nie udało się ponownie wysłać kodu, spróbuj później, a następnie skontaktuj się z pomocą techniczną.",
  },
  {
    FIELD1: "t('forget_password.main.error_resend_code')",
    English:
      "Couldn't resend the code, please try again later, then contact support.",
    French:
      "Impossible de renvoyer le code, veuillez réessayer ultérieurement, puis contacter le support.",
    German:
      "Der Code konnte nicht erneut gesendet werden. Bitte versuchen Sie es später erneut und wenden Sie sich dann an den Support.",
    Spanish:
      "No se pudo reenviar el código, por favor inténtelo de nuevo más tarde, luego contacte al soporte.",
    Italian:
      "Impossibile inviare nuovamente il codice, riprova più tardi, quindi contatta il supporto.",
    Polish:
      "Nie udało się ponownie wysłać kodu, spróbuj później, a następnie skontaktuj się z pomocą techniczną.",
  },
  {
    FIELD1: "t('add_device.main.step1_title')",
    English: "Tracker Details",
    French: "Détails du Tracker",
    German: "Tracker-Details",
    Spanish: "Detalles del rastreador",
    Italian: "Dettagli del tracker",
    Polish: "Szczegóły lokalizatora",
  },
  {
    FIELD1: "t('add_device.main.step1_desc')",
    English: "Enter your Tracker IMEI and give it a friendly name",
    French: "Entrez votre IMEI de Tracker et donnez-lui un nom convivial",
    German:
      "Geben Sie Ihre Tracker IMEI ein und geben Sie ihm einen freundlichen Namen",
    Spanish: "Ingrese su IMEI de rastreador y asígnele un nombre amigable",
    Italian:
      "Inserisci il tuo IMEI del tracker e assegnagli un nome amichevole",
    Polish: "Wprowadź IMEI lokalizatora i nadaj mu przyjazną nazwę",
  },
  {
    FIELD1: "t('add_device.main.step2_title')",
    English: "Choose your plan",
    French: "Choisissez votre plan",
    German: "Wählen Sie Ihren Tarif",
    Spanish: "Elige tu plan",
    Italian: "Scegli il tuo piano",
    Polish: "Wybierz plan",
  },
  {
    FIELD1: "t('add_device.main.step2_desc')",
    English: "Select a coverage zone, and a billing frequency",
    French:
      "Sélectionnez une zone de couverture et une fréquence de facturation",
    German: "Wählen Sie eine Abdeckungszone und eine Abrechnungsfrequenz aus",
    Spanish: "Seleccione una zona de cobertura y una frecuencia de facturación",
    Italian: "Seleziona una zona di copertura e una frequenza di fatturazione",
    Polish: "Wybierz strefę zasięgu i częstotliwość rozliczeń",
  },
  {
    FIELD1: "t('add_device.main.step3_title')",
    English: "Confirm your choices",
    French: "Confirmez vos choix",
    German: "Bestätigen Sie Ihre Auswahl",
    Spanish: "Confirma tus elecciones",
    Italian: "Conferma le tue scelte",
    Polish: "Potwierdź wybór",
  },
  {
    FIELD1: "t('add_device.main.step3_desc')",
    English: "Please check your tracker IMEI name, and billing plan choices",
    French:
      "Veuillez vérifier le nom de votre IMEI de tracker et les choix de plan de facturation",
    German:
      "Bitte überprüfen Sie den Namen Ihres Tracker IMEI und die Auswahl des Abrechnungsplans",
    Spanish:
      "Por favor, verifique el nombre de su IMEI de rastreador y las opciones del plan de facturación",
    Italian:
      "Si prega di verificare il nome del tuo IMEI del tracker e le scelte del piano di fatturazione",
    Polish: "Sprawdź IMEI, nazwę i plan rozliczeń",
  },
  {
    FIELD1: "t('add_device.button.step_prev')",
    English: "Previous Step",
    French: "Étape précédente",
    German: "Vorheriger Schritt",
    Spanish: "Paso anterior",
    Italian: "Passo precedente",
    Polish: "Poprzedni krok",
  },
  {
    FIELD1: "t('add_device.button.step_next')",
    English: "Next Step",
    French: "Étape suivante",
    German: "Nächster Schritt",
    Spanish: "Siguiente paso",
    Italian: "Passo successivo",
    Polish: "Następny krok",
  },
  {
    FIELD1: "t('add_device.main.refresh_label')",
    English: "Refresh Tier",
    French: "Niveau de rafraîchissement",
    German: "Aktualisierungsstufe",
    Spanish: "Nivel de actualización",
    Italian: "Livello di aggiornamento",
    Polish: "Odświeżanie poziomu",
  },
  {
    FIELD1: "t('add_device.main.refresh_desc')",
    English: "This is how often your tracker will update its location.",
    French:
      "C'est la fréquence à laquelle votre tracker mettra à jour sa position.",
    German: "So oft wird Ihr Tracker seinen Standort aktualisieren.",
    Spanish:
      "Esta es la frecuencia con la que su rastreador actualizará su ubicación.",
    Italian:
      "Questo è quanto spesso il tuo tracker aggiornerà la sua posizione.",
    Polish: "Jak często lokalizator będzie aktualizował swoją lokalizację.",
  },
  {
    FIELD1: "t('add_device.main.step3_imei')",
    English: "Tracker IMEI",
    French: "IMEI du tracker",
    German: "Tracker IMEI",
    Spanish: "IMEI del rastreador",
    Italian: "IMEI del tracker",
    Polish: "IMEI lokalizatora",
  },
  {
    FIELD1: "t('add_device.main.step3_name')",
    English: "Tracker Name",
    French: "Nom du tracker",
    German: "Tracker-Name",
    Spanish: "Nombre del rastreador",
    Italian: "Nome del tracker",
    Polish: "Nazwa lokalizatora",
  },
  {
    FIELD1: "t('add_device.main.step3_zone')",
    English: "Coverage Zone",
    French: "Zone de couverture",
    German: "Abdeckungszone",
    Spanish: "Zona de cobertura",
    Italian: "Zona di copertura",
    Polish: "Strefa zasięgu",
  },
  {
    FIELD1: "t('add_device.main.step3_plan')",
    English: "Billing Plan",
    French: "Plan de facturation",
    German: "Abrechnungsplan",
    Spanish: "Plan de facturación",
    Italian: "Piano di fatturazione",
    Polish: "Plan rozliczeniowy",
  },
  {
    FIELD1: "t('add_device.main.accept_terms_1')",
    English: "By clicking the “Purchase Subscription” button, ",
    French: "En cliquant sur le bouton “Acheter l'abonnement”, ",
    German: "Durch Klicken auf die Schaltfläche „Abonnement kaufen“, ",
    Spanish: "Al hacer clic en el botón “Comprar suscripción”, ",
    Italian: "Cliccando sul pulsante “Acquista abbonamento”, ",
    Polish: "Klikając przycisk „Kup subskrypcję”,",
  },
  {
    FIELD1: "t('add_device.main.accept_terms_2')",
    English: "I agree to the Terms of Service",
    French: "J'accepte les conditions d'utilisation",
    German: "Ich stimme den Nutzungsbedingungen zu",
    Spanish: "Acepto los Términos de Servicio",
    Italian: "Accetto i Termini di Servizio",
    Polish: "akceptuję Warunki korzystania z usługi",
  },
  {
    FIELD1: "t('add_device.option.refresh_rate')",
    English: "Second Refresh Rate",
    French: "Second Taux de rafraîchissement",
    German: "Sekunde Aktualisierungsrate",
    Spanish: "Segundo nivel de actualización",
    Italian: "Aggiornamento in pochi secondi",
    Polish: "Druga częstotliwość odświeżania",
  },
  {
    FIELD1: "t('add_device.main.step3_refresh')",
    English: "Refresh Tier",
    French: "Niveau de rafraîchissement",
    German: "Stufe aktualisieren",
    Spanish: "Nivel de actualización",
    Italian: "Aggiorna il livello",
    Polish: "Poziom odświeżania",
  },
  {
    FIELD1: "t('add_device.main.step3_billed_every')",
    English: "billed every",
    French: "facturés toutles les",
    German: "wird alle ",
    Spanish: "facturado cada",
    Italian: "fatturati ogni",
    Polish: "rozliczane co",
  },
  {
    FIELD1: "t('add_device.main.step2_standard')",
    English: "Standard",
    French: "Standard",
    German: "Standard",
    Spanish: "Estándar",
    Italian: "Standard",
    Polish: "Standard",
  },
  {
    FIELD1: "t('add_device.main.step2_pro')",
    English: "Pro",
    French: "Pro",
    German: "Pro",
    Spanish: "Pro",
    Italian: "Pro",
    Polish: "Pro",
  },
  {
    FIELD1: "t('add_device.main.step2_plus')",
    English: "Plus",
    French: "Plus",
    German: "Plus",
    Spanish: "Plus",
    Italian: "Plus",
    Polish: "Plus",
  },
  {
    FIELD1: "t('add_device.option.refresh_rate_warning')",
    English: "Please ensure your device is online and allow 24 hours for it to take effect.",
    French: "Veuillez vous assurer que votre appareil est en ligne et accordez 24 heures pour que cela prenne effet.",
    German: "Bitte stellen Sie sicher, dass Ihr Gerät online ist, und lassen Sie 24 Stunden, bis es wirksam wird.",
    Spanish: "Asegúrese de que su dispositivo esté en línea y permita 24 horas para que surta efecto.",
    Italian: "Assicurati che il tuo dispositivo sia online e concedi 24 ore affinché abbia effetto.",
    Polish: "Upewnij się, że Twoje urządzenie jest online i poczekaj 24 godziny, aby zmiana weszła w życie.",
  },
  {
    FIELD1: "t('add_device.error.cov')",
    English:
      "Please select the coverage zone you would like to use your tracker in.",
    French:
      "Veuillez sélectionner la zone de couverture dans laquelle vous souhaitez utiliser votre traceur.",
    German:
      "Bitte wählen Sie die Abdeckungszone aus, in der Sie Ihren Tracker verwenden möchten.",
    Spanish:
      "Por favor, seleccione la zona de cobertura en la que desea utilizar su rastreador.",
    Italian:
      "Seleziona la zona di copertura nella quale si desidera utilizzare il dispositivo.",
    Polish: "Wybierz strefę zasięgu, w której chcesz używać lokalizatora.",
  },
  {
    FIELD1: "t('my_devices.main.zone_not_found')",
    English: "Coverage zone not found. Please contact support to upgrade.",
    French:
      "Zone de couverture introuvable. Veuillez contacter le support pour une mise à niveau.",
    German:
      "Abdeckungsbereich nicht gefunden. Bitte kontaktieren Sie den Support, um ein Upgrade durchzuführen.",
    Spanish:
      "Zona de cobertura no encontrada. Por favor, contacte con soporte para actualizar.",
    Italian:
      "Zona di copertura non trovata. Si prega di contattare il supporto per un aggiornamento.",
    Polish:
      "Nie znaleziono strefy zasięgu. Skontaktuj się z pomocą techniczną, aby ją rozszerzyć",
  },
  {
    FIELD1: "t('add_device.main.step3_trail')",
    English: "7 day trial, then",
    French: "7 jours d'essai, puis",
    German: "7 Tage testen, dann ",
    Spanish: "Prueba de 7 días, luego",
    Italian: "7 giorni di prova gratuita, poi",
    Polish: "7-dniowy okres próbny, potem",
  },
  {
    FIELD1: "t('add_device.main.step2_pro')",
    English: "Pro",
    French: "Pro",
    German: "Pro",
    Spanish: "Pro",
    Italian: "Pro",
    Polish: "Pro",
  },
  {
    FIELD1: "t('add_device.main.step2_plus')",
    English: "Plus",
    French: "Plus",
    German: "Plus",
    Spanish: "Plus",
    Italian: "Plus",
    Polish: "Plus",
  },
  {
    FIELD1: "t('add_device.main.selected')",
    English: "Selected",
    French: "Choisi",
    German: "Ausgewählt",
    Spanish: "Seleccionado",
    Italian: "Selezionato",
    Polish: "Wybrane",
  },
  {
    FIELD1: "t('forget_password.main.code_required')",
    English: "Confirmation Code is Required",
    French: "Le code de confirmation est obligatoire",
    German: "Bestätigungscode ist erforderlich",
    Spanish: "Se requiere código de confirmación",
    Italian: "È necessario un codice di conferma",
    Polish: "Kod potwierdzający jest wymagany",
  },
  {
    FIELD1: "t('forget_password.main.password_required')",
    English: "Password is Required",
    French: "Le mot de passe est obligatoire",
    German: "Passwort ist erforderlich",
    Spanish: "Se requiere contraseña",
    Italian: "È richiesta la password",
    Polish: "Wymagane jest hasło",
  },
  {
    FIELD1: "t('my_devices.refresh_rate.label')",
    English: "Sec. Refresh",
    French: "Sec. rafraîchir",
    German: "Sek. Aktualisieren",
    Spanish: "Actualizar seg.",
    Italian: "Secondo aggiornamento",
    Polish: "Odświeżanie (sek.)",
  },
  {
    FIELD1: "t('my_devices.cancel.feedback')",
    English: "Can you tell us more? Your feedback is important to us...",
    French:
      "Pouvez-vous nous en dire plus ? Vos commentaires sont importants pour nous...",
    German: "Können Sie uns mehr sagen? Ihr Feedback ist wichtig für uns...",
    Spanish:
      "¿Puede contarnos más? Sus comentarios son importantes para nosotros...",
    Italian: "Puoi dirci di più? Il tuo feedback è importante per noi...",
    Polish:
      "Czy możesz powiedzieć nam więcej? Twoja opinia jest dla nas ważna…",
  },
  {
    FIELD1: "t('my_devices.retention.title')",
    English: "Are you sure you would like to cancel?",
    French: "Êtes-vous sûr de vouloir annuler ?",
    German: "Sind Sie sicher, dass Sie stornieren möchten?",
    Spanish: "¿Seguro que quiere darse de baja?",
    Italian: "Sei sicuro di voler cancellare?",
    Polish: "Czy na pewno chcesz anulować?",
  },
  {
    FIELD1: "t('my_devices.retention.message')",
    English:
      "We'd love to offer you a more competitive plan if this would tempt you to stay.",
    French:
      "Nous serions ravis de vous proposer un plan plus compétitif si cela peut vous inciter à rester.",
    German:
      "Wir würden Ihnen gerne einen günstigeren Tarif anbieten, wenn Sie das zum Bleiben verleiten würde.",
    Spanish:
      "Nos encantaría ofrecerle un plan más competitivo si esto le tienta a quedarse.",
    Italian:
      "Saremo lieti di offrirti un abbonamento più conveniente se questo ti invoglierà a restare con noi.",
    Polish:
      "Chcielibyśmy zaoferować Ci bardziej konkurencyjny plan, jeśli to skłoni Cię do pozostania.",
  },
  {
    FIELD1: "t('my_devices.retention.claim')",
    English: "Claim offer",
    French: "Offre de réclamation",
    German: "Angebot beanspruchen",
    Spanish: "Reclamar oferta",
    Italian: "Richiedi l'offerta",
    Polish: "Skorzystaj z oferty",
  },
  {
    FIELD1: "t('my_devices.retention.new_price')",
    English: "New one time price",
    French: "Nouveau prix unique",
    German: "Neuer einmaliger Preis",
    Spanish: "Nuevo precio único",
    Italian: "Nuovo prezzo unico",
    Polish: "Nowa jednorazowa cena",
  },
  {
    FIELD1: "t('my_devices.retention.offer')",
    English: "Offer",
    French: "Offre",
    German: "Angebot",
    Spanish: "Oferta",
    Italian: "Offerta",
    Polish: "Oferta",
  },
  {
    FIELD1: "t('my_devices.retention.save')",
    English: "Save",
    French: "Économiser",
    German: "Sparen Sie",
    Spanish: "Guardar",
    Italian: "Salva",
    Polish: "Zapisz",
  },
  {
    FIELD1: "t('my_devices.retention.cancel')",
    English: "No thanks, I'd like to cancel",
    French: "Non merci, j'aimerais annuler",
    German: "Nein danke, ich möchte stornieren",
    Spanish: "No, gracias, quiero cancelar",
    Italian: "No grazie, preferisco cancellare",
    Polish: "Nie, dziękuję, chcę anulować",
  },
  {
    FIELD1: "t('my_devices.retention.success')",
    English: "Offer Redeemed!",
    French: "Offre acceptée !",
    German: "Angebot eingelöst!",
    Spanish: "Oferta canjeada",
    Italian: "Offerta riscattata!",
    Polish: "Oferta zrealizowana",
  },
  {
    FIELD1: "t('my_devices.retention.error')",
    English: "Coupon couldn't be applied, please get in touch!",
    French: "Le coupon n'a pas pu être appliqué, veuillez nous contacter !",
    German:
      "Der Coupon konnte nicht angewendet werden, bitte kontaktieren Sie uns.",
    Spanish:
      "No se ha podido aplicar el cupón, por favor, póngase en contacto con nosotros.",
    Italian: "Il coupon non è stato applicato, contattaci!",
    Polish:
      "Kupon nie mógł zostać zastosowany, skontaktuj się z pomocą techniczną",
  },
  {
    FIELD1: "t('track.sidebar.acc_on')",
    English: "Ignition On",
    French: "Allumage",
    German: "Zündung an",
    Spanish: "Encendido",
    Italian: "Accensione",
    Polish: "Zapłon włączony",
  },
  {
    FIELD1: "t('track.sidebar.acc_off')",
    English: "Ignition Off",
    French: "Arrêt",
    German: "Zündung aus",
    Spanish: "Apagado",
    Italian: "Spegnimento",
    Polish: "Zapłon wyłączony",
  },
  {
    FIELD1: "t('dashboard.main.title')",
    English: "Your Dashboard",
    French: "Votre tableau de bord",
    German: "Ihr Dashboard",
    Spanish: "Su panel de control",
    Italian: "La tua home",
    Polish: "Twój panel",
  },
  {
    FIELD1: "t('dashboard.main.subheading')",
    English: "Get key metrics on your trackers",
    French: "Obtenez des mesures clés sur vos traceurs",
    German: "Erhalten Sie wichtige Metriken auf Ihren Trackern",
    Spanish: "Obtenga métricas clave en sus rastreadores",
    Italian: "Ottieni metriche chiave sui tuoi localizzatori",
    Polish: "Uzyskaj kluczowe dane o swoich lokalizatorach",
  },
  {
    FIELD1: "t('dashboard.buttons.email_reports')",
    English: "Email Reports",
    French: "Rapports par e-mail",
    German: "E-Mail-Berichte",
    Spanish: "Informes por correo electrónico",
    Italian: "Notifiche e-mail",
    Polish: "Raporty e-mail",
  },
  {
    FIELD1: "t('dashboard.buttons.edit')",
    English: "Edit",
    French: "Modifier",
    German: "Bearbeiten",
    Spanish: "Editar",
    Italian: "Modifica",
    Polish: "Edytuj",
  },
  {
    FIELD1: "t('dashboard.errors.heading')",
    English: "An Error Occurred",
    French: "Une erreur s'est produite",
    German: "Ein Fehler ist aufgetreten",
    Spanish: "Se ha producido un error",
    Italian: "Si è verificato un errore",
    Polish: "Wystąpił błąd",
  },
  {
    FIELD1: "t('dashboard.errors.subheading')",
    English: "An error occurred while fetching data.",
    French: "Une erreur s'est produite lors de l'extraction des données.",
    German: "Beim Abrufen der Daten ist ein Fehler aufgetreten.",
    Spanish: "Se ha producido un error al obtener los datos.",
    Italian: "Si è verificato un errore durante il recupero dei dati.",
    Polish: "Wystąpił błąd podczas pobierania danych",
  },
  {
    FIELD1: "t('dashboard.trackers.title')",
    English: "Trackers",
    French: "Traceurs",
    German: "Tracker",
    Spanish: "Seguidores",
    Italian: "Dispositivi",
    Polish: "Lokalizatory",
  },
  {
    FIELD1: "t('dashboard.online.title')",
    English: "Trackers Online",
    French: "Traceurs en ligne",
    German: "Tracker online",
    Spanish: "Rastreadores en línea",
    Italian: "Dispositivi online",
    Polish: "Lokalizatory online",
  },
  {
    FIELD1: "t('dashboard.speedViolation.title')",
    English: "Speed Violation",
    French: "Violation de la vitesse",
    German: "Geschwindigkeitsübertretung",
    Spanish: "Infracción de velocidad",
    Italian: "Infrazione della velocità",
    Polish: "Naruszenie prędkości",
  },
  {
    FIELD1: "t('dashboard.alertFeed.title')",
    English: "Alert Feed",
    French: "Fil d'alerte",
    German: "Alarm-Feed",
    Spanish: "Alerta",
    Italian: "Feed di avviso",
    Polish: "Strumień alertów",
  },
  {
    FIELD1: "t('dashboard.geofenceOccupation.title')",
    English: "Geofence Occupation",
    French: "Occupation de la géofence",
    German: "Geofence Besetzung",
    Spanish: "Ocupación de la geocerca",
    Italian: "Occupazione di geofence",
    Polish: "Zajęcie geostrefy",
  },
  {
    FIELD1: "t('dashboard.trackerLastMovement.title')",
    English: "Tracker Last Movement",
    French: "Dernier mouvement du traceur",
    German: "Tracker Letzte Bewegung",
    Spanish: "Último movimiento del rastreador",
    Italian: "Ultimo movimento del dispositivo",
    Polish: "Ostatni ruch lokalizatora",
  },
  {
    FIELD1: "t('dashboard.trackerLastMovement.today')",
    English: "Today",
    French: "Aujourd'hui",
    German: "Heute",
    Spanish: "Hoy",
    Italian: "Oggi",
    Polish: "Dzisiaj",
  },
  {
    FIELD1: "t('dashboard.trackerLastMovement.ago')",
    English: "Days",
    French: "Jours",
    German: "Tage",
    Spanish: "Días",
    Italian: "Giorni",
    Polish: "Dni",
  },
  {
    FIELD1: "t('dashboard.trackerStatus.title')",
    English: "Tracker Status",
    French: "Statut du traceur",
    German: "Tracker-Status",
    Spanish: "Estado del rastreador",
    Italian: "Stato del dispositivo",
    Polish: "Status lokalizatora",
  },
  {
    FIELD1: "t('dashboard.trackerMovement.title')",
    English: "Tracker Movement",
    French: "Mouvement du traceur",
    German: "Tracker-Bewegung",
    Spanish: "Movimiento del rastreador",
    Italian: "Movimento del dispositivo",
    Polish: "Ruch lokalizatora",
  },
  {
    FIELD1: "t('dashboard.trackerTypes.title')",
    English: "Tracker Types",
    French: "Types de traceurs",
    German: "Tracker-Typen",
    Spanish: "Tipos de rastreadores",
    Italian: "Tipologie di dispositivo",
    Polish: "Typy lokalizatorów",
  },
  {
    FIELD1: "t('dashboard.topSpeeds.title')",
    English: "Top Speeds",
    French: "Vitesses maximales",
    German: "Höchstgeschwindigkeiten",
    Spanish: "Velocidades máximas",
    Italian: "Velocità massime",
    Polish: "Najwyższe prędkości",
  },
  {
    FIELD1: "t('dashboard.charge.title')",
    English: "Devices To Charge",
    French: "Appareils à charger",
    German: "Zu ladende Geräte",
    Spanish: "Dispositivos para cargar",
    Italian: "Dispositivi da caricare",
    Polish: "Urządzenia do naładowania",
  },
  {
    FIELD1: "t('dashboard.offlineTrackers.title')",
    English: "Offline Trackers",
    French: "Traceurs hors ligne",
    German: "Offline-Tracker",
    Spanish: "Rastreadores sin conexión",
    Italian: "Dispositivi offline",
    Polish: "Lokalizatory offline",
  },
  {
    FIELD1: "t('dashboard.subscriptions.title')",
    English: "Subscriptions",
    French: "Abonnements",
    German: "Abonnements",
    Spanish: "Suscripciones",
    Italian: "Iscrizioni",
    Polish: "Subskrypcje",
  },
  {
    FIELD1: "t('dashboard.activations.title')",
    English: "Activations",
    French: "Activations",
    German: "Aktivierungen",
    Spanish: "Activaciones",
    Italian: "Attivazioni",
    Polish: "Aktywacje",
  },
  {
    FIELD1: "t('dashboard.distanceTravelled.title')",
    English: "Distance Travelled",
    French: "Distance parcourue",
    German: "Zurückgelegte Strecke",
    Spanish: "Distancia recorrida",
    Italian: "Distanza percorsa",
    Polish: "Przebyta odległość",
  },
  {
    FIELD1: "t('dashboard.distanceTravelled.updated')",
    English: "Updated at {{time}}",
    French: "Mis à jour à {{time}}",
    German: "Aktualisiert um {{time}}",
    Spanish: "Actualizado a las {{time}}",
    Italian: "Aggiornato alle {{time}}",
    Polish: "Zaktualizowano o {{time}}",
  },
  {
    FIELD1: "t('dashboard.distanceTravelled.tracker')",
    English: "Tracker",
    French: "Traceur",
    German: "Tracker",
    Spanish: "Rastreador",
    Italian: "Dispositivo",
    Polish: "Lokalizator",
  },
  {
    FIELD1: "t('dashboard.distanceTravelled.distance')",
    English: "Distance",
    French: "Distance",
    German: "Strecke",
    Spanish: "Distancia",
    Italian: "Distanza",
    Polish: "Odległość",
  },
  {
    FIELD1: "t('dashboard.distanceTravelled.no_data')",
    English: "No distance data",
    French: "Aucune donnée de distance",
    German: "Keine Streckendaten",
    Spanish: "Sin datos de distancia",
    Italian: "Nessun dato sulla distanza",
    Polish: "Brak danych o odległości",
  },
  {
    FIELD1: "t('dashboard.trackerStatus.online')",
    English: "Online",
    French: "En ligne",
    German: "Online",
    Spanish: "En línea",
    Italian: "Online",
    Polish: "Online",
  },
  {
    FIELD1: "t('dashboard.trackerStatus.offline')",
    English: "Offline",
    French: "Hors ligne",
    German: "Offline",
    Spanish: "Fuera de línea",
    Italian: "Offline",
    Polish: "Offline",
  },
  {
    FIELD1: "t('dashboard.trackerStatus.registered')",
    English: "Registered",
    French: "Enregistré",
    German: "Registriert",
    Spanish: "Registrado",
    Italian: "Registrato",
    Polish: "Zarejestrowany",
  },
  {
    FIELD1: "t('dashboard.subscriptions.active')",
    English: "Active",
    French: "Actif",
    German: "Aktiv",
    Spanish: "Activo",
    Italian: "Attivo",
    Polish: "Aktywny",
  },
  {
    FIELD1: "t('dashboard.subscriptions.canceled')",
    English: "Canceled",
    French: "Annulé",
    German: "Abgesagt",
    Spanish: "Cancelado",
    Italian: "Cancellato",
    Polish: "Anulowany",
  },
  {
    FIELD1: "t('dashboard.subscriptions.registered')",
    English: "Registered",
    French: "Enregistré",
    German: "Registriert",
    Spanish: "Registrado",
    Italian: "Registrato",
    Polish: "Zarejestrowany",
  },
  {
    FIELD1: "t('dashboard.subscriptions.overdue')",
    English: "Overdue",
    French: "En retard",
    German: "Überfällig",
    Spanish: "Atrasado",
    Italian: "Scaduto",
    Polish: "Zaległy",
  },
  {
    FIELD1: "t('dashboard.trackerMovement.moving')",
    English: "Moving",
    French: "En mouvement",
    German: "Unterwegs",
    Spanish: "En movimiento",
    Italian: "In movimento",
    Polish: "W ruchu",
  },
  {
    FIELD1: "t('dashboard.trackerMovement.stopped')",
    English: "Stopped",
    French: "En arrêt",
    German: "Gestoppt",
    Spanish: "Detenido",
    Italian: "Fermo",
    Polish: "Zatrzymany",
  },
  {
    FIELD1: "t('dashboard.trackerMovement.idling')",
    English: "Idling",
    French: "Ralenti",
    German: "Leerlauf",
    Spanish: "En espera",
    Italian: "Minimo funzionamento",
    Polish: "Na biegu jałowym",
  },
  {
    FIELD1: "t('dashboard.offlineTrackers.manage')",
    English: "Manage",
    French: "Gérer",
    German: "Verwalten",
    Spanish: "Gestionar",
    Italian: "Gestisci",
    Polish: "Zarządzaj",
  },
  {
    FIELD1: "t('dashboard.topSpeeds.month')",
    English: "Month",
    French: "Mois",
    German: "Monat",
    Spanish: "Mes",
    Italian: "Mese",
    Polish: "Miesiąc",
  },
  {
    FIELD1: "t('dashboard.topSpeeds.week')",
    English: "Week",
    French: "Semaine",
    German: "Woche",
    Spanish: "Semana",
    Italian: "Settimana",
    Polish: "Tydzień",
  },
  {
    FIELD1: "t('dashboard.topSpeeds.day')",
    English: "Day",
    French: "Jour",
    German: "Tag",
    Spanish: "Día",
    Italian: "Giorno",
    Polish: "Dzień",
  },
  {
    FIELD1: "t('dashboard.charge.charged')",
    English: "All devices are charged",
    French: "Tous les appareils sont chargés",
    German: "Alle Geräte sind aufgeladen",
    Spanish: "Todos los dispositivos están cargados",
    Italian: "Tutti i dispositivi sono carichi",
    Polish: "Wszystkie urządzenia są naładowane",
  },
  {
    FIELD1: "t('dashboard.alertFeed.loading')",
    English: "Loading more",
    French: "Plus d'informations",
    German: "Mehr laden",
    Spanish: "Cargando más",
    Italian: "Caricamento dei dati",
    Polish: "Ładowanie kolejnych",
  },
  {
    FIELD1: "t('dashboard.email.title')",
    English: "Email Reports",
    French: "Rapports par e-mail",
    German: "E-Mail-Berichte",
    Spanish: "Informes por correo electrónico",
    Italian: "Notifiche e-mail",
    Polish: "Raporty e-mail",
  },
  {
    FIELD1: "t('dashboard.email.pref_heading')",
    English: "Report",
    French: "Rapport",
    German: "Bericht",
    Spanish: "Informe",
    Italian: "Notifiche",
    Polish: "Raport",
  },
  {
    FIELD1: "t('dashboard.email.summary')",
    English: "Summary",
    French: "Aperçu",
    German: "Zusammenfassung",
    Spanish: "Resumen",
    Italian: "Resoconto",
    Polish: "Podsumowanie",
  },
  {
    FIELD1: "t('dashboard.email.mileage')",
    English: "Mileage",
    French: "Kilométrage",
    German: "Kilometerstand",
    Spanish: "Kilometraje",
    Italian: "Chilometraggio",
    Polish: "Przebieg",
  },
  {
    FIELD1: "t('dashboard.email.rec_heading')",
    English: "Additional Recipients",
    French: "Autres destinataires",
    German: "Zusätzliche Empfänger",
    Spanish: "Destinatarios adicionales",
    Italian: "Ulteriori destinatari",
    Polish: "Dodatkowi odbiorcy",
  },
  {
    FIELD1: "t('dashboard.email.rec_subheading')",
    English: "Please enter comma seperated email addresses",
    French:
      "Veuillez saisir des adresses électroniques séparées par des virgules",
    German: "Bitte geben Sie durch Komma getrennte E-Mail-Adressen ein",
    Spanish: "Introduzca direcciones de correo electrónico separadas por comas",
    Italian: "Inserire indirizzi e-mail separati da virgole",
    Polish: "Wprowadź adresy e-mail oddzielone przecinkami",
  },
  {
    FIELD1: "t('dashboard.errors.invalid')",
    English:
      "Please make sure you've entered valid email addresses and each email has a comma between",
    French:
      "Veuillez vous assurer que vous avez saisi des adresses électroniques valides et que chaque courriel est séparé par une virgule.",
    German:
      "Bitte vergewissern Sie sich, dass Sie gültige E-Mail-Adressen eingegeben haben und dass zwischen jeder E-Mail ein Komma steht.",
    Spanish:
      "Asegúrese de que ha introducido direcciones de correo electrónico válidas y de que cada una de ellas está separada por una coma.",
    Italian:
      "Accertarsi di aver inserito indirizzi e-mail validi e che ogni e-mail sia separata da una virgola.",
    Polish:
      "Upewnij się, że wprowadziłeś poprawne adresy e-mail i że każdy adres jest oddzielony przecinkiem",
  },
  {
    FIELD1: "t('dashboard.errors.limit')",
    English: "You can only enter 3 email addresses in the CC field.",
    French:
      "Vous ne pouvez saisir que 3 adresses électroniques dans le champ CC.",
    German: "Sie können nur 3 E-Mail-Adressen in das CC-Feld eingeben.",
    Spanish:
      "Sólo puede introducir 3 direcciones de correo electrónico en el campo CC.",
    Italian: "È possibile inserire solo 3 indirizzi e-mail nel campo CC.",
    Polish: "Możesz dodać maksymalnie 3 adresy e-mail w polu CC",
  },
  {
    FIELD1: "t('dashboard.errors.username')",
    English: "Your account email address will always receive the report",
    French:
      "L'adresse électronique de votre compte recevra toujours le rapport",
    German: "Ihre Konto-E-Mail-Adresse wird den Bericht immer erhalten",
    Spanish:
      "La dirección de correo electrónico de su cuenta siempre recibirá el informe",
    Italian: "L'indirizzo e-mail del tuo account riceverà sempre la notifica",
    Polish: "Twój adres e-mail zawsze otrzyma raport",
  },
  {
    FIELD1: "t('dashboard.buttons.save')",
    English: "Save",
    French: "Sauvegarder",
    German: "Speichern",
    Spanish: "Guardar",
    Italian: "Salva",
    Polish: "Zapisz",
  },
  {
    FIELD1: "t('dashboard.buttons.saving')",
    English: "Saving",
    French: "Sauvegarde",
    German: "Sparen",
    Spanish: "Guardando",
    Italian: "Salvataggio",
    Polish: "Zapisywanie",
  },
  {
    FIELD1: "t('dashboard.edit.general')",
    English: "General",
    French: "Général",
    German: "Allgemein",
    Spanish: "General",
    Italian: "Generale",
    Polish: "Ogólne",
  },
  {
    FIELD1: "t('dashboard.edit.tracking')",
    English: "Tracking",
    French: "Suivi",
    German: "Nachverfolgung",
    Spanish: "Seguimiento",
    Italian: "Tracciamento",
    Polish: "Śledzenie",
  },
  {
    FIELD1: "t('dashboard.edit.billing')",
    English: "Billing",
    French: "Facturation",
    German: "Rechnungsstellung",
    Spanish: "Facturación",
    Italian: "Fatturazione",
    Polish: "Rozliczenia,",
  },
  {
    FIELD1: "t('dashboard.alertFeed.empty')",
    English: "No Alerts to show",
    French: "Pas d'alertes à afficher",
    German: "Keine Warnungen anzeigen",
    Spanish: "No mostrar alertas",
    Italian: "Non ci sono avvisi da visualizzare",
    Polish: "Brak alertów do wyświetlenia",
  },
  {
    FIELD1: "t('dashboard.geofenceOccupation.label')",
    English: "Devices",
    French: "Appareils",
    German: "Geräte",
    Spanish: "Dispositivos",
    Italian: "Dispositivi",
    Polish: "Urządzenia",
  },
  {
    FIELD1: "t('dashboard.charge.name')",
    English: "Name",
    French: "Nom",
    German: "Name",
    Spanish: "Nombre",
    Italian: "Nome",
    Polish: "Nazwa",
  },
  {
    FIELD1: "t('dashboard.charge.imei')",
    English: "IMEI",
    French: "IMEI",
    German: "IMEI",
    Spanish: "IMEI",
    Italian: "IMEI",
    Polish: "IMEI",
  },
  {
    FIELD1: "t('dashboard.trackerLastMovement.label')",
    English: "Last Movement",
    French: "Dernier mouvement",
    German: "Letzte Bewegung",
    Spanish: "Último movimiento",
    Italian: "Ultimo movimento",
    Polish: "Ostatni ruch",
  },
  {
    FIELD1: "t('dashboard.trackerLastMovement.xLabel')",
    English: "Days since Last Movement",
    French: "Nombre de jours depuis le dernier mouvement",
    German: "Tage seit der letzten Bewegung",
    Spanish: "Días desde el último movimiento",
    Italian: "Giorni dall'ultimo movimento",
    Polish: "Liczba dni od ostatniego ruchu",
  },
  {
    FIELD1: "t('navigation.main.history_management')",
    English: "Manage Data",
    French: "Gérer les données",
    German: "Daten verwalten ",
    Spanish: "Administrar datos",
    Italian: "Gestire i dati",
    Polish: "Zarządzanie danymi",
  },
  {
    FIELD1: "t('history_management.main.heading')",
    English: "Your Tracker's History",
    French: "Historique de notre traqueur",
    German: "die Geschichte unseres Trackers",
    Spanish: "Historial de nuestro rastreador",
    Italian: "La cronologia del nostro localizzatore",
    Polish: "Historia Twojego lokalizatora",
  },
  {
    FIELD1: "t('history_management.main.subheading')",
    English: "View or delete the location history for your trackers.",
    French:
      "Afficher ou supprimer l'historique de localisation de vos traceurs.",
    German:
      "Zeigen Sie den Standortverlauf für Ihre Tracker an oder löschen Sie ihn.",
    Spanish: "Vea o elimine el historial de localización de sus rastreadores.",
    Italian:
      "Visualizza o elimina la cronologia delle posizioni dei localizzatori.",
    Polish: "Przeglądaj lub usuń historię lokalizacji swoich lokalizatorów",
  },
  {
    FIELD1: "t('history_management.main.delete_history')",
    English: "Delete History",
    French: "Supprimer l'historique",
    German: "Verlauf löschen",
    Spanish: "Borrar Historial",
    Italian: "Cancella cronologia",
    Polish: "Usuń historię",
  },
  {
    FIELD1: "t('history_management.main.select_label')",
    English: "Select a Tracker",
    French: "Sélectionner un traceur",
    German: "Wählen Sie einen Tracker",
    Spanish: "Seleccione un Rastreador",
    Italian: "Selezionare un dispositivo di tracciamento",
    Polish: "Wybierz lokalizator",
  },
  {
    FIELD1: "t('history_management.main.download_history')",
    English: "Download History",
    French: "Télécharger l'historique",
    German: "Geschichte herunterladen",
    Spanish: "Descargar historial",
    Italian: "Scarica cronologia",
    Polish: "Pobierz historię",
  },
  {
    FIELD1: "t('history_management.delete.title')",
    English: "Delete tracker history",
    French: "Supprimer l'historique du traceur",
    German: "Tracker-Verlauf löschen",
    Spanish: "Eliminar el historial del rastreador",
    Italian: "Elimina la cronologia del localizzatore",
    Polish: "Usuń historię lokalizatora",
  },
  {
    FIELD1: "t('history_management.delete.message')",
    English: "Are you sure you want to remove the tracker history for",
    French: "Êtes-vous sûr de vouloir supprimer l'historique du traceur pour",
    German: "Sind Sie sicher, dass Sie den Trackerverlauf für",
    Spanish:
      "¿Estás seguro de que desea eliminar el historial del rastreador para",
    Italian:
      "Sei sicuro di voler rimuovere la cronologia del localizzatore per",
    Polish: "Czy na pewno chcesz usunąć historię dla",
  },
  {
    FIELD1: "t('history_management.delete.irreversible')",
    English: "This action is irreversible",
    French: "Cette action est irréversible",
    German: "Diese Aktion ist unumkehrbar",
    Spanish: "Esta acción es irreversible",
    Italian: "Questa azione è irreversibile",
    Polish: "Ta czynność jest nieodwracalna",
  },
  {
    FIELD1: "t('history_management.delete.irreversible_mobile')",
    English:
      "This action will permanently delete all location history for this tracker, including all data ever recorded.",
    French:
      "Cette action supprimera définitivement tout l'historique de localisation de ce traceur, y compris toutes les données précédemment enregistrées.",
    German:
      "Diese Aktion löscht dauerhaft den gesamten Standortverlauf für diesen Tracker, einschließlich aller jemals aufgezeichneten Daten.",
    Spanish:
      "Esta acción eliminará permanentemente todo el historial de ubicación de este rastreador, incluyendo todos los datos registrados.",
    Italian:
      "Questa azione eliminerà definitivamente tutta la cronologia di localizzazione di questo dispositivo di localizzazione, compresi tutti i dati mai registrati.",
    Polish:
      "Ta operacja trwale usunie całą historię lokalizacji tego lokalizatora, w tym wszystkie zapisane dane",
  },
  {
    FIELD1: "t('history_management.download.success')",
    English: "Your history was successfully downloaded",
    French: "Votre historique a été téléchargé avec succès",
    German: "Ihr Verlauf wurde erfolgreich heruntergeladen",
    Spanish: "Su historial se ha descargado correctamente",
    Italian: "La cronologia è stata scaricata con successo",
    Polish: "Historia została pomyślnie pobrana",
  },
  {
    FIELD1: "t('history_management.delete.success')",
    English: "Your history was successfully deleted",
    French: "Votre historique a été supprimé avec succès",
    German: "Ihr Verlauf wurde erfolgreich gelöscht",
    Spanish: "Su historial se ha eliminado correctamente",
    Italian: "La cronologia è stata cancellata con successo",
    Polish: "Historia została pomyślnie usunięta",
  },
  {
    FIELD1: "t('history_management.delete.error')",
    English: "An error occurred with deletion. Please contact support.",
    French:
      "Une erreur s'est produite lors de la suppression. Veuillez contacter l'assistance.",
    German:
      "Bei der Löschung ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Support.",
    Spanish:
      "Se ha producido un error al eliminarlo. Por favor, póngase en contacto con el servicio de asistencia.",
    Italian:
      "Si è verificato un errore di cancellazione. Contattare l'assistenza.",
    Polish:
      "Wystąpił błąd podczas usuwania. Skontaktuj się z pomocą techniczną",
  },
  {
    FIELD1: "t('history_management.download.title')",
    English: "Download tracker history",
    French: "Télécharger l'historique du traceur",
    German: "Tracker-Verlauf herunterladen",
    Spanish: "Descargar el historial del rastreador",
    Italian: "Scarica la cronologia del dispositivo",
    Polish: "Pobierz historię lokalizatora",
  },
  {
    FIELD1: "t('history_management.download.message')",
    English: "Select the dates to download the location history for",
    French:
      "Sélectionnez les dates pour lesquelles vous souhaitez télécharger l'historique",
    German:
      "Wählen Sie die Daten aus, für die Sie den Standortverlauf herunterladen möchten",
    Spanish:
      "Seleccione las fechas para las que desea descargar el historial de localizaciones",
    Italian:
      "Seleziona le date per cui scaricare la cronologia della posizione",
    Polish: "Wybierz daty do pobrania historii lokalizacji",
  },
  {
    FIELD1: "t('history_management.download.start_date')",
    English: "Start date",
    French: "Date de début",
    German: "Startdatum",
    Spanish: "Fecha de inicio",
    Italian: "Data di inizio",
    Polish: "Data początkowa",
  },
  {
    FIELD1: "t('history_management.download.end_date')",
    English: "End date",
    French: "Date de fin",
    German: "Enddatum",
    Spanish: "Fecha de finalización",
    Italian: "Data di fine",
    Polish: "Data końcowa",
  },
  {
    FIELD1: "t('history_management.download.no_data')",
    English:
      "No location data for the selected dates. Try selecting different dates.",
    French:
      "Aucune donnée de localisation pour les dates sélectionnées. Essayez de sélectionner d'autres dates.",
    German:
      "Keine Standortdaten für die ausgewählten Daten. Versuchen Sie, andere Daten auszuwählen.",
    Spanish:
      "No hay datos de ubicación para las fechas seleccionadas. Intente seleccionar fechas diferentes.",
    Italian:
      "Non ci sono dati relativi alla posizione per le date selezionate. Prova a selezionare date diverse.",
    Polish:
      "Brak danych lokalizacji dla wybranego zakresu dat. Spróbuj wybrać inne daty",
  },
  {
    FIELD1: "t('history_management.download.travelled')",
    English: "traveled in the selected dates",
    French: "a voyagé dans les dates sélectionnées",
    German: "in den ausgewählten Daten gereist sind",
    Spanish: "viajado en las fechas seleccionadas",
    Italian: "viaggiato nelle date selezionate",
    Polish: "przejechane w wybranych datach",
  },
  {
    FIELD1: "t('history_management.download.no_travel')",
    English: "No travel recorded during this period",
    French: "Aucun trajet enregistré pendant cette période",
    German: "Keine Fahrt in diesem Zeitraum aufgezeichnet",
    Spanish: "No se registraron desplazamientos durante este período",
    Italian: "Nessun viaggio registrato in questo periodo",
    Polish: "Brak zarejestrowanych przejazdów w tym okresie",
  },
  {
    FIELD1: "t('history_management.main.get_mileage')",
    English: "Get Mileage",
    French: "Obtenir le kilométrage",
    German: "Kilometerstand abrufen",
    Spanish: "Obtener kilometraje",
    Italian: "Ottieni chilometraggio",
    Polish: "Pobierz przebieg",
  },
  {
    FIELD1: "t('history_management.download.mileage_message')",
    English: "Select a date range to get the distance travelled by",
    French: "Sélectionnez une période pour obtenir la distance parcourue par",
    German: "Wählen Sie einen Zeitraum, um die zurückgelegte Strecke abzurufen für",
    Spanish: "Seleccione un rango de fechas para obtener la distancia recorrida por",
    Italian: "Seleziona un intervallo di date per ottenere la distanza percorsa da",
    Polish: "Wybierz zakres dat, aby uzyskać przebyty dystans dla",
  },
  {
    FIELD1: "t('history_management.main.download')",
    English: "Download",
    French: "Télécharger",
    German: "Herunterladen",
    Spanish: "Descargar",
    Italian: "Scaricamento",
    Polish: "Pobierz",
  },
  {
    FIELD1: "t('account.webhook.test')",
    English: "Test",
    French: "Tester",
    German: "Test",
    Spanish: "Prueba",
    Italian: "Fai una prova",
    Polish: "Test",
  },
  {
    FIELD1: "t('account.webhook.test_tooltip')",
    English:
      "Use browser developer tools to inspect the response to this webhook",
    French:
      "Utilisez les outils de développement du navigateur pour inspecter la réponse à ce webhook.",
    German:
      "Verwenden Sie die Browser-Entwicklerwerkzeuge, um die Antwort auf diesen Webhook zu überprüfen",
    Spanish:
      "Use las herramientas de desarrollo del navegador para inspeccionar la respuesta a este webhook",
    Italian:
      "È possibile utilizzare gli strumenti di sviluppo del browser per ispezionare la risposta a questo webhook.",
    Polish:
      "Użyj narzędzi deweloperskich przeglądarki, aby sprawdzić odpowiedź webhooka",
  },
  {
    FIELD1: "t('account.webhook.test_error')",
    English: "Something went wrong, please contact support.",
    French: "Un problème s'est produit, veuillez contacter l'assistance.",
    German: "Etwas ist schiefgelaufen, bitte kontaktieren Sie den Support.",
    Spanish: "Algo salió mal, por favor contacte al soporte.",
    Italian: "Qualcosa è andato storto, contattare l'assistenza.",
    Polish: "Coś poszło nie tak, skontaktuj się z pomocą techniczną",
  },
  {
    FIELD1: "t('account.webhook.delete_title')",
    English: "Remove Webhook Setup",
    French: "Supprimer la configuration du Webhook",
    German: "Webhook-Einrichtung entfernen",
    Spanish: "Eliminar Configuración de Webhook",
    Italian: "Rimuovere l'impostazione di Webhook",
    Polish: "Usuń konfigurację webhooka",
  },
  {
    FIELD1: "t('account.webhook.delete_msg')",
    English: "Are you sure you want to remove your Webhook setup?",
    French: "Êtes-vous sûr de vouloir supprimer votre configuration Webhook ?",
    German:
      "Sind Sie sicher, dass Sie Ihre Webhook-Einrichtung entfernen möchten?",
    Spanish: "¿Está seguro de que quiere eliminar su configuración de Webhook?",
    Italian: "Sei sicuro di voler rimuovere la configurazione di Webhook?",
    Polish: "Czy na pewno chcesz usunąć konfigurację webhooka?",
  },
  {
    FIELD1: "t('account.webhook.edit')",
    English: "Edit",
    French: "Modifier",
    German: "Bearbeiten",
    Spanish: "Editar",
    Italian: "Modifica",
    Polish: "Edytuj",
  },
  {
    FIELD1: "t('account.webhook.remove')",
    English: "Remove",
    French: "Supprimer",
    German: "Entfernen",
    Spanish: "Eliminar",
    Italian: "Rimuovi",
    Polish: "Usuń",
  },
  {
    FIELD1: "t('account.webhook.removing')",
    English: "Removing",
    French: "Suppression",
    German: "Entfernung",
    Spanish: "Eliminando",
    Italian: "Rimozione",
    Polish: "Usuwanie",
  },
  {
    FIELD1: "t('account.webhook.no_setup')",
    English: "You currently have no Webhook setup.",
    French: "Vous n'avez actuellement aucune configuration de Webhook.",
    German: "Sie haben derzeit keinen Webhook eingerichtet.",
    Spanish: "Actualmente no tiene ninguna configuración de Webhook.",
    Italian: "Al momento non è stato configurato alcun Webhook.",
    Polish: "Obecnie nie masz skonfigurowanego webhooka.",
  },
  {
    FIELD1: "t('account.webhook.setup_webhook')",
    English: "Set up Webhook",
    French: "Configuration de Webhook",
    German: "Webhook einrichten",
    Spanish: "Configurar Webhook",
    Italian: "Configurazione di Webhook",
    Polish: "Konfiguracja webhooka",
  },
  {
    FIELD1: "t('account.api.new_key')",
    English: "New API Key",
    French: "Nouvelle clé API",
    German: "Neuer API-Schlüssel",
    Spanish: "Nueva Clave API",
    Italian: "Nuova chiave API",
    Polish: "Nowy klucz API",
  },
  {
    FIELD1: "t('account.api.delete_title')",
    English: "Delete API Key",
    French: "Supprimer la clé API",
    German: "API-Schlüssel löschen",
    Spanish: "Eliminar Clave API",
    Italian: "Cancellare la chiave API",
    Polish: "Usuń klucz API",
  },
  {
    FIELD1: "t('account.api.delete_msg')",
    English: "This will revoke access of any application using this token",
    French: "Cela révoquera l'accès à toute application utilisant ce jeton.",
    German:
      "Damit wird der Zugriff auf alle Anwendungen, die dieses Token verwenden, gesperrt.",
    Spanish:
      "Esto revocará el acceso de cualquier aplicación que utilice este token",
    Italian:
      "In questo modo si revoca l'accesso a qualsiasi applicazione che utilizzi questo token",
    Polish:
      "Spowoduje to cofnięcie dostępu wszystkim aplikacjom używającym tego tokena",
  },
  {
    FIELD1: "t('account.api.create_title')",
    English: "Create new API Key",
    French: "Créer une nouvelle clé API",
    German: "Neuen API-Schlüssel erstellen",
    Spanish: "Crear nueva Clave API",
    Italian: "Creare una nuova chiave API",
    Polish: "Utwórz nowy klucz API",
  },
  {
    FIELD1: "t('account.api.expiry_msg')",
    English: "API Key has expiry date",
    French: "La clé API a une date d'expiration",
    German: "API-Schlüssel hat ein Verfallsdatum",
    Spanish: "La Clave API tiene fecha de caducidad",
    Italian: "La chiave API ha una data di scadenza",
    Polish: "Klucz API ma datę wygaśnięcia",
  },
  {
    FIELD1: "t('account.api.expiry_label')",
    English: "Select a expiry date",
    French: "Sélectionnez une date d'expiration",
    German: "Wählen Sie ein Verfallsdatum",
    Spanish: "Seleccione una fecha de caducidad",
    Italian: "Selezionare una data di scadenza",
    Polish: "Wybierz datę wygaśnięcia",
  },
  {
    FIELD1: "t('account.api.create_btn')",
    English: "Create API Key",
    French: "Créer une clé API",
    German: "Erstellen Sie den API Schlüssel",
    Spanish: "Crear clave API",
    Italian: "Creare la chiave API",
    Polish: "Utwórz klucz API",
  },
  {
    FIELD1: "t('account.api.creating_btn')",
    English: "Creating",
    French: "Création",
    German: "Erstellung",
    Spanish: "Creando",
    Italian: "Creare",
    Polish: "Tworzenie",
  },
  {
    FIELD1: "t('account.api.docs')",
    English: "Documentation",
    French: "Documentation",
    German: "Dokumentation",
    Spanish: "Documentación",
    Italian: "Documentazione",
    Polish: "Dokumentacja",
  },
  {
    FIELD1: "t('account.users.title')",
    English: "Account Sharing",
    French: "Partage de compte",
    German: "Gemeinsame Nutzung eines Kontos",
    Spanish: "Compartir Cuenta",
    Italian: "Condivisione del conto",
    Polish: "Udostępnianie konta",
  },
  {
    FIELD1: "t('account.users.subheading')",
    English: "Share access to your account with other users in the platform",
    French:
      "partager l'accès à votre compte avec d'autres utilisateurs de la plateforme",
    German:
      "Teilen Sie den Zugang zu Ihrem Konto mit anderen Nutzern der Plattform",
    Spanish: "Comparta acceso a su cuenta con otros usuarios en la plataforma",
    Italian:
      "Condividere l'accesso al proprio account con altri utenti della piattaforma",
    Polish: "Udostępnij dostęp do swojego konta innym użytkownikom platformy",
  },
  {
    FIELD1: "t('account.users.no_members')",
    English: "You’re currently not sharing your account with any other users.",
    French: "Vous ne partagez pas votre compte avec d'autres utilisateurs.",
    German: "Sie teilen Ihr Konto derzeit nicht mit anderen Benutzern.",
    Spanish:
      "Actualmente no está compartiendo su cuenta con ningún otro usuario.",
    Italian:
      "Al momento non stai condividendo il tuo account con altri utenti.",
    Polish: "Obecnie nie udostępniasz swojego konta innym użytkownikom",
  },
  {
    FIELD1: "t('account.users.add')",
    English: "Add Member",
    French: "Ajouter un membre",
    German: "Mitglied hinzufügen",
    Spanish: "Agregar Miembro",
    Italian: "Aggiungi membro",
    Polish: "Dodaj członka",
  },
  {
    FIELD1: "t('account.users.adding')",
    English: "Adding",
    French: "Ajout",
    German: "Hinzufügen",
    Spanish: "Agregando",
    Italian: "Aggiunta di",
    Polish: "Dodawanie",
  },
  {
    FIELD1: "t('account.users.add_label')",
    English: "Search for an Email",
    French: "Recherche d'un e-mail",
    German: "Suche nach einer E-Mail",
    Spanish: "Buscar un Correo Electrónico",
    Italian: "Cerca un'e-mail",
    Polish: "Wyszukaj e-mail",
  },
  {
    FIELD1: "t('account.users.add_placeholder')",
    English: "Enter Email Address",
    French: "Entrer l'adresse e-mail",
    German: "E-Mail-Adresse eingeben",
    Spanish: "Ingrese la Dirección de Correo Electrónico",
    Italian: "Inserire l'indirizzo e-mail",
    Polish: "Wprowadź adres e-mail",
  },
  {
    FIELD1: "t('account.users.no_user')",
    English: "No user was found for the entered email",
    French: "Aucun utilisateur n'a été trouvé pour l'e-mail saisi",
    German: "Es wurde kein Benutzer für die eingegebene E-Mail gefunden",
    Spanish:
      "No se encontró ningún usuario para el correo electrónico ingresado",
    Italian: "Non è stato trovato alcun utente per l'e-mail inserita",
    Polish: "Nie znaleziono użytkownika dla podanego adresu e-mail",
  },
  {
    FIELD1: "t('account.users.remove_title')",
    English: "Remove User",
    French: "Supprimer l'utilisateur",
    German: "Benutzer entfernen",
    Spanish: "Eliminar usuario",
    Italian: "Rimuovi utente",
    Polish: "Usuń użytkownika",
  },
  {
    FIELD1: "t('account.users.remove_message')",
    English: "Are you sure you want to remove this user?",
    French: "Êtes-vous sûr de vouloir supprimer cet utilisateur ?",
    German: "Sind Sie sicher, dass Sie diesen Benutzer entfernen möchten?",
    Spanish: "¿Está seguro de que quiere eliminar a este usuario?",
    Italian: "Sei sicuro di voler rimuovere questo utente?",
    Polish: "Czy na pewno chcesz usunąć tego użytkownika?",
  },
  {
    FIELD1: "t('account.users.remove')",
    English: "Remove User",
    French: "Supprimer l'utilisateur",
    German: "Benutzer entfernen",
    Spanish: "Eliminar Usuario",
    Italian: "Rimuovi utente",
    Polish: "Usuń użytkownika",
  },
  {
    FIELD1: "t('account.users.removing')",
    English: "Removing",
    French: "Suppression",
    German: "Entfernung",
    Spanish: "Eliminando",
    Italian: "Rimozione",
    Polish: "Usuwanie",
  },
  {
    FIELD1: "t('account.users.access')",
    English: "People with access",
    French: "Personnes ayant accès",
    German: "Personen mit Zugang",
    Spanish: "Personas con acceso",
    Italian: "Utenti con accesso",
    Polish: "Osoby z dostępem",
  },
  {
    FIELD1: "t('account.users.viewer')",
    English: "Viewer",
    French: "Consultation",
    German: "Betrachter",
    Spanish: "Visor",
    Italian: "Visualizzazione",
    Polish: "Przeglądający",
  },
  {
    FIELD1: "t('account.users.editor')",
    English: "Admin",
    French: "Administrateur",
    German: "Admin",
    Spanish: "Administrador",
    Italian: "Admin",
    Polish: "Administrator",
  },
  {
    FIELD1: "t('account.users.validation1')",
    English: "Please enter a valid email address",
    French: "Veuillez saisir une adresse e-mail valide",
    German: "Bitte geben Sie eine gültige E-Mail Adresse ein",
    Spanish: "Por favor, ingrese una dirección de correo electrónico válida",
    Italian: "Inserire un indirizzo e-mail valido",
    Polish: "Wprowadź poprawny adres e-mail",
  },
  {
    FIELD1: "t('account.users.validation2')",
    English: "You can't add yourself as a member",
    French: "Vous ne pouvez pas vous ajouter comme membre",
    German: "Sie können sich nicht selbst als Mitglied hinzufügen",
    Spanish: "No puede agregarse a usted mismo como miembro",
    Italian: "Non è possibile aggiungersi come membri",
    Polish: "Nie możesz dodać samego siebie jako członka",
  },
  {
    FIELD1: "t('account.users.add_success')",
    English: "User successfully invited",
    French: "L'utilisateur a été invité avec succès",
    German: "Der Nutzer wurde erfolgreich hinzugefügt",
    Spanish: "Usuario invitado con éxito",
    Italian: "L'utente è stato invitato con successo",
    Polish: "Użytkownik został pomyślnie zaproszony",
  },
  {
    FIELD1: "t('account.users.add_error')",
    English:
      "You cannot invite this user, please try again later or contact support.",
    French:
      "Vous ne pouvez pas inviter cet utilisateur, veuillez réessayer plus tard ou contacter le support.",
    German:
      "Sie können diesen Nutzer nicht einladen, bitte versuchen Sie es später nochmal oder kontaktieren Sie den Support",
    Spanish:
      "No puede invitar a este usuario, por favor intente nuevamente más tarde o contacte al soporte.",
    Italian:
      "Non è possibile invitare questo utente, riprovare più tardi o contattare l'assistenza.",
    Polish:
      "Nie możesz zaprosić tego użytkownika — spróbuj ponownie później lub skontaktuj się z pomocą techniczną",
  },
  {
    FIELD1: "t('account.users.add_error1')",
    English: "already added or invited to an account",
    French: "déjà ajouté ou invité à un compte",
    German: "bereits zu einem Konto hinzugefügt oder eingeladen",
    Spanish: "ya añadido o invitado a una cuenta",
    Italian: "già aggiunto o invitato a un account",
    Polish: "Użytkownik jest już dodany lub zaproszony",
  },
  {
    FIELD1: "t('account.users.add_error2')",
    English: "You cannot invite a user with an existing account",
    French: "Vous ne pouvez pas inviter un utilisateur ayant déjà un compte",
    German: "Sie können keinen Nutzer mit einem existierenden Konto einladen",
    Spanish: "No puede invitar a un usuario con una cuenta existente",
    Italian:
      "Non è possibile invitare un utente che abbia un account esistente",
    Polish: "Nie możesz zaprosić użytkownika z istniejącym kontem",
  },
  {
    FIELD1: "t('account.users.update_success')",
    English: "Successfully updated",
    French: "Mise à jour réussie",
    German: "Es wurde erfolgreich aktualisiert",
    Spanish: "Actualización exitosa",
    Italian: "Aggiornato con successo",
    Polish: "Zaktualizowano pomyślnie",
  },
  {
    FIELD1: "t('account.users.update_error')",
    English: "Couldn't update user, please try again later or contact support",
    French:
      "Impossible de mettre à jour l'utilisateur, veuillez réessayer plus tard ou contacter l'assistance.",
    German:
      "Der Nutzer konnte nicht aktualisiert werden, bitte versuchen Sie es später nochtmal oder kontaktieren Sie den Support",
    Spanish:
      "No se pudo actualizar el usuario, por favor intente nuevamente más tarde o contacte al soporte",
    Italian:
      "Impossibile aggiornare l'utente, riprovare più tardi o contattare l'assistenza.",
    Polish: "Nie udało się zaktualizować użytkownika",
  },
  {
    FIELD1: "t('account.users.delete_success')",
    English: "Successfully deleted",
    French: "Supprimé avec succès",
    German: "Es wurde erfolgreich gelöscht",
    Spanish: "Eliminado con éxito",
    Italian: "Eliminato con successo",
    Polish: "Usunięto pomyślnie",
  },
  {
    FIELD1: "t('account.users.delete_error')",
    English: "Couldn't delete user, please try again later or contact support",
    French:
      "Impossible de supprimer l'utilisateur, veuillez réessayer plus tard ou contacter l'assistance.",
    German:
      "Der Nutzer konnte nicht gelöscht werden, bitte versuchen Sie es später nochmal oder kontaktieren Sie den Support",
    Spanish:
      "No se pudo eliminar al usuario, por favor intente nuevamente más tarde o contacte al soporte",
    Italian:
      "Impossibile eliminare l'utente, riprovare più tardi o contattare l'assistenza.",
    Polish: "Nie udało się usunąć użytkownika",
  },
  {
    FIELD1: "t('account.users.invite_pending')",
    English: "Invite Pending",
    French: "Invitation en attente",
    German: "Die Einladung läuft",
    Spanish: "Invitación pendiente",
    Italian: "In attesa di invito",
    Polish: "Zaproszenie oczekujące",
  },
  {
    FIELD1: "t('referral.helmet.title')",
    English: "SafeTag Referral Scheme",
    French: "Programme de parrainage SafeTag",
    German: "SafeTag Empfehlungsprogramm",
    Spanish: "Programa de recomendación SafeTag",
    Italian: "Schema di riferimento SafeTag",
    Polish: "Program poleceń SafeTag",
  },
  {
    FIELD1: "t('referral.helmet.desc')",
    English:
      "Learn how to refer your friends and earn 10% credit everytime they pay...",
    French:
      "Apprenez à parrainer vos amis et gagnez 10% de crédit à chaque fois qu'ils paient...",
    German:
      "Erfahren Sie, wie Sie Ihre Freunde werben und bei jeder Zahlung eine Gutschrift von 10 % erhalten ...",
    Spanish:
      "Aprenda a recomendar a sus amigos y gane un 10% de crédito cada vez que paguen...",
    Italian:
      "Scopri come invitare i tuoi amici e guadagnare il 10% di credito ogni volta che effettuano un pagamento...",
    Polish:
      "Dowiedz się, jak polecać znajomych i zdobywać 10% kredytu za każdą płatność",
  },
  {
    FIELD1: "t('referral.hero.line1')",
    English: "For your peace of mind.",
    French: "Pour votre tranquillité d'esprit.",
    German: "Für Ihren Seelenfrieden.",
    Spanish: "Para su tranquilidad.",
    Italian: "Per la tua serenità.",
    Polish: "Dla Twojego spokoju",
  },
  {
    FIELD1: "t('referral.hero.heading')",
    English: "Earn money promoting SafeTag",
    French: "Gagnez de l'argent en promouvant SafeTag",
    German: "Geld verdienen mit Werbung für SafeTag",
    Spanish: "Gane dinero promocionando SafeTag",
    Italian: "Guadagnare promuovendo SafeTag",
    Polish: "Zarabiaj, promując SafeTag",
  },
  {
    FIELD1: "t('referral.hero.subheading')",
    English:
      "Earn unlimited free tracking by sharing SafeTag with your friends, family or community.",
    French:
      "Gagnez un nombre illimité de traçages gratuits en partageant SafeTag avec vos amis, votre famille ou votre communauté.",
    German:
      "Verdienen Sie sich eine unbegrenzte Anzahl kostenloser Tracker, indem Sie SafeTag mit Ihren Freunden, Ihrer Familie oder Ihrer Community teilen.",
    Spanish:
      "Gane un número ilimitado de rastreos gratuitos compartiendo SafeTag con sus amigos, su familia o su comunidad.",
    Italian:
      "Guadagna un numero illimitato di tracking gratuiti condividendo SafeTag con i tuoi amici, la tua famiglia o la tua comunità.",
    Polish:
      "Zdobywaj nieograniczone darmowe śledzenie, udostępniając SafeTag znajomym, rodzinie lub społeczności",
  },
  {
    FIELD1: "t('referral.hero.btn1')",
    English: "Share your affiliate link",
    French: "Partagez votre lien de parrainage",
    German: "Teilen Sie Ihren Affiliate-Link",
    Spanish: "Comparta su enlace de afiliado",
    Italian: "Condividi il tuo link di affiliazione",
    Polish: "Udostępnij swój link afiliacyjny",
  },
  {
    FIELD1: "t('referral.hero.btn2')",
    English: "Create a new account",
    French: "Créez un nouveau compte",
    German: "Ein neues Konto erstellen",
    Spanish: "Crear una nueva cuenta",
    Italian: "Crea un nuovo account",
    Polish: "Utwórz nowe konto",
  },
  {
    FIELD1: "t('referral.step1.title')",
    English: "Share your registration link",
    French: "Partagez votre lien d'inscription",
    German: "Teilen Sie Ihren Registrierungslink",
    Spanish: "Comparta su enlace de registro",
    Italian: "Condividi il tuo link di registrazione",
    Polish: "Udostępnij link rejestracyjny",
  },
  {
    FIELD1: "t('referral.step1.desc')",
    English:
      "Share your unique registration link or send an invite email from your account page.",
    French:
      "Partagez votre lien d'inscription unique ou envoyez un e-mail d'invitation à partir de la page de votre compte.",
    German:
      "Geben Sie Ihren einzigartigen Registrierungslink weiter oder senden Sie eine Einladungs-E-Mail von Ihrer Kontoseite aus.",
    Spanish:
      "Comparta su enlace de registro exclusivo o envíe una invitación por correo electrónico desde la página de su cuenta.",
    Italian:
      "Condividi il tuo link di registrazione unico o invia un'e-mail di invito dalla pagina del tuo account.",
    Polish:
      "Udostępnij swój unikalny link lub wyślij zaproszenie e-mail z poziomu konta",
  },
  {
    FIELD1: "t('referral.step2.title')",
    English: "Your friend signs up",
    French: "Votre ami(e) s'inscrit",
    German: "Ihr Freund meldet sich an",
    Spanish: "Su amigo se registra",
    Italian: "Il tuo amico si iscrive",
    Polish: "Twój znajomy rejestruje się",
  },
  {
    FIELD1: "t('referral.step2.desc')",
    English: "Your friends create an account with your shared link.",
    French: "Vos amis créent un compte avec votre lien partagé.",
    German: "Ihre Freunde erstellen ein Konto mit Ihrem gemeinsamen Link.",
    Spanish: "Sus amigos crean una cuenta con su enlace compartido.",
    Italian: "I tuoi amici creano un account con il tuo link condiviso.",
    Polish: "Twój znajomy tworzy konto przez Twój link",
  },
  {
    FIELD1: "t('referral.step3.title')",
    English: "Your referral activates a tracker",
    French: "Votre parrainage active un traceur",
    German: "Ihre Empfehlung aktiviert einen Tracker",
    Spanish: "Su referido activa un rastreador",
    Italian: "Il tuo link attiva un dispositivo",
    Polish: "Twój polecony aktywuje lokalizator",
  },
  {
    FIELD1: "t('referral.step3.desc')",
    English: "Your referee also gets a 10%  discount on their tracker",
    French:
      "Votre référent bénéficie également d'une réduction de 10 % sur son traceur.",
    German:
      "Ihr Schiedsrichter erhält außerdem einen Rabatt von 10 % auf seinen Tracker.",
    Spanish: "Su referido también obtiene un 10% de descuento en su rastreador",
    Italian:
      "Anche il tuo referente ottiene uno sconto del 10% sul suo dispositivo.",
    Polish: "Polecony otrzymuje 10% zniżki na lokalizator",
  },
  {
    FIELD1: "t('referral.step4.title')",
    English: "You get 10% of everything they pay as credit on your account",
    French:
      "Vous recevez 10 % de tout ce qu'ils paient sous forme de crédit sur votre compte.",
    German:
      "Sie erhalten 10 % von allem, was sie bezahlen, als Guthaben auf Ihr Konto.",
    Spanish:
      "Usted recibe el 10% de todo lo que ellos paguen como crédito en su cuenta",
    Italian:
      "Ottieni il 10% di tutto ciò che pagano come credito sul tuo conto.",
    Polish: "Otrzymujesz 10% wszystkich jego płatności jako kredyt na konto",
  },
  {
    FIELD1: "t('referral.step4.desc')",
    English:
      "This will be deducted from your all of your subscription payments, up to 100% off, every month/quarter/year!",
    French:
      "Ce montant sera déduit de tous vos paiements d'abonnement, jusqu'à 100% de réduction, chaque mois/trimestre/année !",
    German:
      "Dieser Betrag wird Ihnen jeden Monat/jedes Quartal/jedes Jahr von allen Ihren Abonnementzahlungen abgezogen, und zwar bis zu 100 %!",
    Spanish:
      "Esto se deducirá de todos sus pagos de suscripción, hasta un 100% de descuento, ¡cada mes/trimestre/año!",
    Italian:
      "Questo verrà detratto da tutti i pagamenti dell'abbonamento, fino al 100% di sconto, ogni mese/trimestre/anno!",
    Polish:
      "To zostanie odliczone od wszystkich Twoich płatności subskrypcyjnych, nawet do 100% zniżki, co miesiąc/kwartał/rok!",
  },
  {
    FIELD1: "t('referral.step5.title')",
    English: "Share your link now!",
    French: "Partagez votre lien maintenant !",
    German: "Teilen Sie Ihren Link jetzt!",
    Spanish: "¡comparta su enlace ahora!",
    Italian: "Condividi subito il tuo link!",
    Polish: "Udostępnij swój link teraz!",
  },
  {
    FIELD1: "t('referral.step5.desc1')",
    English: "Share it to your friends, family, community groups etc...",
    French:
      "Partagez-le avec vos amis, votre famille, vos groupes communautaires, etc.",
    German:
      "Teilen Sie es mit Ihren Freunden, Ihrer Familie, Gemeindegruppen usw ...",
    Spanish: "Compártalo con sus amigos, familiares, grupos comunitarios, etc.",
    Italian:
      "Condividilo con i tuoi amici, la tua famiglia, i tuoi vicini, ecc...",
    Polish: "Udostępnij go znajomym, rodzinie, grupom społecznościowym itd.",
  },
  {
    FIELD1: "t('referral.step5.desc2')",
    English: "Please get in touch if we can help!",
    French: "N'hésitez pas à nous contacter si vous avez besoin d'aide !",
    German: "Bitte kontaktieren Sie uns, wenn wir Ihnen helfen können!",
    Spanish: "Si podemos ayudarle, póngase en contacto con nosotros.",
    Italian: "Contattaci se possiamo esserti d'aiuto!",
    Polish: "Jeśli możemy pomóc, skontaktuj się z nami!",
  },
  {
    FIELD1: "t('referral.step6.title')",
    English: "Terms & Conditions",
    French: "Conditions générales",
    German: "Bedingungen & Konditionen",
    Spanish: "Condiciones de uso",
    Italian: "Termini & Condizioni",
    Polish: "Regulamin",
  },
  {
    FIELD1: "t('referral.step6.desc')",
    English: "See below for our terms and conditions",
    French: "Voir ci-dessous nos conditions générales",
    German: "Siehe unten für unsere Bedingungen und Konditionen",
    Spanish: "Consulte a continuación nuestros términos y condiciones",
    Italian: "Consulta di seguito i nostri termini e condizioni",
    Polish: "Poniżej znajdziesz warunki naszego programu poleceń",
  },
  {
    FIELD1: "t('referral.contact.title')",
    English: "Any questions?",
    French: "Des questions ?",
    German: "Haben Sie Fragen?",
    Spanish: "¿Tiene alguna pregunta?",
    Italian: "Hai domande?",
    Polish: "Masz pytania?",
  },
  {
    FIELD1: "t('referral.contact.desc')",
    English: "Don’t hesitate to get in touch if you have questions.",
    French: "N'hésitez pas à nous contacter si vous avez des questions.",
    German: "Zögern Sie nicht, uns zu kontaktieren, wenn Sie Fragen haben.",
    Spanish:
      "No dude en ponerse en contacto con nosotros si tiene alguna pregunta.",
    Italian: "Non esitare a metterti in contatto con noi se hai delle domande.",
    Polish: "Nie wahaj się skontaktować z nami, jeśli masz pytania.",
  },
  {
    FIELD1: "t('referral.contact.btn')",
    English: "Contact us",
    French: "Contactez-nous",
    German: "Kontaktieren Sie uns",
    Spanish: "Póngase en contacto con nosotros",
    Italian: "Contattaci",
    Polish: "Kontakt",
  },
  {
    FIELD1: "t('referral.tos.title')",
    English: "Terms & Conditions",
    French: "Conditions générales",
    German: "Bedingungen & Konditionen",
    Spanish: "Términos y Condiciones",
    Italian: "Termini & Condizioni",
    Polish: "Warunki i zasady",
  },
  {
    FIELD1: "t('referral.tos.desc')",
    English:
      "We have just a few rules for our referral program. No surprises, just a few terms we should agree on:",
    French:
      "Notre programme de parrainage est soumis à quelques règles. Pas de surprises, juste quelques conditions sur lesquelles nous devons nous mettre d'accord :",
    German:
      "Wir haben nur ein paar Regeln für unser Empfehlungsprogramm. Keine Überraschungen, nur ein paar Bedingungen, auf die wir uns einigen sollten:",
    Spanish:
      "Sólo tenemos unas pocas reglas para nuestro programa de referidos. Sin sorpresas, sólo unos pocos términos que debemos acordar:",
    Italian:
      "Abbiamo solo poche regole per il nostro programma di referenza. Nessuna sorpresa, solo alcuni termini su cui concordare:",
    Polish:
      "Mamy tylko kilka zasad dotyczących programu poleceń. Bez niespodzianek — tylko kilka warunków:",
  },
  {
    FIELD1: "t('referral.tos.pt1')",
    English:
      "Abuse in any form will make you ineligible for the credit e.g. Self Referral",
    French:
      "Tout abus, sous quelque forme que ce soit, vous rendra inéligible au crédit, par exemple en cas d'auto-parrainage.",
    German:
      "Missbrauch in jeglicher Form führt dazu, dass Sie nicht für die Gutschrift infrage kommen, z.B. Selbstüberweisung",
    Spanish:
      "El abuso en cualquier forma le hará inelegible para el crédito, por ejemplo, la auto-referencia.",
    Italian:
      "L'utilizzo illecito, in qualsiasi forma, renderà il candidato non ammissibile al credito, ad esempio l'auto-refertazione.",
    Polish:
      "Nadużycia w jakiejkolwiek formie (np. polecenia własne) dyskwalifikują z kredytu",
  },
  {
    FIELD1: "t('referral.tos.pt2')",
    English:
      "Please don’t act on behalf of us on social media (ie. as an employee, a spokesperson, ... ).",
    French:
      "Veuillez ne pas agir en notre nom sur les médias sociaux (c'est-à-dire en tant qu'employé, porte-parole, ... ).",
    German:
      "Bitte handeln Sie nicht in unserem Namen in den sozialen Medien (d.h. als Mitarbeiter, Sprecher, ...).",
    Spanish:
      "Por favor, no actúe en nuestro nombre en las redes sociales (es decir, como empleado, portavoz, ... ).",
    Italian:
      "Non agire per conto nostro sui social media (ad esempio come dipendente, portavoce, ...).",
    Polish:
      "Prosimy nie przedstawiać się jako pracownik lub rzecznik SafeTag w mediach społecznościowych",
  },
  {
    FIELD1: "t('referral.tos.pt3')",
    English:
      "We reserve the right to change the Terms of Service for our affiliate program at any time.",
    French:
      "Nous nous réservons le droit de modifier à tout moment les conditions de service de notre programme de parrainage.",
    German:
      "Wir behalten uns das Recht vor, die Allgemeinen Geschäftsbedingungen für unser Partnerprogramm jederzeit zu ändern.",
    Spanish:
      "Nos reservamos el derecho de cambiar las condiciones de servicio de nuestro programa de afiliados en cualquier momento.",
    Italian:
      "Ci riserviamo il diritto di modificare in qualsiasi momento i Termini di Servizio del nostro programma di affiliazione.",
    Polish:
      "Zastrzegamy sobie prawo do zmiany warunków programu partnerskiego w dowolnym momencie",
  },
  {
    FIELD1: "t('referral.tos.pt4')",
    English:
      "Credit earned is applicable to SafeTag subscription charges only, and is deducted from the total value of the first charge made to your payment method at the time of having a positive credit balance.",
    French:
      "Le crédit gagné s'applique uniquement aux frais d'abonnement à SafeTag et est déduit de la valeur totale du premier prélèvement effectué sur votre mode de paiement au moment où vous avez un solde créditeur positif.",
    German:
      "Das verdiente Guthaben gilt nur für SafeTag-Abonnementgebühren und wird vom Gesamtwert der ersten Belastung Ihrer Zahlungsmethode abgezogen, wenn Sie ein positives Guthaben haben.",
    Spanish:
      "El crédito obtenido se aplica únicamente a los cargos de suscripción a SafeTag, y se deduce del valor total del primer cargo realizado a su método de pago en el momento de tener un saldo positivo.",
    Italian:
      "Il credito guadagnato è applicabile solo agli addebiti dell'abbonamento SafeTag e viene detratto dal valore totale del primo addebito effettuato sul metodo di pagamento dell'utente nel momento in cui il saldo del credito è positivo.",
    Polish:
      "Kredyt może być użyty tylko na opłaty subskrypcyjne SafeTag i jest odliczany od całkowitej wartości pierwszej opłaty przy dodatnim saldzie kredytowym",
  },
  {
    FIELD1: "t('referral.tos.pt5')",
    English:
      "Subscription refunds will not include any credits that were applied to the charges generated by the subscription",
    French:
      "Les remboursements d'abonnement n'incluront pas les crédits qui ont été appliqués aux frais générés par l'abonnement",
    German:
      "Die Rückerstattung von Abonnements umfasst keine Gutschriften, die auf die durch das Abonnement entstandenen Kosten angewendet wurden.",
    Spanish:
      "Los reembolsos de suscripciones no incluirán ningún crédito que se haya aplicado a los cargos generados por la suscripción.",
    Italian:
      "I rimborsi degli abbonamenti non comprenderanno eventuali crediti applicati agli addebiti generati dall'abbonamento.",
    Polish: "Zwroty subskrypcji nie obejmują kredytów użytych do opłat",
  },
  {
    FIELD1: "t('referral.tos.pt6')",
    English:
      "We reserve the right to pay out credit earned as tracking hardware discounts or Amazon Vouchers at our own discretion",
    French:
      "Nous nous réservons le droit de verser les crédits obtenus sous forme de remises sur le matériel de suivi ou de bons d'achat Amazon, à notre entière discrétion.",
    German:
      "Wir behalten uns das Recht vor, nach eigenem Ermessen Guthaben in Form von Tracking-Hardware-Rabatten oder Amazon-Gutscheinen auszuzahlen.",
    Spanish:
      "Nos reservamos el derecho de pagar el crédito ganado como descuentos de hardware de seguimiento o vales de Amazon a nuestra propia discreción",
    Italian:
      "Ci riserviamo il diritto di versare il credito guadagnato come sconti sulla tracciabilità dell'hardware o buoni Amazon a nostra discrezione.",
    Polish:
      "Zastrzegamy sobie prawo do wypłaty kredytu w formie zniżek na sprzęt lub voucherów Amazon według własnego uznania",
  },
  {
    FIELD1: "t('account.referral.title')",
    English: "Referrals - Earn Free Tracking",
    French: "Parrainage - Gagnez un suivi gratuit",
    German: "Empfehlungen - Verdienen Sie eine kostenlose Fortsetzung",
    Spanish: "Referencias - Gane un seguimiento gratuito",
    Italian: "Referenza - Guadagnare il tracciamento gratuito",
    Polish: "Polecenia – zarabiaj darmowe śledzenie",
  },
  {
    FIELD1: "t('account.referral.desc1')",
    English:
      "Share your peace of mind, and when they sign up, you get 10% of every payment they make.",
    French:
      "Partagez votre tranquillité d'esprit, et lorsqu'ils s'inscrivent, vous recevez 10 % de chaque paiement qu'ils effectuent.",
    German:
      "Teilen Sie Ihren Seelenfrieden, und wenn er sich anmeldet, erhalten Sie 10 % von jeder Zahlung, die er tätigt.",
    Spanish:
      "Comparta su tranquilidad y, cuando se suscriban, obtendrá el 10% de cada pago que realicen.",
    Italian:
      "Condividi con gli altri ciò che ti fa stare bene e, quando si iscrivono, ricevi il 10% di ogni pagamento che effettuano.",
    Polish:
      "Udostępnij spokój ducha — gdy ktoś się zarejestruje, otrzymujesz 10% każdej jego płatności",
  },
  {
    FIELD1: "t('account.referral.desc2')",
    English:
      "Every month/quarter/year that your referee makes a subscription payment, we’ll apply 10% of the value of their payment to your account as subscription credit, which will be deducted from your next subscription payment, up to 100%!",
    French:
      "Chaque mois/trimestre/année où votre filleul effectue un paiement d'abonnement, nous verserons 10 % de la valeur de son paiement sur votre compte en tant que crédit d'abonnement, qui sera déduit de votre prochain paiement d'abonnement, jusqu'à atteindre 100 % !",
    German:
      "Jeden Monat/jedes Quartal/Jahr, in dem Ihr Schiedsrichter eine Abo-Zahlung leistet, schreiben wir Ihrem Konto 10 % des Wertes seiner Zahlung als Abo-Guthaben gut, das von Ihrer nächsten Abo-Zahlung abgezogen wird, bis zu 100 %!",
    Spanish:
      "Cada mes/trimestre/año que su referido realice un pago de suscripción, aplicaremos el 10% del valor de su pago a su cuenta como crédito de suscripción, que se deducirá de su próximo pago de suscripción, ¡hasta el 100%!",
    Italian:
      "Ogni mese/trimestre/anno in cui il tuo referente paga un abbonamento, applicheremo il 10% del valore del suo pagamento al tuo account come credito, che verrà detratto dal pagamento del tuo abbonamento successivo, fino al 100%!",
    Polish:
      "Każdego miesiąca/kwartału/roku, gdy Twój polecony dokona płatności subskrypcji, dodamy 10% wartości jego płatności jako kredyt na Twoje konto, który zostanie odjęty od Twojej następnej płatności subskrypcyjnej — nawet do 100%!",
  },
  {
    FIELD1: "t('account.referral.learn')",
    English: "Learn more about the referral system",
    French: "En savoir plus sur le système d'orientation",
    German: "Erfahren Sie mehr über das Empfehlungssystem",
    Spanish: "Más información sobre el sistema de recomendación",
    Italian: "Per saperne di più sul sistema di referenza",
    Polish: "Dowiedz się więcej o systemie poleceń",
  },
  {
    FIELD1: "t('account.referral.balance')",
    English: "Your credit balance",
    French: "Votre solde de crédit",
    German: "Ihr Guthaben",
    Spanish: "Su saldo acreedor",
    Italian: "Il saldo del credito",
    Polish: "Twoje saldo kredytu",
  },
  {
    FIELD1: "t('account.referral.link_title')",
    English: "Your referral link",
    French: "Votre lien de parrainage",
    German: "Ihr Empfehlungslink",
    Spanish: "Su enlace de recomendación",
    Italian: "Il tuo link di referenza",
    Polish: "Twój link polecający",
  },
  {
    FIELD1: "t('account.referral.link_desc')",
    English:
      "Share your referal link by copying and sending it or through your social media",
    French:
      "Partagez votre lien de parrainage en le copiant et en l'envoyant ou par le biais de vos médias sociaux.",
    German:
      "Teilen Sie Ihren Empfehlungslink, indem Sie ihn kopieren und versenden oder über Ihre sozialen Medien.",
    Spanish:
      "Comparta su enlace de recomendación copiándolo y enviándolo o a través de sus redes sociales",
    Italian:
      "Condividi il tuo link di referenza copiandolo e inviandolo o attraverso i tuoi social media.",
    Polish: "Udostępnij link przez kopiowanie lub media społecznościowe",
  },
  {
    FIELD1: "t('account.referral.link_btn1')",
    English: "Copy link",
    French: "Copier le lien",
    German: "Link kopieren",
    Spanish: "Copiar enlace",
    Italian: "Copia link",
    Polish: "Kopiuj link",
  },
  {
    FIELD1: "t('account.referral.link_btn2')",
    English: "Share",
    French: "Partager",
    German: "Teilen",
    Spanish: "Compartir",
    Italian: "Condividi",
    Polish: "Udostępnij",
  },
  {
    FIELD1: "t('account.referral.invite_title')",
    English: "Invite via email",
    French: "Inviter par courrier électronique",
    German: "Per E-Mail einladen",
    Spanish: "Invitar por correo electrónico",
    Italian: "Invita tramite email",
    Polish: "Zaproś e-mailem",
  },
  {
    FIELD1: "t('account.referral.invite_desc')",
    English:
      "Insert your an email address to send them an invitation to use SafeTag!",
    French:
      "Insérez votre adresse e-mail pour leur envoyer une invitation à utiliser SafeTag !",
    German:
      "Geben Sie Ihre E-Mail-Adresse ein, um Ihnen eine Einladung zur Nutzung von SafeTag zu senden!",
    Spanish:
      "Introduzca su dirección de correo electrónico para enviarles una invitación para utilizar SafeTag.",
    Italian:
      "Inserisci il tuo indirizzo e-mail per inviargli un invito ad utilizzare SafeTag!",
    Polish:
      "Wprowadź adres e-mail, aby wysłać im zaproszenie do korzystania z SafeTag!",
  },
  {
    FIELD1: "t('account.referral.invite_btn')",
    English: "Send Invite",
    French: "Envoyer l'invitation",
    German: "Einladung senden",
    Spanish: "Enviar invitación",
    Italian: "Manda l'invito",
    Polish: "Wyślij zaproszenie",
  },
  {
    FIELD1: "t('account.referral.invite_placeholder')",
    English: "Email address",
    French: "Adresse e-mail",
    German: "E-Mail-Adresse",
    Spanish: "Dirección de correo electrónico",
    Italian: "Indirizzo e-mail",
    Polish: "Adres e-mail",
  },
  {
    FIELD1: "t('account.referral.tooltip')",
    English:
      "Your current referral balance and your total claimed referral value. Please note your current balance may include credit applied by our support team for various reasons.",
    French:
      "Votre solde actuel de parrainage et votre valeur totale de parrainage réclamée. Veuillez noter que votre solde actuel peut inclure un crédit appliqué par notre équipe d'assistance pour diverses raisons.",
    German:
      "Ihr aktuelles Empfehlungsguthaben und den gesamten beanspruchten Empfehlungswert. Bitte beachten Sie, dass Ihr aktuelles Guthaben enthalten kann, das von unserem Support-Team aus verschiedenen Gründen gewährt wurde.",
    Spanish:
      "Su saldo actual de referidos y el valor total de referidos reclamado. Tenga en cuenta que su saldo actual puede incluir crédito aplicado por nuestro equipo de soporte por diversas razones.",
    Italian:
      "Il saldo attuale del programma di referenza e il valore totale del programma di referenza richiesto. Si prega di notare che il saldo attuale può includere crediti applicati dal nostro team di assistenza per vari motivi.",
    Polish:
      "Twoje aktualne saldo w programie poleceń oraz łączna wartość zrealizowanych korzyści z poleceń. Prosimy pamiętać, że bieżące saldo może uwzględniać kredyty przyznane przez nasz zespół wsparcia z różnych powodów.",
  },
  {
    FIELD1: "t('account.referral.link_copied')",
    English: "Copied to clipboard",
    French: "Copié dans le presse-papiers",
    German: "In die Zwischenablage kopiert",
    Spanish: "Copiado al portapapeles",
    Italian: "Copiato negli appunti",
    Polish: "Skopiowano do schowka",
  },
  {
    FIELD1: "t('account.referral.email_error')",
    English: "Please enter a valid email address",
    French: "Veuillez saisir une adresse e-mail valide",
    German: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    Spanish: "Introduzca una dirección de correo electrónico válida",
    Italian: "Inserire un indirizzo e-mail valido",
    Polish: "Wprowadź poprawny adres e-mail",
  },
  {
    FIELD1: "t('account.referral.limit_error')",
    English: "You can only send 5 email invitations each day",
    French: "Vous ne pouvez envoyer que 5 invitations par jour.",
    German: "Sie können nur 5 E-Mail-Einladungen pro Tag versenden",
    Spanish: "Sólo puede enviar 5 invitaciones por correo electrónico al día",
    Italian: "È possibile inviare solo 5 inviti via e-mail al giorno.",
    Polish: "Możesz wysłać maksymalnie 5 zaproszeń dziennie",
  },
  {
    FIELD1: "t('account.referral.already_error')",
    English: "This email address belongs to an existing SafeTag user",
    French: "Cette adresse e-mail appartient à un utilisateur SafeTag existant",
    German: "Diese E-Mail-Adresse gehört zu einem bestehenden SafeTag Benutzer",
    Spanish:
      "Esta dirección de correo electrónico pertenece a un usuario existente de SafeTag",
    Italian: "Questo indirizzo e-mail appartiene a un utente SafeTag esistente",
    Polish: "Ten adres e-mail należy już do użytkownika SafeTag",
  },
  {
    FIELD1: "t('account.referral.other_error')",
    English: "Email couldn't be sent, please share a link with them instead.",
    French:
      "L'e-mail n'a pas pu être envoyé, veuillez partager un lien avec eux à la place.",
    German:
      "Die E-Mail konnte nicht gesendet werden. Bitte teilen Sie ihnen stattdessen einen Link mit.",
    Spanish:
      "No se ha podido enviar el correo electrónico, por favor comparta un enlace con ellos en su lugar.",
    Italian:
      "Non è stato possibile inviare l'e-mail, si prega di condividere un link.",
    Polish: "Nie udało się wysłać e-maila — udostępnij link bezpośrednio",
  },
  {
    FIELD1: "t('account.referral.success')",
    English: "Email sent successfully!",
    French: "E-mail envoyé avec succès !",
    German: "E-Mail erfolgreich gesendet!",
    Spanish: "Correo electrónico enviado correctamente",
    Italian: "Email inviata con successo!",
    Polish: "E-mail wysłany pomyślnie",
  },
  {
    FIELD1: "t('account.referral.read_more')",
    English: "Read more",
    French: "En savoir plus",
    German: "Mehr lesen",
    Spanish: "Leer más",
    Italian: "Per saperne di più",
    Polish: "Czytaj więcej",
  },
  {
    FIELD1: "t('account.referral.read_less')",
    English: "Read less",
    French: "Lire moins",
    German: "Weniger lesen",
    Spanish: "Leer menos",
    Italian: "Per saperne di meno",
    Polish: "Czytaj mniej",
  },
  {
    FIELD1: "t('account.referral.share_text')",
    English: "Join SafeTag Tracking using my referral link",
    French: "Rejoignez SafeTag Tracking en utilisant mon lien de référence",
    German: "Trete dem SafeTag Tracking bei, indem du meinen Link benutzt. ",
    Spanish: "Únase a SafeTag Tracking usando mi enlace de referencia",
    Italian:
      "Iscriviti a SafeTag Tracking utilizzando il mio link di riferimento",
    Polish: "Dołącz do SafeTag przez mój link polecający",
  },
  {
    FIELD1: "t('track.sidebar.tooltip_troubleshoot')",
    English: "Your tracker’s offline?<br/>Click here to troubleshoot",
    French:
      "Votre traceur n'est pas en ligne ?<br/>Cliquez ici pour le dépannage",
    German:
      "Ihr Tracker ist offline?<br/>Klicken Sie hier, um das Problem zu beheben",
    Spanish:
      "¿Su rastreador está sin conexión?<br/>Haga clic aquí para solucionar problemas",
    Italian:
      "Il localizzatore è offline? <br/>Clicca qui per risolvere i problemi",
    Polish:
      "Twój lokalizator jest offline?<br/>Kliknij tutaj, aby rozwiązać problem",
  },
  {
    FIELD1: "t('support.trackers.heading')",
    English: "Having issues with your {tracker}?",
    French: "Vous avez des problèmes avec votre {tracker} ?",
    German: "Haben Sie Probleme mit Ihrem {tracker}?",
    Spanish: "¿Tiene problemas con su {tracker}?",
    Italian: "Stai avendo problemi con il tuo {tracker}?",
    Polish: "Masz problemy z {{tracker}}?",
  },
  {
    FIELD1: "t('support.trackers.subheading')",
    English: "Try these steps to get your tracker working",
    French: "Essayez les étapes suivantes pour faire fonctionner votre traceur",
    German:
      "Versuchen Sie diese Schritte, um Ihren Tracker zum Laufen zu bringen",
    Spanish: "Intente estos pasos para que su rastreador funcione",
    Italian:
      "Prova a seguire questi passaggi per far funzionare il tuo localizzatore",
    Polish: "Spróbuj tych kroków, aby uruchomić lokalizator.",
  },
  {
    FIELD1: "t('support.trackers.subheading')",
    English: "Try these steps to get your tracker working",
    French: "Essayez les étapes suivantes pour faire fonctionner votre traceur",
    German:
      "Versuchen Sie diese Schritte, um Ihren Tracker zum Laufen zu bringen",
    Spanish: "Intente estos pasos para que su rastreador funcione",
    Italian:
      "Prova a seguire questi passaggi per far funzionare il tuo localizzatore",
    Polish: "Spróbuj tych kroków, aby uruchomić lokalizator.",
  },
  {
    FIELD1: "t('tracker_support.0.1')",
    English:
      "Please allow the device to charge for at least 8 hours with the supplied cable and a wall adapter. The supplied cable has a longer head to reach into the tracker, other cables of the same type won't work. If you've lost it, please get in touch and we can send you another one.",
    French:
      "Laissez l'appareil se charger pendant au moins 8 heures à l'aide du câble fourni et d'un adaptateur mural. Le câble fourni a une tête plus longue pour atteindre le traceur, d'autres câbles du même type ne fonctionneront pas. Si vous l'avez perdu, contactez-nous et nous vous en enverrons un autre.",
    German:
      "Bitte lassen Sie das Gerät mindestens 8 Stunden lang mit dem mitgelieferten Kabel und einem Wandadapter aufladen. Das mitgelieferte Kabel hat einen längeren Kopf, um in den Tracker zu reichen, andere Kabel desselben Typs werden nicht funktionieren. Wenn Sie es verloren haben, kontaktieren Sie uns bitte und wir können Ihnen ein neues schicken.",
    Spanish:
      "Permita que el dispositivo se cargue durante al menos 8 horas con el cable suministrado y un adaptador de pared. El cable suministrado tiene una cabeza más larga para llegar al rastreador, otros cables del mismo tipo no funcionarán. Si lo ha perdido, póngase en contacto con nosotros y podemos enviarle otro.",
    Italian:
      "Si consiglia di lasciare caricare il dispositivo per almeno 8 ore con il cavo in dotazione e un adattatore a muro. Il cavo in dotazione ha una testa più lunga per raggiungere il localizzatore, altri cavi dello stesso tipo non funzionano. Se lo hai perso, contattaci e te ne invieremo un altro.",
    Polish:
      "Prosimy o ładowanie urządzenia przez co najmniej 8 godzin przy użyciu dołączonego kabla i zasilacza sieciowego. Dołączony kabel ma wydłużoną końcówkę, która pasuje do lokalizatora — inne kable tego samego typu mogą nie działać. Jeśli go zgubiono, prosimy o kontakt, a wyślemy nowy egzemplarz.",
  },
  {
    FIELD1: "t('tracker_support.0.2')",
    English:
      "If the device is currently in a vehicle, it may have had its signal blocked, please ensure that the device is in an open space, moving the device may yield better results.",
    French:
      "Si l'appareil se trouve actuellement dans un véhicule, il se peut que son signal soit bloqué. Assurez-vous que l'appareil se trouve dans un espace ouvert, ou déplacez l'appareil pour obtenir de meilleurs résultats.",
    German:
      "Wenn sich das Gerät derzeit in einem Fahrzeug befindet, wurde das Signal möglicherweise blockiert. Bitte stellen Sie sicher, dass sich das Gerät an einem offenen Ort befindet, ein Umzug des Geräts kann bessere Ergebnisse liefern.",
    Spanish:
      "Si el dispositivo está actualmente en un vehículo, es posible que su señal haya sido bloqueada, asegúrese de que el dispositivo esté en un espacio abierto, mover el dispositivo podría ofrecer mejores resultados.",
    Italian:
      "Se il dispositivo si trova in un veicolo, è possibile che il segnale sia stato bloccato; assicurati che il dispositivo si trovi in uno spazio aperto; se lo sposti, i risultati saranno migliori.",
    Polish:
      "Jeśli urządzenie znajduje się obecnie w pojeździe, sygnał mógł zostać zablokowany. Upewnij się, że urządzenie jest w otwartej przestrzeni — przeniesienie go może poprawić wyniki.",
  },
  {
    FIELD1: "t('tracker_support.0.3')",
    English:
      'Please ensure the sim is seated correctly within the tracker, it may have been knocked loose. The gold side of the SIM should be facing towards your IMEI code. It will require something thin and some considerable force, and when pushed in correctly it should make a satisfying "Click" noise.',
    French:
      'Veillez à ce que la carte SIM soit correctement insérée dans le traceur, car elle a pu se détacher. La face dorée de la carte SIM doit être orientée vers votre code IMEI. Il vous faudra un objet fin et une force considérable pour l\'enfoncer correctement, ce qui devrait produire un "clic" satisfaisant.',
    German:
      "Vergewissern Sie sich, dass die SIM-Karte richtig im Tracker sitzt, sie könnte sich gelockert haben. Die goldene Seite der SIM-Karte sollte in Richtung Ihres IMEI-Codes zeigen. Dazu benötigen Sie etwas Dünnes und etwas Kraft. Wenn Sie sie richtig einschieben, sollte sie ein zufriedenstellendes „Klick“-Geräusch machen.",
    Spanish:
      'Asegúrese de que la tarjeta SIM esté correctamente colocada dentro del rastreador, es posible que se haya soltado. El lado dorado de la SIM debe estar orientado hacia su código IMEI. Requerirá algo delgado y una fuerza considerable, y cuando se inserte correctamente debería hacer un sonido de "Click" satisfactorio.',
    Italian:
      "Verifica che la sim sia inserita correttamente nel localizzatore, perché potrebbe essersi allentata. Il lato dorato della SIM deve essere rivolto verso il codice IMEI. Per inserirla correttamente è necessario un oggetto sottile ed esercitare pressione; una volta inserita, dovrebbe emettere un suono simile a quello di un “clic”.",
    Polish:
      "Upewnij się, że karta SIM jest prawidłowo osadzona w lokalizatorze — mogła się poluzować. Złota strona karty SIM powinna być skierowana w stronę numeru IMEI. Może być potrzebne użycie cienkiego narzędzia i pewnego nacisku, a po prawidłowym włożeniu powinno być słychać charakterystyczne „kliknięcie”.",
  },
  {
    FIELD1: "t('tracker_support.0.4')",
    English:
      "Failing these steps, please initiate a manual reboot, by clicking the sim out with a thin tool like some tweezers, then pop back in. Please ensure the vibration sensor on the back is in the outwards position. Tutorial Video - https://youtu.be/YVZdZx_BgKg",
    French:
      "Si ces étapes échouent, veuillez procéder à un redémarrage manuel, en cliquant sur la sim avec un outil fin comme une pince à épiler, puis en la remettant en place. Veillez à ce que le capteur de vibrations situé à l'arrière de l'appareil soit orienté vers l'extérieur. Tutoriel vidéo - https://youtu.be/YVZdZx_BgKg",
    German:
      "Andernfalls führen Sie bitte einen manuellen Neustart durch, indem Sie die SIM-Karte mit einem dünnen Werkzeug (z.B. einer Pinzette) herausdrücken und dann wieder einstecken. Vergewissern Sie sich, dass der Vibrationssensor auf der Rückseite nach außen gerichtet ist. Anleitungsvideo - https://youtu.be/YVZdZx_BgKg",
    Spanish:
      "Si estos pasos fallan, inicie un reinicio manual haciendo clic en la SIM con una herramienta delgada, como unas pinzas, y luego vuelva a insertarla. Asegúrese de que el sensor de vibración en la parte posterior esté en la posición hacia afuera. Video tutorial: https://youtu.be/YVZdZx_BgKg",
    Italian:
      "In caso contrario, avvia un riavvio manuale, estraendo la sim con uno strumento sottile come una pinzetta, quindi reinserirla. Assicurati che il sensore di vibrazione sul retro sia in posizione esterna. Video tutorial - https://youtu.be/YVZdZx_BgKg",
    Polish:
      "Jeśli te kroki nie pomogą, zainicjuj ręczny restart, wyjmując kartę SIM cienkim narzędziem (np. pęsetą), a następnie włóż ją ponownie. Upewnij się, że czujnik wibracji z tyłu urządzenia jest ustawiony na zewnątrz.",
  },
  {
    FIELD1: "t('tracker_support.1.1')",
    English:
      "Please ensure the tracker it is correctly seated within the OBD-2 port and has not been knocked loose.",
    French:
      "Assurez-vous que le traceur est correctement installé dans le port OBD-2 et qu'il ne s'est pas détaché.",
    German:
      "Bitte vergewissern Sie sich, dass der Tracker richtig im OBD-2 Anschluss sitzt und sich nicht gelockert hat.",
    Spanish:
      "Asegúrese de que el rastreador esté correctamente colocado en el puerto OBD-2 y que no se haya aflojado.",
    Italian:
      "Assicurati che il localizzatore sia correttamente inserito nella porta OBD-2 e non sia stato allentato.",
    Polish:
      "Upewnij się, że lokalizator jest prawidłowo podłączony do portu OBD-2 i nie został poluzowany.",
  },
  {
    FIELD1: "t('tracker_support.1.2')",
    English:
      "If the tracker has recently been installed, please ensure that the vehicle trim is not blocking the tracker from being fully inserted into the port.  ",
    French:
      "Si le traceur a été récemment installé, assurez-vous que la garniture du véhicule n'empêche pas le traceur d'être complètement inséré dans le port.",
    German:
      "Wenn der Tracker erst kürzlich installiert wurde, stellen Sie bitte sicher, dass die Fahrzeugverkleidung den Tracker nicht daran hindert, vollständig in den Anschluss eingeführt zu werden.",
    Spanish:
      "Si el rastreador se ha instalado recientemente, asegúrese de que el revestimiento del vehículo no esté bloqueando el rastreador para que se inserte completamente en el puerto.",
    Italian:
      "Se il localizzatore è stato installato di recente, assicurati che il rivestimento del veicolo non blocchi l'inserimento completo del localizzatore nella porta.",
    Polish:
      "Jeśli lokalizator został niedawno zainstalowany, upewnij się, że elementy wykończenia wnętrza pojazdu nie blokują jego pełnego wpięcia do portu.",
  },
  {
    FIELD1: "t('tracker_support.2.1')",
    English:
      'Please check that your Mini is switched on. This can be done by sliding the cover off, flicking the sliding switch to "ON" and then holding the power button for 3 seconds.',
    French:
      "Veuillez vérifier que votre Mini est sous tension. Pour ce faire, retirez le couvercle, placez l'interrupteur coulissant sur \"ON\" et maintenez le bouton d'alimentation enfoncé pendant 3 secondes.",
    German:
      "Bitte überprüfen Sie, ob Ihr Mini eingeschaltet ist. Schieben Sie dazu den Deckel ab, stellen Sie den Schiebeschalter auf „ON“ und halten Sie dann die Power-Taste 3 Sekunden lang gedrückt.",
    Spanish:
      'Verifique que su Mini esté encendido. Esto se puede hacer deslizando la tapa, moviendo el interruptor deslizante a "ON" y luego manteniendo presionado el botón de encendido durante 3 segundos.',
    Italian:
      "Verifica che il Mini sia acceso. A tale scopo, è sufficiente togliere il coperchio, spostare l'interruttore scorrevole su “ON” e tenere premuto il pulsante di accensione per 3 secondi.",
    Polish:
      "Upewnij się, że Twój Mini jest włączony. Zrób to, zdejmując pokrywę, ustawiając przełącznik na „ON”, a następnie przytrzymując przycisk zasilania przez 3 sekundy.",
  },
  {
    FIELD1: "t('tracker_support.2.2')",
    English:
      "If your Mini won't turn on, it may be out of charge. Please allow the device to charge for at least 4 hours with the supplied cable and a wall adapter. Make sure that the switch is set to ON for charging. The supplied cable has a longer head to reach into the tracker, other cables of the same type won't work. If you've lost it, please get in touch and we can send you another one.",
    French:
      "Si votre Mini ne s'allume pas, il se peut qu'il soit à court de charge. Laissez l'appareil se charger pendant au moins 4 heures à l'aide du câble fourni et d'un adaptateur mural. Assurez-vous que l'interrupteur est sur ON pour la charge. Le câble fourni a une tête plus longue pour atteindre le traceur, d'autres câbles du même type ne fonctionneront pas. Si vous l'avez perdu, contactez-nous et nous vous en enverrons un autre.",
    German:
      "Wenn sich Ihr Mini nicht einschalten lässt, ist er möglicherweise nicht ausreichend aufgeladen. Bitte lassen Sie das Gerät mindestens 4 Stunden lang mit dem mitgelieferten Kabel und einem Netzadapter aufladen. Stellen Sie sicher, dass der Schalter zum Aufladen auf „ON“ steht. Das mitgelieferte Kabel hat einen längeren Kopf, um in den Tracker zu reichen, andere Kabel desselben Typs werden nicht funktionieren. Wenn Sie es verloren haben, kontaktieren Sie uns bitte und wir können Ihnen ein neues schicken.",
    Spanish:
      "Si su Mini no se enciende, es posible que esté sin carga. Permita que el dispositivo se cargue durante al menos 4 horas con el cable suministrado y un adaptador de pared. Asegúrese de que el interruptor esté en ON para la carga. El cable suministrado tiene una cabeza más larga para alcanzar el rastreador, otros cables del mismo tipo no funcionarán. Si lo ha perdido, por favor póngase en contacto con nosotros y le podemos enviar otro.",
    Italian:
      "Se il Mini non si accende, potrebbe essere scarico. Lascia caricare il dispositivo per almeno 4 ore con il cavo in dotazione e un adattatore a muro. Assicurati che l'interruttore sia impostato su ON per la ricarica. Il cavo in dotazione ha una testa più lunga per raggiungere il localizzatore, altri cavi dello stesso tipo non funzionano. Se lo hai perso, contattaci e te ne invieremo un altro.",
    Polish:
      "Jeśli Mini się nie włącza, może być rozładowany. Pozostaw urządzenie do ładowania przez co najmniej 4 godziny przy użyciu dołączonego kabla i zasilacza sieciowego. Upewnij się, że przełącznik jest ustawiony na ON podczas ładowania. Dołączony kabel ma wydłużoną końcówkę — inne kable tego samego typu nie będą działać. Jeśli go zgubiłeś, skontaktuj się z nami, a wyślemy nowy.",
  },
  {
    FIELD1: "t('tracker_support.2.3')",
    English:
      "If the device is in a densely packed location, it may have had its signal blocked, so please ensure that the device is in an open space, moving the device may yield better results, with the logo facing upwards.",
    French:
      "Si l'appareil se trouve dans un endroit très peuplé, il se peut que le signal soit bloqué. Assurez-vous donc que l'appareil se trouve dans un espace ouvert, et déplacez le pour obtenir de meilleurs résultats, en orientant le logo vers le haut.",
    German:
      "Wenn sich das Gerät an einem dicht gedrängten Ort befindet, wurde das Signal möglicherweise blockiert. Stellen Sie daher sicher, dass sich das Gerät an einem offenen Ort befindet, und bewegen Sie das Gerät, so dass das Logo nach oben zeigt.",
    Spanish:
      "Si el dispositivo está en un lugar densamente empaquetado, es posible que haya tenido su señal bloqueada, por lo que asegúrese de que el dispositivo esté en un espacio abierto; mover el dispositivo puede dar mejores resultados, con el logotipo hacia arriba.",
    Italian:
      "Se il dispositivo si trova in un luogo densamente affollato, è possibile che il segnale sia stato bloccato; assicurarsi quindi che il dispositivo si trovi in uno spazio aperto, spostandolo per ottenere risultati migliori, con il logo rivolto verso l'alto.",
    Polish:
      "Jeśli urządzenie znajduje się w gęsto zabudowanym miejscu, sygnał mógł zostać zablokowany. Upewnij się, że urządzenie jest w otwartej przestrzeni — przeniesienie go może poprawić działanie. Logo powinno być skierowane do góry.",
  },
  {
    FIELD1: "t('tracker_support.2.4')",
    English:
      "Please ensure the sim is seated correctly within the tracker, it may have been knocked loose. The gold side of the SIM should be face down in the slot.",
    French:
      "Assurez-vous que la carte SIM est correctement insérée dans le traceur, car elle peut s'être détachée. La face dorée de la carte SIM doit être orientée vers le bas dans la fente.",
    German:
      "Vergewissern Sie sich, dass die SIM-Karte richtig im Tracker sitzt, sie könnte sich gelöst haben. Die goldene Seite der SIM-Karte sollte mit der Vorderseite nach unten im Steckplatz liegen.",
    Spanish:
      "Asegúrese de que la SIM esté correctamente colocada dentro del rastreador, es posible que se haya aflojado. El lado dorado de la SIM debe estar hacia abajo en la ranura.",
    Italian:
      "Assicurati che la sim sia inserita correttamente nel localizzatore, perché potrebbe essersi allentata. Il lato dorato della SIM deve essere rivolto verso il basso nello slot.",
    Polish:
      "Upewnij się, że karta SIM jest prawidłowo osadzona w lokalizatorze. Jeśli wystaje, dociśnij ją cienkim narzędziem, aż kliknie. Złota strona SIM powinna być skierowana w dół do slotu.",
  },
  {
    FIELD1: "t('tracker_support.2.5')",
    English:
      "Failing these steps, please initiate a manual reboot by: Flicking the switch to OFF, waiting 3 seconds, flicking the switch to ON, press and hold the power button for 3 seconds.",
    French:
      "Si vous ne parvenez pas à suivre ces étapes, veuillez procéder à un redémarrage manuel : Mettez l'interrupteur sur OFF, attendez 3 secondes, mettez l'interrupteur sur ON, appuyez sur le bouton d'alimentation et maintenez-le enfoncé pendant 3 secondes.",
    German:
      "Wenn Sie diese Schritte nicht durchführen können, starten Sie bitte einen manuellen Neustart durch: Schalten Sie den Schalter auf OFF, warten Sie 3 Sekunden, schalten Sie den Schalter auf ON und halten Sie den Netzschalter 3 Sekunden lang gedrückt.",
    Spanish:
      "Si estos pasos fallan, inicie un reinicio manual haciendo lo siguiente: Mueva el interruptor a OFF, espere 3 segundos, mueva el interruptor a ON, presione y mantenga presionado el botón de encendido durante 3 segundos.",
    Italian:
      "In caso contrario, è necessario avviare un riavvio manuale: Spegnere l'interruttore, attendere 3 secondi, accendere l'interruttore, tenere premuto il pulsante di accensione per 3 secondi.",
    Polish:
      "Jeśli te kroki nie pomogą, wykonaj ręczny restart: przełącz urządzenie na OFF, odczekaj 3 sekundy, przełącz na ON, a następnie przytrzymaj przycisk zasilania przez 3 sekundy.",
  },
  {
    FIELD1: "t('tracker_support.3.1')",
    English:
      "Please ensure the tracker power terminals are connected to to it's power source (vehicle battery).",
    French:
      "Veillez à ce que les bornes d'alimentation du traceur soient connectées à sa source d'alimentation (batterie du véhicule).",
    German:
      "Bitte stellen Sie sicher, dass die Stromanschlüsse des Trackers mit der Stromquelle (Fahrzeugbatterie) verbunden sind.",
    Spanish:
      "Asegúrese de que los terminales de alimentación del rastreador estén conectados a su fuente de alimentación (batería del vehículo).",
    Italian:
      "Assicurati che i terminali di alimentazione del localizzatore siano collegati alla fonte di alimentazione (batteria del veicolo).",
    Polish:
      "Upewnij się, że przewody zasilające tracker są podłączone do źródła zasilania (akumulatora pojazdu).",
  },
  {
    FIELD1: "t('tracker_support.3.2')",
    English:
      "Please check that it is placed with the logo side facing upwards in an area and it's not too insulated as this could block GPS and Data signal.",
    French:
      "Veillez à ce que le logo soit orienté vers le haut et que l'appareil ne soit pas trop isolé, car il pourrait bloquer le signal GPS et le signal de données.",
    German:
      "Bitte achten Sie darauf, dass es mit dem Logo nach oben in einem Bereich platziert wird und nicht zu sehr isoliert ist, da dies das GPS- und Datensignal blockieren könnte.",
    Spanish:
      "Verifique que esté colocado con el logotipo hacia arriba en un área que no esté demasiado aislada, ya que esto podría bloquear la señal GPS y de datos.",
    Italian:
      "Si prega di verificare che sia posizionato con il lato del logo rivolto verso l'alto in un'area e che non sia troppo isolata, in quanto potrebbe bloccare il segnale GPS e dati.",
    Polish:
      "Sprawdź, czy urządzenie jest poprawnie zamontowane (logo do góry) i czy nie jest zbyt „izolowane”, ponieważ może to blokować sygnał GPS i transmisję danych.",
  },
  {
    FIELD1: "t('tracker_support.3.3')",
    English:
      "Please check for any issues with the cable or inline fuse. It should be firmly clicked into the black plastic clip connected to the tracker. We can provide a replacement if needed.",
    French:
      "Veuillez vérifier que le câble ou le fusible en ligne ne présente pas de problème. Il doit être fermement enclenché dans le crochet en plastique noir connecté au traceur. Nous pouvons fournir un remplacement si nécessaire.",
    German:
      "Überprüfen Sie bitte, ob es Probleme mit dem Kabel oder der Inline-Sicherung gibt. Sie sollte fest in den schwarzen Plastikclip am Tracker eingeklickt sein. Bei Bedarf können wir Ihnen einen Ersatz liefern.",
    Spanish:
      "Revise si hay problemas con el cable o el fusible en línea. Debe estar firmemente encajado en el clip de plástico negro conectado al rastreador. Podemos proporcionarle un reemplazo si es necesario.",
    Italian:
      "Verifica che non vi siano problemi con il cavo o il fusibile in linea. Dovrebbe essere saldamente inserito nella clip di plastica nera collegata al localizzatore. Se necessario, possiamo fornire un ricambio.",
    Polish:
      "Sprawdź, czy nie ma problemów z kablem lub bezpiecznikiem liniowym. Powinien być solidnie wpięty w czarny plastikowy klips połączony z trackerem. W razie potrzeby możemy zapewnić zamiennik.",
  },
  {
    FIELD1: "t('tracker_support.4.1')",
    English:
      "Please ensure the tracker is correctly seated within the OBD-2 port and has not been knocked loose.",
    French:
      "Assurez-vous que le traceur est correctement installé dans le port OBD-2 et qu'il ne s'est pas détaché.",
    German:
      "Bitte vergewissern Sie sich, dass der Tracker richtig im OBD-2 Anschluss sitzt und sich nicht gelockert hat.",
    Spanish:
      "Asegúrese de que el rastreador esté correctamente colocado en el puerto OBD-2 y que no se haya aflojado.",
    Italian:
      "Assicurati che il localizzatore sia correttamente inserito nella porta OBD-2 e non sia stato allentato.",
    Polish:
      "Upewnij się, że lokalizator jest prawidłowo osadzony w porcie OBD-2 i nie został poluzowany.",
  },
  {
    FIELD1: "t('tracker_support.4.2')",
    English:
      "If the tracker has recently been installed, please ensure that the vehicle trim is not blocking the tracker from being fully inserted into the port.  This could prevent the tracker from being able to connect to the vehicle.",
    French:
      "Si le traceur a été récemment installé, assurez-vous que la garniture du véhicule n'empêche pas le traceur d'être complètement inséré dans le port.  Cela pourrait empêcher le traceur de se connecter au véhicule.",
    German:
      "Wenn der Tracker erst kürzlich installiert wurde, stellen Sie bitte sicher, dass die Fahrzeugverkleidung den Tracker nicht daran hindert, vollständig in den Anschluss eingeführt zu werden.  Dies könnte verhindern, dass der Tracker eine Verbindung zum Fahrzeug herstellen kann.",
    Spanish:
      "Si el rastreador se ha instalado recientemente, asegúrese de que el revestimiento del vehículo no esté bloqueando el rastreador para que se inserte completamente en el puerto. Esto podría impedir que el rastreador se conecte al vehículo.",
    Italian:
      "Se il localizzatore è stato installato di recente, assicurati che le finiture del veicolo non blocchino l'inserimento completo del localizzatore nella porta. Ciò potrebbe impedire al localizzatore di collegarsi al veicolo.",
    Polish:
      "Jeśli lokalizator został niedawno zainstalowany, upewnij się, że elementy wykończenia wnętrza pojazdu nie blokują jego pełnego wpięcia do portu. Może to uniemożliwić urządzeniu połączenie z pojazdem.",
  },
  {
    FIELD1: "t('tracker_support.5.1')",
    English:
      'Please check that your Mini is switched on. This can be done by opening the rubber flap and setting the switch to "ON".',
    French:
      'Vérifiez que votre Mini est bien allumée. Pour ce faire, ouvrez la trappe en caoutchouc et placez l\'interrupteur sur "ON".',
    German:
      'Bitte überprüfen Sie, ob Ihr Mini eingeschaltet ist. Öffnen Sie dazu die Gummiklappe und stellen Sie den Schalter auf "ON".',
    Spanish:
      'Verifique que su Mini esté encendido. Esto se puede hacer abriendo la tapa de goma y colocando el interruptor en "ON".',
    Italian:
      'Verifica che il Mini sia acceso. A tal fine, apri lo sportello di gomma e posiziona l\'interruttore su "ON".',
    Polish:
      "Upewnij się, że Twój Mini jest włączony. Możesz to zrobić, otwierając gumową klapkę i ustawiając przełącznik na „ON”.",
  },
  {
    FIELD1: "t('tracker_support.5.2')",
    English:
      "If your Mini won't turn on, it may be out of charge. Please allow the device to charge for at least 4 hours with the supplied cable and a wall adapter.",
    French:
      "Si votre Mini ne s'allume pas, il se peut qu'il soit à court de charge. Laissez l'appareil se recharger pendant au moins 4 heures à l'aide du câble fourni et d'un adaptateur mural.",
    German:
      "Wenn sich Ihr Mini nicht einschalten lässt, ist er möglicherweise nicht ausreichend aufgeladen. Bitte lassen Sie das Gerät mindestens 4 Stunden lang mit dem mitgelieferten Kabel und einem Netzadapter aufladen.",
    Spanish:
      "Si su Mini no se enciende, es posible que esté sin carga. Permita que el dispositivo se cargue durante al menos 4 horas con el cable suministrado y un adaptador de pared.",
    Italian:
      "Se il Mini non si accende, potrebbe essere scarico. Lasciare caricare il dispositivo per almeno 4 ore con il cavo in dotazione e un adattatore a muro.",
    Polish:
      "Jeśli Twój Mini się nie włącza, może być rozładowany. Pozostaw urządzenie do ładowania przez co najmniej 4 godziny przy użyciu dołączonego kabla i zasilacza sieciowego.",
  },
  {
    FIELD1: "t('tracker_support.5.3')",
    English:
      "If the device is in a densely packed location, it may have had its signal blocked, so please ensure that the device is in an open space, moving the device may yield better results, with the logo facing upwards.",
    French:
      "Si l'appareil se trouve dans un endroit très peuplé, il se peut que le signal soit bloqué. Assurez-vous donc que l'appareil se trouve dans un espace ouvert, et déplacez le pour obtenir de meilleurs résultats, en orientant le logo vers le haut.",
    German:
      "Wenn sich das Gerät an einem dicht gedrängten Ort befindet, wurde das Signal möglicherweise blockiert. Stellen Sie daher sicher, dass sich das Gerät an einem offenen Ort befindet, und bewegen Sie das Gerät, so dass das Logo nach oben zeigt.",
    Spanish:
      "Si el dispositivo está en un lugar densamente empaquetado, es posible que haya tenido su señal bloqueada, por lo que asegúrese de que el dispositivo esté en un espacio abierto; mover el dispositivo puede dar mejores resultados, con el logotipo hacia arriba.",
    Italian:
      "Se il dispositivo si trova in un luogo densamente affollato, è possibile che il segnale sia stato bloccato; assicurarsi quindi che il dispositivo si trovi in uno spazio aperto, spostandolo per ottenere risultati migliori, con il logo rivolto verso l'alto.",
    Polish:
      "Jeśli urządzenie znajduje się w gęsto zabudowanym miejscu, sygnał mógł zostać zablokowany. Upewnij się, że urządzenie jest w otwartej przestrzeni — przeniesienie go może poprawić działanie. Logo powinno być skierowane do góry.",
  },
  {
    FIELD1: "t('tracker_support.5.4')",
    English:
      "Please ensure the sim is seated correctly within the tracker. If it's sticking out, please click it back into place with something thin.",
    French:
      "Veillez à ce que la carte sim soit correctement placée dans le traceur. Si elle dépasse, veuillez la remettre en place avec un objet fin.",
    German:
      "Bitte vergewissern Sie sich, dass der Simulator richtig im Tracker sitzt. Wenn er herausragt, klicken Sie ihn bitte mit etwas Dünnem wieder an seinen Platz.",
    Spanish:
      "Asegúrese de que la SIM esté correctamente colocada dentro del rastreador. Si está sobresaliendo, empújela de nuevo en su lugar con algo delgado.",
    Italian:
      "Assicurati che la sim sia inserita correttamente nel localizzatore. Se fuoriesce, è necessario farla rientrare in posizione utilizzando un oggetto sottile.",
    Polish:
      "Upewnij się, że karta SIM jest prawidłowo osadzona w trackerze. Jeśli wystaje, dociśnij ją z powrotem cienkim narzędziem, aż się zatrzaśnie.",
  },
  {
    FIELD1: "t('tracker_support.5.5')",
    English:
      "Failing these steps, please initiate a manual reboot by following these steps: set the switch to OFF, waiting 3 seconds, set the switch to ON.",
    French:
      "En l'absence de ces mesures, veuillez procéder à un redémarrage manuel en suivant les étapes suivantes : mettre l'interrupteur sur OFF, attendre 3 secondes, mettre l'interrupteur sur ON.",
    German:
      "Wenn Sie diese Schritte nicht durchführen können, führen Sie bitte einen manuellen Neustart durch: Stellen Sie den Schalter auf OFF, warten Sie 3 Sekunden und stellen Sie den Schalter auf ON.",
    Spanish:
      "Si estos pasos fallan, inicie un reinicio manual siguiendo estos pasos: mueva el interruptor a OFF, espere 3 segundos, y luego coloque el interruptor en ON.",
    Italian:
      "In caso contrario, è necessario avviare un riavvio manuale seguendo la seguente procedura: impostare l'interruttore su OFF, attendere 3 secondi e impostare l'interruttore su ON.",
    Polish:
      "Jeśli te kroki nie pomogą, wykonaj ręczny restart, wykonując następujące czynności: ustaw przełącznik na OFF, odczekaj 3 sekundy, następnie ustaw go na ON.",
  },
  {
    FIELD1: "t('tracker_support.6.1')",
    English:
      "Please ensure the tracker power terminals are connected to to it's power source (vehicle battery).",
    French:
      "Veillez à ce que les bornes d'alimentation du traceur soient connectées à sa source d'alimentation (batterie du véhicule).",
    German:
      "Bitte stellen Sie sicher, dass die Stromanschlüsse des Trackers mit der Stromquelle (Fahrzeugbatterie) verbunden sind.",
    Spanish:
      "Asegúrese de que los terminales de alimentación del rastreador estén conectados a su fuente de alimentación (batería del vehículo).",
    Italian:
      "Assicurarsi che i terminali di alimentazione del localizzatore siano collegati alla fonte di alimentazione (batteria del veicolo).",
    Polish:
      "Upewnij się, że zaciski zasilania lokalizatora są prawidłowo podłączone do źródła zasilania (akumulatora pojazdu).",
  },
  {
    FIELD1: "t('tracker_support.6.2')",
    English:
      "Please check that it's logo side facing up in an area and it's not too insulated.",
    French:
      "Vérifiez que la face du logo est orientée vers le haut dans une zone et qu'elle n'est pas trop isolée.",
    German:
      "Vergewissern Sie sich, dass das Logo in einem Bereich nach oben zeigt und nicht zu sehr isoliert ist.",
    Spanish:
      "Verifique que esté colocado con el logotipo hacia arriba en un área que no esté demasiado aislada.",
    Italian:
      "Verificare che il lato del logo sia rivolto verso l'alto in un'area e che non sia troppo isolato.",
    Polish:
      "Upewnij się, że urządzenie jest umieszczone w miejscu z logo skierowanym do góry i nie jest zbyt „izolowane” (otoczone materiałami, które mogą blokować sygnał).",
  },
  {
    FIELD1: "t('tracker_support.6.3')",
    English:
      "Please check for any issues with the cable or inline fuse. It should be firmly clicked into the black plastic clip connected to the tracker. We can provide a replacement if needed!",
    French:
      "Veuillez vérifier que le câble ou le fusible en ligne ne présente pas de problème. Il doit être fermement enclenché dans le crochet en plastique noir connecté au traceur. Nous pouvons fournir un remplacement si nécessaire !",
    German:
      "Überprüfen Sie bitte, ob es Probleme mit dem Kabel oder der Inline-Sicherung gibt. Sie sollte fest in den schwarzen Plastikclip am Tracker eingerastet sein. Bei Bedarf können wir Ihnen einen Ersatz liefern!",
    Spanish:
      "Revise si hay problemas con el cable o el fusible en línea. Debe estar firmemente encajado en el clip de plástico negro conectado al rastreador. ¡Podemos proporcionarle un reemplazo si es necesario!",
    Italian:
      "Verificare che non vi siano problemi con il cavo o il fusibile in linea. Dovrebbe essere saldamente inserito nella clip di plastica nera collegata al localizzatore. Se necessario, possiamo fornire un ricambio!",
    Polish:
      "Sprawdź, czy nie ma problemów z kablem lub bezpiecznikiem liniowym. Powinien być solidnie wpięty w czarny plastikowy klips połączony z trackerem. W razie potrzeby możemy wysłać zamiennik.",
  },
  {
    FIELD1: "t('tracker_support.9.1')",
    English:
      'Please check that your Mini is switched on. This can be done by opening the rubber flap and setting the switch to "ON".',
    French:
      'Vérifiez que votre Mini est bien allumé. Pour ce faire, ouvrez la trappe en caoutchouc et placez l\'interrupteur sur "ON".',
    German:
      'Bitte überprüfen Sie, ob Ihr Mini eingeschaltet ist. Öffnen Sie dazu die Gummiklappe und stellen Sie den Schalter auf "ON".',
    Spanish:
      'Verifique que su Mini esté encendido. Esto se puede hacer abriendo la tapa de goma y colocando el interruptor en "ON".',
    Italian:
      "Verificare che il Mini sia acceso. A tal fine, aprire lo sportello di gomma e posizionare l'interruttore su “ON”.",
    Polish:
      "Upewnij się, że Twój Mini jest włączony. Zrób to, otwierając gumową klapkę i ustawiając przełącznik na „ON”.",
  },
  {
    FIELD1: "t('tracker_support.9.2')",
    English:
      "If your Mini won't turn on, it may be out of charge. Please allow the device to charge for at least 4 hours with the supplied cable and a wall adapter.",
    French:
      "Si votre Mini ne s'allume pas, il se peut qu'il soit à court de charge. Laissez l'appareil se recharger pendant au moins 4 heures à l'aide du câble fourni et d'un adaptateur mural.",
    German:
      "Wenn sich Ihr Mini nicht einschalten lässt, ist er möglicherweise nicht ausreichend aufgeladen. Bitte lassen Sie das Gerät mindestens 4 Stunden lang mit dem mitgelieferten Kabel und einem Netzadapter aufladen.",
    Spanish:
      "Si su Mini no se enciende, es posible que esté sin carga. Permita que el dispositivo se cargue durante al menos 4 horas con el cable suministrado y un adaptador de pared.",
    Italian:
      "Se il Mini non si accende, potrebbe essere scarico. Lasciare caricare il dispositivo per almeno 4 ore con il cavo in dotazione e un adattatore a muro.",
    Polish:
      "Jeśli Twój Mini się nie włącza, może być rozładowany. Pozostaw urządzenie do ładowania przez co najmniej 4 godziny przy użyciu dołączonego kabla i zasilacza sieciowego.",
  },
  {
    FIELD1: "t('tracker_support.9.3')",
    English:
      "If the device is in a densely packed location, it may have had its signal blocked, so please ensure that the device is in an open space, moving the device may yield better results, with the logo facing upwards.",
    French:
      "Si l'appareil se trouve dans un endroit très peuplé, il se peut que le signal soit bloqué. Assurez-vous donc que l'appareil se trouve dans un espace ouvert, et déplacez le pour obtenir de meilleurs résultats, en orientant le logo vers le haut.",
    German:
      "Wenn sich das Gerät an einem dicht gedrängten Ort befindet, wurde das Signal möglicherweise blockiert. Stellen Sie daher sicher, dass sich das Gerät an einem offenen Ort befindet, und bewegen Sie das Gerät, so dass das Logo nach oben zeigt.",
    Spanish:
      "Si el dispositivo está en un lugar densamente empaquetado, es posible que haya tenido su señal bloqueada, por lo que asegúrese de que el dispositivo esté en un espacio abierto; mover el dispositivo puede dar mejores resultados, con el logotipo hacia arriba.",
    Italian:
      "Se il dispositivo si trova in un luogo densamente affollato, è possibile che il segnale sia stato bloccato; assicurarsi quindi che il dispositivo si trovi in uno spazio aperto, spostandolo per ottenere risultati migliori, con il logo rivolto verso l'alto.",
    Polish:
      "Jeśli urządzenie znajduje się w gęsto zabudowanym miejscu, sygnał mógł zostać zablokowany. Upewnij się, że urządzenie jest w otwartej przestrzeni — przeniesienie go może poprawić działanie, a logo powinno być skierowane do góry.",
  },
  {
    FIELD1: "t('tracker_support.9.4')",
    English:
      "Please ensure the sim is seated correctly within the tracker. If it's sticking out, please click it back into place with something thin.",
    French:
      "Veillez à ce que la carte sim soit correctement placée dans le traceur. Si elle dépasse, veuillez la remettre en place avec un objet fin.",
    German:
      "Bitte vergewissern Sie sich, dass der Simulator richtig im Tracker sitzt. Wenn er herausragt, klicken Sie ihn bitte mit etwas Dünnem wieder an seinen Platz.",
    Spanish:
      "Asegúrese de que la SIM esté correctamente colocada dentro del rastreador. Si está sobresaliendo, empújela de nuevo en su lugar con algo delgado.",
    Italian:
      "Assicurarsi che la sim sia inserita correttamente nel localizzatore. Se fuoriesce, è necessario farla rientrare in posizione utilizzando un oggetto sottile.",
    Polish:
      "Upewnij się, że karta SIM jest prawidłowo osadzona w lokalizatorze. Jeśli wystaje, dociśnij ją z powrotem cienkim narzędziem, aż się zatrzaśnie.",
  },
  {
    FIELD1: "t('tracker_support.9.5')",
    English:
      "Failing these steps, please initiate a manual reboot by following these steps: set the switch to OFF, waiting 3 seconds, set the switch to ON.",
    French:
      "En l'absence de ces mesures, veuillez procéder à un redémarrage manuel en suivant les étapes suivantes : mettre l'interrupteur sur OFF, attendre 3 secondes, mettre l'interrupteur sur ON.",
    German:
      "Wenn Sie diese Schritte nicht durchführen können, führen Sie bitte einen manuellen Neustart durch: Stellen Sie den Schalter auf OFF, warten Sie 3 Sekunden und stellen Sie den Schalter auf ON.",
    Spanish:
      "Si estos pasos fallan, inicie un reinicio manual siguiendo estos pasos: mueva el interruptor a OFF, espere 3 segundos, y luego coloque el interruptor en ON.",
    Italian:
      "In caso contrario, avviare un riavvio manuale seguendo la seguente procedura: impostare l'interruttore su OFF, attendere 3 secondi e impostare l'interruttore su ON.",
    Polish:
      "Jeśli te kroki nie pomogą, wykonaj ręczny restart, wykonując następujące czynności: ustaw przełącznik na OFF, odczekaj 3 sekundy, następnie ustaw go na ON.",
  },
  {
    FIELD1: "t('tracker_support.11.1')",
    English:
      "Please ensure the tracker it is correctly seated within the obd-2 port and has not been knocked loose.",
    French:
      "Assurez-vous que le traceur est correctement installé dans le port obd-2 et qu'il ne s'est pas détaché.",
    German:
      "Bitte vergewissern Sie sich, dass der Tracker richtig in der Obd-2 Schnittstelle sitzt und nicht herausgeschlagen wurde.",
    Spanish:
      "Asegúrese de que el rastreador esté correctamente colocado en el puerto OBD-2 y que no se haya aflojado.",
    Italian:
      "Assicurarsi che il localizzatore sia correttamente inserito nella porta obd-2 e non sia stato allentato.",
    Polish:
      "Upewnij się, że lokalizator jest prawidłowo osadzony w porcie OBD-2 i nie został poluzowany.",
  },
  {
    FIELD1: "t('tracker_support.11.2')",
    English:
      "If the tracker has recently been installed, please ensure that the vehicle trim is not blocking the tracker from being fully inserted into the port.  ",
    French:
      "Si le traceur a été récemment installé, assurez-vous que la garniture du véhicule n'empêche pas le traceur d'être complètement inséré dans le port.  ",
    German:
      "Wenn Sie diese Schritte nicht durchführen können, starten Sie bitte einen manuellen Neustart durch: Schalten Sie den Schalter auf AUS, warten Sie 3 Sekunden, schalten Sie den Schalter auf ON und halten Sie den Netzschalter 3 Sekunden lang gedrückt.",
    Spanish:
      "Si el rastreador se ha instalado recientemente, asegúrese de que el revestimiento del vehículo no esté bloqueando el rastreador para que se inserte completamente en el puerto.",
    Italian:
      "Se il localizzatore è stato installato di recente, assicurarsi che il rivestimento del veicolo non blocchi l'inserimento completo del localizzatore nella porta.",
    Polish:
      "Jeśli lokalizator został niedawno zainstalowany, upewnij się, że elementy wykończenia wnętrza pojazdu nie blokują jego pełnego wpięcia do portu.",
  },
  {
    FIELD1: "t('tracker_support.12.1')",
    English:
      "Please ensure the tracker it is correctly seated within the obd-2 port and has not been knocked loose.",
    French:
      "Assurez-vous que le traceur est correctement installé dans le port obd-2 et qu'il ne s'est pas détaché.",
    German:
      "Bitte vergewissern Sie sich, dass der Tracker richtig in der Obd-2 Schnittstelle sitzt und nicht herausgeschlagen wurde.",
    Spanish:
      "Asegúrese de que el rastreador esté correctamente colocado en el puerto OBD-2 y que no se haya aflojado.",
    Italian:
      "Assicurarsi che il localizzatore sia correttamente inserito nella porta obd-2 e non sia stato allentato.",
    Polish:
      "Upewnij się, że lokalizator jest prawidłowo osadzony w porcie OBD-2 i nie został poluzowany.",
  },
  {
    FIELD1: "t('tracker_support.12.2')",
    English:
      "If the tracker has recently been installed, please ensure that the vehicle trim is not blocking the tracker from being fully inserted into the port.  ",
    French:
      "Si le traceur a été récemment installé, assurez-vous que la garniture du véhicule n'empêche pas le traceur d'être complètement inséré dans le port.  ",
    German:
      "Wenn der Tracker erst kürzlich installiert wurde, stellen Sie bitte sicher, dass die Fahrzeugverkleidung den Tracker nicht daran hindert, vollständig in den Anschluss eingeführt zu werden.  ",
    Spanish:
      "Si el rastreador se ha instalado recientemente, asegúrese de que el revestimiento del vehículo no esté bloqueando el rastreador para que se inserte completamente en el puerto.",
    Italian:
      "Se il localizzatore è stato installato di recente, assicurarsi che il rivestimento del veicolo non blocchi l'inserimento completo del localizzatore nella porta.",
    Polish:
      "Jeśli lokalizator został niedawno zainstalowany, upewnij się, że elementy wykończenia wnętrza pojazdu nie blokują jego pełnego wpięcia do portu.",
  },
  {
    FIELD1: "t('tracker_support.16.1')",
    English:
      'Please check that your Mag is switched on. This can be done by opening the rubber flap and flicking the sliding switch to "ON".',
    French:
      'Veuillez vérifier que votre Mag est bien allumé. Pour ce faire, ouvrez la trappe en caoutchouc et placez l\'interrupteur coulissant sur "ON".',
    German:
      "Bitte überprüfen Sie, ob Ihr Mag eingeschaltet ist. Öffnen Sie dazu die Gummiklappe und stellen Sie den Schiebeschalter auf „ON“.",
    Spanish:
      'Verifique que su Mag esté encendido. Esto se puede hacer abriendo la tapa de goma y moviendo el interruptor deslizante a "ON".',
    Italian:
      "Verificare che il Mag sia acceso. A tal fine, aprire lo sportello di gomma e spostare l'interruttore scorrevole su “ON”.",
    Polish:
      "Upewnij się, że Twój Mag jest włączony. Możesz to zrobić, otwierając gumową klapkę i ustawiając przełącznik suwakowy na „ON”.",
  },
  {
    FIELD1: "t('tracker_support.16.2')",
    English:
      "If your Mag won't turn on, it may be out of charge. Please allow the device to charge for at least 6 hours with the supplied cable and a wall plug.",
    French:
      "Si votre Mag ne s'allume pas, il se peut qu'il soit déchargé. Laissez l'appareil se recharger pendant au moins 6 heures à l'aide du câble fourni et d'une prise murale.",
    German:
      "Wenn sich Ihr Mag nicht einschalten lässt, ist es möglicherweise nicht ausreichend geladen. Bitte lassen Sie das Gerät mindestens 6 Stunden lang mit dem mitgelieferten Kabel und einem Netzstecker aufladen.",
    Spanish:
      "Si su Mag no se enciende, es posible que esté sin carga. Permita que el dispositivo se cargue durante al menos 6 horas con el cable suministrado y un enchufe de pared.",
    Italian:
      "Se il Mag non si accende, potrebbe essere scarico. Lasciare caricare il dispositivo per almeno 6 ore con il cavo in dotazione e una spina a muro.",
    Polish:
      "Jeśli Twój Mag się nie włącza, może być rozładowany. Pozostaw urządzenie do ładowania przez co najmniej 6 godzin przy użyciu dołączonego kabla i zasilacza sieciowego.",
  },
  {
    FIELD1: "t('tracker_support.16.3')",
    English:
      "If the device is in a densely packed location, it may have had its signal blocked, so please ensure that the device is in an open space, moving the device may yield better results, with the logo facing upwards.",
    French:
      "Si l'appareil se trouve dans un endroit très peuplé, il se peut que le signal soit bloqué. Assurez-vous donc que l'appareil se trouve dans un espace ouvert, et déplacez le pour obtenir de meilleurs résultats, en orientant le logo vers le haut.",
    German:
      "Wenn sich das Gerät an einem dicht gedrängten Ort befindet, wurde das Signal möglicherweise blockiert. Stellen Sie daher sicher, dass sich das Gerät an einem offenen Ort befindet, und bewegen Sie das Gerät, so dass das Logo nach oben zeigt.",
    Spanish:
      "Si el dispositivo está en un lugar densamente empaquetado, es posible que haya tenido su señal bloqueada, por lo que asegúrese de que el dispositivo esté en un espacio abierto; mover el dispositivo puede dar mejores resultados, con el logotipo hacia arriba.",
    Italian:
      "Se il dispositivo si trova in un luogo densamente affollato, è possibile che il segnale sia stato bloccato; assicurarsi quindi che il dispositivo si trovi in uno spazio aperto, spostandolo per ottenere risultati migliori, con il logo rivolto verso l'alto.",
    Polish:
      "Jeśli urządzenie znajduje się w gęsto zabudowanym miejscu, sygnał mógł zostać zablokowany. Upewnij się, że urządzenie jest w otwartej przestrzeni — przeniesienie go może poprawić działanie, a logo powinno być skierowane do góry.",
  },
  {
    FIELD1: "t('tracker_support.16.4')",
    English:
      "Please ensure the sim is seated correctly within the tracker. If it's sticking out, please click it back into place with something thin.",
    French:
      "Veillez à ce que la carte sim soit correctement placée dans le traceur. Si elle dépasse, veuillez la remettre en place avec un objet fin.",
    German:
      "Bitte vergewissern Sie sich, dass der Simulator richtig im Tracker sitzt. Wenn er herausragt, klicken Sie ihn bitte mit etwas Dünnem wieder an seinen Platz.",
    Spanish:
      "Asegúrese de que la SIM esté correctamente colocada dentro del rastreador. Si está sobresaliendo, empújela de nuevo en su lugar con algo delgado.",
    Italian:
      "Assicurarsi che la sim sia inserita correttamente nel localizzatore. Se fuoriesce, è necessario farla rientrare in posizione utilizzando un oggetto sottile.",
    Polish:
      "Upewnij się, że karta SIM jest prawidłowo osadzona w trackerze. Jeśli wystaje, dociśnij ją z powrotem cienkim narzędziem, aż się zatrzaśnie.",
  },
  {
    FIELD1: "t('tracker_support.16.5')",
    English:
      "Failing these steps, please initiate a manual reboot by following these steps: set the switch to OFF, waiting 3 seconds, set the switch to ON.",
    French:
      "En l'absence de ces mesures, veuillez procéder à un redémarrage manuel en suivant les étapes suivantes : mettre l'interrupteur sur OFF, attendre 3 secondes, mettre l'interrupteur sur ON.",
    German:
      "Wenn Sie diese Schritte nicht durchführen können, führen Sie bitte einen manuellen Neustart durch: Stellen Sie den Schalter auf OFF, warten Sie 3 Sekunden und stellen Sie den Schalter auf ON.",
    Spanish:
      "Si estos pasos fallan, inicie un reinicio manual siguiendo estos pasos: mueva el interruptor a OFF, espere 3 segundos, y luego coloque el interruptor en ON.",
    Italian:
      "In caso contrario, avviare un riavvio manuale seguendo la seguente procedura: impostare l'interruttore su OFF, attendere 3 secondi e impostare l'interruttore su ON.",
    Polish:
      "Jeśli te kroki nie pomogą, wykonaj ręczny restart, wykonując następujące czynności: ustaw przełącznik na OFF, odczekaj 3 sekundy, a następnie ustaw go na ON.",
  },
  {
    FIELD1: "t('tracker_support.17.1')",
    English:
      'Please check that your Mag is switched on. This can be done by opening the rubber flap and setting the switch to "ON".',
    French:
      'Veuillez vérifier que votre Mag est bien allumé. Pour ce faire, ouvrez la trappe en caoutchouc et placez l\'interrupteur coulissant sur "ON".',
    German:
      "Bitte überprüfen Sie, ob Ihr Mag eingeschaltet ist. Öffnen Sie dazu die Gummiklappe und stellen Sie den Schalter auf „ON“.",
    Spanish:
      'Verifique que su Mag esté encendido. Esto se puede hacer abriendo la tapa de goma y colocando el interruptor en "ON".',
    Italian:
      "Verificare che il Mag sia acceso. Per farlo, aprire lo sportello di gomma e posizionare l'interruttore su “ON”.",
    Polish:
      "Upewnij się, że Twój Mag jest włączony. Możesz to zrobić, otwierając gumową klapkę i ustawiając przełącznik na „ON”.",
  },
  {
    FIELD1: "t('tracker_support.17.2')",
    English:
      "If your Mag won't turn on, it may be out of charge. Please allow the device to charge for at least 6 hours with the supplied cable and a wall adapter.",
    French:
      "Si votre Mag ne s'allume pas, il se peut qu'il soit déchargé. Laissez l'appareil se recharger pendant au moins 6 heures à l'aide du câble fourni et d'un adaptateur mural.",
    German:
      "Wenn sich Ihr Mag nicht einschalten lässt, ist es möglicherweise nicht ausreichend geladen. Bitte lassen Sie das Gerät mindestens 6 Stunden lang mit dem mitgelieferten Kabel und einem Netzadapter aufladen.",
    Spanish:
      "Si su Mag no se enciende, es posible que esté sin carga. Permita que el dispositivo se cargue durante al menos 6 horas con el cable suministrado y un adaptador de pared.",
    Italian:
      "Se il Mag non si accende, potrebbe essere scarico. Lasciare caricare il dispositivo per almeno 6 ore con il cavo in dotazione e un adattatore a muro.",
    Polish:
      "Jeśli Twój Mag się nie włącza, może być rozładowany. Pozostaw urządzenie do ładowania przez co najmniej 6 godzin przy użyciu dołączonego kabla i zasilacza sieciowego.",
  },
  {
    FIELD1: "t('tracker_support.17.3')",
    English:
      "If the device is in a densely packed location, it may have had its signal blocked, so please ensure that the device is in an open space, moving the device may yield better results, with the logo facing upwards.",
    French:
      "Si l'appareil se trouve dans un endroit très peuplé, il se peut que le signal soit bloqué. Assurez-vous donc que l'appareil se trouve dans un espace ouvert, et déplacez le pour obtenir de meilleurs résultats, en orientant le logo vers le haut.",
    German:
      "Wenn sich das Gerät an einem dicht gedrängten Ort befindet, wurde das Signal möglicherweise blockiert. Stellen Sie daher sicher, dass sich das Gerät an einem offenen Ort befindet, und bewegen Sie das Gerät, so dass das Logo nach oben zeigt.",
    Spanish:
      "Si el dispositivo está en un lugar densamente empaquetado, es posible que haya tenido su señal bloqueada, por lo que asegúrese de que el dispositivo esté en un espacio abierto; mover el dispositivo puede dar mejores resultados, con el logotipo hacia arriba.",
    Italian:
      "Se il dispositivo si trova in un luogo densamente affollato, è possibile che il segnale sia stato bloccato; assicurarsi quindi che il dispositivo si trovi in uno spazio aperto, spostandolo per ottenere risultati migliori, con il logo rivolto verso l'alto.",
    Polish:
      "Jeśli urządzenie znajduje się w gęsto zabudowanym miejscu, sygnał mógł zostać zablokowany. Upewnij się, że urządzenie znajduje się w otwartej przestrzeni — przeniesienie go może poprawić działanie. Logo powinno być skierowane do góry.",
  },
  {
    FIELD1: "t('tracker_support.17.4')",
    English:
      "Please ensure the sim is seated correctly within the tracker. If it's sticking out, please click it back into place with something thin.",
    French:
      "Veillez à ce que la carte sim soit correctement placée dans le traceur. Si elle dépasse, veuillez la remettre en place avec un objet fin.",
    German:
      "Bitte vergewissern Sie sich, dass der Simulator richtig im Tracker sitzt. Wenn er herausragt, klicken Sie ihn bitte mit etwas Dünnem wieder an seinen Platz.",
    Spanish:
      "Asegúrese de que la SIM esté correctamente colocada dentro del rastreador. Si está sobresaliendo, empújela de nuevo en su lugar con algo delgado.",
    Italian:
      "Assicurarsi che la sim sia inserita correttamente nel localizzatore. Se fuoriesce, è necessario farla rientrare in posizione utilizzando un oggetto sottile.",
    Polish:
      "Upewnij się, że karta SIM jest prawidłowo osadzona w trackerze. Jeśli wystaje, dociśnij ją z powrotem cienkim narzędziem, aż się zatrzaśnie.",
  },
  {
    FIELD1: "t('tracker_support.17.5')",
    English:
      "Failing these steps, please initiate a manual reboot by following these steps: set the switch to OFF, waiting 3 seconds, set the switch to ON.",
    French:
      "En l'absence de ces mesures, veuillez procéder à un redémarrage manuel en suivant les étapes suivantes : mettre l'interrupteur sur OFF, attendre 3 secondes, mettre l'interrupteur sur ON.",
    German:
      "Wenn Sie diese Schritte nicht durchführen können, führen Sie bitte einen manuellen Neustart durch: Stellen Sie den Schalter auf OFF, warten Sie 3 Sekunden und stellen Sie den Schalter auf ON.",
    Spanish:
      "Si estos pasos fallan, inicie un reinicio manual siguiendo estos pasos: mueva el interruptor a OFF, espere 3 segundos, y luego coloque el interruptor en ON.",
    Italian:
      "In caso contrario, avviare un riavvio manuale seguendo la seguente procedura: impostare l'interruttore su OFF, attendere 3 secondi e impostare l'interruttore su ON.",
    Polish:
      "Jeśli te kroki nie pomogą, wykonaj ręczny restart: ustaw przełącznik na OFF, odczekaj 3 sekundy, a następnie ustaw go z powrotem na ON.",
  },
  {
    FIELD1: "support.trackers.bottom",
    English:
      "Please wait a few minutes after following these steps for your tracker to reconnect to our network...",
    French:
      "Veuillez attendre quelques minutes après avoir suivi ces étapes pour que votre traceur se reconnecte à notre réseau...",
    German:
      "Bitte warten Sie nach diesen Schritten einige Minuten, bis sich Ihr Tracker wieder mit unserem Netzwerk verbunden hat...",
    Spanish:
      "Espere unos minutos después de seguir estos pasos para que su rastreador se vuelva a conectar a nuestra red...",
    Italian:
      "Attendi qualche minuto dopo aver seguito questi passaggi affinché il localizzatore si riconnetta alla nostra rete...",
    Polish:
      "Po wykonaniu tych kroków odczekaj kilka minut, aż Twój tracker ponownie połączy się z naszą siecią.",
  },
  {
    FIELD1: "support.trackers.contact",
    English: "Couldn't get it to work?",
    French: "Vous n'arrivez pas à le faire fonctionner ?",
    German: "Sie konnten es nicht zum Laufen bringen?",
    Spanish: "¿No pudo hacerlo funcionar?",
    Italian: "Il problema persiste?",
    Polish: "Nie udało się?",
  },
  {
    FIELD1: "support.trackers.contactbtn",
    English: "Contact Support",
    French: "Contacter le support",
    German: "Kontakt Unterstützung",
    Spanish: "Contacte al Soporte",
    Italian: "Contatta l'assistenza",
    Polish: "Skontaktuj się z pomocą techniczną.",
  },
  {
    FIELD1: "t('track.link_sharing.button')",
    English: "Share",
    French: "Partager",
    German: "Teilen",
    Spanish: "Compartir",
    Italian: "Condividi",
    Polish: "Udostępnij",
  },
  {
    FIELD1: "t('track.link_sharing.title_main')",
    English: "Share your tracker's locations",
    French: "Partagez les emplacements de vos traceurs",
    German: "Teile die Standorte deines  Trackers",
    Spanish: "Comparta las ubicaciones de su rastreador",
    Italian: "Condividi le posizioni del tuo tracker",
    Polish: "Udostępnij lokalizację swojego lokalizatora",
  },
  {
    FIELD1: "t('track.link_sharing.title_create')",
    English: "New share",
    French: "Nouveau partage",
    German: "Neue Freigabe",
    Spanish: "Nueva compartición",
    Italian: "Nuova condivisione",
    Polish: "Nowe udostępnienie",
  },
  {
    FIELD1: "t('track.link_sharing.title_view')",
    English: "View share",
    French: "Afficher le partage",
    German: "Freigabe anschauen",
    Spanish: "Ver compartición",
    Italian: "Visualizza condivisione",
    Polish: "Wyświetl udostępnienie",
  },
  {
    FIELD1: "t('track.link_sharing.title_edit')",
    English: "Edit share",
    French: "Modifier le partage",
    German: "Bearbeitung teilen",
    Spanish: "Editar compartición",
    Italian: "Modifica condivisione",
    Polish: "Edytuj udostępnienie",
  },
  {
    FIELD1: "t('track.link_sharing.title_delete')",
    English: "Delete share",
    French: "Supprimer le partage",
    German: "Freigabe löschen",
    Spanish: "Eliminar compartición",
    Italian: "Cancella condivisione",
    Polish: "Usuń udostępnienie",
  },
  {
    FIELD1: "t('track.link_sharing.title_success')",
    English: "Share created",
    French: "Partage créé",
    German: "Das Teilen wurde erstellt",
    Spanish: "Compartición creada",
    Italian: "Condivisione creata",
    Polish: "Udostępnienie utworzone",
  },
  {
    FIELD1: "t('track.link_sharing.toast_success')",
    English: "Share Link created successfully",
    French: "Lien de partage créé avec succès",
    German: "Freigabelink wurde erfolgreich erstellt",
    Spanish: "Enlace de compartición creado con éxito",
    Italian: "Link di condivisione creato con successo",
    Polish: "Link udostępnienia utworzony pomyślnie",
  },
  {
    FIELD1: "t('track.link_sharing.toast_update')",
    English: "Share Link updated successfully",
    French: "Lien de partage mis à jour avec succès",
    German: "Freigabelink wurde erfolgreich hochgeladen",
    Spanish: "Enlace de compartición actualizado con éxito",
    Italian: "Link di condivisione aggiornato con successo",
    Polish: "Link zaktualizowany pomyślnie",
  },
  {
    FIELD1: "t('track.link_sharing.toast_delete')",
    English: "Share Link delete successfully",
    French: "Lien de partage supprimé avec succès",
    German: "Freigabelink wurde erfolgreich gelöscht",
    Spanish: "Enlace de compartición eliminado con éxito",
    Italian: "Condivisione link cancellata con successo",
    Polish: "Link usunięty pomyślnie",
  },
  {
    FIELD1: "t('track.link_sharing.toast_copied')",
    English: "Share Link copied to clipboard",
    French: "Lien de partage copié dans le presse-papiers",
    German: "Freigabelink wurde erfolgreich in die Zwischenablage kopiert",
    Spanish: "Enlace de compartición copiado al portapapeles",
    Italian: "Link da condividere copiato negli appunti",
    Polish: "Link skopiowany do schowka",
  },
  {
    FIELD1: "t('track.link_sharing.label_name')",
    English: "Name",
    French: "Nom",
    German: "Name",
    Spanish: "Nombre",
    Italian: "Nome",
    Polish: "Nazwa",
  },
  {
    FIELD1: "t('track.link_sharing.label_trackers')",
    English: "Trackers",
    French: "Traceurs",
    German: "Tracker",
    Spanish: "Rastreadores",
    Italian: "Dispositivo",
    Polish: "Lokalizatory",
  },
  {
    FIELD1: "t('track.link_sharing.label_expiry')",
    English: "Expiry",
    French: "Expiration",
    German: "Ablaufdatum ",
    Spanish: "Vencimiento",
    Italian: "Scadenza",
    Polish: "Wygaśnięcie",
  },
  {
    FIELD1: "t('track.link_sharing.label_share')",
    English: "Share Link",
    French: "Partager le lien",
    German: "Freigabelink",
    Spanish: "Enlace de compartición",
    Italian: "Condividi link",
    Polish: "Link udostępnienia",
  },
  {
    FIELD1: "t('track.link_sharing.message_success')",
    English: "Share your tracker with this link",
    French: "Partagez votre traceur avec ce lien",
    German: "Teile deinen Tracker mit diesem Link",
    Spanish: "Comparta su rastreador con este enlace",
    Italian: "Condividi il tuo dispositivo con questo link",
    Polish: "Udostępnij lokalizację trackera przez link",
  },
  {
    FIELD1: "t('track.link_sharing.message_delete')",
    English: "Please confirm if you want to delete this share link",
    French: "Veuillez confirmer si vous souhaitez supprimer ce lien de partage",
    German: "Bitte bestätige, ob du diesen Freigabelink löschen möchtest",
    Spanish:
      "Por favor, confirme si desea eliminar este enlace de compartición",
    Italian: "Confermare se si desidera eliminare questo link di condivisione",
    Polish: "Potwierdź usunięcie linku",
  },
  {
    FIELD1: "t('track.link_sharing.placeholder_all')",
    English: "Select All",
    French: "Sélectionner tout",
    German: "Alle auswählen",
    Spanish: "Seleccionar todo",
    Italian: "Seleziona tutto",
    Polish: "Wybierz wszystkie",
  },
  {
    FIELD1: "t('track.link_sharing.placeholder_search')",
    English: "Search Trackers or IMEI",
    French: "Recherche de traceurs ou d'IMEI",
    German: "Tracker oder IMEI auswählen",
    Spanish: "Buscar rastreadores o IMEI",
    Italian: "Ricerca di localizzatori o IMEI",
    Polish: "Wyszukaj lokalizatory lub IMEI",
  },
  {
    FIELD1: "t('track.link_sharing.all')",
    English: "All",
    French: "Tous",
    German: "Alle auswählen",
    Spanish: "Todo",
    Italian: "Tutto",
    Polish: "Wszystko",
  },
  {
    FIELD1: "t('track.link_sharing.max40')",
    English: "Max. 40 Chars",
    French: "Max. 40 caractères",
    German: "Max. 40 Char.",
    Spanish: "Máx. 40 caracteres",
    Italian: "Max. 40 caratteri",
    Polish: "Maks. 40 znaków",
  },
  {
    FIELD1: "t('track.link_sharing.expire')",
    English: "Share will expire",
    French: "Le partage va expirer",
    German: "Die Freigabe läuft ab ",
    Spanish: "La compartición vencerá",
    Italian: "La condivisione sta per scadere",
    Polish: "Udostępnienie wygaśnie",
  },
  {
    FIELD1: "t('track.link_sharing.expired')",
    English: "Share expired",
    French: "Le partage a expiré",
    German: "Die Freigabe ist abgelaufen ",
    Spanish: "Compartición vencida",
    Italian: "Condivisione scaduta",
    Polish: "Udostępnienie wygasło",
  },
  {
    FIELD1: "t('track.link_sharing.expire1')",
    English: "Expires",
    French: "Expire",
    German: "Läuft bald ab",
    Spanish: "Vence",
    Italian: "In scadenza",
    Polish: "Link wygaśnie",
  },
  {
    FIELD1: "t('track.link_sharing.expired1')",
    English: "Expired",
    French: "Expiré",
    German: "Ist abgelaufen ",
    Spanish: "Vencido",
    Italian: "Scaduti",
    Polish: "Wygasł",
  },
  {
    FIELD1: "t('track.link_sharing.on')",
    English: "on",
    French: "le",
    German: "auf",
    Spanish: "en",
    Italian: "su",
    Polish: "włączone",
  },
  {
    FIELD1: "t('track.link_sharing.create')",
    English: "Create",
    French: "Créer",
    German: "erstellen",
    Spanish: "Crear",
    Italian: "Crea",
    Polish: "Tworzenie",
  },
  {
    FIELD1: "t('track.link_sharing.cancel')",
    English: "Cancel",
    French: "Annuler",
    German: "abbrechen",
    Spanish: "Cancelar",
    Italian: "Cancella",
    Polish: "Anuluj",
  },
  {
    FIELD1: "t('track.link_sharing.edit')",
    English: "Edit",
    French: "Modifier",
    German: "bearbeiten",
    Spanish: "Editar",
    Italian: "Modifica",
    Polish: "Edytuj",
  },
  {
    FIELD1: "t('track.link_sharing.delete')",
    English: "Delete",
    French: "Supprimer",
    German: "löschen",
    Spanish: "Eliminar",
    Italian: "Elimina",
    Polish: "Usuń",
  },
  {
    FIELD1: "t('track.link_sharing.done')",
    English: "Done",
    French: "Terminé",
    German: "fertig",
    Spanish: "Hecho",
    Italian: "Fatto",
    Polish: "Gotowe",
  },
  {
    FIELD1: "t('track.link_sharing.main_title')",
    English: "Active Links",
    French: "Liens actifs",
    German: "aktive Links",
    Spanish: "Enlaces activos",
    Italian: "Link attivi",
    Polish: "Aktywne linki",
  },
  {
    FIELD1: "t('track.link_sharing.limit')",
    English: "Maximum limit reached",
    French: "Limite maximale atteinte",
    German: "Das maximale Limit wurde erreicht",
    Spanish: "Límite máximo alcanzado",
    Italian: "Limite massimo raggiunto",
    Polish: "Maksymalny limit osiągnięty",
  },
  {
    FIELD1: "t('track.link_sharing.new')",
    English: "New Share",
    French: "Nouveau partage",
    German: "Neue Freigabe",
    Spanish: "Nueva compartición",
    Italian: "Nuova condivisione",
    Polish: "Nowe udostępnienie",
  },
  {
    FIELD1: "t('track.link_sharing.empty')",
    English: "You’re currently not sharing any tracker’s location",
    French: "Vous ne partagez actuellement l'emplacement d'aucun traceur.",
    German: "Derzeit teilst du aktuell keinen keinen Standort eines Trackers",
    Spanish:
      "Actualmente no está compartiendo la ubicación de ningún rastreador",
    Italian:
      "Al momento non si sta condividendo la posizione di nessun tracker.",
    Polish: "Obecnie nie udostępniasz żadnej lokalizacji",
  },
  {
    FIELD1: "t('share.main.error')",
    English: "Link not found or expired",
    French: "Lien introuvable ou expiré",
    German: "Der Link wurde nicht gefunden oder ist abgelaufen ",
    Spanish: "Enlace no encontrado o vencido",
    Italian: "Link non trovato o scaduto",
    Polish: "Link nie znaleziony lub wygasł",
  },
  {
    FIELD1: "t('share.main.error2')",
    English: "No tracker data",
    French: "Pas de données sur le traceur",
    German: "Keine Tracker Daten ",
    Spanish: "Sin datos del rastreador",
    Italian: "Nessun dato del tracker",
    Polish: "Brak danych trackera",
  },
  {
    FIELD1: "t('share.main.error3')",
    English:
      "This share has reached the maximum number of requests allowed within a short period. Please try again in 15 minutes.",
    French:
      "Ce partage a atteint le nombre maximum de demandes autorisées dans un court laps de temps. Veuillez réessayer dans 15 minutes.",
    German:
      "Diese Freigabe hat die maximale Anzahl and Anfragen innerhalb eines kurzen Zeitraums erreicht. Bitte versuche es in 15 Minuten erneut. ",
    Spanish:
      "Esta compartición ha alcanzado el número máximo de solicitudes permitidas en un corto período. Intente nuevamente en 15 minutos.",
    Italian:
      "Questa condivisione ha raggiunto il numero massimo di richieste consentite in un breve periodo. Riprovare tra 15 minuti.",
    Polish:
      "Ten link został wykorzystany zbyt wiele razy — spróbuj ponownie za 15 minut",
  },
  {
    FIELD1: "t('share.link.title')",
    English: "Looking for a GPS tracker?",
    French: "Vous cherchez un traceur GPS ?",
    German: "Suchen Sie nach einem GPS Tracker?",
    Spanish: "¿ Busca un localizador GPS ?",
    Italian: "Sei alla ricerca di un localizzatore GPS?",
    Polish: "Szukasz lokalizatora GPS?",
  },
  {
    FIELD1: "t('share.link.link')",
    English: "Learn more",
    French: "En savoir plus",
    German: "Erfahren Sie mehr darüber",
    Spanish: "Más información",
    Italian: "Per saperne di più",
    Polish: "Dowiedz się więcej",
  },
  {
    FIELD1: "t('support_trackers.helmet.title')",
    English: "SafeTag Tracker Support",
    French: "Support pour le traceur SafeTag",
    German: "SafeTag Tracker Unterstützung",
    Spanish: "Soporte de SafeTag Tracker",
    Italian: "Supporto SafeTag Tracker",
    Polish: "Wsparcie SafeTag",
  },
  {
    FIELD1: "t('share.helmet.title')",
    English: "SafeTag Tracking Link",
    French: "Lien de suivi SafeTag",
    German: "SafeTag Verfolgungslink",
    Spanish: "Enlace de seguimiento SafeTag",
    Italian: "Link per il tracciamento SafeTag",
    Polish: "Link śledzenia SafeTag",
  },
  {
    FIELD1: "t('dashboard.helmet.title')",
    English: "SafeTag Dashboard",
    French: "Tableau de bord SafeTag",
    German: "SafeTag-Dashboard",
    Spanish: "Panel SafeTag",
    Italian: "Dashboard SafeTag",
    Polish: "Panel SafeTag",
  },
  {
    FIELD1: "t('history_management.helmet.title')",
    English: "Manage History Data",
    French: "Gérer l'historique des données",
    German: "Verwalten Sie den Datenverlauf",
    Spanish: "Gestionar datos históricos",
    Italian: "Gestire i dati della cronologia",
    Polish: "Zarządzanie historią",
  },
  {
    FIELD1: "t('geofences.helmet.title')",
    English: "Setup Geofences",
    French: "Configurer les géofences",
    German: "Geofencing einrichten",
    Spanish: "Configurar geocercas",
    Italian: "Impostazione delle geofence",
    Polish: "Ustawienia geofencingu",
  },
  {
    FIELD1: "t('mua.helmet.title')",
    English: "Accept your SafeTag Invite",
    French: "Accepter votre invitation SafeTag",
    German: "Aktzeptieren Sie ihre SafeTag Einladung",
    Spanish: "Acepte su invitación SafeTag",
    Italian: "Accettare l'invito di SafeTag",
    Polish: "Akceptuj zaproszenie SafeTag",
  },
  {
    FIELD1: "t('default.helmet.title')",
    English: "SafeTag Tracking",
    French: "Suivi SafeTag",
    German: "SafeTag-Tracking",
    Spanish: "Seguimiento SafeTag",
    Italian: "Tracciamento SafeTag",
    Polish: "Śledzenie SafeTag",
  },
  {
    FIELD1: "t('track.settings.upgrade')",
    English: "Upgrade",
    French: "Mise à jour",
    German: "Upgrade",
    Spanish: "Actualizar",
    Italian: "Aggiornamento",
    Polish: "Aktualizacja",
  },
  {
    FIELD1: "t('track.settings.refresh_rate')",
    English: "Refresh Rate",
    French: "Taux de rafraîchissement",
    German: "Die Rate erneuern",
    Spanish: "Frecuencia de actualización",
    Italian: "Frequenza di aggiornamento",
    Polish: "Częstotliwość odświeżania",
  },
  {
    FIELD1: "t('track.settings.metadata')",
    English: "Metadata",
    French: "Métadonnées",
    German: "Metadaten",
    Spanish: "Metadatos",
    Italian: "Metadati",
    Polish: "Metadane",
  },
  {
    FIELD1: "t('track.settings.name')",
    English: "Name",
    French: "Nom",
    German: "Name",
    Spanish: "Nombre",
    Italian: "Nome",
    Polish: "Nazwa",
  },
  {
    FIELD1: "t('track.settings.value')",
    English: "Value",
    French: "Valeur",
    German: "Wert",
    Spanish: "Valor",
    Italian: "Valore",
    Polish: "Wartość",
  },
  {
    FIELD1: "t('track.settings.max_20')",
    English: "Max 20 characters",
    French: "20 caractères maximum",
    German: "Maximal 20 Zeichen",
    Spanish: "Máximo 20 caracteres",
    Italian: "Massimo 20 caratteri",
    Polish: "Maks. 20 znaków",
  },
  {
    FIELD1: "t('track.settings.missing_name')",
    English: "Name is required",
    French: "Le nom est requis",
    German: "Der Name ist erforderlich",
    Spanish: "El nombre es obligatorio",
    Italian: "Il nome è obbligatorio",
    Polish: "Nazwa jest wymagana",
  },
  {
    FIELD1: "t('track.settings.missing_value')",
    English: "Value is required",
    French: "La valeur est requise",
    German: "Der Wert ist erforderlich",
    Spanish: "El valor es requerido",
    Italian: "Il valore è richiesto",
    Polish: "Wartość jest wymagana",
  },
];

const updatedTranslations = [];

// for (let i of translationData) {
//   const newT = newTranslations.find((t) => i.FIELD1.includes(t.FIELD1));
//   if (newT) {
//     updatedTranslations.push({ ...newT, FIELD1: i.FIELD1 });
//   } else {
//     updatedTranslations.push({
//       FIELD1: i.FIELD1,
//       English: i.English,
//       French: i.French,
//       German: i.German,
//       Spanish: i.Spanish,
//       Italian: i.Italian,
//       Polish: i.Polish,
//     });
//   }
// }
// console.log(updatedTranslations);

function generateI18nData(language) {
  const i18nData = {};

  const countries = {
    FIELD1: "localization.main.countries",
    English: JSON.stringify(countryListEN),
    French: JSON.stringify(countryListFR),
    German: JSON.stringify(countryListDE),
    Spanish: JSON.stringify(countryListES),
    Italian: JSON.stringify(countryListIT),
    Polish: JSON.stringify(countryListPL),
  };

  [countries, ...translationData].forEach((obj) => {
    let FIELD = obj.FIELD1.includes("t('")
      ? obj.FIELD1.split("t('")[1].split("')")[0]
      : obj.FIELD1;
    obj.Page = FIELD.split(".")[0];
    obj.Section = FIELD.split(".")[1];
    obj.Name = FIELD.split(".")[2];
    if (!i18nData[obj.Page]) {
      i18nData[obj.Page] = {};
    }
    if (!i18nData[obj.Page][obj.Section]) {
      i18nData[obj.Page][obj.Section] = {};
    }
    i18nData[obj.Page][obj.Section][obj.Name] = obj[language];
  });
  return i18nData;
}

export default generateI18nData;
